const ar = {
    'chatAiDevis.qualityIncell': 'InCell',
    'chatAiDevis.qualityOled': 'OLED',
    'chatAiDevis.qualityOriginal': 'أصلي / OEM',
    'chatAiDevis.qualityCompatible': 'متوافق',
    'chatAiDevis.qualityReconditionné': 'مُجدَّد',
    'chatAiDevis.qualityPremium': 'بريميوم',
    'chatAiDevis.qualityStandard': 'قياسي',
    'chatAiDevis.fieldName': 'الاسم',
    'chatAiDevis.fieldPhone': 'الهاتف',
    'chatAiDevis.fieldEmail': 'البريد الإلكتروني',
    'chatAiDevis.familyAccessoryStock': 'ملحق · مخزون',
    'chatAiDevis.familyAccessoryCapped': 'ملحق · ≤ 49€',
    'chatAiDevis.familyAccessory': 'ملحق',
    'chatAiDevis.familyPart': 'قطعة',
    'chatAiDevis.familyScreen': 'شاشة',
    'chatAiDevis.badgeFallback': 'سعر تقديري (احتياطي)',
    'chatAiDevis.badgeModelScore': 'درجة المطابقة {{score}}',
    'chatAiDevis.badgeModelScoreShort': 'درجة المطابقة',
    'chatAiDevis.badgeNeedsReview': 'بحاجة إلى مراجعة',
    'chatAiDevis.altOtherParts': 'قطع أخرى (كل المورّدين)',
    'chatAiDevis.altSelected': 'المختارة',
    'chatAiDevis.useBtn': 'استخدام',
    'chatAiDevis.compareTitle': 'مقارنة Jens / Mobilax / LCD-Phone',
    'chatAiDevis.compareCurrentLabel': 'الحالي:',
    'chatAiDevis.htSuffix': 'بدون ضريبة',
    'chatAiDevis.compareNoneFound': 'لم يتم العثور على أي قطعة لدى المورّدين الثلاثة.',
    'chatAiDevis.colSupplier': 'المورّد',
    'chatAiDevis.colPart': 'القطعة',
    'chatAiDevis.colPurchaseHt': 'الشراء بدون ضريبة',
    'chatAiDevis.colTtcEst': 'شامل الضريبة (تقديري)',
    'chatAiDevis.colStock': 'المخزون',
    'chatAiDevis.colExactModel': 'الطراز المطابق',
    'chatAiDevis.badgeCheapest': 'الأرخص',
    'chatAiDevis.badgeCurrent': 'الحالي',
    'chatAiDevis.scoreInline': 'درجة {{score}}',
    'chatAiDevis.compareNoResultFor': 'بدون نتيجة: {{suppliers}}',
    'chatAiDevis.cadbotEmptyCache': 'طلب CADBOT — ذاكرة المورّد فارغة. أدخل سعر الشراء بدون ضريبة ثم اضغط تحقّق لإرسال عرض السعر.',
    'chatAiDevis.purchaseMissingZero': 'سعر الشراء مفقود (0 €) — حدِّث القطعة أو أدخل سعر الشراء يدويًا.',
    'chatAiDevis.supplierPrimary': 'رئيسي',
    'chatAiDevis.supplierAlternate': 'بديل',
    'chatAiDevis.defaultRepair': 'إصلاح',
    'chatAiDevis.defaultPart': 'قطعة',
    'chatAiDevis.defaultClient': 'العميل',
    'chatAiDevis.identityIncompleteInline': 'بطاقة العميل غير مكتملة ({{fields}}) — إلزامية قبل التحقّق',
    'chatAiDevis.willSendTo': 'سيُرسَل عرض السعر إلى {{email}}',
    'chatAiDevis.phName': 'الاسم الكامل *',
    'chatAiDevis.phPhone': 'الهاتف *',
    'chatAiDevis.phEmail': 'البريد الإلكتروني *',
    'chatAiDevis.saveIdentityBtn': 'حفظ بطاقة العميل',
    'chatAiDevis.ttcCalcul': 'شامل الضريبة · /calcul',
    'chatAiDevis.selectedPart': 'القطعة المختارة',
    'chatAiDevis.purchasePriceHt': 'سعر الشراء بدون ضريبة',
    'chatAiDevis.labor': 'أجرة العمل',
    'chatAiDevis.recalcTotal': 'إعادة حساب الإجمالي',
    'chatAiDevis.hideCompare': 'إخفاء المقارنة',
    'chatAiDevis.compareBtn': 'قارن Jens / Mobilax / LCD-Phone',
    'chatAiDevis.showAlternatives': 'عرض البدائل (قائمة)',
    'chatAiDevis.hideAlternatives': 'إخفاء البدائل (قائمة)',
    'chatAiDevis.botStaff': 'بوت الموظفين',
    'chatAiDevis.bestPartAuto': 'أفضل قطعة (تلقائي)',
    'chatAiDevis.pdf': 'PDF',
    'chatAiDevis.approveSingle': 'تحقّق (فردي)',
    'chatAiDevis.reject': 'رفض',
    'chatAiDevis.print': 'طباعة',
    'chatAiDevis.dirAdminTitle': 'الإدارة / مسؤول المتجر',
    'chatAiDevis.delete': 'حذف',
    'chatAiDevis.approvedShort': 'تم التحقّق',
    'chatAiDevis.rejectedShort': 'مرفوض',
    'chatAiDevis.batchLabel': 'دفعة {{count}} عروض أسعار',
    'chatAiDevis.clientChat': 'دردشة العميل',
    'chatAiDevis.approveAllSend': 'تحقّق من الـ {{count}} وأرسِل',
    'chatAiDevis.deleteBatch': 'حذف الدفعة',
    'chatAiDevis.pageTitle': 'عروض الأسعار بالذكاء الاصطناعي — التحقّق',
    'chatAiDevis.pageSubtitle': '4 خيارات لكل طلب شاشة · InCell · OLED · مُجدَّد · أصلي',
    'chatAiDevis.filterPending': 'قيد الانتظار',
    'chatAiDevis.filterApproved': 'تم التحقّق منها',
    'chatAiDevis.filterRejected': 'مرفوضة',
    'chatAiDevis.filterAll': 'الكل',
    'chatAiDevis.infoTitle': 'الدردشة بالذكاء الاصطناعي و Auto-Devis — المورّدون',
    'chatAiDevis.infoJensPrimary': 'هو المورّد الرئيسي (الأولوية في التقييم).',
    'chatAiDevis.infoAnd': 'و',
    'chatAiDevis.infoMobilaxLcd': 'تتم استشارتهما عند وجود تطابق أفضل أو إذا لم تتوفّر القطعة لدى Jens.',
    'chatAiDevis.infoEachRange': 'قد تأتي كل فئة (InCell، OLED، إلخ) من مورّد مختلف — راجعها قبل التحقّق.',
    'chatAiDevis.infoCompareExplain': '«قارن Jens / Mobilax / LCD-Phone» يعرض سعر الشراء بدون ضريبة، والإجمالي الشامل للضريبة التقديري، والمخزون، والطراز المطابق لدى كل مورّد — «استخدام» يبدّل المسودّة.',
    'chatAiDevis.infoBadgesLabel': 'الشارات:',
    'chatAiDevis.infoBadgesCheck': '— افحص القطعة قبل التحقّق.',
    'chatAiDevis.infoBotStaffExplain': '(اللوحة على اليمين) — صِف عملية إصلاح لإنشاء المسودّات، أو اكتب «comparer» لعرض جميع المورّدين.',
    'chatAiDevis.loading': 'جارٍ التحميل…',
    'chatAiDevis.noQuotesPending': 'لا توجد عروض أسعار قيد الانتظار.',
    'chatAiDevis.noQuotes': 'لا توجد عروض أسعار.',
    'chatAiDevis.emptyHint': 'استخدم بوت Auto-Devis على اليمين لإنشاء واحد (مثال: «شاشة iPhone 14»).',
    'chatAiDevis.backToStaff': '→ العودة إلى مساحة الموظفين',
    'chatAiDevis.botAutoDevis': 'بوت Auto-Devis',
    'chatAiDevis.staffSpace': '→ مساحة الموظفين',
    'chatAiDevis.errPdfPreview': 'خطأ في معاينة PDF',
    'chatAiDevis.alertPurchaseMissingPrint': 'سعر الشراء مفقود — أدخل سعرًا أو حدِّث القطعة قبل الطباعة.',
    'chatAiDevis.errPrintTicket': 'خطأ في طباعة تذكرة 80mm',
    'chatAiDevis.errRecalc': 'خطأ في إعادة الحساب',
    'chatAiDevis.errPartNotFound': 'القطعة غير موجودة في ذاكرة المورّد',
    'chatAiDevis.errCompare': 'خطأ في مقارنة المورّدين',
    'chatAiDevis.errAlternatives': 'خطأ في تحميل البدائل',
    'chatAiDevis.errSaveIdentity': 'خطأ في حفظ بطاقة العميل',
    'chatAiDevis.alertIdentityIncomplete': 'بطاقة العميل غير مكتملة: {{fields}}. الاسم والهاتف والبريد الإلكتروني إلزامية قبل التحقّق من عرض السعر وإرساله.',
    'chatAiDevis.mailWillSend': 'سيُرسَل بريد إلكتروني مرفق به ملف PDF إلى: {{email}}',
    'chatAiDevis.noClientEmail': '(لا يوجد بريد إلكتروني للعميل — التحقّق عبر الدردشة فقط)',
    'chatAiDevis.confirmApprove': 'هل تريد التحقّق من عرض السعر هذا وإرساله إلى العميل؟',
    'chatAiDevis.sumupWarn': 'تنبيه: تعذّر إنشاء رابط الدفع SumUp ({{error}}). سيعرض زر البريد الإلكتروني الدفع عند النقر؛ تحقّق من مفتاح SumUp API في الإعدادات.',
    'chatAiDevis.sumupUnavailable': 'SumUp غير متاح',
    'chatAiDevis.approvedMailSent': 'تم التحقّق من عرض السعر — أُرسِل البريد الإلكتروني إلى {{email}}.',
    'chatAiDevis.approvedSent': 'تم التحقّق من عرض السعر وإرساله إلى العميل.',
    'chatAiDevis.errApprove': 'خطأ في التحقّق',
    'chatAiDevis.confirmApproveBatch': 'هل تريد التحقّق من الـ {{count}} عروض أسعار وإرسال الملخّص إلى العميل؟',
    'chatAiDevis.batchApproved': 'تم التحقّق من {{count}} عروض أسعار وإرسالها إلى العميل.',
    'chatAiDevis.errApproveBatch': 'خطأ في التحقّق من الدفعة',
    'chatAiDevis.promptRejectReason': 'سبب الرفض (اختياري):',
    'chatAiDevis.errGeneric': 'خطأ',
    'chatAiDevis.confirmDeleteDevis': 'حذف عرض السعر {{ref}} نهائيًا؟\n\nإجراء لا يمكن التراجع عنه.',
    'chatAiDevis.errDelete': 'خطأ في الحذف',
    'chatAiDevis.confirmDeleteBatch': 'حذف الـ {{count}} عروض أسعار في الدفعة نهائيًا؟\n\nإجراء لا يمكن التراجع عنه.',
    'chatAiDevis.errDeleteBatch': 'خطأ في حذف الدفعة',
    'saLayout.nav_dashboard': 'لوحة التحكم',
    'saLayout.nav_analytics': 'التحليلات',
    'saLayout.nav_companies': 'الشركات',
    'saLayout.nav_subscriptions': 'الاشتراكات',
    'saLayout.nav_users': 'المستخدمون',
    'saLayout.nav_stats': 'الإحصائيات',
    'saLayout.nav_communications': 'الاتصالات',
    'saLayout.nav_impersonation': 'وضع الدعم',
    'saLayout.nav_config': 'الإعدادات',
    'saLayout.nav_integrations': 'تكاملات API',
    'saLayout.nav_security': 'الأمان (المصادقة الثنائية)',
    'saLayout.nav_logs': 'السجل والتدقيق',
    'saLayout.super_admin': 'المشرف الأعلى',
    'saLayout.role_super_admin': 'المشرف الأعلى',
    'saLayout.logout': 'تسجيل الخروج',
    'saLayout.top_bar_title': 'لوحة المشرف الأعلى',
    'saConfig.error': 'خطأ',
    'saConfig.confirmMaintenance': 'هل تريد تفعيل وضع الصيانة؟ لن يتمكن العملاء من الوصول إلى المنصة بعد الآن.',
    'saConfig.title': 'الإعدادات',
    'saConfig.subtitle': 'الإعدادات العامة للمنصة',
    'saConfig.saved': 'تم الحفظ',
    'saConfig.saving': 'جارٍ الحفظ...',
    'saConfig.save': 'حفظ',
    'saConfig.maintenanceTitle': 'وضع الصيانة',
    'saConfig.maintenanceDesc': 'حظر وصول العملاء مؤقتًا',
    'saConfig.generalSettings': 'الإعدادات العامة',
    'saConfig.platformName': 'اسم المنصة',
    'saConfig.gracePeriod': 'فترة السماح (أيام)',
    'saConfig.plans': 'خطط الأسعار',
    'saConfig.planPrice': 'السعر (يورو/شهر)',
    'saConfig.maxShops': 'الحد الأقصى للمتاجر',
    'saConfig.maxUsers': 'الحد الأقصى للمستخدمين',
    'saConfig.features': 'الميزات',
    'saImpersonation.title': 'وضع الدعم (انتحال الهوية)',
    'saImpersonation.subtitle': 'الوصول مؤقتًا إلى حساب شركة',
    'saImpersonation.confirmEnter': 'هل تريد الدخول إلى وضع الدعم لهذه الشركة؟',
    'saImpersonation.errorGeneric': 'خطأ',
    'saImpersonation.activeBannerTitle': 'وضع الدعم نشط',
    'saImpersonation.connectedAs': 'متصل بصفة: {{name}}',
    'saImpersonation.stopSupport': 'الخروج من وضع الدعم',
    'saImpersonation.warningTitle': 'تنبيه — وظيفة حساسة',
    'saImpersonation.warningText': 'يمنحك انتحال الهوية وصولاً كاملاً إلى حساب العميل. تُسجَّل جميع إجراءاتك. لن تُعدَّل كلمة مرور العميل أبدًا.',
    'saImpersonation.searchPlaceholder': 'البحث عن شركة...',
    'saImpersonation.emptyList': 'لم يتم العثور على أي شركة',
    'saImpersonation.companyMeta': '{{email}} - الباقة {{plan}}',
    'saImpersonation.enterBtn': 'دخول',
    'saPackages.title': 'إدارة الحزم',
    'saPackages.subtitle': 'استبدل مباشرةً ملفات ZIP ووكيل Windows المقدَّمة في بيئة الإنتاج.',
    'saPackages.refresh': 'تحديث',
    'saPackages.statAvailable': 'العناصر المتوفّرة',
    'saPackages.statTotalSize': 'الحجم الإجمالي',
    'saPackages.statAlert': 'تنبيه',
    'saPackages.alertText': 'تؤدّي عمليات الاستبدال إلى الكتابة فوق الملف المباشر. لا يوجد حذف منفصل.',
    'saPackages.statusAvailable': 'متوفّر',
    'saPackages.statusMissing': 'مفقود',
    'saPackages.download': 'تنزيل',
    'saPackages.activeFile': 'الملف النشط',
    'saPackages.size': 'الحجم',
    'saPackages.lastUpdate': 'آخر تحديث',
    'saPackages.uploadedBy': 'تم الرفع بواسطة',
    'saPackages.replaceLiveFile': 'استبدال الملف المباشر',
    'saPackages.uploading': 'جارٍ الرفع…',
    'saPackages.replace': 'استبدال',
    'saPackages.replaceHint': 'يحلّ الملف المختار مباشرةً محلّ الملف المقدَّم للمستخدمين على remobiles.com.',
    'saPackages.selectedFile': 'الملف المحدَّد: {{name}}',
    'saPackages.errorLoad': 'خطأ في تحميل الملفات',
    'saPackages.downloadLinkUnavailable': 'رابط التنزيل غير متاح',
    'saPackages.downloadFailed': 'تعذّر التنزيل',
    'saPackages.selectFileFor': 'اختر ملفًا لـ {{label}}.',
    'saPackages.confirmReplace': 'هل تريد استبدال {{label}} الآن بـ {{name}}؟',
    'saPackages.replaceSuccess': 'تم استبدال {{label}} بنجاح.',
    'saPackages.errorUpload': 'خطأ أثناء الرفع',
    'saPackages.superAdminOnly': 'الوصول لمسؤول النظام الأعلى فقط',
    'saPackages.superAdminDesc': 'تتيح هذه الصفحة تحديث الملفات المقدَّمة حاليًا من remobiles.com. تبقى روابط التنزيل العامة مُدارة عبر المسارات الموقَّعة في الواجهة الخلفية.',
    'saDashboard.title': 'لوحة التحكم',
    'saDashboard.subtitle': 'نظرة عامة على منصة {{brand}}',
    'saDashboard.companies': 'الشركات',
    'saDashboard.activeCount': '{{count}} نشطة',
    'saDashboard.users': 'المستخدمون',
    'saDashboard.shops': 'المتاجر',
    'saDashboard.mrr': 'MRR',
    'saDashboard.mrrSub': 'الإيراد الشهري المتكرر',
    'saDashboard.newThisMonth': 'جديدة هذا الشهر',
    'saDashboard.expired': 'منتهية',
    'saDashboard.suspended': 'موقوفة',
    'saDashboard.recentCompanies': 'أحدث الشركات',
    'saDashboard.viewAll': 'عرض الكل',
    'saDashboard.noCompanies': 'لا توجد شركات بعد',
    'saDashboard.recentActivity': 'النشاط الأخير',
    'saDashboard.noActivity': 'لا يوجد نشاط حديث',
    'saAnalytics.title': 'تحليلات المنصة',
    'saAnalytics.subtitle': 'المؤشرات العامة والأداء حسب الشركة',
    'saAnalytics.kpiRepairsToday': 'الإصلاحات اليوم',
    'saAnalytics.kpiActiveRepairs': 'الإصلاحات النشطة',
    'saAnalytics.kpiRevenueMonth': 'إيرادات هذا الشهر',
    'saAnalytics.kpiClientsTotal': 'إجمالي العملاء',
    'saAnalytics.kpiRepairsWeek': 'إصلاحات الأسبوع',
    'saAnalytics.kpiRepairsMonth': 'إصلاحات الشهر',
    'saAnalytics.kpiRepairsTotal': 'إجمالي الإصلاحات',
    'saAnalytics.kpiRevenueTotal': 'إجمالي الإيرادات',
    'saAnalytics.kpiActiveCompanies': 'الشركات النشطة',
    'saAnalytics.companyPerformance': 'الأداء حسب الشركة',
    'saAnalytics.companiesCount': '{{count}} شركة',
    'saAnalytics.emptyCompanies': 'لا توجد شركات نشطة',
    'saAnalytics.colCompany': 'الشركة',
    'saAnalytics.colPlan': 'الخطة',
    'saAnalytics.colRepairs': 'الإصلاحات',
    'saAnalytics.colActive': 'نشطة',
    'saAnalytics.colClients': 'العملاء',
    'saAnalytics.colStock': 'المخزون',
    'saAnalytics.colSales': 'المبيعات',
    'saAnalytics.colRevenue': 'الإيرادات',
    'saAnalytics.colAvgTime': 'متوسط الوقت',
    'saAnalytics.daysShort': '{{n}} يوم',
    'saLogs.title': 'السجل والأمان',
    'saLogs.subtitle': 'تدقيق الإجراءات وحالة النظام',
    'saLogs.systemHealth': 'حالة النظام',
    'saLogs.database': 'قاعدة البيانات',
    'saLogs.statusOk': 'سليم',
    'saLogs.statusError': 'خطأ',
    'saLogs.filterAll': 'جميع الإجراءات',
    'saLogs.filterCreateCompany': 'إنشاء شركة',
    'saLogs.filterUpdateCompany': 'تعديل شركة',
    'saLogs.filterSuspend': 'تعليق',
    'saLogs.filterActivate': 'إعادة التفعيل',
    'saLogs.filterImpersonate': 'انتحال الهوية',
    'saLogs.filterCreateUser': 'إنشاء مستخدم',
    'saLogs.filterDeleteUser': 'حذف مستخدم',
    'saLogs.filterResetPassword': 'إعادة تعيين كلمة المرور',
    'saLogs.filterUpdateSubscription': 'تعديل الاشتراك',
    'saLogs.filterUpdateConfig': 'تعديل الإعدادات',
    'saLogs.entriesCount': '{{count}} إدخال',
    'saLogs.empty': 'لا توجد إدخالات في السجل',
    'saLogs.onTarget': 'على {{target}}',
    'saLogs.byUserAt': 'بواسطة {{user}} - {{date}}',
    'saComm.title': 'المراسلات',
    'saComm.messagesSent': '{{count}} رسالة مُرسَلة',
    'saComm.newMessage': 'رسالة جديدة',
    'saComm.emptyList': 'لم تُرسَل أي مراسلة',
    'saComm.noSubject': 'بدون موضوع',
    'saComm.allClients': 'جميع العملاء',
    'saComm.companiesCount': '{{count}} شركة',
    'saComm.modalTitle': 'إرسال مراسلة',
    'saComm.typeLabel': 'النوع',
    'saComm.typeNotification': 'إشعار',
    'saComm.typeMaintenance': 'صيانة',
    'saComm.typeUpdate': 'تحديث',
    'saComm.recipients': 'المستلمون',
    'saComm.targetSelected': 'تحديد',
    'saComm.targetedCompanies': 'الشركات المستهدفة',
    'saComm.subjectLabel': 'الموضوع *',
    'saComm.messageLabel': 'الرسالة *',
    'saComm.cancel': 'إلغاء',
    'saComm.send': 'إرسال',
    'saComm.errorGeneric': 'خطأ',
    'saSecurity.pageTitle': 'أمان الحساب',
    'saSecurity.pageSubtitle': 'المصادقة الثنائية (2FA) وتقييد عناوين IP وإعدادات الأمان',
    'saSecurity.errorGeneric': 'خطأ',
    'saSecurity.twoFAEnabledSuccess': 'تم تفعيل المصادقة الثنائية (2FA) بنجاح!',
    'saSecurity.invalidCode': 'رمز غير صالح',
    'saSecurity.twoFADisabled': 'تم تعطيل المصادقة الثنائية (2FA)',
    'saSecurity.saveError': 'خطأ أثناء الحفظ',
    'saSecurity.twoFATitle': 'المصادقة الثنائية (2FA)',
    'saSecurity.statusEnabled': 'مُفعَّل',
    'saSecurity.statusDisabled': 'مُعطَّل',
    'saSecurity.setupBtn': 'إعداد المصادقة الثنائية (2FA)',
    'saSecurity.scanQrInstruction': 'امسح رمز QR هذا باستخدام Google Authenticator:',
    'saSecurity.qrCodeAlt': 'رمز QR',
    'saSecurity.manualKeyInstruction': 'أو أدخل هذا المفتاح يدويًا:',
    'saSecurity.verificationCodeLabel': 'رمز التحقق',
    'saSecurity.verifyBtn': 'تحقق',
    'saSecurity.disableInstruction': 'لتعطيل المصادقة الثنائية (2FA)، أدخل رمزك الحالي:',
    'saSecurity.ipRestrictionTitle': 'تقييد عناوين IP (اختياري)',
    'saSecurity.ipRestrictionSubtitle': 'تقييد وصول المشرف العام إلى عناوين IP معيّنة',
    'saSecurity.ipPlaceholder': 'عنوان IP واحد في كل سطر (مثال: 192.168.1.1)',
    'saSecurity.saved': 'تم الحفظ',
    'saSecurity.save': 'حفظ',
    'saStats.title': 'إحصائيات الأعمال',
    'saStats.subtitle': 'تحليلات وتوقعات مالية',
    'saStats.mrrTitle': 'الإيرادات الشهرية المتكررة (MRR)',
    'saStats.planDistTitle': 'توزيع الخطط',
    'saStats.emptyData': 'لا توجد بيانات',
    'saStats.churnTitle': 'معدل إلغاء الاشتراك (Churn)',
    'saStats.cancelledCount': '{{count}} إلغاء',
    'saStats.growthTitle': 'النمو - شركات جديدة',
    'repairUi.repairs': 'الإصلاحات',
    'repairUi.repairSheet': 'بطاقة الإصلاح',
    'repairUi.edit': 'تعديل',
    'repairUi.print': 'طباعة',
    'repairUi.backToRepairs': 'العودة إلى الإصلاحات',
    'repairUi.editRepair': 'تعديل الإصلاح',
    'repairUi.newDeposit': 'إيداع جديد',
    'repairUi.ref': 'مرجع',
    'saSubscriptions.title': 'الاشتراكات',
    'saSubscriptions.count': '{{count}} اشتراك',
    'saSubscriptions.filter_all_statuses': 'كل الحالات',
    'saSubscriptions.filter_all_plans': 'كل الخطط',
    'saSubscriptions.status_active': 'نشط',
    'saSubscriptions.status_suspended': 'موقوف',
    'saSubscriptions.status_expired': 'منتهٍ',
    'saSubscriptions.status_overdue': 'متأخر',
    'saSubscriptions.status_cancelled': 'ملغى',
    'saSubscriptions.col_company': 'الشركة',
    'saSubscriptions.col_plan': 'الخطة',
    'saSubscriptions.col_price': 'السعر',
    'saSubscriptions.col_status': 'الحالة',
    'saSubscriptions.col_next_billing': 'الفوترة التالية',
    'saSubscriptions.col_discount': 'الخصم',
    'saSubscriptions.col_actions': 'إجراءات',
    'saSubscriptions.empty': 'لا توجد اشتراكات',
    'saSubscriptions.action_edit': 'تعديل',
    'saSubscriptions.action_extend': 'تمديد',
    'saSubscriptions.modal_title': 'تعديل الاشتراك',
    'saSubscriptions.label_discount': 'الخصم (%)',
    'saSubscriptions.plan_option_start': 'Start ({{price}})',
    'saSubscriptions.plan_option_pro': 'Pro ({{price}})',
    'saSubscriptions.plan_option_super': 'Super ({{price}})',
    'saSubscriptions.cancel': 'إلغاء',
    'saSubscriptions.save': 'حفظ',
    'saSubscriptions.prompt_extend_days': 'عدد الأيام المراد إضافتها:',
    'saSubscriptions.error': 'خطأ',
    'saUsers.title': 'المستخدمون',
    'saUsers.totalUsers': '{{count}} مستخدم',
    'saUsers.newUser': 'مستخدم جديد',
    'saUsers.searchPlaceholder': 'بحث...',
    'saUsers.filterAllRoles': 'كل الأدوار',
    'saUsers.roleSuperAdmin': 'مدير عام',
    'saUsers.roleAdmin': 'مدير',
    'saUsers.roleUser': 'موظف',
    'saUsers.roleTechnicien': 'فني',
    'saUsers.roleClient': 'عميل',
    'saUsers.roleB2b': 'B2B',
    'saUsers.emptyState': 'لم يتم العثور على مستخدمين',
    'saUsers.colUser': 'المستخدم',
    'saUsers.colRole': 'الدور',
    'saUsers.colCompany': 'الشركة',
    'saUsers.colCreatedAt': 'تاريخ الإنشاء',
    'saUsers.colActions': 'إجراءات',
    'saUsers.resetPassword': 'إعادة تعيين كلمة المرور',
    'saUsers.delete': 'حذف',
    'saUsers.labelUsername': 'اسم المستخدم',
    'saUsers.labelEmail': 'البريد الإلكتروني',
    'saUsers.labelPassword': 'كلمة المرور',
    'saUsers.companyNone': 'لا شيء',
    'saUsers.cancel': 'إلغاء',
    'saUsers.create': 'إنشاء',
    'saUsers.labelNewPassword': 'كلمة المرور الجديدة',
    'saUsers.reset': 'إعادة تعيين',
    'saUsers.error': 'خطأ',
    'saUsers.resetSuccess': 'تمت إعادة تعيين كلمة المرور بنجاح',
    'saUsers.confirmDelete': 'حذف المستخدم {{username}}؟',
    'saCompanies.status_active': 'نشط',
    'saCompanies.status_suspended': 'معلّق',
    'saCompanies.status_overdue': 'متأخر',
    'saCompanies.status_archived': 'مؤرشف',
    'saCompanies.error': 'خطأ',
    'saCompanies.confirm_suspend': 'هل تريد إيقاف هذه الشركة؟',
    'saCompanies.suspend_reason_manual': 'موقوف يدويًا',
    'saCompanies.confirm_archive': 'هل تريد أرشفة هذه الشركة؟ هذا الإجراء لا يمكن التراجع عنه.',
    'saCompanies.reminder_sent': 'تم إرسال بريد التذكير',
    'saCompanies.reminder_error': 'حدث خطأ أثناء الإرسال',
    'saCompanies.title': 'الشركات',
    'saCompanies.total_companies': '{{count}} شركة إجمالاً',
    'saCompanies.new_company': 'شركة جديدة',
    'saCompanies.search_placeholder': 'بحث...',
    'saCompanies.filter_all_status': 'كل الحالات',
    'saCompanies.filter_overdue': 'متأخر',
    'saCompanies.filter_all_plans': 'كل الخطط',
    'saCompanies.empty': 'لم يتم العثور على أي شركة',
    'saCompanies.col_company': 'الشركة',
    'saCompanies.col_plan': 'الخطة',
    'saCompanies.col_status': 'الحالة',
    'saCompanies.col_users': 'المستخدمون',
    'saCompanies.col_registered': 'تاريخ التسجيل',
    'saCompanies.col_actions': 'الإجراءات',
    'saCompanies.action_view': 'عرض',
    'saCompanies.action_reminder': 'إرسال تذكير بالدفع',
    'saCompanies.action_suspend': 'إيقاف',
    'saCompanies.action_reactivate': 'إعادة التفعيل',
    'saCompanies.action_archive': 'أرشفة',
    'saCompanies.field_company_name': 'اسم الشركة',
    'saCompanies.field_contact': 'جهة الاتصال الرئيسية',
    'saCompanies.field_email': 'البريد الإلكتروني',
    'saCompanies.field_phone': 'الهاتف',
    'saCompanies.field_address': 'العنوان',
    'saCompanies.field_plan': 'خطة الاشتراك',
    'saCompanies.plan_option_start': 'Start ({{price}}/شهر)',
    'saCompanies.plan_option_pro': 'Pro ({{price}}/شهر)',
    'saCompanies.plan_option_super': 'Super ({{price}}/شهر)',
    'saCompanies.field_shop_count': 'عدد المتاجر',
    'saCompanies.admin_account': 'حساب مسؤول الشركة',
    'saCompanies.field_admin_email': 'بريد المسؤول',
    'saCompanies.field_password': 'كلمة المرور',
    'saCompanies.field_notes': 'ملاحظات داخلية',
    'saCompanies.cancel': 'إلغاء',
    'saCompanies.create_company': 'إنشاء الشركة',
    'saCompanies.users_count': '{{count}} مستخدم',
    'saCompanies.subscription': 'الاشتراك',
    'saCompanies.monthly_price': 'السعر الشهري',
    'saCompanies.next_billing': 'الفاتورة القادمة',
    'saCompanies.no_users': 'لا يوجد مستخدمون',
    'qrRouter.redirecting': 'جارٍ إعادة التوجيه...',
    'subscriptionPages.verifyingPayment': 'جارٍ التحقق من الدفع...',
    'subscriptionPages.successTitle': 'تم الدفع بنجاح!',
    'subscriptionPages.successBody': 'اشتراكك مُفعَّل الآن.',
    'subscriptionPages.goToDashboard': 'الانتقال إلى لوحة التحكم',
    'subscriptionPages.processingPayment': 'جارٍ معالجة الدفع...',
    'subscriptionPages.errorTitle': 'خطأ',
    'subscriptionPages.errorBody': 'تعذَّر التحقق من الدفع.',
    'subscriptionPages.backToDashboard': 'العودة إلى لوحة التحكم',
    'subscriptionPages.cancelTitle': 'تم إلغاء الدفع',
    'subscriptionPages.cancelBody': 'تم إلغاء الدفع. يمكنك المحاولة مرة أخرى في أي وقت.',
    'common.error': 'خطأ',
    'notes.uploadError': 'خطأ أثناء رفع الملف',
    'notes.downloadError': 'خطأ أثناء التنزيل',
    'notes.confirmDeleteFile': 'حذف هذا الملف؟',
    'notes.uploading': 'جارٍ الرفع...',
    'notes.attach': 'إرفاق',
    'notes.addedBy': 'أُضيف بواسطة {{author}} — {{date}}',
    'notes.sizeBytes': '{{size}} بايت',
    'notes.sizeKb': '{{size}} ك.ب',
    'notes.sizeMb': '{{size}} م.ب',
    'historique.subtitle': 'المبيعات والإيصالات والدفعات المقدمة',
    'historique.centreActivite': 'مركز النشاط',
    'historique.filtresRecherche': 'التصفية والبحث',
    'historique.rechercher': 'بحث',
    'historique.searchPlaceholder': 'منتج، مرجع…',
    'historique.vendeur': 'البائع',
    'historique.tous': 'الكل',
    'historique.dateDebut': 'تاريخ البداية',
    'historique.dateFin': 'تاريخ النهاية',
    'historique.magasin': 'المتجر',
    'historique.filtrer': 'تصفية',
    'historique.reinitialiser': 'إعادة تعيين',
    'historique.totalVentes': 'إجمالي المبيعات',
    'historique.totalAcomptes': 'إجمالي الدفعات المقدمة',
    'historique.totalRetraits': 'إجمالي السحوبات',
    'historique.totalGlobal': 'الإجمالي العام',
    'historique.commVentes': 'عمولة المبيعات ({{pct}}%)',
    'historique.commReparations': 'عمولة الإصلاحات ({{pct}}%)',
    'historique.commCommandes': 'عمولة الطلبات ({{pct}}%)',
    'historique.totalCommissions': 'إجمالي العمولات',
    'historique.popupsAutoriser': 'يرجى السماح بالنوافذ المنبثقة للطباعة.',
    'historique.erreurTelechargement': 'حدث خطأ أثناء التنزيل',
    'historique.vendeurDatesRequis': 'يرجى إدخال البائع والتواريخ',
    'historique.erreurImpressionRapport': 'خطأ في طباعة التقرير',
    'historique.erreurConfirmationSumup': 'خطأ أثناء تأكيد SumUp',
    'historique.confirmRefusPaiement': 'هل تريد وضع علامة على هذه الدفعة كمرفوضة / ملغاة؟',
    'historique.erreurRefusSumup': 'خطأ أثناء رفض SumUp',
    'dash.forceOpen': 'فتح إجباري',
    'dash.force': 'فرض',
    'dash.forceOpenTitle': 'فرض فتح صندوق {{magasin}}',
    'dash.forceOpenWarning': 'سيتم إغلاق أي صندوق مفتوح تلقائيًا. وسيتم إنشاء صندوق جديد بالمبلغ المحدد.',
    'dash.noOpenCaisseToForce': 'لا يوجد صندوق مفتوح لفرض إغلاقه في {{magasin}}.',
    'dash.thisMagasin': 'هذا المتجر',
    'dash.statusOpenF': 'مفتوح',
    'dash.statusClosedF': 'مغلق',
    'dash.openMagasin': 'فتح {{magasin}}',
    'dash.forceOpenShort': 'فرض الفتح',
    'dash.closeMagasin': 'إغلاق {{magasin}}',
    'dash.forceCloseShort': 'فرض الإغلاق',
    'dash.subtitleNetwork': 'عرض الشبكة · الصندوق · المؤشرات',
    'dash.subtitleWorkshop': 'الورشة · الإصلاحات',
    'dash.subtitleDefault': 'لوحة التحكم · المبيعات والنشاط',
    'dash.caisseActionsByStore': 'إجراءات الصندوق حسب المتجر',
    'devisFactures.printPopupBlocked': 'يرجى السماح بالنوافذ المنبثقة للطباعة.',
    'devisFactures.errorPrintTicket': 'خطأ في طباعة الإيصال',
    'devisFactures.errorPrintA4': 'خطأ في طباعة A4',
    'devisFactures.errorConvert': 'خطأ في التحويل إلى طلب',
    'devisFactures.errorDelete': 'خطأ في الحذف',
    'devisFactures.errorInvalidEmail': 'عنوان بريد إلكتروني غير صالح',
    'devisFactures.emailSent': 'تم إرسال {{type}} إلى {{email}}',
    'devisFactures.errorSendEmail': 'خطأ في إرسال البريد الإلكتروني',
    'devisFactures.linkedTo': 'مرتبط بـ {{ref}}',
    'devisFactures.sendByEmail': 'إرسال بالبريد الإلكتروني',
    'devisFactures.detachConfirm': 'هل تريد فصل هذا العرض عن {{ref}}؟',
    'devisFactures.error': 'خطأ',
    'devisFactures.attachToRepair': 'ربط بعملية إصلاح',
    'devisFactures.emailModalTitle': 'إرسال {{type}} بالبريد الإلكتروني',
    'devisFactures.refLabel': 'المرجع:',
    'devisFactures.a4PdfNote': 'سيتم إرسال المستند بصيغة PDF بقياس A4',
    'devisFactures.clientEmailLabel': 'عنوان البريد الإلكتروني للعميل',
    'devisFactures.emailPlaceholder': 'client@example.com',
    'devisFactures.labelDevis': 'عرض سعر',
    'devisFactures.labelFacture': 'فاتورة',
    'devisFactures.labelCommande': 'طلب',
    'devisFactures.labelAvoir': 'إشعار دائن',
    'devisFactures.labelPaye': 'مدفوع',
    'devisFactures.labelAnnule': 'ملغى',
    'devisFactures.labelEnAttente': 'قيد الانتظار',
    'clients.tabPins': 'رموز PIN / كلمات المرور',
    'clients.pin': 'رمز PIN',
    'clients.error': 'خطأ',
    'clients.loadError': 'خطأ أثناء التحميل',
    'clients.saveError': 'خطأ أثناء الحفظ',
    'clients.sendError': 'خطأ في الإرسال',
    'clients.noIdLegacy': 'هذا العميل ليس له معرّف (قديم). عدّله لتحديثه.',
    'clients.ficheAccessDenied': 'تم رفض الوصول: المسؤول وحده يمكنه الاطلاع على بطاقة العميل.',
    'clients.pinGenerated': 'تم إنشاء رمز PIN {{pin}} للعميل {{nom}}',
    'clients.ficheClient': 'بطاقة العميل',
    'clients.optional': 'اختياري',
    'clients.genNewPin': 'إنشاء رمز PIN جديد',
    'clients.sendPinEmail': 'إرسال رمز PIN عبر البريد الإلكتروني',
    'clients.loyaltyLine': 'الولاء: {{level}} — {{points}} نقطة — {{purchases}} عملية شراء',
    'clients.repairs': 'الإصلاحات',
    'clients.commandes': 'الطلبات',
    'clients.devis': 'عروض الأسعار',
    'clients.ventesPos': 'مبيعات نقطة البيع',
    'clients.acomptes': 'الدفعات المقدمة',
    'clients.noneFem': 'لا يوجد',
    'clients.noneMasc': 'لا يوجد',
    'cmd.clientPartsTitle': 'طلبات قطع العملاء',
    'cmd.pageIntro': 'أضف القطع (من المخزون أو للطلب) كما في الإصلاح. تُخصم الدفعات المقدمة من الإجمالي.',
    'cmd.deposits': 'الدفعات المقدمة',
    'cmd.remainingShort': 'المتبقي',
    'cmd.statusConverting': 'قيد التحويل',
    'cmd.repairBadge': 'إصلاح {{ref}}',
    'cmd.toOrderShort': 'للطلب',
    'cmd.stockOutShort': 'خرج من المخزون',
    'cmd.inStockShort': 'في المخزون',
    'cmd.view': 'عرض',
    'cmd.addDeposit': '+ دفعة',
    'cmd.settled': 'مسدّد',
    'cmd.convertToRepair': 'تحويل إلى إصلاح',
    'cmd.trackingWith': 'التتبّع: {{num}}',
    'cmd.trackingNumber': 'رقم التتبّع',
    'cmd.newClientParts': 'طلب قطع جديد',
    'cmd.partsSectionTitle': 'القطع (كما في الإصلاح)',
    'cmd.searchStockPlaceholder': 'ابحث عن قطعة في المخزون…',
    'cmd.noRef': 'بدون مرجع',
    'cmd.toOrder': 'للطلب',
    'cmd.stock': 'مخزون',
    'cmd.qtyShort': 'الكمية',
    'cmd.unitPriceLabel': 'سعر الوحدة (€)',
    'cmd.stockSection': 'المخزون',
    'cmd.alreadyOut': 'تم إخراجها من المخزون',
    'cmd.decrementOnSave': 'يُخصم عند الحفظ',
    'cmd.stillInStock': 'ما زالت في المخزون',
    'cmd.outOnConvert': 'تُخرَج عند التحويل إلى إصلاح',
    'cmd.addPendingBtn': 'قطعة للطلب (خارج المخزون)',
    'cmd.pendingTitle': 'قطعة للطلب',
    'cmd.designationPlaceholder': 'التسمية *',
    'cmd.refOptPlaceholder': 'المرجع (اختياري)',
    'cmd.salePricePlaceholder': 'سعر البيع €',
    'cmd.partsTotal': 'إجمالي القطع',
    'cmd.depositsPaid': 'الدفعات المقدمة المدفوعة',
    'cmd.addDepositTitle': 'إضافة دفعة مقدمة',
    'cmd.orderLabel': 'طلب',
    'cmd.alreadyPaid': 'المدفوع',
    'cmd.depositAmount': 'مبلغ الدفعة المقدمة (€)',
    'cmd.paymentMode': 'طريقة الدفع',
    'cmd.payCash': 'نقداً',
    'cmd.payCard': 'بطاقة',
    'cmd.payTransfer': 'تحويل',
    'cmd.payCheck': 'شيك',
    'cmd.newRemainingAfter': 'المتبقي الجديد بعد الدفعة:',
    'cmd.depositsPaidTitle': 'الدفعات المقدمة المدفوعة',
    'cmd.noDeposits': 'لا توجد دفعات مقدمة',
    'cmd.trackingPlaceholder': 'مثال: 8R123456789FR',
    'cmd.trackingEmailNote': 'سيُرسَل بريد إلكتروني إلى العميل إذا كان هناك بريد مُسجَّل.',
    'cmd.error': 'خطأ',
    'cmd.errDesignationRequired': 'التسمية مطلوبة للقطعة المراد طلبها',
    'cmd.errClientPhoneRequired': 'العميل والهاتف مطلوبان',
    'cmd.errAddPart': 'أضف قطعة واحدة على الأقل (البحث في المخزون أو قطعة للطلب)',
    'cmd.errDelete': 'خطأ أثناء الحذف',
    'cmd.cancelConfirm': 'إلغاء هذا الطلب؟',
    'cmd.errInvalidAmount': 'مبلغ غير صالح',
    'cmd.errDepositExceeds': 'لا يمكن أن تتجاوز الدفعة المقدمة المبلغ المتبقي ({{reste}})',
    'cmd.errPrintTicket': 'خطأ في طباعة الإيصال',
    'cmd.errPrintDepositTicket': 'خطأ في طباعة إيصال الدفعة المقدمة',
    'cmd.convertConfirm': 'تحويل هذا الطلب إلى إصلاح؟',
    'cmd.errConvert': 'خطأ في التحويل إلى إصلاح',
    'cmd.promptClientEmail': 'البريد الإلكتروني للعميل:',
    'cmd.emailSent': 'تم إرسال سند الطلب إلى {{email}}',
    'cmd.errSendEmail': 'خطأ في إرسال البريد الإلكتروني',
    'cmd.errTracking': 'خطأ في التتبّع',
    'pos.insufficientStock': 'المخزون غير كافٍ',
    'pos.partialPaymentConfirm': 'المبلغ المدفوع ({{paid}}) أقل من الإجمالي ({{total}}).\n\nالمبلغ المتبقّي: {{remaining}}\n\nهل تريد التأكيد كدفعة جزئية؟',
    'pos.loyaltyRewardEarned': '\n\nالولاء: تهانينا! تم فتح المكافأة! خصم 15% على الشراء القادم أو 10% على الإصلاح القادم!',
    'pos.loyaltyRewardPending': '\n\nالولاء: مكافأة قيد الانتظار (خصم 15% على الشراء القادم من الكاشير أو 10% على إصلاح)',
    'pos.loyaltyProgress': '\n\nالولاء: {{points}}/10 مشتريات. تبقّى {{remaining}} عملية شراء قبل المكافأة!',
    'pos.partialPaymentLine': '\nدفعة جزئية - المبلغ المتبقّي: {{remaining}}',
    'pos.invoiceSentAuto': '\nتم إرسال الفاتورة تلقائيًا إلى {{email}}',
    'pos.offlineSaleMsg': '\n\nوضع عدم الاتصال - تم حفظ البيع محليًا.\nستتم المزامنة تلقائيًا بمجرد عودة الإنترنت.\n(سيتم إرسال البريد الإلكتروني وتحديث المخزون في ذلك الوقت.)',
    'pos.refLabel': 'المرجع: {{ref}}',
    'pos.totalLabel': 'الإجمالي: {{total}}',
    'pos.saleError': 'حدث خطأ أثناء البيع.\nرمز HTTP: {{code}}\nقد لا يكون البيع قد حُفظ. تحقّق من السجلّ.',
    'pos.unknownStatus': 'غير معروف',
    'pos.invalidEmailEnter': 'يُرجى إدخال عنوان بريد إلكتروني صالح',
    'pos.accountCreated': 'تم إنشاء حساب العميل! تم إرسال بيانات الدخول عبر البريد الإلكتروني.',
    'pos.accountCreateError': 'حدث خطأ أثناء إنشاء الحساب',
    'pos.invalidAmount': 'مبلغ غير صالح',
    'pos.acompteDesignation': 'دفعة مقدّمة للإصلاح {{ref}}',
    'pos.designationPriceRequired': 'الوصف والسعر مطلوبان',
    'pos.manualAddError': 'خطأ في الإضافة اليدوية',
    'pos.adminValidationFailed': 'فشل التحقّق من المسؤول',
    'pos.printTicketError': 'خطأ في طباعة الإيصال',
    'pos.notAllTicketsPrintedConfirm': '⚠️ لم تطبع كل الإيصالات.\n\nيجب أن يحصل العميل على كل إيصال. هل تريد الإغلاق على أي حال؟',
    'pos.invalidEmail': 'عنوان بريد إلكتروني غير صالح',
    'pos.invoiceSentTo': 'تم إرسال الفاتورة إلى {{email}}',
    'pos.sendEmailError': 'خطأ في إرسال البريد الإلكتروني',
    'pos.caisseClosedOffline': 'الصندوق مغلق. اتصل بالإنترنت وافتح الصندوق من لوحة التحكّم لإجراء عمليات البيع.',
    'pos.caisseCachedHint': 'تم استرجاع حالة الصندوق من الذاكرة المحلية (وضع عدم الاتصال). سيتم التحقّق النهائي عند عودة الإنترنت.',
    'pos.catalog': 'الكتالوج',
    'pos.available': '{{count}} متوفّر',
    'pos.outOfStockShort': 'نفد',
    'pos.acompteRepair': 'دفعة مقدّمة للإصلاح',
    'pos.rewardAvailable': 'المكافأة متاحة!',
    'pos.rewardAutoApplied': '-15% مطبّق تلقائيًا',
    'pos.purchases': 'مشتريات',
    'pos.beforeReward': '({{count}} قبل المكافأة)',
    'pos.searchClientPlaceholder': 'بحث...',
    'pos.clientName': 'اسم العميل',
    'pos.phone': 'الهاتف',
    'pos.emailOptional': 'البريد الإلكتروني (اختياري)',
    'pos.totalCaps': 'الإجمالي',
    'pos.willGenerateTickets': 'سيُنشئ هذا البيع {{count}} إيصالات منفصلة:',
    'pos.neutralItems': 'محايدة',
    'pos.attachedToSession': '(مرتبطة بالجلسة)',
    'pos.clientEmailPlaceholder': 'البريد الإلكتروني للعميل',
    'pos.sent': 'تم الإرسال',
    'pos.send': 'إرسال',
    'pos.alsoAddToStock': 'أضِف أيضًا إلى المخزون',
    'pos.offlineCbHint': 'وضع عدم الاتصال — الدفع بالبطاقة معطّل (الجهاز يحتاج إلى الشبكة).',
    'pos.whichMagasinTitle': 'في أي متجر يُسجَّل البيع؟',
    'pos.close': 'إغلاق',
    'pos.magasinChoiceHelp': 'اختر المتجر الذي سيُسجَّل فيه هذا البيع. سيُستخدم المتجر المحدَّد للبيع وللأصناف التي ليس لها متجر محدَّد.',
    'pos.magasinLabel': 'المتجر {{code}}',
    'pos.currentPosSessionFull': 'جلسة نقطة البيع الحالية: {{code}}. إذا اخترت متجرًا آخر، ستنتقل جلسة نقطة البيع إليه لهذا البيع.',
    'pos.validateFor': 'تأكيد لـ {{magasin}}',
    'pos.createClientAccount': 'إنشاء حساب عميل؟',
    'pos.createAccountPrompt': 'هذا العميل ليس لديه حساب بعد. هل تريد إنشاء حساب له للوصول إلى فواتيره عبر الإنترنت؟',
    'pos.creating': 'جارٍ الإنشاء...',
    'pos.yesSendCredentials': 'نعم، أرسل بيانات الدخول',
    'pos.noThanks': 'لا، شكرًا',
    'pos.searchRepair': 'ابحث عن الإصلاح',
    'pos.searchRepairPlaceholder': 'REP0047، اسم العميل، الطراز...',
    'pos.priceLabel': 'السعر: {{price}}',
    'pos.alreadyPaid': 'المدفوع سابقًا: {{amount}}',
    'pos.remainingDue': 'المتبقّي المستحقّ: {{amount}}',
    'pos.changeSelection': 'تغيير',
    'pos.totalPrice': 'السعر الإجمالي',
    'pos.alreadyPaidShort': 'المدفوع سابقًا',
    'pos.remainingDueShort': 'المتبقّي المستحقّ',
    'pos.acompteAmountLabel': 'مبلغ الدفعة المقدّمة (يورو)',
    'pos.addToCart': 'أضِف إلى السلة',
    'pos.saleRecordedTickets': 'تم تسجيل البيع — تم إنشاء {{count}} إيصالات',
    'pos.printAllForClient': 'اطبع الإيصالات الـ {{count}} للعميل.',
    'pos.printed': 'تمت الطباعة',
    'pos.scanToFind': 'امسح للعثور على {{ref}}',
    'pos.detailUnavailable': 'التفاصيل غير متاحة (وضع عدم الاتصال؟)',
    'pos.payment': 'الدفع',
    'pos.printing': 'جارٍ الطباعة...',
    'pos.printTicketFor': 'طباعة إيصال {{magasin}}',
    'pos.allTicketsSentToPrint': 'تم إرسال جميع الإيصالات إلى الطباعة.',
    'pos.ticketsPrintedCount': 'تمت طباعة {{printed}} / {{total}} إيصال.',
    'pos.printAllTickets': 'طباعة جميع الإيصالات',
    'pos.articlesCount': '{{count}} صنف',
    'activite.pageTitle': 'مركز النشاط',
    'activite.pageSubtitle': 'مخطط زمني موحّد · المبيعات · المدفوعات · الصندوق · المخزون · الإصلاحات',
    'activite.historiqueDetaille': 'السجل المفصّل',
    'remcaches.err_connexion': 'خطأ في الاتصال بالخادم',
    'remcaches.err_champs_requis': 'اسم المستخدم ورمز PIN إلزاميان',
    'remcaches.err_pin_court': 'يجب أن يحتوي رمز PIN على 4 أرقام على الأقل',
    'remcaches.err_creation': 'خطأ أثناء الإنشاء',
    'remcaches.config_initiale': 'الإعداد الأولي',
    'remcaches.deja_config': 'تم الإعداد بالفعل',
    'remcaches.admin_existe': 'يوجد مسؤول بالفعل. هذه الصفحة معطّلة.',
    'remcaches.aller_connexion': 'الذهاب إلى تسجيل الدخول',
    'remcaches.admin_cree': 'تم إنشاء المسؤول بنجاح!',
    'remcaches.label_utilisateur': 'المستخدم:',
    'remcaches.label_role': 'الدور:',
    'remcaches.conserver_identifiants': 'احتفظ بهذه البيانات في مكان آمن. لن تكون هذه الصفحة متاحة بعد الآن.',
    'remcaches.se_connecter': 'تسجيل الدخول',
    'remcaches.label_username': 'اسم المستخدم *',
    'remcaches.ph_username': 'مثال: carlos',
    'remcaches.label_pin': 'رمز PIN (كلمة المرور) *',
    'remcaches.ph_pin': 'من 4 إلى 6 أرقام',
    'remcaches.label_email': 'البريد الإلكتروني (اختياري)',
    'remcaches.label_telephone': 'الهاتف (اختياري)',
    'remcaches.btn_creer_admin': 'إنشاء المسؤول',
    'remcaches.footer': 'R.E.Mobiles - إعداد آمن',
    'blog.page_title': 'مدوّنة إصلاح الهواتف',
    'blog.subtitle': 'نصائح وحيل وأخبار حول إصلاح الهواتف الذكية في غويانا الفرنسية.',
    'blog.cta_title': 'هل تحتاج إلى إصلاح؟',
    'blog.cta_desc': 'تواصل مع Resurrection Mobile للحصول على عرض سعر مجاني.',
    'blog.loading': 'جارٍ التحميل...',
    'blog.article_not_found': 'المقال غير موجود',
    'blog.back_to_blog': 'العودة إلى المدوّنة',
    'blog.home': 'الرئيسية',
    'blog.see_pricing': 'اطّلع على أسعارنا',
    'blog.footer_pricing': 'أسعارنا',
    'blog.empty_title': 'لا توجد مقالات حتى الآن',
    'blog.empty_subtitle': 'عُد قريبًا لاكتشاف نصائحنا!',
    'brandsModels.error': 'خطأ',
    'brandsModels.deleteBrandConfirm': 'حذف العلامة التجارية «{{name}}» وجميع طُرزها؟',
    'brandsModels.noModels': 'لا توجد طُرز.',
    'brandsModels.home': 'الرئيسية',
    'brandsModels.title': 'العلامات التجارية والطُرز',
    'brandsModels.countBrands': '{{count}} علامة تجارية',
    'brandsModels.countSeries': '{{count}} سلسلة',
    'brandsModels.countModels': '{{count}} طراز',
    'brandsModels.searchPlaceholder': 'ابحث عن علامة تجارية أو سلسلة أو طراز...',
    'brandsModels.newBrandPlaceholder': 'علامة تجارية جديدة...',
    'brandsModels.addBrand': 'إضافة',
    'brandsModels.loading': 'جارٍ التحميل...',
    'brandsModels.rename': 'إعادة تسمية',
    'brandsModels.delete': 'حذف',
    'brandsModels.addModelPlaceholder': 'إضافة طراز {{brand}}...',
    'brandsModels.addModel': 'طراز',
    'brandsModels.deleteModel': 'حذف هذا الطراز',
    'brandsModels.noResults': 'لا توجد نتائج لهذا البحث',
    'brandsModels.empty': 'لا توجد علامات تجارية. أضف واحدة في الأعلى.',
    'allDocs.title': 'جميع المستندات',
    'allDocs.docsCount': '{{count}} مستند',
    'allDocs.stat.devis': 'عروض الأسعار',
    'allDocs.stat.factures': 'الفواتير',
    'allDocs.stat.bonsCmd': 'أوامر الشراء',
    'allDocs.stat.tickets': 'التذاكر',
    'allDocs.stat.total': 'الإجمالي',
    'allDocs.searchPlaceholder': 'البحث بالمرجع أو العميل أو الهاتف...',
    'allDocs.filter': 'تصفية',
    'allDocs.filterAll': 'الكل',
    'allDocs.type.devis': 'عرض سعر',
    'allDocs.type.facture': 'فاتورة',
    'allDocs.type.bonCommande': 'أمر شراء',
    'allDocs.type.ticket': 'تذكرة',
    'allDocs.col.reference': 'المرجع',
    'allDocs.col.type': 'النوع',
    'allDocs.col.client': 'العميل',
    'allDocs.col.telephone': 'الهاتف',
    'allDocs.col.total': 'الإجمالي',
    'allDocs.col.statut': 'الحالة',
    'allDocs.col.liaisons': 'الروابط',
    'allDocs.col.date': 'التاريخ',
    'allDocs.col.actions': 'الإجراءات',
    'allDocs.loading': 'جارٍ التحميل...',
    'allDocs.empty': 'لم يتم العثور على أي مستند',
    'allDocs.status.devis': 'عرض سعر',
    'allDocs.status.enAttente': 'قيد الانتظار',
    'allDocs.status.accepte': 'مقبول',
    'allDocs.status.refuse': 'مرفوض',
    'allDocs.status.payee': 'مدفوعة',
    'allDocs.status.commande': 'تم الطلب',
    'allDocs.status.enCours': 'قيد التنفيذ',
    'allDocs.status.recu': 'مُستلم',
    'allDocs.status.livre': 'تم التسليم',
    'allDocs.status.termine': 'مكتمل',
    'allDocs.action.print': 'طباعة / عرض PDF',
    'allDocs.action.download': 'تنزيل PDF',
    'allDocs.action.email': 'إرسال بالبريد الإلكتروني',
    'allDocs.footerCount': '{{count}} مستند معروض',
    'allDocs.footerCountPlural': '{{count}} مستندات معروضة',
    'allDocs.printUnavailable': 'طباعة تذكرة 80 مم غير متاحة لهذا المستند (source={{source}}).',
    'allDocs.downloadUnavailable': 'التنزيل غير متاح لهذا النوع من المستندات (source={{source}}).',
    'allDocs.emailUnavailable': 'الإرسال بالبريد الإلكتروني غير متاح لهذا النوع من المستندات (source={{source}}).',
    'allDocs.emailPrompt': 'البريد الإلكتروني للمستلم:',
    'allDocs.emailSent': 'تم إرسال البريد الإلكتروني!',
    'allDocs.error': 'خطأ: {{msg}}',
    'themeSettings.title': 'تخصيص الألوان',
    'themeSettings.subtitle': 'خصّص مظهر منصّتك',
    'themeSettings.cancel': 'إلغاء',
    'themeSettings.saved': 'تم الحفظ',
    'themeSettings.saving': 'جارٍ الحفظ...',
    'themeSettings.save': 'حفظ',
    'themeSettings.presetsTitle': 'لوحات ألوان جاهزة',
    'themeSettings.customTitle': 'ألوان مخصّصة',
    'themeSettings.previewTitle': 'معاينة مباشرة',
    'themeSettings.previewCompany': 'شركتي',
    'themeSettings.previewPrimaryBtn': 'الزر الرئيسي',
    'themeSettings.previewSecondaryBtn': 'الزر الثانوي',
    'themeSettings.previewNavDashboard': 'لوحة التحكم',
    'themeSettings.previewNavRepairs': 'الإصلاحات',
    'themeSettings.previewNavStock': 'المخزون',
    'themeSettings.previewNavClients': 'العملاء',
    'themeSettings.previewStatusInProgress': 'قيد التنفيذ',
    'themeSettings.previewStatusPending': 'قيد الانتظار',
    'themeSettings.fieldPrimaryLabel': 'اللون الأساسي',
    'themeSettings.fieldPrimaryDesc': 'الأزرار والروابط والعناصر المميّزة الرئيسية',
    'themeSettings.fieldSecondaryLabel': 'اللون الثانوي',
    'themeSettings.fieldSecondaryDesc': 'الشارات والمؤشّرات والعناصر المميّزة الثانوية',
    'themeSettings.fieldAccentLabel': 'لون التمييز',
    'themeSettings.fieldAccentDesc': 'خلفية الترويسات ونصّ متباين',
    'themeSettings.fieldSidebarBgLabel': 'خلفية الشريط الجانبي',
    'themeSettings.fieldSidebarBgDesc': 'خلفية القائمة الجانبية',
    'themeSettings.fieldSidebarTextLabel': 'نصّ الشريط الجانبي',
    'themeSettings.fieldSidebarTextDesc': 'لون النصّ في القائمة',
    'themeSettings.fieldHeaderBgLabel': 'خلفية الترويسة',
    'themeSettings.fieldHeaderBgDesc': 'خلفية الشريط العلوي',
    'themeSettings.presetRougeJaune': 'أحمر وأصفر',
    'themeSettings.presetGuyane': 'غويانا',
    'themeSettings.presetOceanBleu': 'محيط أزرق',
    'themeSettings.presetRoyalViolet': 'بنفسجي ملكي',
    'themeSettings.presetEmeraude': 'زمرّد',
    'themeSettings.presetSunset': 'غروب الشمس',
    'boutiqueCmd.pageTitle': 'طلبات المتجر الإلكتروني',
    'boutiqueCmd.deleteSelection': 'حذف المحدد ({{count}})',
    'boutiqueCmd.confirmDelete': 'حذف {{count}} طلب؟',
    'boutiqueCmd.errUpdate': 'خطأ أثناء التحديث',
    'boutiqueCmd.errDelete': 'خطأ أثناء الحذف',
    'boutiqueCmd.noteSent': '✅ تم إرسال الملاحظة إلى العميل بنجاح',
    'boutiqueCmd.errSendNote': 'خطأ أثناء إرسال الملاحظة',
    'boutiqueCmd.trackingSavedEmail': '✅ تم حفظ رقم التتبع وإرسال بريد إلكتروني إلى العميل!',
    'boutiqueCmd.trackingSaved': '✅ تم حفظ رقم التتبع!',
    'boutiqueCmd.errSaveTracking': 'خطأ أثناء الحفظ',
    'boutiqueCmd.confirmValidateProof': 'اعتماد إثبات الدفع هذا؟',
    'boutiqueCmd.confirmRejectProof': 'رفض إثبات الدفع هذا؟',
    'boutiqueCmd.errGeneric': 'خطأ',
    'boutiqueCmd.errDownload': 'خطأ أثناء التنزيل',
    'boutiqueCmd.statutEnAttente': 'قيد الانتظار',
    'boutiqueCmd.statutProofUploaded': 'تم إرسال الإثبات',
    'boutiqueCmd.statutPayee': 'مدفوع',
    'boutiqueCmd.statutConfirmee': 'مؤكد',
    'boutiqueCmd.statutPreparee': 'تم التجهيز',
    'boutiqueCmd.statutExpediee': 'تم الشحن',
    'boutiqueCmd.statutLivree': 'تم التسليم',
    'boutiqueCmd.statutAnnulee': 'ملغى',
    'boutiqueCmd.colReference': 'المرجع',
    'boutiqueCmd.colClient': 'العميل',
    'boutiqueCmd.colArticles': 'المنتجات',
    'boutiqueCmd.colTotal': 'الإجمالي',
    'boutiqueCmd.colAdresse': 'العنوان',
    'boutiqueCmd.colStatut': 'الحالة',
    'boutiqueCmd.colSuivi': 'التتبع',
    'boutiqueCmd.colPaiement': 'الدفع',
    'boutiqueCmd.colDate': 'التاريخ',
    'boutiqueCmd.colActions': 'الإجراءات',
    'boutiqueCmd.noOrders': 'لا توجد طلبات',
    'boutiqueCmd.editTracking': 'تعديل',
    'boutiqueCmd.addTrackingTitle': 'إضافة رقم تتبع',
    'boutiqueCmd.addTrackingBtn': '+ تتبع',
    'boutiqueCmd.viewProof': 'عرض الإثبات',
    'boutiqueCmd.validatePayment': 'اعتماد الدفع',
    'boutiqueCmd.rejectProof': 'رفض الإثبات',
    'boutiqueCmd.validated': 'مُعتمد',
    'boutiqueCmd.notesMessages': 'ملاحظات/رسائل',
    'boutiqueCmd.notesModalTitle': 'ملاحظات ورسائل - الطلب {{ref}}',
    'boutiqueCmd.clientLabel': 'العميل:',
    'boutiqueCmd.phoneLabel': 'الهاتف:',
    'boutiqueCmd.deliveryAddressLabel': 'عنوان التسليم:',
    'boutiqueCmd.notSpecified': 'غير محدد',
    'boutiqueCmd.exchangeHistory': 'سجل المراسلات',
    'boutiqueCmd.noNote': 'لا توجد ملاحظات لهذا الطلب',
    'boutiqueCmd.staff': '👤 الموظف',
    'boutiqueCmd.client': '👥 العميل',
    'boutiqueCmd.clientResponse': 'رد العميل:',
    'boutiqueCmd.sendMessageTitle': '✉️ إرسال رسالة إلى العميل',
    'boutiqueCmd.notePlaceholder': 'مثال: مرحبًا، هل يمكنك تأكيد عنوان التسليم؟ شكرًا.',
    'boutiqueCmd.noteHint': '💡 سيستلم العميل هذه الرسالة ويمكنه الرد عليها من حسابه',
    'boutiqueCmd.close': 'إغلاق',
    'boutiqueCmd.sending': 'جارٍ الإرسال...',
    'boutiqueCmd.sendToClient': 'إرسال إلى العميل',
    'boutiqueCmd.trackingNumber': 'رقم التتبع',
    'boutiqueCmd.orderShortLabel': 'الطلب:',
    'boutiqueCmd.clientShortLabel': 'العميل:',
    'boutiqueCmd.trackingPlaceholder': 'مثال: LA123456789FR',
    'boutiqueCmd.trackingHint': 'سيرى العميل هذا الرقم في حسابه',
    'boutiqueCmd.cancel': 'إلغاء',
    'boutiqueCmd.saving': 'جارٍ الحفظ...',
    'boutiqueCmd.save': 'حفظ',
    'blogAdmin.confirmDelete': 'حذف هذا المقال؟',
    'blogAdmin.pageTitle': 'المدوّنة ومقالات السيو',
    'blogAdmin.pageSubtitle': 'انشر المقالات وأدر محتوى المدوّنة',
    'blogAdmin.viewBlog': 'عرض المدوّنة',
    'blogAdmin.newArticle': 'مقال جديد',
    'blogAdmin.tabArticles': 'المقالات',
    'blogAdmin.tabContent': 'محتوى الصفحة',
    'blogAdmin.editArticle': 'تعديل المقال',
    'blogAdmin.fieldTitle': 'العنوان *',
    'blogAdmin.titlePlaceholder': 'مثال: إصلاح شاشة iPhone في كايين: الأسعار والمهل',
    'blogAdmin.fieldExcerpt': 'مقتطف (معاينة)',
    'blogAdmin.excerptPlaceholder': 'وصف قصير للقائمة...',
    'blogAdmin.fieldContent': 'المحتوى * (يدعم Markdown)',
    'blogAdmin.contentPlaceholder': 'اكتب مقالك هنا...',
    'blogAdmin.fieldTags': 'الوسوم (مفصولة بفاصلة)',
    'blogAdmin.tagsPlaceholder': 'تصليح, iphone, cayenne',
    'blogAdmin.fieldMeta': 'وصف ميتا للسيو',
    'blogAdmin.metaPlaceholder': 'وصف لجوجل (160 حرفًا كحد أقصى)',
    'blogAdmin.publishNow': 'النشر فورًا',
    'blogAdmin.update': 'تحديث',
    'blogAdmin.save': 'حفظ',
    'blogAdmin.loading': 'جارٍ التحميل...',
    'blogAdmin.noArticles': 'لا توجد مقالات',
    'blogAdmin.noArticlesHint': 'أنشئ مقالك الأول لتحسين السيو',
    'blogAdmin.statusPublished': 'منشور',
    'blogAdmin.statusDraft': 'مسودة',
    'blogAdmin.byAuthor': 'بواسطة {{author}}',
    'blogAdmin.unpublish': 'إلغاء النشر',
    'blogAdmin.publish': 'نشر',
    'blogAdmin.loadingContent': 'جارٍ تحميل المحتوى...',
    'blogAdmin.contentNotice1': 'عدّل هنا المحتوى المعروض على الصفحة العامة ',
    'blogAdmin.contentNotice2': '. ستظهر التعديلات فورًا.',
    'blogAdmin.blogHeader': 'ترويسة المدوّنة',
    'blogAdmin.mainTitle': 'العنوان الرئيسي',
    'blogAdmin.accentWord': 'الكلمة الملوّنة (تمييز)',
    'blogAdmin.description': 'الوصف',
    'blogAdmin.ctaSection': 'دعوة إلى إجراء (CTA في المقالات)',
    'blogAdmin.ctaTitle': 'عنوان CTA',
    'blogAdmin.ctaDescription': 'وصف CTA',
    'blogAdmin.footerSection': 'تذييل الصفحة',
    'blogAdmin.footerText': 'نص التذييل',
    'blogAdmin.hidePreview': 'إخفاء المعاينة',
    'blogAdmin.livePreview': 'معاينة مباشرة',
    'blogAdmin.savedSuccess': 'تم الحفظ بنجاح!',
    'blogAdmin.saving': 'جارٍ الحفظ...',
    'blogAdmin.saveContent': 'حفظ المحتوى',
    'blogAdmin.previewLabel': 'معاينة صفحة المدوّنة',
    'businessCard.title': 'بطاقات العمل',
    'businessCard.subtitle': 'القوالب والتحرير والطباعة بحجم A4 (10 بطاقات)',
    'businessCard.previewBtn': 'معاينة',
    'businessCard.edit': 'تعديل',
    'businessCard.printA4': 'طباعة A4 (10 بطاقات)',
    'businessCard.chooseTemplate': 'اختر قالبًا ({{count}} متاح)',
    'businessCard.tplName.classic': 'كلاسيكي',
    'businessCard.tplName.modern': 'عصري',
    'businessCard.tplName.gradient': 'متدرّج',
    'businessCard.tplName.minimal': 'بسيط',
    'businessCard.tplName.gold': 'ذهبي فاخر',
    'businessCard.tplName.ocean': 'محيط',
    'businessCard.tplName.forest': 'غابة',
    'businessCard.tplName.sunset': 'غروب الشمس',
    'businessCard.tplName.corporate': 'مؤسسي',
    'businessCard.tplName.pastel': 'وردي باستيل',
    'businessCard.tplDesc.classic': 'أنيق واحترافي',
    'businessCard.tplDesc.modern': 'أنيق بلمسة سماوية',
    'businessCard.tplDesc.gradient': 'خلفية متدرّجة نابضة بالحياة',
    'businessCard.tplDesc.minimal': 'أبيض وواضح',
    'businessCard.tplDesc.gold': 'أسود وذهبي فاخر',
    'businessCard.tplDesc.ocean': 'أزرق عميق مريح',
    'businessCard.tplDesc.forest': 'أخضر طبيعي أنيق',
    'businessCard.tplDesc.sunset': 'برتقالي دافئ',
    'businessCard.tplDesc.corporate': 'أزرق كحلي احترافي',
    'businessCard.tplDesc.pastel': 'ناعم وأنثوي',
    'businessCard.logoTransparent': 'شعار بخلفية شفافة',
    'businessCard.cardInfo': 'معلومات البطاقة',
    'businessCard.field.companyName': 'اسم الشركة',
    'businessCard.field.subtitle': 'العنوان الفرعي / النشاط',
    'businessCard.field.ownerName': 'اسم المسؤول',
    'businessCard.field.ownerTitle': 'اللقب / الوظيفة',
    'businessCard.field.phone': 'الهاتف',
    'businessCard.field.email': 'البريد الإلكتروني',
    'businessCard.field.address': 'العنوان',
    'businessCard.field.city': 'المدينة / الرمز البريدي',
    'businessCard.field.website': 'الموقع الإلكتروني',
    'businessCard.field.siret': 'SIRET',
    'businessCard.reset': 'إعادة التعيين',
    'businessCard.previewTitle': 'معاينة — {{name}}',
    'businessCard.viewFront': 'عرض الوجه الأمامي',
    'businessCard.viewBack': 'عرض الوجه الخلفي',
    'businessCard.standardFormat': 'الحجم القياسي: 85 × 55 مم',
    'businessCard.allTemplates': 'كل القوالب',
    'businessCard.printTitle': 'بطاقات العمل',
    'businessCard.recto': 'الوجه الأمامي',
    'businessCard.verso': 'الوجه الخلفي',
    'hub.title': 'المركز',
    'hub.refresh': 'تحديث',
    'hub.kpiTicketsOpen': '{{n}} تذاكر مفتوحة',
    'hub.kpiFacturesToday': '{{n}} فواتير اليوم ({{total}})',
    'hub.kpiDevisOpen': '{{n}} عروض أسعار مفتوحة',
    'hub.magasinDefaultName': 'المتجر 1',
    'hub.magasinBadgeTitle': 'المتجر الحالي (نقطة البيع) — {{name}}',
    'hub.counterViewDetailed': 'عرض تفصيلي',
    'hub.counterViewCompact': 'عرض مختصر',
    'hub.counterMagasinTitle': '{{name}} — {{tickets}} تذاكر · {{devis}} عروض أسعار · {{total}}',
    'hub.counterCompact': '{{tickets}}ت·{{devis}}ع·{{total}}',
    'hub.counterTickets': 'تذاكر',
    'hub.counterDevis': 'عروض أسعار',
    'hub.counterPerDay': '€/يوم',
    'hub.searchPlaceholder': 'ابحث عن مرجع (REM0143، POS-...، DEV-00002) أو عميل أو هاتف…',
    'hub.filterAll': 'الكل',
    'hub.filterToday': 'اليوم',
    'hub.filterOverdue': 'متأخر',
    'hub.filterPaid': 'مدفوع',
    'hub.filterUnpaid': 'غير مدفوع',
    'hub.columnReparations': 'إصلاحات',
    'hub.columnFactures': 'فواتير',
    'hub.columnDevis': 'عروض الأسعار',
    'hub.seeAll': 'عرض الكل',
    'hub.empty': 'لا توجد عناصر',
    'hub.actionView': 'عرض',
    'hub.actionPrint': 'طباعة',
    'hub.actionMail': 'إرسال عبر البريد الإلكتروني',
    'hub.actionMarkReady': 'تحديد كجاهز',
    'hub.walkinClient': 'عميل عابر',
    'hub.invoicedAs': '→ تمت الفوترة: {{ref}}',
    'hub.errorPrint': 'خطأ أثناء الطباعة',
    'hub.errorPopupBlocked': 'يرجى السماح بالنوافذ المنبثقة للطباعة.',
    'hub.statusWaiting': 'قيد الانتظار',
    'hub.statusInProgress': 'قيد التنفيذ',
    'hub.statusReady': 'جاهز',
    'hub.statusDelivered': 'تم التسليم',
    'hub.statusPaid': 'مدفوعة',
    'hub.statusInvoiced': 'تمت الفوترة',
    'hub.statusSent': 'تم الإرسال',
    'hub.statusAccepted': 'مقبول',
    'hub.statusCancelled': 'ملغى',
    'hub.statusDone': 'منتهى',
    'subscription.title': 'اشتراكي',
    'subscription.subtitle': 'أدِر خطتك وفوترتك',
    'subscription.currentPlan': 'الخطة الحالية',
    'subscription.status': 'الحالة',
    'subscription.statusActive': 'نشط',
    'subscription.statusTrial': 'تجربة مجانية',
    'subscription.monthlyPrice': 'السعر الشهري',
    'subscription.perMonth': '‏/شهر',
    'subscription.nextBilling': 'الدفعة القادمة',
    'subscription.changePlan': 'تغيير الخطة',
    'subscription.redirecting': 'جارٍ التحويل...',
    'subscription.upgrade': 'الترقية',
    'subscription.downgrade': 'التخفيض',
    'subscription.upgradeTitle': 'ترقية الخطة',
    'subscription.downgradeTitle': 'تخفيض الخطة',
    'subscription.newPlan': 'الخطة الجديدة',
    'subscription.newMonthlyPrice': 'السعر الشهري الجديد',
    'subscription.upgradeDiffNow': 'الفرق المستحق الآن',
    'subscription.changeFee': 'رسوم التغيير',
    'subscription.downgradeFeeNotice': 'تُطبَّق رسوم ثابتة قدرها {{amount}} على أي تخفيض للخطة.',
    'subscription.cancel': 'إلغاء',
    'subscription.confirmWithAmount': 'تأكيد ({{amount}})',
    'subscription.toastChanged': 'تم تغيير خطتك بنجاح!',
    'subscription.toastCancelled': 'تم إلغاء تغيير الخطة.',
    'subscription.errorPreview': 'حدث خطأ أثناء المعاينة',
    'subscription.errorChange': 'حدث خطأ أثناء تغيير الخطة',
    'subscription.featStartRepairs': 'إدارة الإصلاحات',
    'subscription.featStartClients': 'متابعة العملاء',
    'subscription.featStartQuotesInvoices': 'عروض الأسعار والفواتير',
    'subscription.featStartOnePos': 'نقطة بيع واحدة',
    'subscription.featProAllStart': 'كل ما في خطة Start',
    'subscription.featProMultiUsers': 'متعدد المستخدمين',
    'subscription.featProAdvancedStats': 'إحصاءات متقدمة',
    'subscription.featProThreePos': '3 نقاط بيع',
    'subscription.featProPrioritySupport': 'دعم ذو أولوية',
    'subscription.featSuperAllPro': 'كل ما في خطة Pro',
    'subscription.featSuperUnlimitedPos': 'نقاط بيع غير محدودة',
    'subscription.featSuperCustomApi': 'واجهة برمجة مخصّصة',
    'subscription.featSuperDedicatedSupport': 'دعم مخصّص على مدار الساعة طوال أيام الأسبوع',
    'subscription.featSuperWhiteLabel': 'علامة بيضاء',
    'terms.title': 'الشروط العامة للاستخدام',
    'terms.edition': 'يونيو 2026',
    'terms.introBefore': 'تحكم هذه الشروط استخدام موقع',
    'terms.introMiddle': '، ومساحة العميل، ودردشة الدعم، وخدمات الإصلاح التي تقدمها',
    'terms.introAfter': '، SASU، كايين، غويانا الفرنسية.',
    'terms.acceptIntro': 'بإنشاء حساب أو بالتواصل معنا (الموقع، الدردشة، واتساب)، فإنك توافق على هذه الشروط وعلى',
    'terms.privacyPolicy': 'سياسة الخصوصية',
    'terms.servicesTitle': 'الخدمات',
    'terms.servicesBody': 'إصلاح الهواتف وبيعها، ومتابعة خدمة ما بعد البيع، وإعداد عروض الأسعار، والدفع عبر الإنترنت عند تفعيله، والدعم عبر الدردشة أو WhatsApp Business.',
    'terms.pricingTitle': 'الأسعار',
    'terms.pricingBody': 'عروض الأسعار والأسعار المُبلَّغة (في المتجر، الدردشة، واتساب) إرشادية حتى تأكيدها في نقطة البيع.',
    'terms.dataTitle': 'البيانات الشخصية',
    'terms.dataBefore': 'تُعالَج بياناتك وفقًا للائحة العامة لحماية البيانات (GDPR). طلب الحذف:',
    'terms.dataAfter': 'أو راجع قسم «حقوقك» في سياسة الخصوصية.',
    'terms.contactTitle': 'التواصل',
    'notifSettings.title': 'إشعارات فورية',
    'notifSettings.intro': 'تلقَّ تنبيهًا أصليًا (Windows / macOS / Android) بمجرد وقوع حدث مهم في المتجر. مخصّص لموظفي R.E.Mobiles.',
    'notifSettings.statusUnsupported': 'غير مدعوم (يتطلّب iOS 16.4+)',
    'notifSettings.statusBlocked': 'محظورة (تم رفض الإذن)',
    'notifSettings.statusEnabled': 'مُفعَّلة على هذا المتصفح',
    'notifSettings.statusDisabled': 'غير مُفعَّلة',
    'notifSettings.activeCount': '{{count}} اشتراك نشط',
    'notifSettings.enableBtn': 'تفعيل الإشعارات',
    'notifSettings.testBtn': 'إرسال إشعار تجريبي',
    'notifSettings.disableBtn': 'إيقاف',
    'notifSettings.iosHintPre': 'على iPhone، تتطلّب إشعارات الويب الفورية',
    'notifSettings.iosHintPost': 'وتثبيت التطبيق على الشاشة الرئيسية (PWA). حدِّث جهاز iPhone ثم أعِد تثبيت التطبيق.',
    'notifSettings.blockedHint': 'تم رفض الإذن. افتح إعدادات الموقع في المتصفح، واسمح بالإشعارات لهذا النطاق ثم أعِد تحميل الصفحة.',
    'notifSettings.categoriesTitle': 'الفئات',
    'notifSettings.categoriesHint': 'أوقِف ما لا تريد تلقّيه. يُطبَّق فورًا، لهذا الحساب.',
    'notifSettings.catNewTicketLabel': 'تذكرة إصلاح جديدة',
    'notifSettings.catNewTicketDesc': 'تم إنشاء إيداع في المتجر.',
    'notifSettings.catTicketReadyLabel': 'تم تحويل التذكرة إلى «جاهز»',
    'notifSettings.catTicketReadyDesc': 'يضع الفنّي الإصلاح كجاهز. لا تنسَ إبلاغ العميل.',
    'notifSettings.catNewInvoiceLabel': 'فاتورة POS جديدة',
    'notifSettings.catNewInvoiceDesc': 'تم تحصيل عملية بيع للتو.',
    'notifSettings.catNewChatLabel': 'رسالة جديدة في الدردشة',
    'notifSettings.catNewChatDesc': 'رسالة مباشرة من الفريق أو العميل أو B2B.',
    'notifSettings.catDevisLabel': 'عرض سعر تم إنشاؤه أو قبوله',
    'notifSettings.catDevisDesc': 'يتم إنشاء عرض سعر جديد أو ينقر عميل على «قبول».',
    'notifSettings.accountLabel': 'الحساب',
    'notifSettings.roleLabel': 'الدور',
    'notifSettings.totalSubsLabel': 'إجمالي الاشتراكات',
    'notifSettings.errPermDenied': 'تم رفض الإذن. فعِّل الإشعارات في إعدادات المتصفح.',
    'notifSettings.errPermNotGranted': 'لم يُمنح الإذن.',
    'notifSettings.errVapidUnavailable': 'مفتاح VAPID غير متوفّر على الخادم.',
    'notifSettings.infoEnabled': 'تم تفعيل الإشعارات على هذا المتصفح.',
    'notifSettings.errEnableFailed': 'فشل التفعيل.',
    'notifSettings.infoDisabled': 'تم إيقاف الإشعارات على هذا المتصفح.',
    'notifSettings.errDisableFailed': 'فشل الإيقاف.',
    'notifSettings.errPrefsUpdate': 'فشل تحديث التفضيلات.',
    'notifSettings.infoTestSent': 'تم إرسال إشعار تجريبي ({{sent}}/{{subs}}). تحقّق من مركز الإشعارات في نظام تشغيلك.',
    'notifSettings.errNoneSent': 'لم يُرسَل أي إشعار. تحقّق من أن الإشعارات مُفعَّلة على هذا المتصفح.',
    'notifSettings.errTestFailed': 'فشل الاختبار.',
    'guyarepairLogin.subscriberSpace': 'مساحة المشترك',
    'guyarepairLogin.businessLoginTitle': 'تسجيل دخول الشركة',
    'guyarepairLogin.businessLoginSubtitle': 'سجّل الدخول إلى لوحة تحكم GUYAREPAIR الخاصة بك',
    'guyarepairLogin.emailLabel': 'البريد الإلكتروني',
    'guyarepairLogin.emailPlaceholder': 'you@email.com',
    'guyarepairLogin.passwordLabel': 'كلمة المرور',
    'guyarepairLogin.passwordPlaceholder': 'كلمة المرور الخاصة بك',
    'guyarepairLogin.loggingIn': 'جارٍ تسجيل الدخول...',
    'guyarepairLogin.loginButton': 'تسجيل الدخول',
    'guyarepairLogin.twoFATitle': 'التحقق بخطوتين (2FA)',
    'guyarepairLogin.twoFASubtitle': 'أدخل الرمز من تطبيق المصادقة الخاص بك',
    'guyarepairLogin.otpLabel': 'رمز مكوّن من 6 أرقام',
    'guyarepairLogin.verifying': 'جارٍ التحقق...',
    'guyarepairLogin.verifyButton': 'تحقّق',
    'guyarepairLogin.backToLogin': 'العودة إلى تسجيل الدخول',
    'guyarepairLogin.notSubscribedYet': 'لست مشتركًا بعد؟',
    'guyarepairLogin.freeTrial': 'تجربة مجانية',
    'guyarepairLogin.secureConnection': 'اتصال آمن',
    'guyarepairLogin.guyarepairHome': 'الصفحة الرئيسية GUYAREPAIR',
    'guyarepairLogin.errInvalidCredentials': 'بيانات الاعتماد غير صحيحة',
    'guyarepairLogin.err2FAInvalid': 'رمز التحقق بخطوتين غير صالح',
    'analytics.period_today': 'اليوم',
    'analytics.period_7d': '7 أيام',
    'analytics.period_30d': '30 يومًا',
    'analytics.period_90d': '90 يومًا',
    'analytics.period_365d': 'سنة واحدة',
    'analytics.alert_suspicious_found': 'تم رصد {{count}} عنوان IP مشبوه!',
    'analytics.alert_no_suspicious': 'لم يتم رصد أي عنوان IP مشبوه.',
    'analytics.page_title': 'التحليلات — الزيارات',
    'analytics.page_subtitle': 'تتبع الزيارات عبر جميع مواقعك',
    'analytics.refresh': 'تحديث',
    'analytics.tab_dashboard': 'لوحة التحكم',
    'analytics.tab_visits': 'الزيارات',
    'analytics.tab_blocked': 'عناوين IP المحظورة',
    'analytics.tab_alerts': 'تنبيهات IP',
    'analytics.all_sites': 'جميع المواقع',
    'analytics.kpi_total_visits': 'إجمالي الزيارات',
    'analytics.kpi_unique_visitors': 'زوار فريدون',
    'analytics.kpi_active_sites': 'مواقع نشطة',
    'analytics.kpi_countries': 'البلدان',
    'analytics.visits_per_day': 'الزيارات حسب اليوم',
    'analytics.by_site': 'حسب الموقع',
    'analytics.by_country': 'حسب البلد',
    'analytics.top_pages': 'الصفحات الأكثر زيارة',
    'analytics.visits_per_hour': 'الزيارات حسب الساعة',
    'analytics.empty_no_visits': 'لا توجد زيارات مسجلة لهذه الفترة',
    'analytics.empty_install_script': 'يجب تثبيت سكربت التتبع على مواقعك',
    'analytics.search_placeholder': 'البحث حسب IP أو الصفحة أو البلد...',
    'analytics.col_date': 'التاريخ',
    'analytics.col_site': 'الموقع',
    'analytics.col_page': 'الصفحة',
    'analytics.col_country_city': 'البلد / المدينة',
    'analytics.col_screen': 'الشاشة',
    'analytics.col_action': 'إجراء',
    'analytics.no_visits': 'لا توجد زيارات',
    'analytics.blocked_inline': '(محظور)',
    'analytics.unblock': 'إلغاء الحظر',
    'analytics.block': 'حظر',
    'analytics.visits_count': '{{count}} زيارة',
    'analytics.blocked_ips_title': 'عناوين IP المحظورة',
    'analytics.active_count': '{{count}} نشط',
    'analytics.col_status': 'الحالة',
    'analytics.col_reason': 'السبب',
    'analytics.col_blocked_by': 'حُظر بواسطة',
    'analytics.no_blocked_ips': 'لا توجد عناوين IP محظورة',
    'analytics.status_blocked': 'محظور',
    'analytics.status_inactive': 'غير نشط',
    'analytics.reblock': 'إعادة الحظر',
    'analytics.alert_config_title': 'إعدادات التنبيهات',
    'analytics.checking': 'جارٍ الفحص...',
    'analytics.check_now': 'افحص الآن',
    'analytics.saving': 'جارٍ الحفظ...',
    'analytics.save': 'حفظ',
    'analytics.alerts_enabled': 'التنبيهات مفعّلة',
    'analytics.alerts_enabled_desc': 'يراقب عناوين IP المشبوهة كل 15 دقيقة',
    'analytics.threshold_label': 'الحد (زيارات/ساعة)',
    'analytics.alert_email_label': 'البريد الإلكتروني للتنبيه',
    'analytics.autoblock': 'الحظر التلقائي',
    'analytics.autoblock_desc': 'حظر عناوين IP التي تتجاوز الحد تلقائيًا',
    'analytics.alert_history_title': 'سجل التنبيهات',
    'analytics.alerts_count': '{{count}} تنبيه',
    'analytics.no_alerts': 'لم يتم تشغيل أي تنبيه',
    'analytics.col_visits_per_hour': 'زيارات/ساعة',
    'analytics.col_sites': 'المواقع',
    'analytics.col_autoblocked': 'محظور تلقائيًا',
    'analytics.col_email': 'البريد الإلكتروني',
    'analytics.yes': 'نعم',
    'analytics.no': 'لا',
    'analytics.sent': 'تم الإرسال',
    'analytics.confirm_block_title': 'حظر عنوان IP هذا؟',
    'analytics.confirm_block_ip_prefix': 'سيتم حظر عنوان IP ',
    'analytics.confirm_block_ip_suffix': ' على جميع المواقع',
    'analytics.block_reason_placeholder': 'سبب الحظر (اختياري)...',
    'analytics.cancel': 'إلغاء',
    'analytics.blocking': 'جارٍ الحظر...',
    'analytics.confirm_block': 'تأكيد الحظر',
    'guyarepairLanding.navTarifs': 'الأسعار',
    'guyarepairLanding.navAnnuaire': 'الدليل',
    'guyarepairLanding.navMaReparation': 'إصلاحي',
    'guyarepairLanding.navConnexion': 'تسجيل الدخول',
    'guyarepairLanding.navEssaiGratuit': 'تجربة مجانية',
    'guyarepairLanding.heroBadge': 'منصة SaaS لإدارة الإصلاحات',
    'guyarepairLanding.heroTitleLine1': 'أدِر ورشة',
    'guyarepairLanding.heroTitleLine2': 'الإصلاح',
    'guyarepairLanding.heroTitleHighlight': 'بكل بساطة',
    'guyarepairLanding.heroSubtitle': '‏GUYAREPAIR هو الحل الشامل لورش الإصلاح. نقطة بيع، وتتبّع الإصلاحات، وإدارة المخزون، والفوترة، وولاء العملاء — كل ذلك في منصة واحدة.',
    'guyarepairLanding.heroCtaStart': 'ابدأ مجاناً',
    'guyarepairLanding.heroCtaPricing': 'عرض الأسعار',
    'guyarepairLanding.repairLookupTitle': 'البحث عن إصلاحي',
    'guyarepairLanding.repairLookupSubtitle': 'أدخل مرجع الإصلاح لمتابعة حالته',
    'guyarepairLanding.repairLookupPlaceholder': 'مثال: TFX0001, MBR0012...',
    'guyarepairLanding.rechercher': 'بحث',
    'guyarepairLanding.repairErrorDefault': 'حدث خطأ أثناء البحث',
    'guyarepairLanding.repairFoundAt': 'تم العثور على الإصلاح لدى',
    'guyarepairLanding.statutTermine': 'مكتمل',
    'guyarepairLanding.statutEnCours': 'قيد التنفيذ',
    'guyarepairLanding.statutEnAttente': 'قيد الانتظار',
    'guyarepairLanding.labelReference': 'المرجع',
    'guyarepairLanding.labelAppareil': 'الجهاز',
    'guyarepairLanding.labelProbleme': 'المشكلة',
    'guyarepairLanding.voirPageDe': 'عرض صفحة {{nom}}',
    'guyarepairLanding.directoryTitle': 'اعثر على فنّي الإصلاح',
    'guyarepairLanding.directorySubtitle': 'ابحث عن متجر إصلاح شريك لـ GUYAREPAIR',
    'guyarepairLanding.searchPlaceholder': 'اسم المتجر، المدينة...',
    'guyarepairLanding.resultats': '{{count}} نتيجة',
    'guyarepairLanding.featuresTitle': 'كل ما تحتاجه',
    'guyarepairLanding.featuresSubtitle': 'مجموعة متكاملة من الأدوات لورشتك',
    'guyarepairLanding.feature1Title': 'إدارة الإصلاحات',
    'guyarepairLanding.feature1Desc': 'تتبّع كامل لكل إصلاح، من التشخيص إلى التسليم',
    'guyarepairLanding.feature2Title': 'نقطة البيع (POS)',
    'guyarepairLanding.feature2Desc': 'تحصيل المدفوعات، وحساب الأسعار، وإدارة صندوق مدمجة',
    'guyarepairLanding.feature3Title': 'المخزون والجرد',
    'guyarepairLanding.feature3Desc': 'حركات المخزون، والتنبيهات، والموردون، والطلبات',
    'guyarepairLanding.feature4Title': 'العملاء والولاء',
    'guyarepairLanding.feature4Desc': 'قاعدة بيانات العملاء، وبرنامج ولاء مع مكافآت',
    'guyarepairLanding.feature5Title': 'عروض الأسعار والفواتير',
    'guyarepairLanding.feature5Desc': 'إنشاء سريع لعروض الأسعار، وتحويلها إلى فواتير، وإرسالها بالبريد الإلكتروني',
    'guyarepairLanding.feature6Title': 'متاجر متعددة',
    'guyarepairLanding.feature6Desc': 'أدِر عدة متاجر من لوحة تحكم واحدة',
    'guyarepairLanding.pricingTitle': 'أسعار بسيطة وشفافة',
    'guyarepairLanding.pricingSubtitle': 'اختر الخطة المناسبة لنشاطك',
    'guyarepairLanding.popular': 'الأكثر شيوعاً',
    'guyarepairLanding.perMonth': 'يورو/شهر',
    'guyarepairLanding.commencer': 'ابدأ',
    'guyarepairLanding.copyright': '© {{year}} REMCOMPANY. جميع الحقوق محفوظة.',
    'guyarepairLanding.trademarkNotice': '‏GUYAREPAIR هي العلامة التجارية للخدمة.',
    'guyarepairLanding.passwordTooShort': 'يجب أن تتكوّن كلمة المرور من 6 أحرف على الأقل',
    'guyarepairLanding.registerErrorDefault': 'حدث خطأ أثناء التسجيل',
    'guyarepairLanding.registerSuccessTitle': 'تم التسجيل بنجاح!',
    'guyarepairLanding.successAccountCreated': 'تم إنشاء حسابك مع',
    'guyarepairLanding.successTrial': 'تجربة مجانية لمدة 5 أيام',
    'guyarepairLanding.successLoginHint': 'سجّل الدخول لإعداد مساحتك. تم إرسال بريد إلكتروني ترحيبي.',
    'guyarepairLanding.seConnecter': 'تسجيل الدخول',
    'guyarepairLanding.createAccountTitle': 'أنشئ حسابك',
    'guyarepairLanding.planLine': 'خطة {{nom}} — {{prix}} يورو/شهر',
    'guyarepairLanding.planLabel': 'الخطة',
    'guyarepairLanding.companyNameLabel': 'اسم الشركة',
    'guyarepairLanding.contactNameLabel': 'اسم جهة الاتصال',
    'guyarepairLanding.phoneLabel': 'الهاتف',
    'guyarepairLanding.emailLabel': 'البريد الإلكتروني',
    'guyarepairLanding.passwordLabel': 'كلمة المرور',
    'guyarepairLanding.cityLabel': 'المدينة',
    'guyarepairLanding.addressLabel': 'العنوان',
    'guyarepairLanding.directoryToggle': 'الظهور في دليل GUYAREPAIR العام',
    'guyarepairLanding.creating': 'جارٍ الإنشاء...',
    'guyarepairLanding.createMyAccount': 'إنشاء حسابي',
    'guyarepairLanding.alreadyRegistered': 'مسجّل بالفعل؟',
    'alertsConfig.saved': 'تم حفظ إعدادات التنبيهات',
    'alertsConfig.error': 'خطأ',
    'alertsConfig.title': 'التنبيهات التلقائية',
    'alertsConfig.subtitle': 'اضبط التنبيهات التلقائية لشركتك. ستتلقى بريدًا إلكترونيًا يوميًا عند استيفاء الشروط.',
    'alertsConfig.emailAlertsLabel': 'التنبيهات عبر البريد الإلكتروني',
    'alertsConfig.emailAlertsDesc': 'تفعيل التنبيهات التلقائية عبر البريد الإلكتروني (إصلاحات قيد الانتظار، نفاد المخزون)',
    'alertsConfig.repairAlertsTitle': 'تنبيهات الإصلاحات قيد الانتظار',
    'alertsConfig.repairAlertsDesc': 'استلم بريدًا إلكترونيًا عندما يكون الإصلاح قيد الانتظار منذ أكثر من X يوم.',
    'alertsConfig.delayLabel': 'المهلة (أيام)',
    'alertsConfig.daysShort': '{{n}}ي',
    'alertsConfig.stockAlertsTitle': 'تنبيهات المخزون',
    'alertsConfig.stockAlertsDesc': 'استلم بريدًا إلكترونيًا عندما تنفد السلع من المخزون أو تنخفض دون حدٍّ معيّن.',
    'alertsConfig.lowStockThresholdLabel': 'حد انخفاض المخزون',
    'alertsConfig.clientNotifLabel': 'إشعارات العملاء',
    'alertsConfig.clientNotifDesc': 'إرسال بريد إلكتروني إلى العميل عند تغيّر حالة الإصلاح (مكتمل، قيد التنفيذ، إلخ.)',
    'alertsConfig.emailSenderInfo': 'سيُرسَل البريد الإلكتروني من عنوانك المُعَدّ، أو من GUYAREPAIR بشكل افتراضي.',
    'alertsConfig.saving': 'جارٍ الحفظ...',
    'alertsConfig.save': 'حفظ',
    'companyAnalytics.title': 'التحليلات',
    'companyAnalytics.subtitle': 'نظرة عامة على أداء شركتك',
    'companyAnalytics.loadError': 'حدث خطأ أثناء التحميل',
    'companyAnalytics.kpiRepairsToday': 'الإصلاحات اليوم',
    'companyAnalytics.kpiThisWeek': '{{count}} هذا الأسبوع',
    'companyAnalytics.kpiRevenueToday': 'الإيرادات اليوم',
    'companyAnalytics.kpiThisMonthAmount': '{{amount}} هذا الشهر',
    'companyAnalytics.kpiClients': 'العملاء',
    'companyAnalytics.kpiNewThisMonth': '{{count}} جديد هذا الشهر',
    'companyAnalytics.kpiAvgTime': 'متوسط الوقت',
    'companyAnalytics.daysShort': '{{count}} ي',
    'companyAnalytics.kpiPerRepair': 'لكل إصلاح',
    'companyAnalytics.statTotalRepairs': 'إجمالي الإصلاحات',
    'companyAnalytics.statActive': 'النشطة',
    'companyAnalytics.statCompleted': 'المكتملة',
    'companyAnalytics.statStockItems': 'أصناف المخزون',
    'companyAnalytics.statOutOfStock': 'نفاد المخزون',
    'companyAnalytics.repairsByStore': 'الإصلاحات الجارية حسب المتجر',
    'companyAnalytics.repairsM1Explicit': '{{count}} إصلاحات M1 صريحة',
    'companyAnalytics.repairsLegacy': '{{count}} إصلاحات قديمة (ما قبل M2)',
    'companyAnalytics.totalShown': 'الإجمالي المعروض: {{count}}',
    'companyAnalytics.repairsM2': '{{count}} إصلاحات M2',
    'companyAnalytics.repairsTrend14Days': 'الإصلاحات (آخر 14 يومًا)',
    'companyAnalytics.statusDistribution': 'توزيع الحالات',
    'companyAnalytics.noRepairs': 'لا توجد إصلاحات',
    'companyAnalytics.revenue': 'الإيرادات',
    'companyAnalytics.revToday': 'اليوم',
    'companyAnalytics.revThisWeek': 'هذا الأسبوع',
    'companyAnalytics.revThisMonth': 'هذا الشهر',
    'companyAnalytics.revTotal': 'الإجمالي',
    'companyAnalytics.statusPending': 'قيد الانتظار',
    'companyAnalytics.statusInProgress': 'قيد التنفيذ',
    'companyAnalytics.statusCompleted': 'مكتمل',
    'companyAnalytics.statusDelivered': 'تم التسليم',
    'companyAnalytics.statusCancelled': 'ملغى',
    'staffCommissions.title': 'عمولاتي',
    'staffCommissions.pdfDownloadError': 'حدث خطأ أثناء تنزيل ملف PDF',
    'staffCommissions.downloadMonthSheet': 'تنزيل كشف الشهر:',
    'staffCommissions.generating': 'جارٍ الإنشاء…',
    'staffCommissions.downloadPdf': 'تنزيل PDF',
    'staffCommissions.toReceive': 'مستحق القبض',
    'staffCommissions.alreadyReceived': 'تم استلامه',
    'staffCommissions.totalCumulative': 'الإجمالي التراكمي',
    'staffCommissions.detailByType': 'التفصيل حسب النوع',
    'staffCommissions.toPay': 'مستحق الدفع: {{amount}}',
    'staffCommissions.paidDetail': 'مدفوع: {{amount}}',
    'staffCommissions.noCommissionYet': 'لا توجد عمولات بعد',
    'staffCommissions.filterAll': 'الكل',
    'staffCommissions.filterPending': 'مستحق الدفع',
    'staffCommissions.filterPaid': 'المدفوعة',
    'staffCommissions.filterCancelled': 'الملغاة',
    'staffCommissions.colDate': 'التاريخ',
    'staffCommissions.colType': 'النوع',
    'staffCommissions.colTransaction': 'المعاملة',
    'staffCommissions.colAmountTtc': 'المبلغ شامل الضريبة',
    'staffCommissions.colCommission': 'العمولة',
    'staffCommissions.colStatus': 'الحالة',
    'staffCommissions.noCommission': 'لا توجد عمولات',
    'staffCommissions.month1': 'يناير',
    'staffCommissions.month2': 'فبراير',
    'staffCommissions.month3': 'مارس',
    'staffCommissions.month4': 'أبريل',
    'staffCommissions.month5': 'مايو',
    'staffCommissions.month6': 'يونيو',
    'staffCommissions.month7': 'يوليو',
    'staffCommissions.month8': 'أغسطس',
    'staffCommissions.month9': 'سبتمبر',
    'staffCommissions.month10': 'أكتوبر',
    'staffCommissions.month11': 'نوفمبر',
    'staffCommissions.month12': 'ديسمبر',
    'staffCommissions.typeVentes': 'بيع نقطة البيع',
    'staffCommissions.typeCommandes': 'طلب',
    'staffCommissions.typeAcomptes': 'دفعة مقدمة',
    'staffCommissions.typeReparations': 'إصلاح',
    'staffCommissions.typeFactures': 'فاتورة',
    'staffCommissions.typeDevis': 'عرض سعر',
    'staffCommissions.typeB2b': 'B2B',
    'staffCommissions.typeDeplacement': 'زيارة ميدانية',
    'labelConfig.title': 'إعداد الملصقات',
    'labelConfig.subtitle': 'اضبط الهوامش والأبعاد بما يناسب طابعتك',
    'labelConfig.reset': 'القيم الافتراضية',
    'labelConfig.save': 'حفظ',
    'labelConfig.saving': 'جارٍ الحفظ...',
    'labelConfig.saved': 'تم الحفظ',
    'labelConfig.save_error': 'خطأ في الحفظ: {{error}}',
    'labelConfig.global_dimensions': 'الأبعاد العامة',
    'labelConfig.label_width': 'عرض الملصق',
    'labelConfig.label_height': 'ارتفاع الملصق',
    'labelConfig.cols': 'الأعمدة',
    'labelConfig.rows': 'الصفوف',
    'labelConfig.margins_spacing': 'الهوامش والتباعد',
    'labelConfig.left_margin': 'الهامش الأيسر',
    'labelConfig.top_margin': 'الهامش العلوي',
    'labelConfig.h_spacing': 'تباعد أفقي',
    'labelConfig.v_spacing': 'تباعد عمودي',
    'labelConfig.col_offset_title': 'إزاحة لكل عمود',
    'labelConfig.cols_count': '({{count}} أعمدة)',
    'labelConfig.col_n': 'عمود {{n}}',
    'labelConfig.col_offset_hint': 'القيم الموجبة = إزاحة نحو اليمين. السالبة = نحو اليسار.',
    'labelConfig.row_offset_title': 'إزاحة لكل صف',
    'labelConfig.rows_count': '({{count}} صفوف)',
    'labelConfig.row_n': 'صف {{n}}',
    'labelConfig.row_offset_hint': 'القيم الموجبة = إزاحة نحو الأعلى. السالبة = نحو الأسفل.',
    'labelConfig.preview_title': 'معاينة ورقة A4',
    'labelConfig.preview_count': '{{cols}} × {{rows}} = {{total}} ملصق/ورقة',
    'labelConfig.preview_dims': '{{width}} × {{height}} مم',
    'paymentConfig.title': 'إعدادات المدفوعات',
    'paymentConfig.statusActiveTitle': 'المدفوعات عبر الإنترنت مفعّلة',
    'paymentConfig.providerLabel': 'المزوّد: {{name}}',
    'paymentConfig.statusInactiveTitle': 'المدفوعات عبر الإنترنت معطّلة',
    'paymentConfig.statusInactiveDesc': 'قم بإعداد مزوّد لقبول المدفوعات عبر الإنترنت. لا تتوفّر سوى المدفوعات دون اتصال (نقدًا، بطاقة في المتجر).',
    'paymentConfig.chooseProvider': 'اختر مزوّد الدفع الخاص بك:',
    'paymentConfig.apiKeysTitle': 'مفاتيح API لـ {{name}}',
    'paymentConfig.savedPlaceholder': 'محفوظة: {{value}}',
    'paymentConfig.save': 'حفظ',
    'paymentConfig.testConnection': 'اختبار الاتصال',
    'paymentConfig.infoTitle': 'معلومات مهمة',
    'paymentConfig.info1': 'تُحوَّل المدفوعات عبر الإنترنت مباشرةً إلى حساب التاجر الخاص بك.',
    'paymentConfig.info2': 'يتم تشفير مفاتيح API الخاصة بك وتخزينها بأمان.',
    'paymentConfig.info3': 'بدون إعداد صالح، لا تتوفّر سوى المدفوعات دون اتصال.',
    'paymentConfig.info4': 'تدير كل شركة مفاتيحها الخاصة بشكل مستقل.',
    'paymentConfig.saveError': 'خطأ في الحفظ',
    'paymentConfig.testError': 'خطأ في الاختبار',
    'paymentConfig.disableConfirm': 'تعطيل المدفوعات عبر الإنترنت؟',
    'paymentConfig.stripeDesc': 'مدفوعات بالبطاقة البنكية، Apple Pay، Google Pay',
    'paymentConfig.sumupDesc': 'جهاز دفع POS V2 + مدفوعات عبر الإنترنت (merchant_code, client_id/secret)',
    'paymentConfig.fieldPublicKey': 'المفتاح العام (pk_...)',
    'paymentConfig.fieldSecretKey': 'المفتاح السري (sk_...)',
    'paymentConfig.fieldWebhookSecret': 'سرّ الـ webhook ‏(whsec_...)',
    'paymentConfig.fieldApiKey': 'مفتاح API',
    'paymentConfig.fieldMerchantCode': 'رمز التاجر',
    'paymentConfig.fieldClientId': 'معرّف العميل (Client ID)',
    'paymentConfig.fieldClientSecret': 'سرّ العميل (Client Secret)',
    'loyaltyAdmin.title': 'برنامج الولاء',
    'loyaltyAdmin.subtitle': 'متابعة نقاط ومكافآت العملاء',
    'loyaltyAdmin.refresh': 'تحديث',
    'loyaltyAdmin.kpiMembers': 'الأعضاء',
    'loyaltyAdmin.kpiPendingRewards': 'مكافآت قيد الانتظار',
    'loyaltyAdmin.kpiRedeemed': 'مكافآت مستخدمة',
    'loyaltyAdmin.kpiThreshold': 'حد المكافأة',
    'loyaltyAdmin.purchasesSuffix': 'عمليات شراء',
    'loyaltyAdmin.rewardRule': '-{{pos}}% POS / -{{repair}}% إصلاح',
    'loyaltyAdmin.topClients': 'أكثر العملاء ولاءً',
    'loyaltyAdmin.clientFallback': 'عميل',
    'loyaltyAdmin.flashOffers': 'عروض فلاش',
    'loyaltyAdmin.newOffer': 'عرض جديد',
    'loyaltyAdmin.createFlashOffer': 'إنشاء عرض فلاش',
    'loyaltyAdmin.offerTitlePlaceholder': 'عنوان العرض (مثال: Weekend Special)',
    'loyaltyAdmin.offerDescPlaceholder': 'الوصف (مثال: إصلاح الشاشة بسعر مخفّض)',
    'loyaltyAdmin.discountLabel': 'الخصم (%)',
    'loyaltyAdmin.endDateLabel': 'تاريخ الانتهاء',
    'loyaltyAdmin.targetLevelsLabel': 'المستويات المستهدفة',
    'loyaltyAdmin.creating': 'جارٍ الإنشاء...',
    'loyaltyAdmin.createOffer': 'إنشاء العرض',
    'loyaltyAdmin.noOffers': 'لم يتم إنشاء أي عرض فلاش',
    'loyaltyAdmin.offerMeta': 'المستهدفون: {{levels}} | إيميلات: {{emails}}',
    'loyaltyAdmin.offerEnd': ' | الانتهاء: {{date}}',
    'loyaltyAdmin.deactivate': 'إلغاء التفعيل',
    'loyaltyAdmin.activate': 'تفعيل',
    'loyaltyAdmin.sendByEmail': 'إرسال بالبريد الإلكتروني',
    'loyaltyAdmin.delete': 'حذف',
    'loyaltyAdmin.allMembers': 'كل الأعضاء ({{count}})',
    'loyaltyAdmin.searchPlaceholder': 'بحث...',
    'loyaltyAdmin.colClient': 'العميل',
    'loyaltyAdmin.colPhone': 'الهاتف',
    'loyaltyAdmin.colPurchases': 'المشتريات',
    'loyaltyAdmin.colPoints': 'النقاط',
    'loyaltyAdmin.colTotalSpent': 'إجمالي الإنفاق',
    'loyaltyAdmin.colStatus': 'الحالة',
    'loyaltyAdmin.colRewards': 'المكافآت',
    'loyaltyAdmin.noMembers': 'لا يوجد أعضاء',
    'loyaltyAdmin.rewardAvailable': 'مكافأة متاحة',
    'loyaltyAdmin.purchasesRemaining': 'بقي {{count}} عمليات شراء',
    'loyaltyAdmin.pageOf': 'صفحة {{page}} / {{total}}',
    'loyaltyAdmin.confirmDeleteOffer': 'حذف هذا العرض؟',
    'loyaltyAdmin.emailsSent': 'تم إرسال الرسائل',
    'loyaltyAdmin.levelBronze': 'برونزي',
    'loyaltyAdmin.levelArgent': 'فضي',
    'loyaltyAdmin.levelOr': 'ذهبي',
    'emailConfig.pageTitle': 'إعدادات البريد الإلكتروني',
    'emailConfig.pageSubtitle': 'اضبط خادم SMTP لإرسال الفواتير وعروض الأسعار والإشعارات عبر البريد الإلكتروني.',
    'emailConfig.smtpSection': 'خادم SMTP',
    'emailConfig.fieldHost': 'مضيف SMTP',
    'emailConfig.fieldPort': 'المنفذ',
    'emailConfig.fieldUser': 'مستخدم SMTP (البريد الإلكتروني)',
    'emailConfig.fieldPassword': 'كلمة مرور البريد الإلكتروني',
    'emailConfig.passwordPlaceholderExisting': '•••••••• (اتركه فارغًا للإبقاء عليه)',
    'emailConfig.passwordPlaceholderNew': 'كلمة مرور بريد Hostinger',
    'emailConfig.useSsl': 'استخدام SSL/TLS (يُنصح به مع المنفذ 465)',
    'emailConfig.enableEmails': 'تفعيل إرسال البريد الإلكتروني',
    'emailConfig.tipTitle': 'نصيحة Hostinger:',
    'emailConfig.tipBody': 'كلمة مرور البريد الإلكتروني تختلف عن كلمة مرور hPanel. يمكنك التحقق منها أو إعادة تعيينها من hPanel ← البريد الإلكتروني ← حسابات البريد ← إدارة.',
    'emailConfig.senderSection': 'المُرسِل',
    'emailConfig.fieldSenderName': 'اسم المُرسِل',
    'emailConfig.fieldSenderEmail': 'بريد المُرسِل الإلكتروني',
    'emailConfig.saving': 'جارٍ الحفظ…',
    'emailConfig.save': 'حفظ',
    'emailConfig.testing': 'جارٍ الإرسال…',
    'emailConfig.testConnection': 'اختبار الاتصال',
    'emailConfig.disable': 'تعطيل',
    'emailConfig.loadError': 'خطأ في التحميل (HTTP {{status}})',
    'emailConfig.saveSuccess': 'تم حفظ الإعدادات. يمكنك الآن النقر على «اختبار الاتصال».',
    'emailConfig.saveErrorFallback': 'خطأ في الحفظ',
    'emailConfig.testSuccess': 'تم إرسال بريد اختبار. تحقق من صندوق الوارد.',
    'emailConfig.testErrorFallback': 'فشل اختبار SMTP. تحقق من كلمة مرور بريد Hostinger (تختلف عن كلمة مرور hPanel).',
    'emailConfig.disableConfirm': 'تعطيل الإعدادات المخصّصة؟ سيعود الخادم إلى إعدادات .env الافتراضية.',
    'emailConfig.disableSuccess': 'تم تعطيل الإعدادات المخصّصة.',
    'emailConfig.disableErrorFallback': 'خطأ أثناء التعطيل',
    'promosCalendar.title': 'تقويم العروض الترويجية',
    'promosCalendar.subtitle': 'العروض الترويجية المجدولة حسب اليوم',
    'promosCalendar.empty': 'لا توجد عروض ترويجية مجدولة لهذا الشهر.',
    'adminIntegrations.supplierCredentials': 'بيانات اعتماد الموردين (Mobilax · Jens · LCD-Phone)',
    'adminIntegrations.generateStockPhotos': 'إنشاء صور المخزون (ذكاء اصطناعي) — M1 / M2',
    'adminIntegrations.stockCategoryAudit': 'تدقيق فئات المخزون — هاتف / IMEI / ملحقات',
    'printerTokens.title': 'رموز وكيل الطابعة',
    'printerTokens.desc': 'إدارة الرموز التي يستخدمها وكيل ويندوز للمصادقة مع الخادم الخلفي. رمز واحد لكل جهاز (مُستحسَن) أو رمز مشترك للتركيبات الصغيرة.',
    'printerTokens.newBtn': 'رمز جديد',
    'printerTokens.includeRevoked': 'تضمين الرموز المُبطَلة',
    'printerTokens.refresh': 'تحديث',
    'printerTokens.loading': 'جارٍ التحميل…',
    'printerTokens.emptyPre': 'لا توجد رموز. انقر على',
    'printerTokens.emptyPost': 'لإنشاء واحد.',
    'printerTokens.colLabel': 'التسمية',
    'printerTokens.colType': 'النوع',
    'printerTokens.colPreview': 'معاينة',
    'printerTokens.colCreated': 'تاريخ الإنشاء',
    'printerTokens.colLastUsed': 'آخر استخدام',
    'printerTokens.colStatus': 'الحالة',
    'printerTokens.colActions': 'إجراءات',
    'printerTokens.typeShared': 'مشترك',
    'printerTokens.typePersonal': 'شخصي',
    'printerTokens.createdBy': 'بواسطة {{user}}',
    'printerTokens.statusRevoked': 'مُبطَل',
    'printerTokens.statusActive': 'نشط',
    'printerTokens.revoke': 'إبطال',
    'printerTokens.securityTitle': 'الأمان',
    'printerTokens.securityHashPre': 'تُخزَّن الرموز على شكل بصمة (SHA-256). الرمز الكامل',
    'printerTokens.securityHashEmph': 'لا يُعرض مطلقًا مرة أخرى',
    'printerTokens.securityHashPost': 'بعد إنشائه. في حال نسيانه، قم بإبطاله وأنشئ رمزًا جديدًا.',
    'printerTokens.securityAudit': 'يُسجَّل كل إنشاء وإبطال في سجل تدقيق المسؤول.',
    'printerTokens.createTitle': 'رمز وكيل جديد',
    'printerTokens.createLabelField': 'التسمية (مثال: حاسوب الكاشير، حاسوب كارلوس المحمول)',
    'printerTokens.createLabelPlaceholder': 'حاسوب الكاشير',
    'printerTokens.createSharedLabel': 'رمز مشترك (يمكن استخدامه على عدة أجهزة)',
    'printerTokens.createSharedHint': 'رمز مشترك واحد نشط في كل مرة. من أجل الأمان، يُفضَّل رمز واحد لكل جهاز.',
    'printerTokens.cancel': 'إلغاء',
    'printerTokens.create': 'إنشاء',
    'printerTokens.revealTitle': 'تم إنشاء الرمز — انسخه الآن',
    'printerTokens.revealLabelPrefix': 'التسمية:',
    'printerTokens.revealConfigPre': 'اضبط وكيل ويندوز بهذا الرمز في الترويسة',
    'printerTokens.revealConfigPost': '.',
    'printerTokens.copied': 'تم النسخ',
    'printerTokens.copy': 'نسخ',
    'printerTokens.revealClose': 'لقد حفظت الرمز',
    'printerTokens.revokeTitle': 'إبطال هذا الرمز؟',
    'printerTokens.revokeMsgPre': 'الرمز',
    'printerTokens.revokeMsgPost': 'لن يتمكن بعد الآن من مصادقة أي وكيل. تُحفَظ هذه العملية في السجل ولا تحذف الرمز (يمكنك عرضه بتحديد «تضمين الرموز المُبطَلة»).',
    'printerTokens.actionError': 'خطأ: {{detail}}',
    'servicePrices.pageTitle': 'أسعار الإصلاح',
    'servicePrices.pageSubtitle': 'أدِر الأسعار ومحتوى الصفحة العامة',
    'servicePrices.viewPublicPage': 'عرض الصفحة العامة',
    'servicePrices.add': 'إضافة',
    'servicePrices.tabPrices': 'الأسعار',
    'servicePrices.tabContent': 'محتوى الصفحة',
    'servicePrices.editPriceTitle': 'تعديل السعر',
    'servicePrices.newPriceTitle': 'سعر جديد',
    'servicePrices.brand': 'الماركة *',
    'servicePrices.choose': 'اختر...',
    'servicePrices.model': 'الطراز',
    'servicePrices.modelPlaceholder': 'مثال: iPhone 14 Pro',
    'servicePrices.repairType': 'نوع الإصلاح *',
    'servicePrices.delay': 'المدة',
    'servicePrices.delayPlaceholder': 'مثال: 30 دقيقة',
    'servicePrices.priceMin': 'السعر الأدنى (يورو)',
    'servicePrices.priceMax': 'السعر الأعلى (يورو)',
    'servicePrices.order': 'الترتيب',
    'servicePrices.visiblePublic': 'ظاهر للعموم',
    'servicePrices.btnUpdate': 'تعديل',
    'servicePrices.btnSave': 'حفظ',
    'servicePrices.loading': 'جارٍ التحميل...',
    'servicePrices.noPrices': 'لا توجد أسعار مسجّلة',
    'servicePrices.noPricesHint': 'أضف أسعارك الأولى لعرضها في الصفحة العامة',
    'servicePrices.colRepair': 'الإصلاح',
    'servicePrices.colPrice': 'السعر',
    'servicePrices.colVisible': 'ظاهر',
    'servicePrices.colActions': 'إجراءات',
    'servicePrices.allModels': 'كل الطُّرُز',
    'servicePrices.contentLoading': 'جارٍ تحميل المحتوى...',
    'servicePrices.contentBannerPre': 'عدّل هنا المحتوى المعروض في الصفحة العامة',
    'servicePrices.contentBannerPost': '. تظهر التعديلات فورًا بعد الحفظ.',
    'servicePrices.headerSection': 'ترويسة الصفحة',
    'servicePrices.mainTitle': 'العنوان الرئيسي',
    'servicePrices.accentWord': 'كلمة ملوّنة (تمييز)',
    'servicePrices.seoDescription': 'وصف SEO',
    'servicePrices.contactInfo': 'معلومات الاتصال',
    'servicePrices.phone': 'الهاتف',
    'servicePrices.phoneDisplay': 'الهاتف المعروض',
    'servicePrices.whatsappLabel': 'واتساب (مع رمز الدولة)',
    'servicePrices.address': 'العنوان',
    'servicePrices.hours': 'أوقات العمل',
    'servicePrices.trustBadges': 'شارات الثقة',
    'servicePrices.addShort': '+ إضافة',
    'servicePrices.titleField': 'العنوان',
    'servicePrices.description': 'الوصف',
    'servicePrices.faqTitle': 'الأسئلة الشائعة (FAQ)',
    'servicePrices.question': 'السؤال',
    'servicePrices.answer': 'الجواب',
    'servicePrices.ctaSection': 'قسم الحث على الإجراء (CTA)',
    'servicePrices.ctaTitle': 'عنوان CTA',
    'servicePrices.ctaDescription': 'وصف CTA',
    'servicePrices.footer': 'تذييل الصفحة',
    'servicePrices.line1': 'السطر 1',
    'servicePrices.line2': 'السطر 2',
    'servicePrices.hidePreview': 'إخفاء المعاينة',
    'servicePrices.livePreview': 'معاينة مباشرة',
    'servicePrices.savedSuccess': 'تم الحفظ بنجاح!',
    'servicePrices.saving': 'جارٍ الحفظ...',
    'servicePrices.saveContent': 'حفظ المحتوى',
    'servicePrices.previewLabel': 'معاينة الصفحة العامة',
    'servicePrices.faqShort': 'الأسئلة الشائعة',
    'servicePrices.confirmDelete': 'حذف هذا السعر؟',
    'servicePrices.repairTypes.ecran': 'الشاشة',
    'servicePrices.repairTypes.batterie': 'البطارية',
    'servicePrices.repairTypes.connecteurCharge': 'منفذ الشحن',
    'servicePrices.repairTypes.cameraArriere': 'الكاميرا الخلفية',
    'servicePrices.repairTypes.cameraAvant': 'الكاميرا الأمامية',
    'servicePrices.repairTypes.hautParleur': 'مكبر الصوت',
    'servicePrices.repairTypes.micro': 'الميكروفون',
    'servicePrices.repairTypes.boutonPower': 'زر التشغيل',
    'servicePrices.repairTypes.boutonVolume': 'زر الصوت',
    'servicePrices.repairTypes.vitreArriere': 'الزجاج الخلفي',
    'servicePrices.repairTypes.nappeFaceId': 'كابل Face ID',
    'servicePrices.repairTypes.carteMere': 'اللوحة الأم',
    'servicePrices.repairTypes.diagnostique': 'التشخيص',
    'servicePrices.repairTypes.desoxydation': 'إزالة الأكسدة',
    'servicePrices.repairTypes.autre': 'أخرى',
    'companySettings.toast.loadError': 'حدث خطأ أثناء تحميل الإعدادات',
    'companySettings.toast.saveSuccess': 'تم حفظ الإعدادات بنجاح',
    'companySettings.toast.saveError': 'حدث خطأ أثناء الحفظ',
    'companySettings.toast.notImage': 'يجب أن يكون الملف صورة',
    'companySettings.toast.tooLarge': 'يجب ألا يتجاوز حجم الملف 5 ميغابايت',
    'companySettings.toast.logoSuccess': 'تم تحديث الشعار بنجاح',
    'companySettings.toast.logoError': 'حدث خطأ أثناء رفع الشعار',
    'companySettings.toast.previewError': 'حدث خطأ أثناء إنشاء المعاينة',
    'companySettings.tabs.info': 'المعلومات',
    'companySettings.tabs.documents': 'المستندات (الفواتير، عروض الأسعار، أوامر الشراء)',
    'companySettings.tabs.payment': 'الدفع',
    'companySettings.tabs.logo': 'الشعار',
    'companySettings.tabs.preview': 'معاينة PDF',
    'companySettings.tabs.security': 'الأمان',
    'companySettings.title': 'إعدادات الشركة',
    'companySettings.subtitle': 'قم بإعداد معلومات شركتك ومستنداتك',
    'companySettings.save': 'حفظ',
    'companySettings.info.sectionTitle': 'معلومات الشركة',
    'companySettings.info.companyNameLabel': 'اسم الشركة',
    'companySettings.info.companyNamePlaceholder': 'مثال: شركتي ش.م.م',
    'companySettings.info.legalFormLabel': 'الشكل القانوني',
    'companySettings.info.legalFormPlaceholder': 'مثال: ش.م.م، ش.ذ.م.م، مؤسسة فردية...',
    'companySettings.info.capitalLabel': 'رأس المال',
    'companySettings.info.capitalPlaceholder': 'مثال: 1000 يورو',
    'companySettings.info.siretLabel': 'SIRET',
    'companySettings.info.siretPlaceholder': 'مثال: 123 456 789 00014',
    'companySettings.info.rcsLabel': 'RCS',
    'companySettings.info.rcsPlaceholder': 'مثال: Paris B 123 456 789',
    'companySettings.info.phoneLabel': 'الهاتف',
    'companySettings.info.phonePlaceholder': 'مثال: +594 694 XX XX XX',
    'companySettings.info.emailLabel': 'البريد الإلكتروني',
    'companySettings.info.emailPlaceholder': 'مثال: contact@monentreprise.com',
    'companySettings.info.postalLabel': 'الرمز البريدي',
    'companySettings.info.postalPlaceholder': 'مثال: 97300',
    'companySettings.info.addressLabel': 'العنوان',
    'companySettings.info.addressPlaceholder': 'مثال: 10 الشارع الرئيسي',
    'companySettings.info.cityLabel': 'المدينة',
    'companySettings.info.cityPlaceholder': 'مثال: كايين',
    'companySettings.info.tvaLabel': 'بيان ضريبة القيمة المضافة',
    'companySettings.info.tvaPlaceholder': 'بيان ضريبي يظهر على المستندات',
    'companySettings.documents.devisSectionTitle': 'إعدادات عروض الأسعار',
    'companySettings.documents.devisValidityLabel': 'مدة صلاحية عرض السعر',
    'companySettings.documents.devisValidityPlaceholder': 'مدة صلاحية عرض السعر',
    'companySettings.documents.devisConditionsLabel': 'الشروط العامة (عرض السعر)',
    'companySettings.documents.devisConditionsPlaceholder': 'الشروط العامة التي تظهر على عروض الأسعار',
    'companySettings.documents.bcSectionTitle': 'إعدادات أوامر الشراء',
    'companySettings.documents.bcConditionsLabel': 'شروط أمر الشراء',
    'companySettings.documents.bcConditionsPlaceholder': 'شروط تنفيذ الخدمات',
    'companySettings.documents.factureSectionTitle': 'إعدادات الفواتير',
    'companySettings.documents.facturePaymentLabel': 'شروط الدفع',
    'companySettings.documents.facturePaymentPlaceholder': 'مثال: الدفع عند الاستلام...',
    'companySettings.documents.facturePenaltiesLabel': 'غرامات التأخير',
    'companySettings.documents.facturePenaltiesPlaceholder': 'بند غرامات التأخير',
    'companySettings.documents.factureRecoveryLabel': 'تعويض التحصيل',
    'companySettings.documents.factureRecoveryPlaceholder': 'بند التعويض المقطوع',
    'companySettings.documents.factureReserveLabel': 'الاحتفاظ بحق الملكية',
    'companySettings.documents.factureReservePlaceholder': 'بند الاحتفاظ بحق الملكية',
    'companySettings.documents.warrantySectionTitle': 'الضمان',
    'companySettings.documents.warrantyLabel': 'بيان الضمان',
    'companySettings.documents.warrantyPlaceholder': 'مثال: ضمان 6 أشهر على القطع واليد العاملة اعتبارًا من تاريخ الإصلاح.',
    'companySettings.documents.warrantyHint': 'سيظهر هذا البيان أسفل الفواتير إذا تم إدخاله.',
    'companySettings.payment.sectionTitle': 'الدفع عبر الإنترنت',
    'companySettings.payment.disableTitle': 'تعطيل الدفع عبر الإنترنت',
    'companySettings.payment.disableDesc': 'عند التفعيل، تُخفى خيارات الدفع عبر الإنترنت (Stripe) على جميع عروض الأسعار. لن يتمكن العملاء إلا من طلب رابط دفع SumUp.',
    'companySettings.payment.statusDisabled': 'الدفع عبر الإنترنت مُعطَّل - لن يرى العملاء سوى نموذج طلب SumUp',
    'companySettings.payment.statusEnabled': 'الدفع عبر الإنترنت مُفعَّل - يمكن للعملاء الدفع مباشرة عبر الإنترنت',
    'companySettings.payment.howTitle': 'كيف يعمل؟',
    'companySettings.payment.step1': '1. يستلم العميل عرض السعر بالبريد الإلكتروني ويقبله',
    'companySettings.payment.step2': '2. بدلاً من الدفع عبر الإنترنت، يملأ نموذجًا ببريده الإلكتروني/هاتفه',
    'companySettings.payment.step3': '3. تستلم إشعارًا بطلب الدفع',
    'companySettings.payment.step4': '4. ترسل رابط دفع SumUp يدويًا إلى العميل',
    'companySettings.logo.sectionTitle': 'شعار الشركة',
    'companySettings.logo.description': 'سيظهر هذا الشعار على فواتيرك وعروض أسعارك وأوامر الشراء (صيغ PNG وJPG، بحد أقصى 5 ميغابايت).',
    'companySettings.logo.alt': 'الشعار',
    'companySettings.logo.none': 'لا يوجد شعار',
    'companySettings.logo.uploading': 'جارٍ الرفع...',
    'companySettings.logo.choose': 'اختيار شعار',
    'companySettings.logo.hint': 'سيتم تغيير حجم الشعار تلقائيًا على مستندات PDF.',
    'companySettings.preview.sectionTitle': 'معاينة مستنداتك',
    'companySettings.preview.description': 'اعرض نموذجًا لفاتورة أو عرض سعر بإعداداتك الحالية (الشعار، المعلومات، البيانات القانونية).',
    'companySettings.preview.saveReminder': 'تذكّر حفظ تغييراتك قبل إنشاء المعاينة.',
    'companySettings.preview.facture': 'فاتورة',
    'companySettings.preview.devis': 'عرض سعر',
    'companySettings.preview.generating': 'جارٍ الإنشاء...',
    'companySettings.preview.generate': 'إنشاء المعاينة',
    'companySettings.preview.iframeTitle': 'معاينة PDF',
    'companySettings.security.genericError': 'خطأ',
    'companySettings.security.invalidCode': 'رمز غير صالح',
    'companySettings.security.enabledToast': 'تم تفعيل المصادقة الثنائية بنجاح!',
    'companySettings.security.disabledToast': 'تم تعطيل المصادقة الثنائية',
    'companySettings.security.sectionTitle': 'أمان الحساب',
    'companySettings.security.twoFaTitle': 'المصادقة الثنائية (2FA)',
    'companySettings.security.statusActive': 'مُفعَّل',
    'companySettings.security.statusInactive': 'مُعطَّل',
    'companySettings.security.intro': 'احمِ حسابك بالتحقق بخطوتين. في كل تسجيل دخول، سيُطلب منك رمز مكوّن من 6 أرقام بالإضافة إلى كلمة المرور.',
    'companySettings.security.configureBtn': 'إعداد المصادقة الثنائية',
    'companySettings.security.step1ScanPrefix': '1. امسح رمز QR هذا باستخدام',
    'companySettings.security.step1ScanSuffix': ' :',
    'companySettings.security.qrAlt': 'رمز QR للمصادقة الثنائية',
    'companySettings.security.manualKeyLabel': 'أو أدخل هذا المفتاح يدويًا:',
    'companySettings.security.step2Enter': '2. أدخل الرمز الظاهر في التطبيق:',
    'companySettings.security.activate': 'تفعيل',
    'companySettings.security.protectedMsg': 'حسابك محمي بالمصادقة الثنائية',
    'companySettings.security.disablePrompt': 'للتعطيل، أدخل رمزك الحالي:',
    'companySettings.security.disable': 'تعطيل',
    'docTimezone.title': 'توقيت المستندات',
    'docTimezone.intro': 'اضبط المنطقة الزمنية المستخدمة للتواريخ والأوقات على مستنداتك (التذاكر، الفواتير، عروض الأسعار، أوامر الشراء).',
    'docTimezone.sectionTimezone': 'المنطقة الزمنية',
    'docTimezone.selectLabel': 'اختر منطقتك الزمنية',
    'docTimezone.currentLabel': 'المنطقة الحالية:',
    'docTimezone.selectHint': 'سيتم تطبيق هذه المنطقة الزمنية على جميع التواريخ المعروضة على مستنداتك. لن يتغير وقت تسجيل التذاكر أبدًا بعد حفظه.',
    'docTimezone.save': 'حفظ',
    'docTimezone.importantTitle': 'هام',
    'docTimezone.importantBody': 'افتراضيًا، تستخدم جميع المستندات المنطقة الزمنية لغويانا الفرنسية (كايين، UTC-3). إذا غيّرت هذا الإعداد، فستستخدم المستندات المستقبلية المنطقة الزمنية الجديدة. أما المستندات التي سبق إنشاؤها فستحتفظ بوقت تسجيلها الأصلي.',
    'docTimezone.toastUpdated': 'تم تحديث المنطقة الزمنية',
    'docTimezone.errUpdate': 'حدث خطأ أثناء التحديث',
    'docTimezone.errNetwork': 'خطأ في الشبكة',
    'docTimezone.tzCayenne': 'غويانا الفرنسية (كايين)',
    'docTimezone.tzMartinique': 'مارتينيك / غوادلوب',
    'docTimezone.tzGuadeloupe': 'غوادلوب',
    'docTimezone.tzParis': 'فرنسا القارية (باريس)',
    'docTimezone.tzReunion': 'لا ريونيون',
    'docTimezone.tzNoumea': 'كاليدونيا الجديدة',
    'docTimezone.tzTahiti': 'بولينيزيا الفرنسية (تاهيتي)',
    'flashOffers.confirmDelete': 'حذف هذا العرض؟',
    'flashOffers.emailsSentFallback': 'تم إرسال رسائل البريد الإلكتروني',
    'flashOffers.pageTitle': 'عروض فلاش وتخفيضات',
    'flashOffers.pageSubtitle': 'أدِر عروضك الترويجية المؤقتة وأرسِلها إلى العملاء الأوفياء',
    'flashOffers.newOffer': 'عرض جديد',
    'flashOffers.createTitle': 'إنشاء عرض فلاش',
    'flashOffers.labelTitle': 'العنوان *',
    'flashOffers.placeholderTitle': 'مثال: عرض نهاية الأسبوع',
    'flashOffers.labelDiscount': 'الخصم (%)',
    'flashOffers.labelDescription': 'الوصف',
    'flashOffers.placeholderDescription': 'مثال: إصلاح الشاشة بسعر مخفّض',
    'flashOffers.labelEndDate': 'تاريخ الانتهاء',
    'flashOffers.labelTargetLevels': 'المستويات المستهدفة',
    'flashOffers.levelBronze': 'برونزي',
    'flashOffers.levelSilver': 'فضي',
    'flashOffers.levelGold': 'ذهبي',
    'flashOffers.creating': 'جارٍ الإنشاء...',
    'flashOffers.createOffer': 'إنشاء العرض',
    'flashOffers.emptyTitle': 'لم يتم إنشاء أي عرض فلاش',
    'flashOffers.emptyHint': 'انقر على «{{btn}}» للبدء',
    'flashOffers.badgeExpired': 'منتهية',
    'flashOffers.badgeDisabled': 'معطّلة',
    'flashOffers.endLabel': 'الانتهاء: {{date}}',
    'flashOffers.emailsCount': 'رسائل البريد: {{count}}',
    'flashOffers.lastSent': 'آخر إرسال: {{date}}',
    'flashOffers.deactivate': 'تعطيل',
    'flashOffers.activate': 'تفعيل',
    'flashOffers.sendByEmail': 'إرسال عبر البريد الإلكتروني',
    'flashOffers.delete': 'حذف',
    'mailsAi.oauthDenied': 'تم رفض إذن Google.',
    'mailsAi.sessionExpired': 'انتهت صلاحية الجلسة، يُرجى المحاولة مرة أخرى.',
    'mailsAi.tokenExchangeFailed': 'خطأ في الاتصال بـ Google، يُرجى المحاولة مرة أخرى.',
    'mailsAi.missingParams': 'معاملات مفقودة.',
    'mailsAi.googleConnectError': 'خطأ في الاتصال بـ Google.',
    'mailsAi.errorWith': 'خطأ: {{msg}}',
    'mailsAi.aiAnalysisError': 'خطأ في تحليل الذكاء الاصطناعي: {{msg}}',
    'mailsAi.confirmDeleteAccount': 'حذف حساب البريد الإلكتروني هذا وجميع رسائله المخزَّنة؟',
    'mailsAi.confirmRefetch': 'سيؤدي هذا إلى حذف جميع الرسائل المخزَّنة مؤقتًا وإعادة تنزيلها مع عرض HTML الكامل. هل تريد المتابعة؟',
    'mailsAi.confirmBulkAnalyze': 'تحليل {{count}} رسالة غير مُحلَّلة؟ (يستهلك رصيد الذكاء الاصطناعي)',
    'mailsAi.fetchAnalyzedHeader': 'تم جلب {{count}} رسالة جديدة وتحليلها.',
    'mailsAi.alertsDetected': 'تم اكتشاف {{count}} تنبيه:',
    'mailsAi.fetchAnalyzedNoThreat': 'تم جلب {{count}} رسالة جديدة وتحليلها تلقائيًا. لم يتم اكتشاف أي تهديد.',
    'mailsAi.fetchRetrieved': 'تم جلب {{count}} رسالة جديدة.',
    'mailsAi.noNewEmail': 'لا توجد رسائل جديدة.',
    'mailsAi.refetchDone': 'اكتملت إعادة المزامنة! تم جلب {{count}} رسالة مع عرض HTML.',
    'mailsAi.allVisibleAnalyzed': 'جميع الرسائل الظاهرة مُحلَّلة بالفعل!',
    'mailsAi.bulkAnalyzeDone': 'اكتمل التحليل! تم تحليل {{done}}/{{total}} رسالة.',
    'mailsAi.emailSent': 'تم إرسال الرسالة بنجاح!',
    'mailsAi.subtitle': 'إدارة ذكية لرسائلك المهنية',
    'mailsAi.autoRefresh': 'تحديث تلقائي',
    'mailsAi.refresh': 'تحديث',
    'mailsAi.analyzeAll': 'تحليل الكل',
    'mailsAi.compose': 'رسالة جديدة',
    'mailsAi.addAccount': 'إضافة حساب',
    'mailsAi.loadingAccounts': 'جارٍ تحميل الحسابات...',
    'mailsAi.noAccountTitle': 'لا يوجد حساب بريد إلكتروني متصل',
    'mailsAi.noAccountDesc': 'اربط أول حساب بريد إلكتروني للبدء.',
    'mailsAi.fetchingAll': 'جارٍ جلب جميع الرسائل...',
    'mailsAi.fetchingAllHint': 'قد يستغرق هذا بضع دقائق',
    'mailsAi.noEmail': 'لا توجد رسائل.',
    'mailsAi.noSubject': '(بدون موضوع)',
    'mailsAi.prev': 'السابق',
    'mailsAi.next': 'التالي',
    'mailsAi.pageOf': '{{page}} / {{total}}',
    'sumupTerminal.title': 'جهاز SumUp (جهاز الدفع)',
    'sumupTerminal.subtitle': 'جهاز دفع واحد لكل متجر — M1 وM2 مستقلان. يستخدم POS V2 جهاز الدفع الخاص بالمتجر المحدد.',
    'sumupTerminal.hintM1': 'جهاز دفع Resurrection Mobile (SOLO)',
    'sumupTerminal.hintM2': 'يُضبط عند إقران جهاز الدفع الثاني مع SumUp',
    'sumupTerminal.m2NotConfigured': 'لم يُضبط M2 بعد — هذا طبيعي إذا لم يُقرن جهاز الدفع الثاني بعد. عند إقرانه، املأ الحقول أدناه (حساب SumUp M2 منفصل).',
    'sumupTerminal.step1Lead': 'في SumUp Cloud ← الأجهزة ← انسخ',
    'sumupTerminal.step1Merchant': 'رمز التاجر',
    'sumupTerminal.step1And': ' و',
    'sumupTerminal.step1Reader': 'معرّف القارئ',
    'sumupTerminal.step2Lead': 'الصق',
    'sumupTerminal.step2Secret': 'المفتاح السري',
    'sumupTerminal.step2Mid': '(sup_sk_…) —',
    'sumupTerminal.step2Public': 'وليس المفتاح العام sup_pk_',
    'sumupTerminal.step3Lead': 'انقر على',
    'sumupTerminal.step3Verify': 'التحقق من مفتاح API',
    'sumupTerminal.step3Rest': '← يُملأ رمز التاجر تلقائيًا',
    'sumupTerminal.step4Lead': 'اختر جهاز الدفع من القائمة، ثم',
    'sumupTerminal.step4Save': 'احفظ',
    'sumupTerminal.labelName': 'اسم جهاز الدفع (اختياري)',
    'sumupTerminal.namePlaceholder': 'مثال: جهازي M1',
    'sumupTerminal.labelApiKey': 'مفتاح API السري الخاص بـ SumUp (sup_sk_…) *',
    'sumupTerminal.savedKeyPlaceholder': 'محفوظ: {{masked}}',
    'sumupTerminal.apiKeyHint': 'المفتاح السري sup_sk_ فقط. تعرضه SumUp مرة واحدة فقط عند الإنشاء.',
    'sumupTerminal.verifyKeyBtn': '1. التحقق من مفتاح API',
    'sumupTerminal.keyConfirmed': '✓ تم تأكيد المفتاح من SumUp',
    'sumupTerminal.labelMerchantCode': 'رمز التاجر *',
    'sumupTerminal.labelReaderId': 'معرّف القارئ (reader) *',
    'sumupTerminal.discoverBtn': 'ابحث عن أجهزتي',
    'sumupTerminal.readerFallback': 'جهاز دفع SumUp',
    'sumupTerminal.labelDeviceId': 'معرّف الجهاز (اختياري)',
    'sumupTerminal.saveBtn': 'احفظ {{mag}}',
    'sumupTerminal.testBtn': 'اختبار {{amount}} على جهاز الدفع',
    'sumupTerminal.checklistTitle': 'قائمة تحقق جهاز الدفع',
    'sumupTerminal.checklistWifi': 'الجهاز مشغّل ومتصل بشبكة Wi‑Fi',
    'sumupTerminal.checklistPaired': 'الحالة «مقترن» في SumUp Cloud',
    'sumupTerminal.checklistSolo': 'برنامج Solo ≥ 3.3.24',
    'sumupTerminal.checklistBluetooth': 'لا يعمل Bluetooth وAPI معًا — أوقف Bluetooth على جهاز SOLO إذا كنت تستخدم POS',
    'sumupTerminal.checklistCancel': 'إذا ظهر المبلغ ثم أُلغي تلقائيًا: أعد توصيل API على جهاز الدفع (ليس خطأ في POS)',
    'sumupTerminal.openCloud': 'فتح SumUp Cloud',
    'sumupTerminal.errLoad': 'تعذّر تحميل الإعدادات',
    'sumupTerminal.msgMerchantChanged': 'تم تغيير حساب التاجر — تحقّق من مفتاح API ثم اختر جهاز الدفع.',
    'sumupTerminal.errPasteSecret': 'الصق أولًا المفتاح السري لـ SumUp (sup_sk_…)، وليس المفتاح العام sup_pk_.',
    'sumupTerminal.keyOkReaders': 'المفتاح سليم — الحساب {{mc}} · تم العثور على {{count}} جهاز دفع.',
    'sumupTerminal.keyOkNone': 'المفتاح سليم — الحساب {{mc}} · لا يوجد جهاز دفع مقترن في SumUp Cloud.',
    'sumupTerminal.errKeyRejected': 'رفضت SumUp مفتاح API',
    'sumupTerminal.msgNoReaders': 'لم يُعثر على أي جهاز دفع — تأكّد من أن الجهاز مقترن في SumUp Cloud.',
    'sumupTerminal.errDiscover': 'خطأ في البحث عن جهاز الدفع',
    'sumupTerminal.readerSelected': 'تم اختيار جهاز الدفع: {{name}}',
    'sumupTerminal.errMerchantChangeKey': 'تغيير حساب SumUp: أدخل مفتاح API الجديد (sup_sk_…) قبل الحفظ.',
    'sumupTerminal.errVerifyFirst': 'انقر أولًا على «التحقق من مفتاح API» — يجب أن تؤكّد SumUp المفتاح قبل الحفظ.',
    'sumupTerminal.errReaderRequired': 'معرّف القارئ مطلوب — انقر على «ابحث عن أجهزتي» واختر الجهاز.',
    'sumupTerminal.savedWithNotice': 'تم حفظ إعدادات {{mag}}. {{notice}}',
    'sumupTerminal.saved': 'تم حفظ إعدادات {{mag}}.',
    'sumupTerminal.errSave': 'خطأ في الحفظ',
    'sumupTerminal.testOk': 'الاختبار ناجح — انظر إلى جهاز الدفع',
    'sumupTerminal.errTest': 'فشل الاختبار',
    'adminB2B.accessDenied': 'تم رفض الوصول',
    'adminB2B.reservedAdmins': 'مخصّص للمسؤولين فقط.',
    'adminB2B.backToDashboard': 'العودة إلى لوحة التحكم',
    'adminB2B.back': 'رجوع',
    'adminB2B.title': 'عملاء B2B',
    'adminB2B.accountsSingular': 'الشركات المسجَّلة على بوّابة B2B — {{count}} حساب',
    'adminB2B.accountsPlural': 'الشركات المسجَّلة على بوّابة B2B — {{count}} حسابات',
    'adminB2B.colCompany': 'الشركة',
    'adminB2B.colManager': 'المدير',
    'adminB2B.colEmail': 'البريد الإلكتروني',
    'adminB2B.colPhone': 'الهاتف',
    'adminB2B.colStatus': 'الحالة',
    'adminB2B.colRegistered': 'تاريخ التسجيل',
    'adminB2B.empty': 'لا يوجد عملاء B2B',
    'adminB2B.statusValide': 'مُعتمَد',
    'adminB2B.statusEnAttente': 'قيد الانتظار',
    'adminB2B.statusRefuse': 'مرفوض',
    'adminCache.statusCompleted': 'مكتمل',
    'adminCache.statusRunning': 'جارٍ التنفيذ...',
    'adminCache.statusUpdating': 'جارٍ التحديث',
    'adminCache.statusError': 'خطأ',
    'adminCache.never': 'أبدًا',
    'adminCache.title': 'بيانات المورّدين',
    'adminCache.refreshing': 'جارٍ التحديث...',
    'adminCache.refreshData': 'تحديث البيانات',
    'adminCache.step1Title': 'الخطوة 1 — بيانات اعتماد المورّدين.',
    'adminCache.step1Intro': 'أدخل البريد الإلكتروني وكلمة المرور لـ Mobilax وJensMobiles وLCD-Phone في صفحة',
    'adminCache.step1LinkText': 'بيانات اعتماد المورّدين',
    'adminCache.step1Outro': 'ثم عُد إلى هنا وانقر على « {{action}} » لتغذية عرض السعر الآلي بالذكاء الاصطناعي.',
    'adminCache.configurePasswords': 'إعداد كلمات المرور',
    'adminCache.totalCached': 'إجمالي المنتجات في الذاكرة المؤقتة',
    'adminCache.spareParts': 'قطع الغيار',
    'adminCache.accessories': 'ملحقات',
    'adminCache.phones': 'هواتف',
    'adminCache.syncState': 'حالة المزامنة',
    'adminCache.noSync': 'لم تُجرَ أي مزامنة',
    'adminCache.exploreCache': 'استكشاف الذاكرة المؤقتة',
    'adminCache.searchPlaceholder': 'بحث (مثال: غطاء iPhone 14، Galaxy A06 جديد)...',
    'adminCache.allTypes': 'كل الأنواع',
    'adminCache.filterParts': 'قطع',
    'adminCache.filterAccessories': 'ملحقات',
    'adminCache.filterPhones': 'هواتف',
    'adminCache.colType': 'النوع',
    'adminCache.colSupplier': 'المورّد',
    'adminCache.colPart': 'القطعة',
    'adminCache.colBrand': 'العلامة التجارية',
    'adminCache.colPrice': 'السعر',
    'adminCache.colStock': 'المخزون',
    'adminCache.colRef': 'المرجع',
    'adminCache.catPart': 'قطعة',
    'adminCache.catAccessory': 'ملحق',
    'adminCache.catPhone': 'هاتف',
    'adminCache.inStock': 'متوفر',
    'adminCache.outOfStock': 'غير متوفر',
    'adminCache.noResults': 'لا نتائج لـ "{{query}}"',
    'adminDownloads.artifactDesktopLabel': 'تطبيق Windows للموظفين',
    'adminDownloads.artifactDesktopDesc': 'أرشيف ZIP يُوزَّع على مستخدمي Windows.',
    'adminDownloads.artifactPackLabel': 'حزمة وكيل الطابعة',
    'adminDownloads.artifactPackDesc': 'أرشيف ZIP مصدري لإعادة بناء وكيل الطباعة.',
    'adminDownloads.artifactExeLabel': 'وكيل Windows',
    'adminDownloads.artifactExeDesc': 'ملف تنفيذي جاهز للتشغيل على جهاز الفني.',
    'adminDownloads.available': 'متوفر',
    'adminDownloads.missing': 'مفقود',
    'adminDownloads.download': 'تنزيل',
    'adminDownloads.activeFile': 'الملف النشط',
    'adminDownloads.size': 'الحجم',
    'adminDownloads.lastUpdate': 'آخر تحديث',
    'adminDownloads.uploadedBy': 'رُفع بواسطة',
    'adminDownloads.replaceLiveFile': 'استبدال الملف المباشر',
    'adminDownloads.uploading': 'جارٍ الرفع...',
    'adminDownloads.replace': 'استبدال',
    'adminDownloads.replaceHint': 'الملف المُختار يستبدل مباشرةً الملف المُقدَّم للمستخدمين على remobiles.com.',
    'adminDownloads.selectedFile': 'الملف المحدد: {{name}}',
    'adminDownloads.loadError': 'خطأ في تحميل الملفات',
    'adminDownloads.downloadLinkUnavailable': 'رابط التنزيل غير متوفر',
    'adminDownloads.downloadFailed': 'تعذّر التنزيل',
    'adminDownloads.selectFilePrompt': 'اختر ملفًا لـ {{label}}.',
    'adminDownloads.confirmReplace': 'استبدال {{label}} بـ {{name}} الآن؟',
    'adminDownloads.replaceSuccess': 'تم استبدال {{label}} بنجاح.',
    'adminDownloads.uploadError': 'خطأ أثناء الرفع',
    'adminDownloads.title': 'المُثبِّتات والتنزيلات',
    'adminDownloads.subtitle': 'تنزيلات مباشرة لحزم Windows واستبدال مباشر لمدير النظام الأعلى.',
    'adminDownloads.printerConfig': 'إعدادات الطابعة',
    'adminDownloads.refresh': 'تحديث',
    'adminDownloads.availableArtifacts': 'العناصر المتوفرة',
    'adminDownloads.totalSize': 'الحجم الإجمالي',
    'adminDownloads.alert': 'تنبيه',
    'adminDownloads.alertText': 'عمليات الاستبدال تكتب فوق الملف المباشر. لا يوجد حذف منفصل.',
    'adminDownloads.accessTitle': 'وصول المدير ومدير النظام الأعلى',
    'adminDownloads.accessText': 'تجمع هذه الصفحة التنزيلات الظاهرة من remobiles.com. لا يظهر الاستبدال المباشر للملفات إلا لمدير النظام الأعلى.',
    'adminDownloads.signedLinksNote': 'تبقى روابط التنزيل موقَّعة من الخادم الخلفي لتفادي كائنات blob في المتصفح.',
    'adminCachePurge.accessDenied': 'الوصول مقصور على كارلوس.',
    'adminCachePurge.title': 'حذف المستندات التجارية',
    'adminCachePurge.descIntro': 'صفحة مخفية — كارلوس فقط. تحذف المبيعات والسجلات والطلبات والدفعات المقدمة وعروض الأسعار/الفواتير',
    'adminCachePurge.descBefore': 'قبل',
    'adminCachePurge.descOutro': 'التاريخ المحدد. لا تتأثر الإصلاحات.',
    'adminCachePurge.warnBackupBefore': 'إجراء مدمّر لا يمكن التراجع عنه. قم بتصدير نسخة احتياطية من',
    'adminCachePurge.warnBackupLink': 'قاعدة البيانات',
    'adminCachePurge.warnBackupAfter': 'قبل أي حذف فعلي.',
    'adminCachePurge.resultDryRunLine': 'اكتملت المحاكاة — سيتم حذف {{count}} مستند قبل {{before}}.',
    'adminCachePurge.resultPurgeLine': 'تم تنفيذ الحذف — تم حذف {{count}} مستند قبل {{before}}.',
    'adminCachePurge.sectionParams': 'الإعدادات',
    'adminCachePurge.labelBeforeDate': 'حذف كل شيء قبل',
    'adminCachePurge.hintStrictlyBefore': 'قبل الساعة 00:00 من ذلك اليوم تمامًا.',
    'adminCachePurge.labelConfirm': 'تأكيد (إلزامي)',
    'adminCachePurge.hintTypeToken': 'اكتب: {{token}}',
    'adminCachePurge.dryRunLabel': 'وضع المحاكاة (تجريبي) — لا يحذف شيئًا',
    'adminCachePurge.previewBtn': 'معاينة',
    'adminCachePurge.simulateBtn': 'محاكاة الحذف',
    'adminCachePurge.executeBtn': 'تنفيذ الحذف',
    'adminCachePurge.previewHeading': 'معاينة — {{count}} مستند',
    'adminCachePurge.beforeLabel': 'قبل {{before}}',
    'adminCachePurge.previewEmpty': 'لا توجد بيانات للعرض.',
    'adminCachePurge.colCollection': 'المجموعة',
    'adminCachePurge.colCount': 'العدد',
    'adminCachePurge.colExamples': 'أمثلة',
    'adminCachePurge.sectionExcluded': 'غير محذوف',
    'adminCachePurge.excludedReparations': 'الإصلاحات (الأجهزة)',
    'adminCachePurge.excludedStock': 'المخزون',
    'adminCachePurge.excludedClients': 'العملاء',
    'adminCachePurge.excludedUtilisateurs': 'المستخدمون',
    'adminCachePurge.confirmDryRun': 'محاكاة حذف قبل {{before}} ({{count}} مستند)؟',
    'adminCachePurge.confirmDelete': '⚠️ لا يمكن التراجع — حذف {{count}} مستند تجاري قبل {{before}}؟',
    'adminCachePurge.errorPreview': 'خطأ في المعاينة',
    'adminCachePurge.errorLoad': 'خطأ في التحميل',
    'adminCachePurge.errorPurge': 'خطأ في الحذف',
    'adminSupplierCreds.title': 'بيانات اعتماد المورّدين',
    'adminSupplierCreds.subtitle': '{{providers}} — لأجل Auto-Devis وذاكرة التخزين المؤقت للكتالوج',
    'adminSupplierCreds.supplierData': 'بيانات المورّدين',
    'adminMagasins.statusActive': 'نشط',
    'adminMagasins.statusArchived': 'مؤرشف',
    'adminMagasins.newStore': 'متجر جديد',
    'adminMagasins.fieldCode': 'الرمز (مُولَّد تلقائيًا، قابل للتعديل)',
    'adminMagasins.fieldName': 'الاسم *',
    'adminMagasins.namePlaceholder': 'مثال: متجر كايين المركزي',
    'adminMagasins.fieldAddress': 'العنوان',
    'adminMagasins.fieldPhone': 'الهاتف',
    'adminMagasins.fieldPrinterIp': 'الطابعة (IP)',
    'adminMagasins.printerIpPlaceholder': 'مثال: 192.168.1.50  — اتركه فارغًا إن لم تكن هناك طابعة مخصصة',
    'adminMagasins.printerIpHint': 'إذا كان فارغًا → يُستخدم طابعة جلسة نقطة البيع (POS).',
    'adminMagasins.fieldBadgeColor': 'لون الشارة',
    'adminMagasins.setAsDefault': 'تعيين كمتجر افتراضي',
    'adminMagasins.defaultWillBeDemoted': 'المتجر {{code}} ({{name}}) هو الافتراضي حاليًا. سيتم إلغاء تعيينه تلقائيًا.',
    'adminMagasins.cancel': 'إلغاء',
    'adminMagasins.createStore': 'إنشاء المتجر',
    'adminMagasins.nameRequired': 'الاسم مطلوب',
    'adminMagasins.createError': 'خطأ في الإنشاء',
    'adminMagasins.confirmOverrideDefault': 'المتجر «{{code}} — {{name}}» هو المتجر الافتراضي حاليًا.\n\nعند تحديد «تعيين كافتراضي»، سيتم إلغاء تعيينه تلقائيًا.\n\nتأكيد؟',
    'adminMagasins.loadError': 'خطأ في التحميل',
    'adminMagasins.confirmArchive': 'أرشفة المتجر {{code}}؟ لن يتم حذف الأصناف والمبيعات.',
    'adminMagasins.genericError': 'خطأ',
    'adminMagasins.back': 'رجوع',
    'adminMagasins.title': 'المتاجر',
    'adminMagasins.subtitle': 'إدارة المتاجر (المحلات الفعلية)',
    'adminMagasins.filterActive': 'النشطة',
    'adminMagasins.filterArchived': 'المؤرشفة',
    'adminMagasins.filterAll': 'الكل',
    'adminMagasins.colCode': 'الرمز',
    'adminMagasins.colName': 'الاسم',
    'adminMagasins.colAddress': 'العنوان',
    'adminMagasins.colPhone': 'الهاتف',
    'adminMagasins.colPrinterIp': 'عنوان IP للطابعة',
    'adminMagasins.colColor': 'اللون',
    'adminMagasins.colStatus': 'الحالة',
    'adminMagasins.colActions': 'الإجراءات',
    'adminMagasins.loading': 'جارٍ التحميل…',
    'adminMagasins.emptyArchived': 'لا يوجد متجر مؤرشف.',
    'adminMagasins.emptyActive': 'لا يوجد متجر نشط.',
    'adminMagasins.defaultBadge': 'افتراضي',
    'adminMagasins.edit': 'تعديل',
    'adminMagasins.cannotArchiveDefault': 'غير ممكن — المتجر الافتراضي',
    'adminMagasins.archive': 'أرشفة',
    'adminMagasins.restore': 'استعادة',
    'adminMagasins.footerNote': 'تحتفظ المتاجر المؤرشفة بأصنافها ومبيعاتها (R1 — حذف ناعم فقط). لا يمكن أرشفة المتجر المميَّز بـ «{{badge}}».',
    'adminPromos.title': 'العروض الترويجية الآلية',
    'adminPromos.subtitle': 'العروض النشطة والتقويم والإعدادات',
    'adminPromos.tabCurrent': 'العروض النشطة',
    'adminPromos.tabCalendar': 'التقويم الشهري',
    'adminPromos.tabSettings': 'الإعدادات',
    'adminPromos.forceDailyDraw': 'فرض سحب يومي جديد',
    'adminPromos.ref': 'المرجع: {{ref}}',
    'adminPromos.statusActive': '🟢 نشط',
    'adminPromos.statusInactive': '⚫ غير نشط',
    'adminPromos.endLabel': 'ينتهي: {{date}}',
    'adminPromos.emptyPromos': 'لا توجد عروض',
    'adminPromos.regenThisMonth': 'إعادة توليد هذا الشهر',
    'adminPromos.productsCount': '{{count}} منتج',
    'adminPromos.emptyCalendar': 'لا يوجد تقويم — إعادة التوليد؟',
    'adminPromos.configDaily': 'البوت اليومي التلقائي',
    'adminPromos.excludedCategories': 'الفئات المستبعدة (مفصولة بفواصل)',
    'adminPromos.excludedKeywords': 'الكلمات المفتاحية المستبعدة (regex OR، اختياري — فارغ = استخدام الإعدادات الافتراضية)',
    'adminPromos.save': 'حفظ',
    'adminPromos.minPct': 'الحد الأدنى %',
    'adminPromos.maxPct': 'الحد الأقصى %',
    'adminPromos.confirmRegenDaily': 'سحب عرض يومي جديد الآن؟',
    'adminPromos.drawResult': 'سحب جديد: {{name}}',
    'adminPromos.statusResult': 'الحالة: {{status}}',
    'adminPromos.confirmRegenCalendar': 'إعادة توليد تقويم {{month}}؟ سيؤدي ذلك إلى استبدال الموجود.',
    'adminPromos.calendarRegenResult': '{{status}} — تم استخدام {{count}} منتج',
    'adminPromos.settingsSaved': 'تم حفظ الإعدادات',
    'adminCadbotPrix.source.ventePos': 'بيع عبر نقطة البيع',
    'adminCadbotPrix.source.reparation': 'إصلاح',
    'adminCadbotPrix.source.devisValide': 'عرض سعر معتمد',
    'adminCadbotPrix.refSource.prixValide': 'سعر معتمد',
    'adminCadbotPrix.refSource.tarifPublic': 'السعر العام',
    'adminCadbotPrix.refSource.calculFournisseur': 'حساب المورّد',
    'adminCadbotPrix.refSource.aucune': 'لا يوجد مرجع',
    'adminCadbotPrix.loadError': 'خطأ في التحميل',
    'adminCadbotPrix.genericError': 'خطأ',
    'adminCadbotPrix.toastCollected': 'تم تسجيل {{ventes}} عملية بيع + {{reparations}} عملية إصلاح',
    'adminCadbotPrix.toastAnalyzed': '{{creees}} اقتراح جديد، {{maj}} تحديث',
    'adminCadbotPrix.priceInvalid': 'سعر غير صالح',
    'adminCadbotPrix.toastApproved': 'تم اعتماد السعر: {{price}} — {{detail}}',
    'adminCadbotPrix.toastApprovedLocked': 'السعر اليدوي مقفل، الاقتراح قيد الانتظار',
    'adminCadbotPrix.toastApprovedPublished': 'تم تحديث صفحة الأسعار',
    'adminCadbotPrix.rejectReasonPrompt': 'سبب الرفض (اختياري):',
    'adminCadbotPrix.proposalRejected': 'تم رفض الاقتراح',
    'adminCadbotPrix.settingsSaved': 'تم حفظ الإعدادات',
    'adminCadbotPrix.confirmRemoveValidated': 'إزالة السعر المعتمد {{model}} · {{part}} · {{quality}}؟',
    'adminCadbotPrix.validatedRemoved': 'تمت إزالة السعر المعتمد',
    'adminCadbotPrix.pageTitle': 'اعتماد أسعار CADBOT',
    'adminCadbotPrix.pageSubtitle': 'يسجّل CADBOT الأسعار المفوترة فعليًا ويقترح تعديلات. كل سعر معتمد يغذّي صفحة الأسعار ويصبح ذا أولوية في عروض الأسعار.',
    'adminCadbotPrix.rules': 'القواعد',
    'adminCadbotPrix.collecting': 'جارٍ الجمع…',
    'adminCadbotPrix.memorizeSales': 'تسجيل المبيعات',
    'adminCadbotPrix.analyzing': 'جارٍ التحليل…',
    'adminCadbotPrix.analyze': 'تحليل',
    'adminCadbotPrix.minSales': 'الحد الأدنى للمبيعات',
    'adminCadbotPrix.tolerancePct': 'الحد الأدنى للفرق (%)',
    'adminCadbotPrix.toleranceEur': 'الحد الأدنى للفرق (€)',
    'adminCadbotPrix.windowDays': 'النافذة (أيام)',
    'adminCadbotPrix.publishOnApprove': 'النشر في صفحة الأسعار عند الاعتماد',
    'adminCadbotPrix.countDevisValides': 'احتساب عروض أسعار الذكاء الاصطناعي المعتمدة أيضًا (إضافةً إلى المبيعات المفوترة)',
    'adminCadbotPrix.filterPending': 'بانتظار الاعتماد',
    'adminCadbotPrix.filterApproved': 'معتمدة',
    'adminCadbotPrix.filterRejected': 'مرفوضة',
    'adminCadbotPrix.filterAll': 'الكل',
    'adminCadbotPrix.refresh': 'تحديث',
    'adminCadbotPrix.loading': 'جارٍ التحميل…',
    'adminCadbotPrix.emptyProposals': 'لا يوجد اقتراح {{scope}}. اضغط «{{collect}}» ثم «{{analyze}}».',
    'adminCadbotPrix.emptyScopePending': 'بانتظار الاعتماد',
    'adminCadbotPrix.tier': 'الفئة',
    'adminCadbotPrix.realSales': '{{count}} عملية بيع فعلية (من {{min}} إلى {{max}})',
    'adminCadbotPrix.lastSaleOn': 'آخرها في {{date}}',
    'adminCadbotPrix.statusBadgePending': 'بانتظار الاعتماد',
    'adminCadbotPrix.statusBadgeApproved': 'معتمدة',
    'adminCadbotPrix.statusBadgeRejected': 'مرفوضة',
    'adminCadbotPrix.referencePrice': 'السعر المرجعي',
    'adminCadbotPrix.medianRealSales': 'وسيط المبيعات الفعلية',
    'adminCadbotPrix.priceToValidate': 'السعر المراد اعتماده (قابل للتعديل)',
    'adminCadbotPrix.priceRetained': 'السعر المعتمد',
    'adminCadbotPrix.evidenceSales': 'المبيعات الداعمة ({{count}})',
    'adminCadbotPrix.thDate': 'التاريخ',
    'adminCadbotPrix.thSource': 'المصدر',
    'adminCadbotPrix.thRef': 'المرجع',
    'adminCadbotPrix.thDesignation': 'البيان',
    'adminCadbotPrix.thPriceTtc': 'السعر شامل الضريبة',
    'adminCadbotPrix.validate': 'اعتماد',
    'adminCadbotPrix.validateAt': 'بسعر {{price}} €',
    'adminCadbotPrix.reject': 'رفض',
    'adminCadbotPrix.reviewApproved': 'اعتُمدت من {{by}} في {{date}}',
    'adminCadbotPrix.reviewRejected': 'رُفضت من {{by}} في {{date}}',
    'adminCadbotPrix.lockedPendingNote': '(سعر مُعدَّل يدويًا: مقفل، السعر قيد الانتظار)',
    'adminCadbotPrix.validatedPrices': 'الأسعار المعتمدة ({{count}})',
    'adminCadbotPrix.noValidatedPrices': 'لا يوجد سعر معتمد حتى الآن.',
    'adminCadbotPrix.thDevice': 'الجهاز',
    'adminCadbotPrix.thPart': 'القطعة',
    'adminCadbotPrix.thTier': 'الفئة',
    'adminCadbotPrix.thPrice': 'السعر',
    'adminCadbotPrix.thValidated': 'معتمد',
    'adminCadbotPrix.salesCountShort': '{{count}} عملية بيع',
    'adminCadbotPrix.remove': 'إزالة',
    'adminCommissions.typeVentes': 'مبيعات',
    'adminCommissions.typeCommandes': 'طلبات',
    'adminCommissions.typeAcomptes': 'دفعات مقدمة',
    'adminCommissions.typeReparations': 'إصلاحات',
    'adminCommissions.typeFactures': 'فواتير',
    'adminCommissions.typeDevis': 'عروض أسعار',
    'adminCommissions.typeB2b': 'B2B',
    'adminCommissions.typeDeplacement': 'تنقّل',
    'adminCommissions.tagBackfill': 'إعادة احتساب',
    'adminCommissions.tagDoublonPotentiel': 'تكرار محتمل',
    'adminCommissions.tagSuspectReparation': 'إصلاح مشبوه',
    'adminCommissions.tagSuspectCommande': 'طلب مشبوه',
    'adminCommissions.confirmCancel': 'هل تريد إلغاء هذه العمولة؟',
    'adminCommissions.noSelection': 'لم يتم تحديد أي سطر',
    'adminCommissions.confirmBulkMarkPaid': 'وضع علامة مدفوعة على {{count}} عمولة؟',
    'adminCommissions.confirmRecompute30d': 'إعادة احتساب عمولات آخر 30 يومًا للمبيعات الحالية؟\nعملية آمنة للتكرار: لا تنشئ نسخًا مكررة.',
    'adminCommissions.recomputeResult': 'الفحص: {{scanned}} مبيعات — {{created}} عمولات منشأة',
    'adminCommissions.error': 'خطأ: {{detail}}',
    'adminCommissions.title': 'العمولات',
    'adminCommissions.totalToPay': 'الإجمالي المستحق الدفع',
    'adminCommissions.alreadyPaid': 'المدفوع سابقًا',
    'adminCommissions.recompute30d': 'إعادة احتساب آخر 30 يومًا',
    'adminCommissions.recompute30dHint': 'إعادة احتساب رجعية للمبيعات الحالية',
    'adminCommissions.configPerStaff': 'الإعداد لكل موظف',
    'adminCommissions.configure': 'إعداد',
    'adminCommissions.noStaffFound': 'لم يتم العثور على موظفين',
    'adminCommissions.filters': 'عوامل التصفية',
    'adminCommissions.allStatuses': 'كل الحالات',
    'adminCommissions.statusToPay': 'مستحقة الدفع',
    'adminCommissions.statusPaid': 'مدفوعة',
    'adminCommissions.statusCancelled': 'ملغاة',
    'adminCommissions.allStaff': 'كل الموظفين',
    'adminCommissions.allTypes': 'كل الأنواع',
    'adminCommissions.auditHeuristic': 'تدقيق استدلالي',
    'adminCommissions.auditAdvanced': 'تدقيق متقدم متعدد الإشارات',
    'adminCommissions.metierAuditReadOnly': 'تدقيق متقدم — للقراءة فقط · سجل Mongo سليم · محلل متعدد الإشارات فقط',
    'adminCommissions.metierAuditLoading': 'جارٍ التحليل المهني…',
    'adminCommissions.ledgerCommissionStored': 'عمولة السجل (مخزّنة)',
    'adminCommissions.metierCommissionTheoretical': 'العمولة المهنية النظرية',
    'adminCommissions.totalGapPeriod': 'إجمالي فارق الفترة',
    'adminCommissions.rowsAnalyzed': 'الأسطر المُحلّلة',
    'adminCommissions.typeMismatchDetected': 'اختلافات النوع المكتشفة',
    'adminCommissions.auditHeuristicLegend': 'تدقيق استدلالي: تصنيف حسب مرجع المعاملة. لا كتابة في قاعدة البيانات.',
    'adminCommissions.legendRecompute30d': 'إعادة احتساب 30 يومًا',
    'adminCommissions.combinedAuditNote': 'أعمدة Ledger = القيم المخزّنة في Mongo (النوع، لقطة المعدّل، commission_amount). أعمدة Métier = تحليل متعدد الإشارات + إعداد الموظف الحالي للنوع المكتشف.',
    'adminCommissions.bulkMarkPaid': 'وضع علامة مدفوعة ({{count}})',
    'adminCommissions.clearSelection': 'إلغاء التحديد',
    'adminCommissions.colDate': 'التاريخ',
    'adminCommissions.colStaff': 'الموظف',
    'adminCommissions.colType': 'النوع',
    'adminCommissions.colTransaction': 'المعاملة',
    'adminCommissions.colAmount': 'المبلغ',
    'adminCommissions.colRateApplied': 'المعدّل المطبّق',
    'adminCommissions.colCommission': 'العمولة',
    'adminCommissions.colStatus': 'الحالة',
    'adminCommissions.colLedgerType': 'L. النوع',
    'adminCommissions.colLedgerRate': 'L. المعدّل',
    'adminCommissions.colLedgerCommission': 'L. العمولة',
    'adminCommissions.colMetierType': 'M. النوع',
    'adminCommissions.colMetierRate': 'M. المعدّل',
    'adminCommissions.colMetierCommission': 'M. العمولة',
    'adminCommissions.colGap': 'الفارق',
    'adminCommissions.colAuditSignals': 'إشارات التدقيق',
    'adminCommissions.colRealType': 'النوع الفعلي (تدقيق)',
    'adminCommissions.colAppliedType': 'النوع المطبّق',
    'adminCommissions.colSource': 'المصدر',
    'adminCommissions.loading': 'جارٍ التحميل…',
    'adminCommissions.mixed': 'مختلط',
    'adminCommissions.pairLabel': 'الزوج: {{id}}',
    'adminCommissions.expectedLabel': 'المتوقع: {{type}}',
    'adminCommissions.markPaidShort': 'مدفوع',
    'adminCommissions.noCommissionInFilter': 'لا توجد عمولة ضمن هذا الفلتر',
    'adminCommissions.noCommissionHint': 'إذا تم تفعيل عمولة للتو، استخدم زر «إعادة احتساب آخر 30 يومًا» أعلاه.',
    'adminCommissions.modalTitle': 'عمولات {{name}}',
    'adminCommissions.cancel': 'إلغاء',
    'adminCommissions.save': 'حفظ',
    'adminCloud.status.ok': 'OK',
    'adminCloud.status.ko': 'فشل',
    'adminCloud.status.skipped': 'مُتخطّى',
    'adminCloud.docType.ticket': 'تذكرة إصلاح',
    'adminCloud.docType.facture': 'فاتورة',
    'adminCloud.docType.acompte': 'دفعة مقدمة',
    'adminCloud.docType.devis': 'عرض سعر',
    'adminCloud.docType.bonCommande': 'أمر شراء',
    'adminCloud.errors.load': 'خطأ في التحميل',
    'adminCloud.errors.save': 'خطأ في الحفظ',
    'adminCloud.errors.test': 'خطأ في الاختبار',
    'adminCloud.errors.rebuild': 'خطأ في إعادة البناء',
    'adminCloud.errors.syncToggle': 'خطأ في تبديل المزامنة.',
    'adminCloud.save.success': 'تم حفظ الإعدادات (لا يُعاد إرسال المفتاح بنصه الصريح أبدًا).',
    'adminCloud.test.ok': '✓ الاتصال ناجح — {{name}} (المالك: {{owner}}، تنتهي الصلاحية: {{expires}})',
    'adminCloud.test.ko': 'فشل الاتصال: {{error}}',
    'adminCloud.test.unknownError': 'غير معروف',
    'adminCloud.hierarchy.ok': '✓ التسلسل الهرمي سليم — {{path}} (folder_id: {{folderId}}...)',
    'adminCloud.hierarchy.ko': 'فشل التسلسل الهرمي — {{message}}',
    'adminCloud.access.adminRequired': 'يلزم وصول المسؤول.',
    'adminCloud.sync.resumed': 'استُؤنفت مزامنة السحابة.',
    'adminCloud.sync.paused': 'أُوقفت مزامنة السحابة مؤقتًا.',
    'adminCloud.title': 'مزامنة السحابة — remobiles.fr',
    'adminCloud.subtitlePre': 'تُؤرشَف ملفات PDF الخاصة بك (التذاكر، الفواتير، عروض الأسعار، الدفعات المقدمة) تلقائيًا في مساحتك الخاصة',
    'adminCloud.refresh': 'تحديث',
    'adminCloud.sync.active': 'مزامنة السحابة فعّالة',
    'adminCloud.sync.pausedLabel': 'مزامنة السحابة متوقفة مؤقتًا',
    'adminCloud.sync.pausedAt': 'أُوقفت مؤقتًا في {{date}}',
    'adminCloud.sync.pausedBy': ' بواسطة {{by}}',
    'adminCloud.sync.activeHint': 'تُرفع جميع مستندات PDF الجديدة تلقائيًا إلى remobiles.fr.',
    'adminCloud.sync.pauseBtn': 'إيقاف مؤقت',
    'adminCloud.sync.resumeBtn': 'استئناف',
    'adminCloud.confirm.resumeTitle': 'استئناف المزامنة؟',
    'adminCloud.confirm.pauseTitle': 'إيقاف المزامنة مؤقتًا؟',
    'adminCloud.confirm.resumeBody': 'ستُرفع المستندات الجديدة تلقائيًا إلى remobiles.fr من جديد.',
    'adminCloud.confirm.pauseBody': 'لن يُرفع أي مستند جديد حتى تستأنف المزامنة. المستندات الموجودة لن تتأثر.',
    'adminCloud.cancel': 'إلغاء',
    'adminCloud.stats.globalStatus': 'الحالة العامة',
    'adminCloud.stats.enabled': 'مُفعّل',
    'adminCloud.stats.disabled': 'معطّل',
    'adminCloud.stats.uploadsOk': 'عمليات الرفع الناجحة',
    'adminCloud.stats.uploadsKo': 'عمليات الرفع الفاشلة',
    'adminCloud.stats.total': 'الإجمالي',
    'adminCloud.structure.title': 'بنية السحابة المستهدفة (التسلسل الهرمي الفعلي)',
    'adminCloud.structure.cachedTotal': '{{count}} مجلد في الذاكرة المؤقتة',
    'adminCloud.structure.createdThisMonth': '{{count}} أُنشئ هذا الشهر',
    'adminCloud.structure.retryHierarchy': 'إعادة محاولة إنشاء التسلسل الهرمي',
    'adminCloud.structure.noUploadToday': '(لا رفع اليوم)',
    'adminCloud.structure.flat': '(مسطّح)',
    'adminCloud.structure.recentFolders': 'المجلدات المُنشأة حديثًا',
    'adminCloud.structure.noFolderCache': '(لا مجلد في الذاكرة المؤقتة)',
    'adminCloud.structure.policyLabel': 'سياسة',
    'adminCloud.structure.policyBody': ': لا يُرسَل أبدًا أي حذف لمجلد أو ملف إلى remobiles.fr. تبقى ملفات الاختبار ظاهرة على جانب السحابة.',
    'adminCloud.loading': 'جارٍ التحميل...',
    'adminCloud.connection.title': 'إعدادات الاتصال',
    'adminCloud.connection.uploadUrl': 'رابط الرفع',
    'adminCloud.connection.status': 'الحالة',
    'adminCloud.connection.enableAuto': 'تفعيل المزامنة التلقائية',
    'adminCloud.connection.currentKey': 'مفتاح API الحالي: {{masked}}',
    'adminCloud.connection.noKey': '<لا يوجد>',
    'adminCloud.connection.keyPlaceholder': 'الصق هنا مفتاحًا جديدًا للاستبدال (rcsk_...)',
    'adminCloud.connection.keyHint': 'المفتاح مُشفّر (Fernet) في قاعدة البيانات. اتركه فارغًا لعدم تعديله.',
    'adminCloud.save.btn': 'حفظ',
    'adminCloud.test.btn': 'اختبار الاتصال (whoami)',
    'adminCloud.test.lastTest': 'آخر اختبار: {{mark}} {{date}}',
    'adminCloud.logs.title': 'سجل عمليات الرفع',
    'adminCloud.logs.allStatuses': 'كل الحالات',
    'adminCloud.logs.filterOk': 'OK',
    'adminCloud.logs.filterKo': 'فشل',
    'adminCloud.logs.filterSkipped': 'مُتخطّى',
    'adminCloud.logs.allTypes': 'كل الأنواع',
    'adminCloud.logs.typeTickets': 'التذاكر',
    'adminCloud.logs.typeFactures': 'الفواتير',
    'adminCloud.logs.typeAcomptes': 'الدفعات المقدمة',
    'adminCloud.logs.typeDevis': 'عروض الأسعار',
    'adminCloud.logs.typeBonsCommande': 'أوامر الشراء',
    'adminCloud.logs.colDate': 'التاريخ',
    'adminCloud.logs.colType': 'النوع',
    'adminCloud.logs.colRef': 'المرجع',
    'adminCloud.logs.colStatus': 'الحالة',
    'adminCloud.logs.colFolder': 'المجلد',
    'adminCloud.logs.colError': 'الخطأ',
    'adminCloud.logs.empty': 'لا عمليات رفع حتى الآن.',
    'size50x30': '50 × 30 مم (معيار Bixolon)',
    'protocolZpl': 'ZPL (موصى به لأجهزة Bixolon الحديثة)',
    'protocolBpl': 'BPL (قديم / سلسلة SLP)',
    'fieldClientName': 'اسم العميل',
    'fieldClientPhone': 'هاتف العميل',
    'fieldDeviceLock': 'الرمز / القفل',
    'fieldModel': 'الطراز',
    'fieldParts': 'القطع / العطل',
    'fieldDate': 'التاريخ',
    'fieldPrice': 'السعر',
    'fieldRef': 'المرجع REM-XXX',
    'errLoad': 'خطأ في تحميل الإعدادات',
    'saved': 'تم حفظ الإعدادات.',
    'errSave': 'خطأ في الحفظ',
    'previewNeedRef': 'أدخل مرجع REM-XXX للمعاينة.',
    'errPreview': 'خطأ في إنشاء المعاينة',
    'testQueued': 'تمت إضافة الاختبار إلى قائمة الانتظار. سيعالجه الوكيل المحلي بمجرد اتصاله.',
    'errTest': 'خطأ في اختبار الطابعة',
    'confirmRotate': 'إعادة توليد الرمز ستُبطل الرمز القديم. هل تريد المتابعة؟',
    'tokenGenerated': 'تم توليد رمز جديد. انسخه والصقه في إعدادات الوكيل المحلي.',
    'errRotate': 'خطأ في إعادة توليد الرمز',
    'tokenCopied': 'تم نسخ الرمز إلى الحافظة.',
    'copyFailed': 'تعذّر النسخ.',
    'errDownloadPack': 'تعذّر التنزيل{{http}}: {{detail}}',
    'downloadLinkUnavailable': 'رابط التنزيل غير متوفر',
    'downloadStartedHint': 'بدأ التنزيل. إذا لم يحدث شيء، فاسمح بالتنزيلات في المتصفح.',
    'errDownloadApp': 'تعذّر تنزيل التطبيق{{http}}: {{detail}}',
    'agentExeDownloaded': 'تم تنزيل وكيل Windows بنجاح.',
    'errDownloadAgent': 'تعذّر تنزيل الوكيل{{http}}: {{detail}}',
    'packDownloaded': 'تم تنزيل حزمة الوكيل بنجاح.',
    'securityTitle': 'أمان طابعة الشبكة',
    'securityBody': 'تذكّر تغيير كلمة مرور المسؤول الافتراضية (admin/admin) وتعطيل TELNET و FTP عبر واجهة الويب الخاصة بالطابعة',
    'securityNoInternet': 'لا تعرّض المنفذ 9100 للإنترنت أبدًا.',
    'downloadsTitle': 'التنزيلات والمثبّتات',
    'downloadsDesc': 'وصول مباشر إلى ملفات ZIP الخاصة بـ Windows ووكيل الطابعة وصفحة الاستبدال المباشر.',
    'openInstallers': 'فتح المثبّتات',
    'loading': 'جارٍ التحميل...',
    'bixolonSection': 'Bixolon - ملصقات QR',
    'fieldPrinterName': 'اسم الطابعة',
    'fieldIp': 'عنوان IP',
    'fieldPortRaw': 'المنفذ (RAW socket)',
    'fieldIpMethod': 'طريقة IP',
    'ipMethodManual': 'يدوي (IP ثابت)',
    'ipMethodDhcp': 'DHCP',
    'fieldSubnet': 'الشبكة الفرعية',
    'fieldGateway': 'البوابة',
    'fieldDns': 'DNS',
    'fieldProtocol': 'بروتوكول الطباعة',
    'fieldDefaultLabelFormat': 'تنسيق الملصق الافتراضي',
    'printerActive': 'الطابعة مفعّلة',
    'testConnection': 'اختبار الاتصال',
    'lastTest': 'آخر اختبار: {{date}}',
    'epsonSection': 'Epson - إيصالات الصندوق',
    'epsonDesc': 'تُستخدم هذه القيم للإيصالات بحجم 80 مم. يقرأ وكيل Windows هذه الإعدادات ثم يرسل الإيصال إلى طابعة Epson الخاصة بالمتجر.',
    'fieldTicketIp': 'عنوان IP لطابعة Epson',
    'fieldTicketPort': 'منفذ Epson',
    'fieldTicketProtocol': 'بروتوكول الإيصال',
    'ticketProtoEscpos': 'ESC/POS (Epson)',
    'ticketProtoZplFallback': 'ZPL (احتياطي)',
    'agentSection': 'الوكيل المحلي',
    'agentDesc': 'يعمل الوكيل المحلي على جهاز ضمن الشبكة المحلية (LAN)، ويستقبل المهام عبر الاستطلاع (polling) ويرسل ملصقات Bixolon أو إيصالات Epson إلى الطابعات المُهيّأة. يُستخدم رمز API للمصادقة كوكيل.',
    'tokenCopyNow': 'الرمز (انسخه الآن - لن يُعرض مرة أخرى):',
    'agentTokenLabel': 'رمز الوكيل',
    'tokenCreated': '(منشأ)',
    'tokenNotGenerated': '(غير مُولّد)',
    'noToken': '— لا يوجد رمز —',
    'hide': 'إخفاء',
    'show': 'إظهار',
    'copy': 'نسخ',
    'regenerateToken': 'إعادة توليد الرمز',
    'generateToken': 'توليد الرمز',
    'agentWinTitle': 'وكيل Windows المحلي',
    'agentWinDesc': 'نزّل الوكيل الجاهز للتشغيل، أو حزمة zip إذا احتجت إلى إعادة بناء الوكيل على جهاز Windows.',
    'directLinks': 'روابط مباشرة',
    'dlDesktopApp': 'تطبيق Windows للموظفين',
    'dlAgentExe': 'وكيل Windows (.exe)',
    'dlAgentPack': 'حزمة الوكيل (.zip)',
    'tempLinksNote': 'روابط مؤقتة موقّعة تلقائيًا. تنتهي صلاحيتها بعد بضع دقائق.',
    'downloading': 'جارٍ التنزيل...',
    'dlAgentExeBtn': 'تنزيل وكيل Windows (.exe)',
    'dlAgentPackBtn': 'تنزيل حزمة الوكيل (.zip)',
    'desktopAppDesc': 'نزّل تطبيق سطح المكتب R.E.Mobiles المُجمّع مسبقًا. يشغّل الواجهة الأمامية المحلية والواجهة الخلفية المحلية ووكيل الطباعة المضمّن.',
    'dlDesktopAppBtn': 'تنزيل تطبيق Windows (.zip)',
    'printedFields': 'الحقول المطبوعة',
    'fieldFontSize': 'حجم الخط (6-16)',
    'fieldMargin': 'الهامش (0-24 نقطة)',
    'previewPdf': 'معاينة PDF',
    'previewDesc': 'إنشاء ملصق PDF تجريبي لعملية إصلاح موجودة.',
    'previewRefPlaceholder': 'مرجع REM-XXX',
    'previewBtn': 'معاينة',
    'save': 'حفظ',
    'reload': 'إعادة التحميل',
    'errUnknown': 'خطأ غير معروف',
    'adminPertes.title': 'الخسائر',
    'adminPertes.subtitle': 'مبيعات خارج المخزون حُصِّلت بأقل من سعر الكتالوج وخصومات تتجاوز الحد المسموح به، حسب البائع.',
    'adminPertes.exportCsv': 'تصدير CSV',
    'adminPertes.recalcul': 'إعادة الحساب على السجل',
    'adminPertes.typeHorsStock': 'خارج المخزون بأقل من السعر',
    'adminPertes.typeRemise': 'خصم مفرط',
    'adminPertes.typeSousCatalogue': 'سعر أقل من الكتالوج',
    'adminPertes.preset30j': '30 ي',
    'adminPertes.preset3m': '3 أشهر',
    'adminPertes.preset12m': '12 شهرًا',
    'adminPertes.presetCustom': 'مخصّص',
    'adminPertes.payCb': 'بطاقة مصرفية',
    'adminPertes.payCash': 'نقدًا',
    'adminPertes.payCheque': 'شيك',
    'adminPertes.payVirement': 'تحويل',
    'adminPertes.payMixte': 'مختلط',
    'adminPertes.payAvoir': 'رصيد دائن',
    'adminPertes.payAcompte': 'عربون',
    'adminPertes.periode': 'الفترة: {{debut}} → {{fin}}',
    'adminPertes.du': 'من',
    'adminPertes.au': 'إلى',
    'adminPertes.vendeur': 'البائع',
    'adminPertes.type': 'النوع',
    'adminPertes.magasin': 'المتجر',
    'adminPertes.tous': 'الكل',
    'adminPertes.tileTotal': 'إجمالي الخسارة',
    'adminPertes.calculeLe': 'حُسب في {{date}}',
    'adminPertes.remisesExcessives': 'خصومات مفرطة',
    'adminPertes.auDelaDe': 'أكثر من {{pct}}',
    'adminPertes.tileNb': 'المبيعات المعنيّة',
    'adminPertes.parVendeur': 'حسب البائع',
    'adminPertes.loading': 'جارٍ التحميل…',
    'adminPertes.aucunePerte': 'لا خسائر خلال الفترة.',
    'adminPertes.colTotal': 'الإجمالي',
    'adminPertes.colNbVentes': 'عدد المبيعات',
    'adminPertes.filtrerVendeur': 'تصفية التفاصيل حسب هذا البائع',
    'adminPertes.detailTitle': 'تفاصيل المبيعات',
    'adminPertes.pageRange': '{{from}}–{{to}} من {{total}}',
    'adminPertes.pageN': 'صفحة {{page}}',
    'adminPertes.aucuneLigne': 'لا صفوف لهذه المرشّحات.',
    'adminPertes.colDate': 'التاريخ',
    'adminPertes.colTicket': 'الإيصال',
    'adminPertes.colArticle': 'الصنف',
    'adminPertes.colQte': 'الكمية',
    'adminPertes.colPrixVendu': 'سعر البيع',
    'adminPertes.colPrixRef': 'السعر المرجعي',
    'adminPertes.colRemise': 'الخصم',
    'adminPertes.colPerte': 'الخسارة',
    'adminPertes.trierPerte': 'الترتيب حسب الخسارة',
    'adminPertes.colStatut': 'الحالة',
    'adminPertes.colActions': 'إجراءات',
    'adminPertes.ticket': 'الإيصال',
    'adminPertes.ouvrirTicket': 'فتح إيصال الصندوق (PDF) في علامة تبويب جديدة',
    'adminPertes.voirVente': 'عرض البيع',
    'adminPertes.masquerVente': 'إخفاء محتوى البيع',
    'adminPertes.voirVenteTitle': 'اطّلع على ما بيع في هذا الإيصال',
    'adminPertes.venteLabel': 'بيع',
    'adminPertes.paiement': 'الدفع:',
    'adminPertes.contenuIndispo': 'محتوى البيع غير متاح لهذا الإيصال (افتح إيصال PDF).',
    'adminPertes.ligneEnPerte': '(سطر بخسارة)',
    'adminPertes.totalVente': 'إجمالي البيع:',
    'adminPertes.precedent': 'السابق',
    'adminPertes.suivant': 'التالي',
    'adminPertes.lignesParPage': '{{count}} صفوف لكل صفحة',
    'adminPertes.legendeTitle': 'كيف تُحسب الخسائر',
    'adminPertes.legendeHorsStockText': 'بيع «خارج المخزون» حُصِّل بأقل من سعر الكتالوج رغم وجود الصنف في قاعدة البيانات وقت البيع. الخسارة =',
    'adminPertes.legendeHorsStockFormula': '(السعر المرجعي − سعر البيع) × الكمية',
    'adminPertes.legendeRemiseText': 'خصم أكبر من {{seuil}} على سطر بيع. يُحتسب فقط الجزء الذي يتجاوز {{seuil}}:',
    'adminPertes.legendeRemiseFormula': '(الخصم − {{seuil}}) × السعر المرجعي × الكمية',
    'adminPertes.legendeSousCatalogue': 'صنف متوفر في المخزون بيع بأقل من سعر الكتالوج دون خصم معلَن: نفس معادلة «خارج المخزون بأقل من السعر».',
    'adminPertes.legendeFooter': 'السعر المرجعي هو سعر الكتالوج للصنف في تاريخ البيع. «إعادة الحساب على السجل» تعيد قراءة كل المبيعات السابقة؛ العرض الحالي مخزَّن مؤقتًا ويُحدَّث تلقائيًا.',
    'adminPertes.confirmRecalcul': 'إعادة حساب الخسائر على كامل سجل المبيعات؟ هذه العملية تعيد قراءة كل المبيعات السابقة وقد تستغرق بعض الوقت.',
    'adminPertes.recalculDone': 'اكتملت إعادة الحساب — تم تحليل {{count}} عملية بيع',
    'adminPertes.recalculDoneGeneric': 'اكتملت إعادة الحساب على كامل السجل',
    'adminPertes.recalculFail': 'فشلت إعادة الحساب',
    'adminPertes.exportDone': 'تم تنزيل ملف CSV',
    'adminPertes.exportUnavailable': 'التصدير غير متاح (يجب تحديث الخادم)',
    'adminPertes.exportFail': 'فشل التصدير',
    'adminPertes.refManquante': 'مرجع البيع مفقود: تعذّر العثور على الإيصال',
    'adminPertes.ticketFail': 'تعذّر فتح الإيصال',
    'adminPertes.endpointIndispo': 'نقطة النهاية «الخسائر» غير متاحة (يجب تحديث الخادم).',
    'adminPertes.errLoad': 'خطأ في التحميل',
    'adminPertes.ticketTooltipRef': 'الإيصال {{ref}}',
    'adminPertes.lignes_one': '{{count}} صف',
    'adminPertes.lignes_other': '{{count}} صفوف',
    'adminPertes.articles_one': '{{count}} صنف',
    'adminPertes.articles_other': '{{count}} أصناف',
    'adminPertes.autres_one': '(+{{count}} آخر)',
    'adminPertes.autres_other': '(+{{count}} آخر)',
    'adminTodo.cat.ventesHorsStock': 'مبيعات خارج المخزون بانتظار التأكيد',
    'adminTodo.cat.cadbotPrix': 'أسعار CADBOT بانتظار الاعتماد',
    'adminTodo.cat.devisChat': 'عروض أسعار المحادثة بانتظار المعالجة',
    'adminTodo.cat.acomptesACommander': 'دفعات مقدّمة ← قطع بانتظار الطلب',
    'adminTodo.cat.commandesSansSuivi': 'طلبات بدون رقم تتبّع',
    'adminTodo.cat.sumupAConfirmer': 'مدفوعات SumUp بانتظار التأكيد',
    'adminTodo.cat.factureRequests': 'طلبات إصدار فاتورة',
    'adminTodo.groupFallback': 'مجموعة',
    'adminTodo.time.now': 'الآن',
    'adminTodo.time.minutesAgo': 'منذ {{n}} دقيقة',
    'adminTodo.time.hoursAgo': 'منذ {{n}} ساعة',
    'adminTodo.error.endpointUnavailable': 'نقطة وصول «المهام» غير متوفّرة (يجب تحديث الواجهة الخلفية).',
    'adminTodo.error.load': 'خطأ في التحميل',
    'adminTodo.settings.unavailable': 'الإعدادات غير متوفّرة (يجب تحديث الواجهة الخلفية).',
    'adminTodo.settings.notLoaded': 'لم يتم تحميل الإعدادات',
    'adminTodo.settings.saved': 'تم حفظ الإعدادات',
    'adminTodo.settings.saveError': 'تعذّر حفظ الإعدادات',
    'adminTodo.title': 'المهام',
    'adminTodo.subtitleUpdated': 'آخر تحديث {{time}} · تحديث تلقائي كل 60 ثانية',
    'adminTodo.subtitleDefault': 'كل ما يحتاج إلى إجراء، في مكان واحد.',
    'adminTodo.notifications': 'الإشعارات',
    'adminTodo.refresh': 'تحديث',
    'adminTodo.settings.saving': 'جارٍ الحفظ…',
    'adminTodo.settings.loading': 'جارٍ تحميل الإعدادات…',
    'adminTodo.settings.pushLabel': 'إشعار فوري على الهاتف',
    'adminTodo.settings.pushHint': 'تنبيه فور ظهور إجراء جديد.',
    'adminTodo.settings.digestLabel': 'ملخّص يومي الساعة 9 صباحًا',
    'adminTodo.settings.digestHint': 'رسالة واحدة كل صباح بكل ما تبقّى من مهام.',
    'adminTodo.settings.categoriesTracked': 'الفئات المتابَعة',
    'adminTodo.allClear': 'لا شيء قيد الانتظار. كل شيء محدّث.',
    'adminTodo.groupNothingPending': 'لا شيء قيد الانتظار',
    'adminTodo.open': 'فتح',
    'adminTodo.seeAll': 'عرض كل العناصر ({{count}})',
    'adminTodo.openPage': 'فتح الصفحة',
    'adminTodo.pushOn': 'الإشعارات الفورية مفعّلة',
    'adminTodo.pushOff': 'الإشعارات الفورية معطّلة',
    'adminTodo.digestOn': 'ملخّص الساعة 9 مفعّل',
    'adminTodo.digestOff': 'ملخّص الساعة 9 معطّل',
    'adminUsers.role.super_admin.label': 'المشرف الأعلى',
    'adminUsers.role.super_admin.desc': 'وصول كامل إلى النظام بأكمله (carlos فقط)',
    'adminUsers.role.admin_magasin.label': 'مدير المتجر',
    'adminUsers.role.admin_magasin.desc': 'يدير متجرًا واحدًا أو عدة متاجر مُسندة',
    'adminUsers.role.technicien.label': 'فني خدمة ما بعد البيع',
    'adminUsers.role.technicien.desc': 'تذاكر خدمة ما بعد البيع للمتجرين. بدون POS، بدون محاسبة.',
    'adminUsers.role.vendeur.label': 'بائع',
    'adminUsers.role.vendeur.desc': 'POS في كل المتاجر. بدون محاسبة، بدون إدارة.',
    'adminUsers.roleUnknown': 'غير معروف',
    'adminUsers.modal.editTitle': 'تعديل {{username}}',
    'adminUsers.createUser': 'إنشاء مستخدم',
    'adminUsers.field.username': 'اسم المستخدم',
    'adminUsers.field.passwordEdit': 'كلمة مرور جديدة (اتركها فارغة للإبقاء على الحالية)',
    'adminUsers.field.passwordCreate': 'كلمة المرور * (الحد الأدنى {{min}} حرفًا)',
    'adminUsers.field.email': 'البريد الإلكتروني',
    'adminUsers.field.telephone': 'الهاتف',
    'adminUsers.field.role': 'دور المتجر',
    'adminUsers.field.assignedMagasins': 'المتاجر المُسندة',
    'adminUsers.modal.minOneRequired': '(مطلوب 1 على الأقل)',
    'adminUsers.modal.ignoredForRole': '— يُحفظ لكن يُتجاهل لهذا الدور (النطاق = كل المتاجر)',
    'adminUsers.modal.loadingMagasins': 'جارٍ تحميل المتاجر…',
    'adminUsers.modal.posOnlyTitle': 'غائب / موقوف — POS فقط',
    'adminUsers.modal.posOnlyDesc': 'يمكنه تسجيل الدخول والتحصيل عبر POS، دون الوصول إلى الصفحات الأخرى (الإصلاحات، المخزون، العملاء، الإدارة…).',
    'adminUsers.action.cancel': 'إلغاء',
    'adminUsers.action.save': 'حفظ',
    'adminUsers.action.create': 'إنشاء',
    'adminUsers.denied.title': 'تم رفض الوصول',
    'adminUsers.denied.desc': 'هذه الصفحة مخصصة للمشرف الأعلى فقط.',
    'adminUsers.denied.back': 'العودة إلى لوحة التحكم',
    'adminUsers.error.load': 'خطأ في التحميل',
    'adminUsers.error.passwordMin': 'يجب أن تحتوي كلمة المرور على {{min}} أحرف على الأقل.',
    'adminUsers.feedback.updated': 'تم تحديث المستخدم {{username}}.',
    'adminUsers.feedback.created': 'تم إنشاء المستخدم {{username}}.',
    'adminUsers.error.operation': 'حدث خطأ أثناء العملية',
    'adminUsers.error.needsMagasinPick': 'اختر أولًا متجر الجلسة (النافذة في وسط الشاشة)، ثم أنشئ المستخدم.',
    'adminUsers.feedback.disabled': 'تم تعطيل {{username}}.',
    'adminUsers.feedback.enabled': 'تمت إعادة تفعيل {{username}}.',
    'adminUsers.error.generic': 'خطأ',
    'adminUsers.action.back': 'رجوع',
    'adminUsers.title': 'المستخدمون الداخليون',
    'adminUsers.subtitle': 'إنشاء / تعديل / تعطيل (المشرف الأعلى فقط)',
    'adminUsers.limitInfo': '{{current}}/{{max}} مستخدم · خطة {{plan}}',
    'adminUsers.limitReachedTitle': 'تم بلوغ الحد الأقصى ({{max}} مستخدم كحد أقصى)',
    'adminUsers.limitReached': 'تم بلوغ الحد الأقصى ({{max}})',
    'adminUsers.includeDisabled': 'تضمين المستخدمين المعطَّلين',
    'adminUsers.col.role': 'الدور',
    'adminUsers.col.emailTel': 'البريد / الهاتف',
    'adminUsers.col.status': 'الحالة',
    'adminUsers.col.actions': 'الإجراءات',
    'adminUsers.empty': 'لا يوجد مستخدمون.',
    'adminUsers.allMagasins': 'الكل',
    'adminUsers.status.active': 'نشط',
    'adminUsers.status.disabled': 'معطَّل',
    'adminUsers.status.posOnly': 'غائب · POS فقط',
    'adminUsers.action.edit': 'تعديل',
    'adminUsers.commissions': 'العمولات',
    'adminUsers.action.disable': 'تعطيل',
    'adminUsers.action.enable': 'إعادة التفعيل',
    'adminHorsStock.stockUnknown': 'المخزون غير معروف',
    'adminHorsStock.stockCount': 'المخزون {{count}}',
    'adminHorsStock.selected': 'محدد',
    'adminHorsStock.lineDefaultDesignation': 'صنف',
    'adminHorsStock.loadError': 'خطأ في التحميل',
    'adminHorsStock.lineStillUnresolved': 'ما زال أحد البنود «قيد التحقق» أو بدون مرجع مرتبط.',
    'adminHorsStock.saleValidatedWithLoss': 'تم اعتماد البيع {{ref}} — {{total}} في السجل. الخسارة المسجّلة: {{loss}}.',
    'adminHorsStock.saleValidatedNoLoss': 'تم اعتماد البيع {{ref}} — {{total}} في السجل، دون خسارة.',
    'adminHorsStock.validationFailed': 'تعذّر الاعتماد',
    'adminHorsStock.catalogBadge': 'الكتالوج',
    'adminHorsStock.cashedLineInfo': 'المحصّل {{qty}} × {{price}}',
    'adminHorsStock.horsStockBadge': 'خارج المخزون',
    'adminHorsStock.articleExistedQuestion': 'هل كان الصنف موجودًا؟',
    'adminHorsStock.optionLoss': 'خسارة — الصنف كان موجودًا، اربط المرجع',
    'adminHorsStock.optionNonExistent': 'صنف غير موجود — قبوله كما هو',
    'adminHorsStock.optionToVerify': 'قيد التحقق',
    'adminHorsStock.attachedArticle': 'الصنف المرتبط',
    'adminHorsStock.refLabel': 'المرجع {{ref}}',
    'adminHorsStock.catalogPriceLabel': 'سعر الكتالوج',
    'adminHorsStock.unknown': 'غير معروف',
    'adminHorsStock.soldLabel': 'المُباع',
    'adminHorsStock.estimatedLoss': 'الخسارة المقدّرة',
    'adminHorsStock.selectCatalogRef': 'اختر مرجع الكتالوج المطابق لهذا الصنف.',
    'adminHorsStock.catalogSuggestions': 'اقتراحات الكتالوج',
    'adminHorsStock.noSuggestion': 'لا توجد اقتراحات لهذا البند — استخدم البحث أدناه.',
    'adminHorsStock.otherCatalogArticle': 'صنف آخر من الكتالوج',
    'adminHorsStock.searchPlaceholder': 'ابحث بالمرجع / التسمية / EAN…',
    'adminHorsStock.noArticleFound': 'لم يُعثر على أي صنف.',
    'adminHorsStock.freeArticleInfo': 'صنف حر: يُحتفظ بالبند كما هو، دون ربط أو حركة مخزون.',
    'adminHorsStock.toVerifyInfo': 'يمنع الاعتماد حتى يُحسم البند (نعم / لا).',
    'adminHorsStock.toValidateBadge': 'قيد الاعتماد',
    'adminHorsStock.cashedBadge': 'محصّلة',
    'adminHorsStock.cashedAmountLabel': 'المحصّل',
    'adminHorsStock.subtotal': 'المجموع الفرعي',
    'adminHorsStock.discountLabel': 'الخصم',
    'adminHorsStock.historyTotal': 'إجمالي السجل',
    'adminHorsStock.amountLockedInfo': 'المبلغ المحصّل فعليًا: لا يمكن تعديل السعر والكميات والخصم هنا.',
    'adminHorsStock.lossesPreview': 'معاينة الخسائر (مرئية للإدارة فقط)',
    'adminHorsStock.remiseExcessiveLabel': 'خصم يتجاوز {{seuil}}٪ (المُمنوح {{pct}})',
    'adminHorsStock.lossRecorded': 'الخسارة المثبَتة',
    'adminHorsStock.lossSavedInfo': 'تُسجَّل في صفحة الخسائر عند الاعتماد.',
    'adminHorsStock.noLossYet': 'لا خسارة مثبَتة في هذه المرحلة',
    'adminHorsStock.noLossYetSuffix': ' — يكتمل الحساب بمجرد ربط المراجع.',
    'adminHorsStock.noteLabel': 'ملاحظة (اختياري)',
    'adminHorsStock.notePlaceholder': 'مثال: سعر متفاوَض عليه، الصنف مستلَم بتاريخ…',
    'adminHorsStock.validateButton': 'اعتمِد واكتب في السجل',
    'adminHorsStock.blockedTitle': 'ما زال هناك بند أو أكثر خارج المخزون بحاجة إلى حسم',
    'adminHorsStock.validationBlocked': 'الاعتماد محظور:',
    'adminHorsStock.blockedVerifierCount': '{{n}} بند «قيد التحقق»',
    'adminHorsStock.blockedNoRefCount': '{{n}} بند «نعم» بدون مرجع مرتبط',
    'adminHorsStock.legendTitle': 'ما الذي يحدث',
    'adminHorsStock.legendIntro': 'البيع محصّل بالفعل: لا يمكن إلغاؤه ولا يُعدَّل المخزون. يربط الاعتماد الصنف الصحيح، ويسجّل فرق السعر أو الخصم المفرط في الخسائر، ثم يكتب البيع في السجل.',
    'adminHorsStock.legendYesWord': 'نعم',
    'adminHorsStock.legendYesDesc': '— الصنف كان موجودًا: اختر مرجع الكتالوج (الاقتراحات أو البحث).',
    'adminHorsStock.legendNonWord': 'لا',
    'adminHorsStock.legendNonDesc': '— صنف حر، يُحتفظ به كما هو.',
    'adminHorsStock.legendVerifierDesc': '— يمنع الاعتماد حتى يُحسم البند.',
    'adminHorsStock.legendPertesWord': 'الخسائر',
    'adminHorsStock.legendPertesDesc': '— الفرق بين سعر الكتالوج وسعر البيع، إضافةً إلى حصة الخصم التي تتجاوز {{seuil}}٪ من المجموع الفرعي؛ مرئية هنا فقط ومسجَّلة في صفحة الخسائر.',
    'adminHorsStock.pageTitle': 'مبيعات خارج المخزون بانتظار الاعتماد',
    'adminHorsStock.pageSubtitle': 'محصّلة بالفعل؛ غير مدرجة في السجل حتى تعتمدها الإدارة.',
    'adminHorsStock.refresh': 'تحديث',
    'adminHorsStock.emptyState': 'لا توجد مبيعات خارج المخزون بانتظار الاعتماد.',
    'adminHorsStock.processedThisSession': 'المعالَجة في هذه الجلسة',
    'adminHorsStock.lossShortLabel': 'خسارة',
    'adminHorsStock.validatedBadge': 'معتمَدة',
    'stockPhotoAi.title': 'صور المخزون · الذكاء الاصطناعي',
    'stockPhotoAi.subtitle': 'المشرف الأعلى Carlos · توليد OpenAI · متجر معزول M1/M2',
    'stockPhotoAi.apiKeysLink': 'مفاتيح OpenAI API',
    'stockPhotoAi.statsTotal': 'أصناف {{mag}}',
    'stockPhotoAi.statsWithPhoto': 'مع صورة',
    'stockPhotoAi.statsMissing': 'بدون صورة',
    'stockPhotoAi.searchPlaceholder': 'ابحث عن المرجع أو الوصف…',
    'stockPhotoAi.filter': 'تصفية',
    'stockPhotoAi.generateBatch': 'توليد دفعة (بحد أقصى 10)',
    'stockPhotoAi.batchResult': 'الدفعة {{mag}}: {{ok}} ناجح · {{skipped}} متجاوَز · {{errors}} أخطاء',
    'stockPhotoAi.loading': 'جارٍ التحميل…',
    'stockPhotoAi.stockLabel': 'المخزون {{qty}}',
    'stockPhotoAi.generateOne': 'توليد بالذكاء الاصطناعي',
    'stockPhotoAi.empty': 'لا يوجد صنف بدون صورة في {{mag}}',
    'stockPhotoAi.errorLoad': 'تعذّر التحميل',
    'stockPhotoAi.errorGenerate': 'فشل التوليد',
    'stockPhotoAi.errorBatch': 'فشلت الدفعة',
    'stockPhotoAi.confirmBatch': 'توليد حتى {{max}} صورة بالذكاء الاصطناعي لـ {{mag}}؟ (OpenAI · تكلفة API)',
    'stockCatAudit.title': 'تدقيق فئات المخزون',
    'stockCatAudit.subtitle': 'تحليل كامل: هاتف مقابل قطعة/ملحق · مخصّص لكارلوس',
    'stockCatAudit.backToIntegrations': 'تكاملات المشرف',
    'stockCatAudit.magasin': 'المتجر',
    'stockCatAudit.allStores': 'الكل',
    'stockCatAudit.issuesOnly': 'الصفوف التي بها مشكلات فقط',
    'stockCatAudit.runAnalysis': 'تشغيل التحليل',
    'stockCatAudit.statTotal': 'الإجمالي',
    'stockCatAudit.statWithIssues': 'بها مشكلات',
    'stockCatAudit.statFalseImei': 'IMEI خاطئ',
    'stockCatAudit.statNeedsImei': 'IMEI مطلوب',
    'stockCatAudit.statCategorieMismatch': 'فئة مختلفة',
    'stockCatAudit.statCategorieMissing': 'فئة فارغة',
    'stockCatAudit.statAmbiguous': 'غامض',
    'stockCatAudit.currentCategories': 'الفئات الحالية',
    'stockCatAudit.suggestedCategories': 'الفئات المقترحة',
    'stockCatAudit.searchPlaceholder': 'المرجع، التسمية، الفئة…',
    'stockCatAudit.allFilters': 'كل المرشِّحات',
    'stockCatAudit.applySuggested': 'تطبيق الفئة المقترحة ({{count}})',
    'stockCatAudit.colRef': 'المرجع',
    'stockCatAudit.colDesignation': 'التسمية',
    'stockCatAudit.colMag': 'المتجر',
    'stockCatAudit.colCurrentCat': 'الفئة الحالية',
    'stockCatAudit.colSuggestedCat': 'الفئة المقترحة',
    'stockCatAudit.colType': 'النوع',
    'stockCatAudit.colIssues': 'المشكلات',
    'stockCatAudit.typePhone': 'هاتف',
    'stockCatAudit.typePiece': 'قطعة',
    'stockCatAudit.analyzing': 'جارٍ التحليل…',
    'stockCatAudit.emptyRows': 'لا توجد صفوف — شغّل التحليل أو وسّع المرشِّحات.',
    'stockCatAudit.hint': 'مثال: «حامل الهاتف» أصبح مصنّفًا كملحق (بدون IMEI). أما الهواتف الكاملة الحقيقية فتبقى خاضعة لـ IMEI عند الجرد.',
    'stockCatAudit.errorAnalyze': 'تعذّر التحليل',
    'stockCatAudit.errorApply': 'فشل التطبيق',
    'stockCatAudit.confirmApply': 'تطبيق الفئة المقترحة على {{count}} عنصر؟',
    'stockCatAudit.issueFalsePhoneImei': 'هاتف خاطئ (IMEI بالخطأ)',
    'stockCatAudit.issueNeedsImei': 'هاتف — IMEI مطلوب',
    'stockCatAudit.issueCategorieMismatch': 'فئة مختلفة',
    'stockCatAudit.issueCategorieMissing': 'فئة مفقودة',
    'stockCatAudit.issueAmbiguous': 'غامض',
    'stockHist.periodToday': 'اليوم',
    'stockHist.periodYesterday': 'أمس',
    'stockHist.periodWeek': 'هذا الأسبوع',
    'stockHist.periodMonth': 'هذا الشهر',
    'stockHist.title': 'سجل المخزون',
    'stockHist.subtitle': 'حركات المتجر والمستودع',
    'stockHist.statMovements': 'الحركات',
    'stockHist.statPieces': 'قطع',
    'stockHist.locationShop': 'المتجر',
    'stockHist.locationWarehouse': 'المستودع',
    'stockHist.empty': 'لا توجد إضافات لهذه الفترة',
    'stockHist.colDateTime': 'التاريخ / الوقت',
    'stockHist.colDesignation': 'الصنف',
    'stockHist.colStore': 'الفرع',
    'stockHist.colLocation': 'الموقع',
    'stockHist.colQty': 'الكمية',
    'stockHist.colSalePrice': 'سعر البيع',
    'stockHist.colBy': 'بواسطة',
    'stockHist.statusNew': 'جديد',
    'stockHist.statusRestock': 'إضافة',
    'stockHist.selectedOne': 'محدد',
    'stockHist.selectedMany': 'محددة',
    'stockHist.labelOne': 'ملصق',
    'stockHist.labelMany': 'ملصقات',
    'stockHist.printCount': 'طباعة ({{count}})',
    'partsOrders.statusPending': 'قيد الانتظار',
    'partsOrders.statusPartial': 'جزئية',
    'partsOrders.statusReceived': 'مستلمة',
    'partsOrders.statusCancelled': 'ملغاة',
    'partsOrders.filterAll': 'الكل',
    'partsOrders.filterReceived': 'المستلمة',
    'partsOrders.filterCancelled': 'الملغاة',
    'partsOrders.partTypeStandard': 'قياسي',
    'partsOrders.partTypeSpare': 'قطعة غيار',
    'partsOrders.partTypeSerialized': 'مُسلسَل (الرقم التسلسلي/IMEI)',
    'partsOrders.createTitle': 'طلب مورّد جديد',
    'partsOrders.supplier': 'المورّد',
    'partsOrders.supplierPlaceholder': 'اسم المورّد',
    'partsOrders.line': 'السطر {{num}}',
    'partsOrders.designationPlaceholder': 'التسمية *',
    'partsOrders.referencePlaceholder': 'المرجع (اختياري)',
    'partsOrders.type': 'النوع',
    'partsOrders.qty': 'الكمية',
    'partsOrders.purchasePriceUnit': 'سعر الشراء للوحدة',
    'partsOrders.expectedSalePrice': 'سعر البيع المتوقع',
    'partsOrders.category': 'الفئة',
    'partsOrders.categoryPlaceholder': 'مثال: شاشة، بطارية',
    'partsOrders.location': 'الموقع',
    'partsOrders.locationShop': 'المحل',
    'partsOrders.locationWarehouse': 'المستودع',
    'partsOrders.addLine': 'إضافة سطر',
    'partsOrders.notes': 'ملاحظات',
    'partsOrders.errorNeedLine': 'أضف سطراً واحداً على الأقل مع تسمية.',
    'partsOrders.errorCreate': 'حدث خطأ أثناء الإنشاء.',
    'partsOrders.cancel': 'إلغاء',
    'partsOrders.creating': 'جارٍ الإنشاء…',
    'partsOrders.create': 'إنشاء الطلب',
    'partsOrders.receiveTitle': 'استلام — {{ref}}',
    'partsOrders.allReceived': 'تم استلام جميع السطور بالفعل.',
    'partsOrders.remaining': 'المتبقي {{count}}',
    'partsOrders.receivedQty': 'الكمية المستلمة',
    'partsOrders.serialsLabel': 'الرقم التسلسلي / IMEI (واحد في كل سطر أو مفصولة بفواصل)',
    'partsOrders.errorNeedQty': 'أدخل كمية مستلمة واحدة على الأقل.',
    'partsOrders.errorReceive': 'حدث خطأ أثناء الاستلام.',
    'partsOrders.close': 'إغلاق',
    'partsOrders.validating': 'جارٍ التأكيد…',
    'partsOrders.validateReceive': 'تأكيد الاستلام',
    'partsOrders.linkTitle': 'تخصيص لإصلاح',
    'partsOrders.linkDescription': 'سيتم إدراج القطعة «{{designation}}» في سعر الإصلاح دون خصمها من المخزون (لم تُستلَم بعد).',
    'partsOrders.linkRefPlaceholder': 'مرجع الإصلاح (مثال: REP-000123)',
    'partsOrders.errorNeedRef': 'أدخل مرجع الإصلاح.',
    'partsOrders.errorRepairNotFound': 'خطأ: الإصلاح غير موجود؟',
    'partsOrders.assign': 'تخصيص',
    'partsOrders.confirmCancel': 'إلغاء هذا الطلب؟ سيتم فصل القطع المرتبطة بالإصلاحات.',
    'partsOrders.errorCancel': 'خطأ في الإلغاء.',
    'partsOrders.errorGeneric': 'خطأ.',
    'partsOrders.supplierUnknown': 'المورّد؟',
    'partsOrders.linesCount': '{{count}} سطر',
    'partsOrders.receivedCount': '{{received}}/{{total}} مستلم',
    'partsOrders.purchaseCost': 'تكلفة الشراء',
    'partsOrders.colDesignation': 'التسمية',
    'partsOrders.colReceivedQty': 'المستلم/الكمية',
    'partsOrders.colPurchaseUnit': 'شراء للوحدة',
    'partsOrders.colSalePlanned': 'البيع المتوقع',
    'partsOrders.colRepair': 'الإصلاح',
    'partsOrders.colAction': 'إجراء',
    'partsOrders.typeSerialized': 'مُسلسَل',
    'partsOrders.typeSpareShort': 'قطعة',
    'partsOrders.typeStandardShort': 'قياسي',
    'partsOrders.detach': 'فصل',
    'partsOrders.receive': 'استلام',
    'partsOrders.pageTitle': 'طلبات القطع',
    'partsOrders.pageSubtitle': 'التوريد من المورّدين — التخصيص المسبق للإصلاح والاستلام',
    'partsOrders.filterAllStores': 'الكل',
    'partsOrders.refresh': 'تحديث',
    'partsOrders.newOrder': 'طلب جديد',
    'partsOrders.kpiOpenOrders': 'الطلبات المفتوحة',
    'partsOrders.kpiAssignedParts': 'قطع مخصصة للإصلاح',
    'partsOrders.kpiCostToReceive': 'التكلفة المنتظر استلامها',
    'partsOrders.loading': 'جارٍ التحميل…',
    'partsOrders.empty': 'لا توجد طلبات قطع.',
    'stockForm.editTitle': 'تعديل الصنف',
    'stockForm.addTitle': 'إضافة صنف',
    'stockForm.productSheet': 'بطاقة المنتج',
    'stockForm.newStockProduct': 'منتج مخزون جديد',
    'stockForm.analyzePhoto': 'تحليل الصورة',
    'stockForm.scan': 'مسح ضوئي',
    'stockForm.supplierSearch': 'بحث عن مورّد',
    'stockForm.supplierSearchPlaceholder': 'المرجع أو EAN أو اسم القطعة…',
    'stockForm.refShort': 'المرجع:',
    'stockForm.priceLabel': 'السعر:',
    'stockForm.sectionArticle': 'قسم الصنف',
    'stockForm.reference': 'المرجع',
    'stockForm.ean': 'EAN',
    'stockForm.eanPlaceholder': 'الباركود',
    'stockForm.category': 'الفئة',
    'stockForm.categoryPlaceholder': 'شاشات، بطاريات…',
    'stockForm.designation': 'الوصف',
    'stockForm.supplier': 'المورّد',
    'stockForm.sectionStock': 'قسم المخزون',
    'stockForm.location': 'الموقع',
    'stockForm.shop': 'المتجر',
    'stockForm.depot': 'المستودع',
    'stockForm.both': 'كلاهما',
    'stockForm.qtyShop': 'كمية المتجر',
    'stockForm.qtyDepot': 'كمية المستودع',
    'stockForm.alertThreshold': 'حد التنبيه',
    'stockForm.sectionPricing': 'قسم الأسعار',
    'stockForm.purchasePrice': 'سعر الشراء (بدون ضريبة)',
    'stockForm.salePrice': 'سعر البيع (€)',
    'stockForm.margin': 'الهامش',
    'stockForm.sectionShop': 'قسم المتجر',
    'stockForm.visibleOnline': 'ظاهر في المتجر الإلكتروني',
    'stockForm.visibleOnlineHint': 'سيتمكن العملاء من شراء هذا الصنف',
    'stockForm.cancel': 'إلغاء',
    'stockForm.saving': 'جارٍ الحفظ…',
    'stockForm.edit': 'تعديل',
    'stockForm.addToStock': 'إضافة إلى المخزون',
    'stockForm.save': 'حفظ',
    'stockForm.reviewTitle': 'التحقق من الصنف',
    'stockForm.newArticle': 'صنف جديد',
    'stockForm.existingBanner': 'موجود — {{designation}} (متجر:{{qb}} مستودع:{{qd}}). تمت إضافة الكمية إلى المخزون.',
    'stockForm.imeiRequired': 'رقم IMEI إلزامي لتسجيل هاتف في المخزون.',
    'stockForm.imeiInvalid': 'رقم IMEI غير صالح (من 14 إلى 20 رقمًا).',
    'stockForm.articleNotFound': 'الصنف غير موجود',
    'stockForm.imeiNotRegistered': 'لم يُسجَّل رقم IMEI — تحقق من الرقم أو المخزون المتقدم > IMEI.',
    'stockForm.imeiFirstRegistered': 'تم تسجيل أول رقم IMEI. تبقّى {{count}} جهاز — أكمل أرقام IMEI في المخزون المتقدم > علامة التبويب IMEI (المرجع {{ref}}).',
    'stockForm.saveError': 'حدث خطأ أثناء الحفظ',
    'clientChat.typeBoutiqueOrder': 'طلب من المتجر',
    'clientChat.typeRepair': 'إصلاح',
    'clientChat.typeClient': 'محادثة العميل',
    'clientChat.title': 'محادثة العملاء',
    'clientChat.convCount': '{{count}} محادثة',
    'clientChat.convCountPlural': '{{count}} محادثات',
    'clientChat.searchPlaceholder': 'البحث عن عميل...',
    'clientChat.noConversations': 'لا توجد محادثات مع العملاء',
    'clientChat.clientFallback': 'العميل',
    'clientChat.startConversation': 'ابدأ المحادثة',
    'clientChat.writePlaceholder': 'اكتب إلى العميل...',
    'clientChat.selectConversation': 'اختر محادثة',
    'stockInvImport.errorAiAnalysis': 'خطأ في تحليل الذكاء الاصطناعي — تحقّق من Admin > تكاملات API ‏(OpenAI)',
    'stockInvImport.confirmMissingImei': '{{count}} سطر/أسطر هواتف بدون رقم IMEI كامل.\n\nهل تريد متابعة الاستيراد؟ يمكنك إكماله في المخزون المتقدّم > IMEI.',
    'stockInvImport.errorImport': 'خطأ في الاستيراد',
    'stockInvImport.locationDepot': 'المستودع',
    'stockInvImport.locationBoutique': 'المتجر',
    'stockInvImport.pageTitle': 'استيراد الفاتورة بالذكاء الاصطناعي',
    'stockInvImport.pageSubtitle': 'تحليل PDF · حسابات متوافقة مع /calcul',
    'stockInvImport.visionHint': 'OpenAI Vision · تقريب الأسعار مطابق لوحدة حساب الهامش',
    'stockInvImport.invoiceLabel': 'الفاتورة (PDF أو صورة)',
    'stockInvImport.fileSize': '{{size}} كيلوبايت',
    'stockInvImport.clickToChoose': 'انقر لاختيار ملف',
    'stockInvImport.shippingTotalLabel': 'إجمالي تكلفة الشحن (EUR)',
    'stockInvImport.autoIfEmpty': '— تلقائي إذا كان فارغًا',
    'stockInvImport.shippingPlaceholder': 'مثال: 29.90',
    'stockInvImport.customsPct': 'الجمارك %',
    'stockInvImport.marginPct': 'الهامش %',
    'stockInvImport.analyzing': 'جارٍ التحليل… (15–30 ثانية)',
    'stockInvImport.analyzeInvoice': 'تحليل الفاتورة',
    'stockInvImport.kpiProducts': 'المنتجات',
    'stockInvImport.kpiSupplier': 'المورّد',
    'stockInvImport.kpiShippingTotal': 'إجمالي الشحن',
    'stockInvImport.kpiShippingPerUnit': 'الشحن / وحدة',
    'stockInvImport.recalc': 'إعادة الحساب…',
    'stockInvImport.phonesCompleteImei': '{{count}} هاتف/هواتف — أكمل رقم IMEI أدناه (يُستخرج تلقائيًا من الفاتورة إن وُجد).',
    'stockInvImport.colRef': 'المرجع',
    'stockInvImport.colDesignation': 'الوصف',
    'stockInvImport.colQty': 'الكمية',
    'stockInvImport.colPurchase': 'الشراء',
    'stockInvImport.colPlusShipping': '+الشحن',
    'stockInvImport.colPlusCustoms': '+{{pct}}% جمارك',
    'stockInvImport.colPlusMargin': '+{{pct}}% هامش',
    'stockInvImport.colLabor': 'أجور',
    'stockInvImport.colFinalPrice': 'السعر النهائي',
    'stockInvImport.remove': 'إزالة',
    'stockInvImport.generateEan': 'توليد EAN',
    'stockInvImport.imeiDevicePlaceholder': 'IMEI الجهاز {{n}}',
    'stockInvImport.back': 'رجوع',
    'stockInvImport.importing': 'جارٍ الاستيراد…',
    'stockInvImport.confirm': 'تأكيد',
    'stockInvImport.importDone': 'اكتمل الاستيراد',
    'stockInvImport.created': 'تم إنشاؤها',
    'stockInvImport.updated': 'تم تحديثها',
    'stockInvImport.imeiRegistered': 'أرقام IMEI المسجّلة',
    'stockInvImport.errors': 'الأخطاء',
    'stockInvImport.imeiMissingTitle': 'أرقام IMEI ناقصة — أكملها في المخزون المتقدّم',
    'stockInvImport.missingOfTotal': '{{missing}} ناقص / {{total}}',
    'stockInvImport.newImport': 'استيراد جديد',
    'stockInvImport.backToStock': 'العودة إلى المخزون',
    'clientPwd.pinGenerated': 'تم إنشاء رمز PIN لـ {{nom}}: {{pin}}',
    'clientPwd.error': 'خطأ',
    'clientPwd.errorSendEmail': 'خطأ في إرسال البريد الإلكتروني',
    'clientPwd.errorSendBulk': 'خطأ في الإرسال الجماعي',
    'clientPwd.bulkResult': 'تم إرسال {{sent}} بريدًا، {{errors}} أخطاء',
    'clientPwd.totalClients': '{{total}} عميلًا إجمالًا',
    'clientPwd.sending': 'جارٍ الإرسال...',
    'clientPwd.sendToClients': 'إرسال إلى {{count}} عملاء',
    'clientPwd.searchPlaceholder': 'البحث بالاسم أو الهاتف أو البريد الإلكتروني...',
    'clientPwd.filterAll': 'الكل',
    'clientPwd.filterSent': 'كلمة المرور مُرسَلة',
    'clientPwd.filterNotSent': 'كلمة المرور غير مُرسَلة',
    'clientPwd.colName': 'الاسم',
    'clientPwd.colPhone': 'الهاتف',
    'clientPwd.colEmail': 'البريد الإلكتروني',
    'clientPwd.colPin': 'رمز PIN',
    'clientPwd.colStatus': 'الحالة',
    'clientPwd.colActions': 'إجراءات',
    'clientPwd.loading': 'جارٍ التحميل...',
    'clientPwd.noEmail': 'لا يوجد بريد إلكتروني',
    'clientPwd.statusSent': 'مُرسَل',
    'clientPwd.statusPending': 'قيد الانتظار',
    'clientPwd.statusNotGenerated': 'غير مُنشأ',
    'clientPwd.genPinTitle': 'إنشاء رمز PIN',
    'clientPwd.resend': 'إعادة الإرسال',
    'clientPwd.pageOf': 'صفحة {{page}} / {{total}}',
    'stockInv.error.pickMagasin': 'اختر أولًا متجرًا لهذا الجرد.',
    'stockInv.error.analyzeFailed': 'تعذّر التحليل — تحقّق من مفتاح OpenAI أو أعد المحاولة.',
    'stockInv.error.server': 'خطأ في الخادم',
    'stockInv.dropdown.refLabel': 'المرجع:',
    'stockInv.short.boutique': 'م',
    'stockInv.short.depot': 'خ',
    'stockInv.summary.title': 'ملخّص الجرد',
    'stockInv.summary.subtitle': '{{count}} عنصر محفوظ',
    'stockInv.summary.statusNew': 'جديد',
    'stockInv.summary.statusUpdated': 'مُحدّث',
    'stockInv.summary.errorsTitle': 'أخطاء',
    'stockInv.summary.created': '{{count}} تم إنشاؤه',
    'stockInv.summary.updated': '{{count}} تم تحديثه',
    'stockInv.summary.pieces': '{{count}} قطعة',
    'stockInv.btn.printLabels': 'طباعة الملصقات',
    'stockInv.btn.newInventory': 'جرد جديد',
    'stockInv.btn.printCount': 'طباعة ({{count}})',
    'stockInv.btn.addRow': 'سطر',
    'stockInv.btn.scan': 'مسح',
    'stockInv.btn.csvImport': 'استيراد CSV',
    'stockInv.btn.csvExport': 'تصدير',
    'stockInv.btn.saving': 'جارٍ الحفظ…',
    'stockInv.btn.saveAll': 'حفظ الكل ({{count}})',
    'stockInv.col.status': 'الحالة',
    'stockInv.col.reference': 'المرجع',
    'stockInv.col.designation': 'الوصف',
    'stockInv.col.pAchat': 'سعر الشراء',
    'stockInv.col.pVente': 'سعر البيع',
    'stockInv.col.lieu': 'المكان',
    'stockInv.col.qteAjoutee': 'الكمية المضافة',
    'stockInv.col.stockTotal': 'إجمالي المخزون',
    'stockInv.col.magasin': 'المتجر',
    'stockInv.col.prixAchat': 'سعر الشراء (€)',
    'stockInv.col.prixVente': 'سعر البيع (€)',
    'stockInv.col.emplacement': 'الموقع',
    'stockInv.col.qte': 'الكمية',
    'stockInv.col.fournisseur': 'المورّد',
    'stockInv.location.boutique': 'المحل',
    'stockInv.location.depot': 'المستودع',
    'stockInv.header.title': 'جرد المخزون',
    'stockInv.header.subtitleMagasin': 'إدخال سريع · {{magasin}}',
    'stockInv.header.subtitleNoMagasin': 'إدخال سريع · اختر متجرًا',
    'stockInv.warn.pickMagasin': 'اختر متجرًا قبل حفظ الجرد.',
    'stockInv.cross.title': '{{count}} مرجع موجود بالفعل في متجر آخر',
    'stockInv.cross.explain': 'لقد أنشأت سطرًا جديدًا في متجرك الهدف. إذا كان ذلك مقصودًا (مخزون مخصّص لكل متجر)، فتجاهل هذه الرسالة. إذا كنت تريد التحويل، انتقل إلى',
    'stockInv.cross.explainTransfer': '→ تحويل.',
    'stockInv.cross.createdIn': 'أُنشئ في {{magasin}}',
    'stockInv.cross.existedIn': 'كان موجودًا في',
    'stockInv.cross.noMagasin': '— بدون متجر —',
    'stockInv.cross.qty': 'الكمية',
    'stockInv.badge.existing': 'موجود',
    'stockInv.badge.new': 'جديد',
    'stockInv.placeholder.refEan': 'المرجع / EAN',
    'stockInv.placeholder.ean13': 'رمز EAN13',
    'stockInv.placeholder.productName': 'اسم المنتج',
    'stockInv.placeholder.fournisseur': 'المورّد',
    'stockInv.footer.rows': 'سطر',
    'stockInv.footer.toSave': 'للحفظ',
    'stockInv.footer.existingCount': '({{count}} موجود)',
    'stockInv.footer.newCount': '({{count}} جديد)',
    'stockInv.footer.piecesAndValue': '{{count}} قطعة · {{value}} شراء',
    'stockInv.hint.enterBefore': 'اضغط',
    'stockInv.hint.enterKey': 'Enter',
    'stockInv.hint.enterAfter': 'للانتقال إلى السطر التالي',
    'stockInv.review.title': 'تحليل أولي للجرد',
    'stockInv.review.subtitle': '{{count}} سطر · متجر {{magasin}}',
    'staffChat.statusOnline': 'متصل',
    'staffChat.statusBusy': 'مشغول',
    'staffChat.statusAway': 'غائب',
    'staffChat.statusOffline': 'غير متصل',
    'staffChat.colorYellow': 'أصفر',
    'staffChat.colorBlue': 'أزرق',
    'staffChat.colorGreen': 'أخضر',
    'staffChat.colorOrange': 'برتقالي',
    'staffChat.colorPurple': 'بنفسجي',
    'staffChat.colorCyan': 'سماوي',
    'staffChat.colorRed': 'أحمر',
    'staffChat.quickRepliesTitle': 'ردود سريعة',
    'staffChat.quickRepliesSubtitle': 'خصّص ردود الدردشة',
    'staffChat.qrLabelPlaceholder': 'التسمية (مثال: جاهز!)',
    'staffChat.qrTextPlaceholder': 'نص الرسالة...',
    'staffChat.qrSaveEdit': 'حفظ',
    'staffChat.cancel': 'إلغاء',
    'staffChat.add': 'إضافة',
    'staffChat.filterAll': 'الكل',
    'staffChat.filterTeam': 'الفريق',
    'staffChat.filterClients': 'العملاء',
    'staffChat.filterTickets': 'التذاكر',
    'staffChat.filterQuick': 'سريعة',
    'staffChat.messaging': 'المراسلة',
    'staffChat.newConversation': 'محادثة جديدة',
    'staffChat.searchPlaceholder': 'البحث عن محادثة...',
    'staffChat.noStaffAvailable': 'لا يوجد عضو متاح',
    'staffChat.labelTeam': 'الفريق',
    'staffChat.labelOrder': 'طلب',
    'staffChat.labelRepair': 'إصلاح',
    'staffChat.labelClient': 'عميل',
    'staffChat.priorityUrgent': 'عاجل',
    'staffChat.priorityMedium': 'متوسط',
    'staffChat.priorityNormal': 'عادي',
    'staffChat.ticketsNone': 'لا توجد تذكرة معلّقة',
    'staffChat.ticketsAllHandled': 'تمت معالجة جميع الرسائل',
    'staffChat.timeAgoLessThanHour': 'منذ أقل من ساعة',
    'staffChat.timeAgoHours': 'منذ {{h}} ساعة',
    'staffChat.viewConversation': 'عرض المحادثة',
    'staffChat.close': 'إغلاق',
    'staffChat.recentlyClosed': 'مغلقة مؤخرًا',
    'staffChat.closedBy': 'بواسطة {{name}}',
    'staffChat.noConversations': 'لا توجد محادثة',
    'staffChat.conversation': 'محادثة',
    'staffChat.startConversation': 'ابدأ المحادثة',
    'staffChat.endToEndEncrypted': 'الرسائل مشفّرة من طرف إلى طرف',
    'staffChat.aiAssistant': 'المساعد الذكي',
    'staffChat.autoBadge': 'تلقائي',
    'staffChat.nudgeTitle': 'أرسل تنبيهًا!',
    'staffChat.sending': 'جارٍ الإرسال...',
    'staffChat.messagePlaceholder': 'اكتب رسالة...',
    'staffChat.selectConversation': 'اختر محادثة',
    'staffChat.chooseFromList': 'اختر من القائمة على اليمين',
    'warnDuplicateReference': 'موجود في المخزون بالفعل — +1 عند الحفظ',
    'warnDuplicateEan': 'رمز EAN موجود في المخزون بالفعل — +1 عند الحفظ',
    'warnCrossMagasin': 'المرجع موجود في متجر آخر',
    'warnLowVision': 'قراءة الصورة غير مؤكدة',
    'warnPrixAchatManual': 'سعر الشراء يُدخل يدويًا',
    'warnLlmUnavailable': 'رؤية الذكاء الاصطناعي غير متاحة (مفاتيح API)',
    'alertAddPhotoOrText': 'أضف صورة أو الصق نص الملصق.',
    'errAnalyzePhoto': 'خطأ في تحليل الصورة',
    'alertEnterPrixAchat': 'أدخل سعر الشراء لإعادة حساب سعر البيع.',
    'errCalcPrice': 'خطأ في حساب السعر',
    'alertRefDesignationRequired': 'المرجع والتسمية مطلوبان.',
    'alertPrixVenteRequired': 'سعر البيع مطلوب.',
    'noticeAddedToList': '+{{qty}} إلى القائمة: {{designation}} (الإجمالي +{{total}})',
    'noticeStockUpdate': 'تحديث المخزون: {{designation}} (+{{qty}})',
    'noticeAdded': 'تمت الإضافة: {{designation}} (×{{qty}})',
    'errServer': 'خطأ في الخادم',
    'alertChooseMagasin': 'اختر متجرًا.',
    'errAnalyzeImpossible': 'تعذّر التحليل',
    'summaryTitle': 'العناصر المسجّلة',
    'summarySubtitle': '{{created}} منشأ · {{updated}} محدّث · {{labels}} ملصق(ات) للطباعة',
    'printLabels': 'طباعة الملصقات ({{count}})',
    'newSession': 'جلسة جديدة',
    'colStatut': 'الحالة',
    'colReference': 'المرجع',
    'colDesignation': 'التسمية',
    'colPrixAchat': 'سعر الشراء',
    'colPrixVente': 'سعر البيع',
    'colQtyAdded': 'الكمية المضافة',
    'badgeNew': 'جديد',
    'badgeAddStock': '+مخزون',
    'pageTitle': 'تحليل منتج',
    'pageSubtitle': 'امسح عدة عناصر · تحقق من كل سطر · احفظ الكل دفعة واحدة',
    'pendingList': 'قائمة الانتظار — {{count}} عنصر · {{pieces}} قطعة',
    'saveAll': 'حفظ الكل ({{count}})',
    'badgeUpdate': 'تحديث',
    'depot': 'المستودع',
    'boutique': 'المتجر',
    'stockAbbrev': 'مخزون م:{{boutique}} خ:{{depot}}',
    'remove': 'إزالة',
    'photoSectionTitle': 'صورة المنتج',
    'productAlt': 'المنتج',
    'photoHint': 'المعرض أو الكاميرا — العبوة أو الملصق (رمز EAN ظاهر)',
    'gallery': 'المعرض',
    'camera': 'الكاميرا',
    'analyzing': 'جارٍ التحليل…',
    'analyze': 'تحليل',
    'aiVisionOption': 'رؤية الذكاء الاصطناعي إذا كان الملصق غير مقروء (OpenAI / Gemini)',
    'labelTextLabel': 'نص الملصق (اختياري — إذا كان الباركود غير مقروء)',
    'labelTextPlaceholder': 'شاشة iPhone 8 OLED\nEAN 3701234567890\nRef IP8-LCD-001',
    'emptyHint': 'ابدأ التحليل لتعبئة بطاقة المخزون مسبقًا.',
    'analyzingHint': 'قراءة الملصق والبحث عن المورّد…',
    'alreadyInStockPrefix': 'موجود في المخزون بالفعل ({{magasin}}) — الحفظ =',
    'alreadyInStockSuffix': '(المتجر {{boutique}} · المستودع {{depot}})',
    'alreadyInListPrefix': 'موجود في القائمة بالفعل (×{{qty}}) — القبول =',
    'alreadyInListSuffix': 'إلى القائمة',
    'currentStockBoutique': '(المخزون الحالي للمتجر: {{qty}})',
    'resultTitle': 'نتيجة التحليل',
    'readConfidence': 'ثقة القراءة: {{pct}}%',
    'aiVision': 'رؤية الذكاء الاصطناعي',
    'matchLabel': 'تطابق',
    'fieldDesignation': 'التسمية *',
    'fieldReference': 'المرجع *',
    'fieldCategorie': 'الفئة',
    'fieldFournisseur': 'المورّد',
    'otherSupplierParts': 'قطع أخرى من المورّد',
    'tarifsTitle': 'الأسعار',
    'fieldPrixAchat': 'سعر الشراء (€)',
    'autoSupplierCache': 'ذاكرة المورّد التلقائية',
    'fieldPrixVente': 'سعر البيع (€)',
    'recalcVente': 'إعادة حساب البيع',
    'laborLabel': 'اليد العاملة: {{amount}}',
    'detailTitle': 'تفاصيل حساب العرض التلقائي',
    'detailAchat': 'الشراء:',
    'detailPort': 'الشحن:',
    'detailDouane': 'الجمارك:',
    'detailCoutPiece': 'تكلفة القطعة:',
    'detailFinal': 'النهائي:',
    'qtyLocationTitle': 'الكمية والموقع',
    'quantite': 'الكمية',
    'quit': 'خروج',
    'acceptPlusOne': 'قبول (+1)',
    'acceptLine': 'قبول السطر',
    'acceptHelp': 'تكرار في القائمة أو المخزون = +1 تلقائيًا · ثم «حفظ الكل» · الملصقات في النهاية.',
    'reviewTitleAccept': 'هل هذا السطر صحيح؟',
    'reviewTitleBulk': 'التحقق قبل الحفظ',
    'reviewSubtitleAccept': 'أكّد للإضافة إلى القائمة، ثم امسح العنصر التالي',
    'reviewBulkSubtitle': '{{count}} عنصر للحفظ في المخزون',
    'avoirs.title': 'الأرصدة الدائنة',
    'avoirs.subtitle': 'رصيد دائن للعميل ناتج عن إيصال أو فاتورة — قابل للاستخدام في نقطة البيع',
    'avoirs.refresh': 'تحديث',
    'avoirs.errorLoad': 'خطأ في تحميل الأرصدة الدائنة',
    'avoirs.searchPlaceholder': 'مرجع الرصيد، الزبون، الإيصال الأصلي…',
    'avoirs.allStatuses': 'كل الحالات',
    'avoirs.empty': 'لا يوجد أي رصيد دائن',
    'avoirs.colRef': 'المرجع',
    'avoirs.colClient': 'الزبون',
    'avoirs.colOrigin': 'المصدر',
    'avoirs.colInitial': 'المبلغ الأولي',
    'avoirs.colSolde': 'الرصيد',
    'avoirs.colStatut': 'الحالة',
    'avoirs.colDate': 'التاريخ',
    'avoirs.createdBy': 'أنشأه',
    'avoirs.originLabel': 'المصدر:',
    'avoirs.motifLabel': 'السبب:',
    'avoirs.clientLabel': 'الزبون:',
    'avoirs.printTicket': 'طباعة إيصال الرصيد',
    'avoirs.downloadPdf': 'تنزيل PDF',
    'avoirs.historyTitle': 'سجل الحركات',
    'avoirs.cancelRemaining': 'إلغاء الرصيد المتبقي',
    'avoirs.confirmCancel': 'هل تريد إلغاء الرصيد المتبقي لـ {{ref}}؟',
    'avoirs.close': 'إغلاق',
    'avoirs.statutDisponible': 'متاح',
    'avoirs.statutPartiel': 'مُستخدَم جزئيًا',
    'avoirs.statutUtilise': 'مُستخدَم',
    'avoirs.statutAnnule': 'مُلغى',
    'stockMov.tab.dashboard': 'لوحة التحكم',
    'stockMov.tab.movements': 'الحركات',
    'stockMov.tab.imei': 'IMEI / الأرقام التسلسلية',
    'stockMov.tab.inventory': 'الجرد',
    'stockMov.header.title': 'المخزون المتقدم',
    'stockMov.header.subtitle': 'الحركات · IMEI · جلسات الجرد · لوحة التحكم',
    'stockMov.cancel': 'إلغاء',
    'stockMov.save': 'حفظ',
    'stockMov.saving': 'جارٍ الحفظ...',
    'stockMov.loadError': 'خطأ في التحميل',
    'stockMov.error': 'خطأ: {{detail}}',
    'stockMov.loading': 'جارٍ التحميل…',
    'stockMov.pageOf': 'صفحة {{page}} / {{total}}',
    'stockMov.kpi.totalArticles': 'إجمالي الأصناف',
    'stockMov.kpi.qteBoutique': 'كمية المتجر',
    'stockMov.kpi.qteDepot': 'كمية المستودع',
    'stockMov.kpi.ruptures': 'النفاد',
    'stockMov.kpi.imeiEnStock': 'IMEI في المخزون',
    'stockMov.boutique': 'المتجر',
    'stockMov.depot': 'المستودع',
    'stockMov.total': 'الإجمالي',
    'stockMov.valeurAchat': 'قيمة الشراء',
    'stockMov.valeurVente': 'قيمة البيع',
    'stockMov.marge': 'الهامش',
    'stockMov.margeTotale': 'إجمالي الهامش',
    'stockMov.stocksNegatifs': 'المخزون السالب ({{count}})',
    'stockMov.aucunStockNegatif': 'لا يوجد مخزون سالب',
    'stockMov.articlesSousSeuil': 'أصناف تحت الحد ({{count}})',
    'stockMov.tousAuDessusSeuil': 'جميع الأصناف فوق حد التنبيه الخاص بها',
    'stockMov.filter.all': 'الكل',
    'stockMov.filter.entrees': 'الإدخالات',
    'stockMov.filter.sorties': 'الإخراجات',
    'stockMov.magasinLabel': 'المتجر:',
    'stockMov.nouveauMouvement': 'حركة جديدة',
    'stockMov.col.date': 'التاريخ',
    'stockMov.col.type': 'النوع',
    'stockMov.col.motif': 'السبب',
    'stockMov.col.article': 'الصنف',
    'stockMov.col.magasin': 'المتجر',
    'stockMov.col.qte': 'الكمية',
    'stockMov.col.stockAvant': 'المخزون قبل',
    'stockMov.col.stockApres': 'المخزون بعد',
    'stockMov.col.imei': 'IMEI',
    'stockMov.col.par': 'بواسطة',
    'stockMov.aucunMouvement': 'لا توجد حركات مسجّلة',
    'stockMov.type.transfert': 'نقل',
    'stockMov.type.entree': 'إدخال',
    'stockMov.type.sortie': 'إخراج',
    'stockMov.modalNewMovement': 'حركة مخزون جديدة',
    'stockMov.field.motif': 'السبب',
    'stockMov.field.article': 'الصنف',
    'stockMov.searchArticlePlaceholder': 'ابحث عن صنف...',
    'stockMov.refStock': '({{ref}}) المخزون: {{qty}}',
    'stockMov.refShort': 'المرجع: {{ref}}',
    'stockMov.field.quantite': 'الكمية',
    'stockMov.field.prixUnitaire': 'سعر الوحدة',
    'stockMov.field.imeiOptional': 'IMEI / الرقم التسلسلي (اختياري)',
    'stockMov.imeiPlaceholder': 'مثال: 353012345678901',
    'stockMov.field.noteOptional': 'ملاحظة (اختياري)',
    'stockMov.commentPlaceholder': 'تعليق...',
    'stockMov.imeiRefRequired': 'الرقم IMEI والمرجع مطلوبان',
    'stockMov.refQtyRequired': 'المرجع والكمية مطلوبان',
    'stockMov.registreTitle': 'سجل IMEI — تتبّع الهواتف',
    'stockMov.registreDesc': 'يجب أن يكون لكل جهاز في المخزون رقم IMEI فريد. يتيح تتبّع السجل (الشراء، البيع عبر نقطة البيع، الإصلاح).',
    'stockMov.nouveauTelephone': 'هاتف جديد',
    'stockMov.searchImeiPlaceholder': 'ابحث عن IMEI أو صنف...',
    'stockMov.tousLesStatuts': 'جميع الحالات',
    'stockMov.enregistrerImei': 'تسجيل IMEI',
    'stockMov.col.imeiSerie': 'IMEI / الرقم التسلسلي',
    'stockMov.col.refDot': 'المرجع',
    'stockMov.col.magShort': 'المتجر',
    'stockMov.col.etat': 'الحالة',
    'stockMov.col.statut': 'الوضع',
    'stockMov.col.origine': 'المصدر',
    'stockMov.aucunImei': 'لا يوجد IMEI — أضِف هاتفًا إلى المخزون ثم سجّل رقمه هنا.',
    'stockMov.historique': 'السجل',
    'stockMov.historiqueImei': 'السجل · {{imei}}',
    'stockMov.byUser': 'بواسطة {{user}}',
    'stockMov.aucunMouvementImei': 'لا توجد حركات مرتبطة بهذا الـ IMEI.',
    'stockMov.modalRegisterImei': 'تسجيل رقم IMEI / رقم تسلسلي',
    'stockMov.field.articleStockRef': 'صنف المخزون (المرجع)',
    'stockMov.searchPlaceholder': 'ابحث...',
    'stockMov.field.etat': 'الحالة',
    'stockMov.field.origine': 'المصدر',
    'stockMov.origine.achat': 'شراء',
    'stockMov.origine.reprise_client': 'استبدال من العميل',
    'stockMov.origine.transfert': 'نقل',
    'stockMov.etat.neuf': 'جديد',
    'stockMov.etat.occasion': 'مستعمل',
    'stockMov.etat.reconditionne': 'مُجدَّد',
    'stockMov.etat.hs': 'معطّل',
    'stockMov.statut.en_stock': 'في المخزون',
    'stockMov.statut.vendu': 'مُباع',
    'stockMov.statut.reserve': 'محجوز',
    'stockMov.statut.en_reparation': 'قيد الإصلاح',
    'stockMov.motif.achat_fournisseur': 'شراء من المورّد',
    'stockMov.motif.retour_client': 'إرجاع من العميل',
    'stockMov.motif.correction_inventaire': 'تصحيح الجرد',
    'stockMov.motif.transfert_entrant': 'نقل وارد',
    'stockMov.motif.reception_commande': 'استلام طلب',
    'stockMov.motif.reintegration_reparation': 'إعادة إدخال بعد الإصلاح',
    'stockMov.motif.vente_pos': 'بيع عبر نقطة البيع',
    'stockMov.motif.consommation_reparation': 'استهلاك في الإصلاح',
    'stockMov.motif.perte_casse': 'فقدان / كسر',
    'stockMov.motif.retour_fournisseur': 'إرجاع إلى المورّد',
    'stockMov.motif.transfert_sortant': 'نقل صادر',
    'stockMov.motif.ajustement_inventaire': 'تسوية الجرد',
    'stockMov.sessionsInventaire': 'جلسات الجرد',
    'stockMov.nouvelInventaire': 'جرد جديد',
    'stockMov.aucuneSession': 'لا توجد جلسات جرد',
    'stockMov.parUser': 'بواسطة {{user}}',
    'stockMov.articlesEcarts': '{{articles}} صنف، {{ecarts}} فرق',
    'stockMov.status.enCours': 'قيد التنفيذ',
    'stockMov.status.valide': 'مُعتمَد',
    'stockMov.retourSessions': 'العودة إلى الجلسات',
    'stockMov.statutColon': 'الحالة:',
    'stockMov.validePar': 'اعتمده {{user}}',
    'stockMov.validerSansCorrection': 'اعتماد بدون تصحيح',
    'stockMov.validerCorriger': 'اعتماد + تصحيح المخزون',
    'stockMov.comptagePhysique': 'الجرد الفعلي',
    'stockMov.searchArticleShort': 'ابحث عن صنف...',
    'stockMov.inv.bdShort': 'متجر:{{b}} مستودع:{{d}}',
    'stockMov.stockSelectionne': 'المخزون المحدد:',
    'stockMov.dotBoutique': '· المتجر {{q}}',
    'stockMov.dotDepot': '· المستودع {{q}}',
    'stockMov.qteComptee': 'الكمية المعدودة',
    'stockMov.col.stockTheorique': 'المخزون النظري',
    'stockMov.col.comptagePhysique': 'الجرد الفعلي',
    'stockMov.col.ecart': 'الفرق',
    'stockMov.col.comptePar': 'عدّه',
    'stockMov.aucunArticleCompte': 'لم يُعَدّ أي صنف. ابدأ العدّ أعلاه.',
    'stockMov.modalNewSession': 'جلسة جرد جديدة',
    'stockMov.field.titreOptional': 'العنوان (اختياري)',
    'stockMov.titrePlaceholder': 'مثال: الجرد الشهري مارس 2026',
    'stockMov.creating': 'جارٍ الإنشاء...',
    'stockMov.creer': 'إنشاء',
    'stockMov.confirmValidateApply': 'اعتماد وتطبيق تصحيحات المخزون؟',
    'stockMov.confirmValidateNoApply': 'اعتماد دون تطبيق التصحيحات؟',
    'stockMov.sessionValidee': 'تم اعتماد الجلسة!',
    'stockMov.countSaved': 'تم حفظ العدّ: المخزون النظري {{theorique}}، الفعلي {{physique}}، الفرق {{ecart}}',
    'stock.err.templateDownload': 'حدث خطأ أثناء تنزيل القالب',
    'stock.err.missingId': 'خطأ: معرّف المادة مفقود',
    'stock.deleteSuccess': 'تم حذف المادة بنجاح',
    'stock.err.delete': 'حدث خطأ أثناء الحذف',
    'stock.confirmDeleteMany': 'حذف {{count}} مادة؟',
    'stock.err.update': 'حدث خطأ أثناء التحديث',
    'stock.err.transfer': 'خطأ في النقل',
    'stock.err.bulkTransfer': 'خطأ في النقل الجماعي',
    'stock.depotOnlyM1': 'المستودع متاح حاليًا على M1 فقط.',
    'stock.sameSourceDest': 'المصدر والوجهة متطابقان.',
    'stock.noLineToTransfer': 'لا يوجد سطر للنقل (كميات صفرية أو المتجر المصدر = الوجهة).',
    'stock.confirmBulkPublish': 'عرض {{count}} مادة للبيع عبر الإنترنت؟',
    'stock.confirmBulkUnpublish': 'إزالة {{count}} مادة من البيع عبر الإنترنت؟',
    'stock.confirmPublishOne': 'عرض «{{name}}» للبيع عبر الإنترنت؟',
    'stock.confirmUnpublishOne': 'إزالة «{{name}}» من البيع عبر الإنترنت؟',
    'stock.importDone': 'اكتمل الاستيراد',
    'stock.importCreated': 'تم إنشاؤها',
    'stock.importUpdated': 'تم تحديثها',
    'stock.importSkipped': 'تم تخطّيها',
    'stock.importErrors': 'أخطاء',
    'stock.importRetryHint': '{{count}} مادة موجودة مسبقًا — أعد التشغيل بوضع «تحديث».',
    'stock.importRetryBtn': 'إعادة التشغيل بالتحديث',
    'stock.importViewErrors': 'عرض الأخطاء ({{count}})',
    'stock.transferTitle': 'نقل المخزون',
    'stock.boutique': 'المحل',
    'stock.depot': 'المستودع',
    'stock.sourceStore': 'المتجر المصدر',
    'stock.sourceLocation': 'الموقع المصدر',
    'stock.destStore': 'المتجر الوجهة',
    'stock.destLocation': 'الموقع الوجهة',
    'stock.quantity': 'الكمية',
    'stock.availableAtSource': 'المتاح في المصدر: {{count}}',
    'stock.cancel': 'إلغاء',
    'stock.transferring': 'جارٍ النقل…',
    'stock.transfer': 'نقل',
    'stock.bulkTransferTitle': 'تغيير متجر {{count}} مادة',
    'stock.location': 'الموقع',
    'stock.bulkTransferR1Note': 'يتّبع النقل القاعدة R1: يحتفظ المستند المصدر بكمية 0 إذا أُفرغ، ويُنشأ مستند جديد في المتجر الوجهة.',
    'stock.colArticle': 'المادة',
    'stock.colCurrentStore': 'المتجر الحالي',
    'stock.colStock': 'المخزون',
    'stock.colQtyToTransfer': 'الكمية المراد نقلها',
    'stock.runTransfer': 'بدء النقل',
    'stock.resultSucceeded': 'ناجحة',
    'stock.resultFailed': 'فاشلة',
    'stock.resultUnitsTransferred': 'وحدات منقولة',
    'stock.failuresLabel': 'الإخفاقات:',
    'stock.done': 'إنهاء',
    'stock.storeN': 'المتجر {{n}}',
    'stock.tab.view': 'عرض',
    'stock.tab.inventory': 'الجرد',
    'stock.tab.analyze': 'تحليل المنتج',
    'stock.tab.history': 'السجل',
    'stock.tab.supplierOrders': 'تزويد المورّد',
    'stock.tab.invoiceImport': 'استيراد الفاتورة بالذكاء الاصطناعي',
    'stock.tab.labels': 'الملصقات',
    'stock.tab.advanced': 'المخزون المتقدّم',
    'stock.tab.reconciliation': 'التسوية',
    'stock.tab.config': 'الإعدادات',
    'posV2.remisePlafonneeMsg': 'الخصم محدود بنسبة {{pct}}٪. بما يتجاوز ذلك، يلزم موافقة الإدارة.',
    'posV2.venteNonEnregRemiseRamenee': 'لم يتم تسجيل البيع — تم إرجاع الخصم إلى الحد الأقصى؛ تحقق من الإجمالي ثم حصّل مرة أخرى.',
    'posV2.remiseRameneeVerif': 'تم إرجاع الخصم إلى الحد الأقصى — تحقق من الإجمالي ثم حصّل.',
    'posV2.catalogUnavailable': 'الكتالوج غير متاح',
    'posV2.paymentRefusedTpe': 'تم رفض الدفع أو إلغاؤه على جهاز الدفع — حاول مرة أخرى.',
    'posV2.caisseClosedOpenFirst': 'الصندوق {{mag}} مغلق — افتحه قبل التحصيل',
    'posV2.sumupCheckoutDesc': 'POS V2 · {{count}} سطر',
    'posV2.sumupTerminalNotConnected': 'جهاز SumUp غير متصل',
    'posV2.sumupSaleNotSaved': '{{msg}}. لم يتم تسجيل البيع (المخزون دون تغيير). تأكد من أن جهاز الدفع مشغّل ومتصل.',
    'posV2.cartEmpty': 'السلة فارغة',
    'posV2.lookupValidAvoir': 'ابحث عن إشعار دائن صالح قبل التحصيل',
    'posV2.printError': 'خطأ في الطباعة',
    'posV2.caisseClosedBanner': 'الصندوق {{mag}} مغلق.',
    'posV2.open': 'فتح',
    'posV2.oneEncaissementMultiStock': 'تحصيل واحد {{mag}} · مخزون متعدد المتاجر',
    'posV2.catalog': 'الكتالوج',
    'posV2.ficheButtonHint': 'زر البطاقة → معرض الصور',
    'posV2.all': 'الكل',
    'posV2.stockMag': 'مخزون {{mag}}',
    'posV2.catalogPlaceholder': 'الكتالوج…',
    'posV2.go': 'بحث',
    'posV2.catalogMeta': '{{total}} مرجع · {{scope}} · ص.{{page}}/{{pages}}',
    'posV2.enterAvoirRefOrClient': 'أدخل مرجع إشعار دائن أو اسم عميل',
    'posV2.avoirNotFound': 'الإشعار الدائن غير موجود',
    'posV2.productSheet': 'بطاقة المنتج',
    'posV2.productSheetSub': 'معرض · مخزون · إضافة إلى السلة',
    'posV2.ticketCenter': 'مركز الإيصالات',
    'posV2.ticketCenterSub': 'إيصالات حديثة · إعادة طباعة',
    'posV2.savStation': 'مركز خدمة ما بعد البيع والإصلاح',
    'posV2.savStationSub': 'البحث عن ملف · تحصيل المتبقي · دفعة مقدمة · السلة',
    'posV2.horsStock': 'خارج المخزون',
    'posV2.horsStockSub': 'بيع صنف عَرَضي · شارة خارج المخزون · تحصيل مباشر',
    'posV2.clientCenter': 'مركز العملاء',
    'posV2.clientCenterSub': 'السجل · الولاء · الربط بعملية التحصيل',
    'posV2.orders': 'الطلبات',
    'posV2.ordersSub': 'طلب العميل · طلبية · دفعة مقدمة · السلة',
    'openCaisse.denomBill': 'ورقة نقدية',
    'openCaisse.denomCoin': 'قطعة نقدية',
    'openCaisse.cardTotal': 'الإجمالي',
    'openCaisse.successOpen': 'تم فتح الصندوق {{magasin}} بنجاح.',
    'openCaisse.errorOpen': 'حدث خطأ أثناء فتح الصندوق',
    'openCaisse.backToDashboard': 'العودة إلى لوحة التحكم',
    'openCaisse.title': 'فتح الصندوق {{magasin}}',
    'openCaisse.titleForce': 'فتح قسري للصندوق {{magasin}}',
    'openCaisse.openingFund': 'رصيد الافتتاح',
    'openCaisse.openingFundHint': 'أدخل الأوراق النقدية والقطع النقدية لصندوق {{magasin}}.',
    'openCaisse.totalOpening': 'إجمالي الافتتاح',
    'openCaisse.forceWarning': 'سيؤدي هذا الإجراء إلى إغلاق الصندوق المفتوح للمتجر المستهدف ثم إنشاء صندوق جديد بهذا المبلغ.',
    'openCaisse.cancel': 'إلغاء',
    'openCaisse.opening': 'جارٍ الفتح...',
    'openCaisse.validateOpening': 'تأكيد الفتح',
    'calcul.title': 'أداة حساب السعر / عرض السعر',
    'calcul.subtitle': 'واجهة مطابقة لحاسبة PHP + إنشاء ملفات PDF بحجم 80مم وA4.',
    'calcul.clientSection': 'معلومات العميل',
    'calcul.clientName': 'اسم العميل',
    'calcul.phone': 'الهاتف',
    'calcul.email': 'البريد الإلكتروني',
    'calcul.saveClient': 'حفظ العميل',
    'calcul.deviceSection': 'اختيار الجهاز',
    'calcul.brand': 'الماركة',
    'calcul.model': 'الطراز',
    'calcul.itemsSection': 'العناصر',
    'calcul.itemDescription': 'القطعة / الوصف',
    'calcul.itemReference': 'مرجع القطعة',
    'calcul.itemPurchasePrice': 'سعر الشراء',
    'calcul.addLine': 'إضافة سطر',
    'calcul.paramsSection': 'الإعدادات',
    'calcul.quantity': 'الكمية',
    'calcul.labor': 'أجرة العمل (€)',
    'calcul.partReference': 'مرجع القطعة',
    'calcul.supplier': 'المورّد',
    'calcul.docType': 'نوع المستند',
    'calcul.docTypeDevis': 'عرض سعر',
    'calcul.docTypeFacture': 'فاتورة',
    'calcul.docTypeProforma': 'فاتورة مبدئية',
    'calcul.acceptOnlinePayment': 'قبول الدفع عبر الإنترنت (SumUp)',
    'calcul.acceptOnlinePaymentHint': 'سيتمكّن العميل من طلب رابط دفع SumUp',
    'calcul.saveTicket': '✅ حفظ الإيصال',
    'calcul.saving': 'جارٍ الحفظ...',
    'calcul.preview': '👁️ معاينة',
    'calcul.previewSection': 'المعاينة',
    'calcul.previewIframeTitle': 'معاينة الإيصال',
    'calcul.previewEmpty': 'ابدأ عملية حساب لعرض الإيصال.',
    'calcul.printTicket': 'طباعة الإيصال',
    'calcul.transformA4': 'التحويل إلى عرض سعر A4',
    'calcul.totalArticles': 'إجمالي العناصر',
    'calcul.totalPurchase': 'إجمالي الشراء',
    'calcul.shippingFees': 'رسوم الشحن',
    'calcul.customsFees': 'الرسوم الجمركية',
    'calcul.costPerPiece': 'التكلفة لكل قطعة',
    'calcul.finalPrice': 'السعر النهائي',
    'calcul.alertAllowPopups': 'يرجى السماح بالنوافذ المنبثقة للطباعة.',
    'calcul.alertAddItem': 'أضف عنصرًا واحدًا على الأقل مع سعر شراء.',
    'calcul.ticketSaved': '✅ تم حفظ الإيصال.',
    'calcul.errorGenerateTicket': 'خطأ أثناء إنشاء الإيصال',
    'calcul.errorPrintTicket': 'خطأ في طباعة الإيصال',
    'calcul.errorGenerateA4': 'خطأ أثناء إنشاء عرض السعر A4',
    'caisseHist.errPrint': 'خطأ في طباعة الصندوق',
    'caisseHist.errPrintGeneric': 'خطأ في الطباعة',
    'caisseHist.errLoadMonthly': 'خطأ في تحميل السجل الشهري',
    'caisseHist.errExport': 'خطأ في تصدير المحاسبة',
    'caisseHist.confirmForceClose': 'هل تريد الإغلاق الإجباري لصندوق يوم {{date}}؟ هذا الإجراء لا يمكن التراجع عنه.',
    'caisseHist.errForceClose': 'خطأ أثناء الإغلاق الإجباري',
    'caisseHist.title': 'سجل فتح / إغلاق الصندوق',
    'caisseHist.month': 'الشهر',
    'caisseHist.store': 'المتجر',
    'caisseHist.allStores': 'كل المتاجر',
    'caisseHist.exportAccounting': 'تصدير محاسبي',
    'caisseHist.totalSales': 'إجمالي المبيعات',
    'caisseHist.totalCash': 'إجمالي النقد',
    'caisseHist.totalCard': 'إجمالي البطاقة',
    'caisseHist.withdrawals': 'السحوبات',
    'caisseHist.totalTheoretical': 'الإجمالي النظري',
    'caisseHist.totalAccounting': 'الإجمالي المحاسبي',
    'caisseHist.discrepancy': 'الفرق',
    'caisseHist.validatedBy': 'تم التحقق بواسطة',
    'caisseHist.validationDate': 'تاريخ التحقق',
    'caisseHist.noValidatedCaisse': 'لا يوجد صندوق تم التحقق منه.',
    'caisseHist.opening': 'الفتح',
    'caisseHist.closing': 'الإغلاق',
    'caisseHist.caisse': 'الصندوق',
    'caisseHist.daySales': 'مبيعات اليوم',
    'caisseHist.dateStart': 'تاريخ البداية',
    'caisseHist.dateEnd': 'تاريخ النهاية',
    'caisseHist.reset': 'إعادة تعيين',
    'caisseHist.cashFloat': 'رصيد الصندوق',
    'caisseHist.openedBy': 'فُتح بواسطة',
    'caisseHist.closedBy': 'أُغلق بواسطة',
    'caisseHist.noHistory': 'لا يوجد سجل متاح',
    'caisseHist.closingProgress': 'جارٍ الإغلاق...',
    'caisseHist.forceClose': 'إغلاق (إجباري)',
    'caisseHist.forced': 'إجباري',
    'caisseHist.showMore': 'عرض المزيد ({{count}} عمليات فتح سابقة)',
    'caisseHist.showLess': 'عرض أقل',
    'repairDetail.popupBlocked': 'يرجى السماح بالنوافذ المنبثقة للطباعة.',
    'repairDetail.downloadError': 'خطأ أثناء التنزيل',
    'repairDetail.statusUpdateError': 'خطأ أثناء التحديث',
    'repairDetail.invalidAmount': 'مبلغ غير صالح',
    'repairDetail.genericError': 'خطأ',
    'repairDetail.filesAttached': '{{count}} ملف (ملفات) مُرفقة',
    'repairDetail.uploadProgress': 'جارٍ الرفع {{current}}/{{total}}…',
    'repairDetail.addNoteError': 'حدث خطأ أثناء إضافة الملاحظة',
    'repairDetail.confirmDeleteNote': 'حذف هذه الملاحظة؟',
    'repairDetail.notFound': 'تعذّر العثور على الإصلاح',
    'repairDetail.backToRepairs': 'العودة إلى الإصلاحات',
    'repairDetail.photosTitle': 'الصور ({{count}})',
    'repairDetail.photoAlt': 'صورة {{index}}',
    'repairDetail.notesTitle': 'الملاحظات ({{count}})',
    'repairDetail.notePlaceholder': 'إضافة ملاحظة...',
    'repairDetail.visibilityPublic': 'عام',
    'repairDetail.visibilityInternal': 'داخلي',
    'repairDetail.filesBtn': 'ملفات',
    'repairDetail.sending': 'جارٍ الإرسال...',
    'repairDetail.add': 'إضافة',
    'repairDetail.noNotes': 'لا توجد ملاحظات',
    'repairDetail.staffDefault': 'الموظف',
    'repairDetail.printAcompteError': 'خطأ في طباعة إيصال العربون',
    'repairDetail.printAvoirError': 'خطأ في طباعة إيصال الرصيد الدائن',
    'repairDetail.downloadPdfError': 'خطأ في تنزيل ملف PDF',
    'repairDetail.changeStatus': 'تغيير الحالة',
    'repairDetail.noStatusChange': 'لا يوجد تغيير مسموح به',
    'repairDetail.addDeposit': 'إضافة عربون',
    'repairDetail.amountLabel': 'المبلغ (€)',
    'repairDetail.paymentMode': 'طريقة الدفع',
    'repairDetail.paymentCash': 'نقداً',
    'repairDetail.paymentCard': 'بطاقة',
    'repairDetail.paymentTransfer': 'تحويل',
    'repairDetail.paymentCheck': 'شيك',
    'repairDetail.cancel': 'إلغاء',
    'repairDetail.statusRecu': 'مستلَم',
    'repairDetail.statusEnCours': 'قيد التنفيذ',
    'repairDetail.statusAttentePieces': 'بانتظار القطع',
    'repairDetail.statusPieceArrivee': 'وصلت القطعة',
    'repairDetail.statusNonReparable': 'غير قابل للإصلاح',
    'repairDetail.statusTermine': 'مكتمل',
    'repairDetail.statusLivre': 'تم التسليم',
    'repairDetail.statusAttenteDepot': 'بانتظار إيداع الجهاز',
    'closeCaisse.denomBillet': 'ورقة نقدية',
    'closeCaisse.denomPiece': 'قطعة نقدية',
    'closeCaisse.countBadge': '× {{count}}',
    'closeCaisse.total': 'المجموع',
    'closeCaisse.errLoad': 'خطأ أثناء تحميل الصندوق',
    'closeCaisse.errPdf': 'خطأ أثناء إنشاء ملف PDF',
    'closeCaisse.errConfirmCb': 'يرجى تأكيد مدفوعات البطاقة قبل إغلاق الصندوق',
    'closeCaisse.confirmEcart': 'تنبيه: تم رصد فارق قدره {{ecart}}.\n\nالإجمالي النظري: {{theorique}}\nالإجمالي المعدود: {{compte}}\n\nهل تريد المتابعة؟',
    'closeCaisse.closeSuccess': 'تم إغلاق الصندوق {{magasin}} بنجاح.',
    'closeCaisse.errClose': 'خطأ أثناء إغلاق الصندوق',
    'closeCaisse.backToDashboard': 'العودة إلى لوحة التحكم',
    'closeCaisse.journee': 'يوم {{date}}',
    'closeCaisse.openedBy': 'فُتح بواسطة {{name}}',
    'closeCaisse.refresh': 'تحديث',
    'closeCaisse.summaryTitle': 'ملخص الصندوق',
    'closeCaisse.activitySummary': 'نشاط المتجر {{magasin}} — {{ops}} عملية ({{pos}} مبيعات نقطة البيع، {{acomptes}} دفعات مقدمة).',
    'closeCaisse.fondOuverture': 'رصيد الافتتاح',
    'closeCaisse.ventesEspeces': 'المبيعات النقدية',
    'closeCaisse.ventesCb': 'مبيعات البطاقة',
    'closeCaisse.paiementsStripe': 'مدفوعات Stripe',
    'closeCaisse.acomptes': 'الدفعات المقدمة',
    'closeCaisse.retraits': 'السحوبات',
    'closeCaisse.totalTheorique': 'الإجمالي النظري',
    'closeCaisse.totalVentes': 'إجمالي المبيعات: {{montant}}',
    'closeCaisse.activiteVendeur': 'النشاط حسب البائع',
    'closeCaisse.colVendeur': 'البائع',
    'closeCaisse.colOps': 'عمليات',
    'closeCaisse.colEspeces': 'نقدًا',
    'closeCaisse.colCb': 'بطاقة',
    'closeCaisse.comptageEspeces': 'جرد النقد',
    'closeCaisse.comptageSubtitle': 'الأوراق والقطع النقدية مع تفصيل مرئي للإغلاق.',
    'closeCaisse.totalCompte': 'الإجمالي المعدود',
    'closeCaisse.ecart': 'الفارق',
    'closeCaisse.ecartImportant': 'تم رصد فارق كبير',
    'closeCaisse.infosComplementaires': 'معلومات إضافية',
    'closeCaisse.montantCoffreLabel': 'المبلغ المودع في الخزنة (EUR)',
    'closeCaisse.montantCoffreHint': 'المبلغ النقدي المودع في الخزنة.',
    'closeCaisse.cbConfirmLabel': 'لقد أكّدت مدفوعات البطاقة',
    'closeCaisse.cbConfirmHint': 'تأكّد من أن جميع مدفوعات البطاقة تم تحصيلها على الجهاز.',
    'closeCaisse.imprimerRapport': 'طباعة التقرير',
    'closeCaisse.validerCaisse': 'اعتماد الصندوق',
    'closeCaisse.onlyAdmin': 'يمكن للمسؤول فقط اعتماد إغلاق الصندوق',
    'paiements.title': 'المدفوعات عبر الإنترنت',
    'paiements.proofsToValidate': '{{count}} إثبات بانتظار التحقق',
    'paiements.pendingCount': '{{count}} قيد الانتظار',
    'paiements.tabSumup': 'مدفوعات SumUp ({{count}})',
    'paiements.tabProofs': 'إثباتات الدفع ({{count}})',
    'paiements.noProof': 'لا يوجد إثبات دفع',
    'paiements.orderDefault': 'طلب',
    'paiements.proofValidated': 'تم التحقق',
    'paiements.proofPendingValidation': 'بانتظار التحقق',
    'paiements.totalLabel': 'الإجمالي: ',
    'paiements.sentLabel': 'أُرسلت: ',
    'paiements.byLabel': 'بواسطة: ',
    'paiements.validatedByLabel': 'تم التحقق بواسطة: ',
    'paiements.viewCapture': 'عرض اللقطة',
    'paiements.validatePayment': 'تأكيد الدفع',
    'paiements.reject': 'رفض',
    'paiements.confirmOrder': 'تأكيد الطلب',
    'paiements.filterAll': 'الكل',
    'paiements.filterPending': 'قيد الانتظار',
    'paiements.filterConfirmed': 'مؤكَّدة',
    'paiements.filterCancelled': 'ملغاة',
    'paiements.noPayment': 'لا يوجد دفع',
    'paiements.amountLabel': 'المبلغ: ',
    'paiements.refLabel': 'المرجع: ',
    'paiements.dateLabel': 'التاريخ: ',
    'paiements.ticketPdf': 'إيصال PDF',
    'paiements.validate': 'تأكيد',
    'paiements.cancel': 'إلغاء',
    'paiements.statusPaidApplied': 'مؤكَّد',
    'paiements.statusPaidPending': 'قيد الانتظار',
    'paiements.statusPending': 'قيد التنفيذ',
    'paiements.statusCancelled': 'ملغى',
    'paiements.orderRepair': 'إصلاح {{ref}}',
    'paiements.orderBoutique': 'طلب من المتجر',
    'paiements.alertConfirmed': 'تم تأكيد الدفع وتطبيقه!',
    'paiements.errorConfirm': 'خطأ أثناء التأكيد',
    'paiements.confirmCancel': 'إلغاء هذا الدفع؟',
    'paiements.error': 'خطأ',
    'paiements.errorTicket': 'خطأ أثناء تنزيل الإيصال',
    'paiements.confirmValidateProof': 'تأكيد إثبات الدفع هذا؟',
    'paiements.alertProofValidated': 'تم التحقق من الدفع!',
    'paiements.confirmRejectProof': 'رفض إثبات الدفع هذا؟',
    'paiements.confirmConfirmOrder': 'تأكيد هذا الطلب؟',
    'paiements.alertOrderConfirmed': 'تم تأكيد الطلب!',
    'repairForm.deviceNotFound': 'الجهاز غير موجود',
    'repairForm.selectMagasinFirst': 'اختر أولاً المتجر الذي يتولى هذا الإصلاح.',
    'repairForm.saveError': 'حدث خطأ أثناء الحفظ',
    'repairForm.conversionFromCommande': 'تحويل من طلب',
    'repairForm.prefillNotice': 'معلومات معبأة مسبقًا · العربون ({{amount}}) يُحوَّل عند الإنهاء.',
    'repairForm.sectionMagasin': 'المتجر',
    'repairForm.magasinLabel': 'المتجر المستلِم *',
    'repairForm.selectMagasinOption': '— اختر متجرًا —',
    'repairForm.sectionForcedEntry': 'تسجيل إجباري',
    'repairForm.forcedEntryHint': 'لإيداع منسيّ: سجّل الإصلاح بتاريخ الإيداع الفعلي (ليس تاريخ اليوم).',
    'repairForm.useBackdateLabel': 'استخدام تاريخ إيداع سابق',
    'repairForm.realDepotDateTime': 'تاريخ ووقت الإيداع الفعلي',
    'repairForm.sectionClient': 'العميل',
    'repairForm.clientName': 'اسم العميل *',
    'repairForm.phone': 'الهاتف *',
    'repairForm.email': 'البريد الإلكتروني',
    'repairForm.address': 'العنوان',
    'repairForm.sectionDevice': 'الجهاز',
    'repairForm.brand': 'العلامة التجارية *',
    'repairForm.model': 'الطراز *',
    'repairForm.problem': 'المشكلة',
    'repairForm.technician': 'الفنّي',
    'repairForm.selectOption': '— اختر —',
    'repairForm.imeiSerial': 'IMEI / الرقم التسلسلي',
    'repairForm.deviceLock': 'رمز القفل',
    'repairForm.sectionParts': 'القطع',
    'repairForm.defectivePartsHint': 'القطع غير العاملة عند الاستلام',
    'repairForm.phoneDoesntTurnOn': 'الهاتف لا يعمل',
    'repairForm.sectionStockParts': 'قطع من المخزون (اختياري)',
    'repairForm.stockPartsHint': 'إذا كانت القطعة متوفرة في مخزون المتجر، فسيتم خصمها عند الإنشاء وإعادة احتساب سعر الإصلاح وفق أسعار الكتالوج. وإلا، أدخل سعرًا يدويًا أدناه (عرض سعر تقديري).',
    'repairForm.stockPartsTotal': 'إجمالي قطع المخزون: {{amount}} — يُطبَّق عند الإنشاء إن توفّرت.',
    'repairForm.sectionPricing': 'الأسعار',
    'repairForm.priceRepair': 'سعر الإصلاح (€)',
    'repairForm.theoreticalQuote': '— عرض سعر تقديري',
    'repairForm.priceDiagnostic': 'سعر التشخيص (€)',
    'repairForm.receptionNotes': 'ملاحظات الاستلام',
    'repairForm.sectionPhotos': 'الصور',
    'repairForm.addPhoto': 'إضافة',
    'repairForm.cancel': 'إلغاء',
    'repairForm.save': 'حفظ',
    'repairForm.createRepair': 'إنشاء الإصلاح',
    'repairForm.parts.speaker': 'السمّاعة الخارجية',
    'repairForm.parts.lcd': 'الشاشة',
    'repairForm.parts.front_cam': 'الكاميرا الأمامية',
    'repairForm.parts.back_cam': 'الكاميرا الخلفية',
    'repairForm.parts.microphone': 'الميكروفون',
    'repairForm.parts.fingerprint': 'بصمة الإصبع',
    'repairForm.parts.home_button': 'زر الرئيسية',
    'repairForm.parts.volume_button': 'زر الصوت',
    'repairForm.parts.power_button': 'زر التشغيل',
    'repairForm.parts.signal_carrier': 'الإشارة',
    'repairForm.parts.battery': 'البطارية',
    'repairForm.parts.wifi_bt': 'واي فاي/بلوتوث',
    'repairForm.parts.ear_speaker': 'سمّاعة الأذن',
    'repairForm.parts.charging_port': 'منفذ الشحن',
    'labels.barcodeAuto': 'سيتم إنشاء EAN13 تلقائيًا',
    'labels.allowPopups': 'يرجى السماح بالنوافذ المنبثقة للطباعة.',
    'labels.selectAtLeastOne': 'اختر منتجًا واحدًا على الأقل',
    'labels.errorGenerate': 'خطأ في إنشاء الملصقات',
    'labels.infoNoEan': 'معلومة: {{count}} منتج بدون EAN — تم إنشاء EAN13 داخلي تلقائيًا. الإجمالي: {{total}} ملصق.',
    'labels.jobCreated': 'تم إنشاء مهمة طباعة ({{count}} ملصق).\nالمعرّف: {{id}}...\nسيقوم وكيل Bixolon بجلب هذه الدفعة.',
    'labels.jobNoEan': '\nملاحظة: {{count}} بدون EAN (تم إنشاؤه تلقائيًا).',
    'labels.errorBatch': 'خطأ في الطباعة بالدفعات',
    'labels.generating': 'جارٍ الإنشاء...',
    'labels.generatePdf': 'إنشاء PDF ({{count}})',
    'labels.previewPdf': 'معاينة PDF ({{count}})',
    'labels.printBixolon': 'طباعة Bixolon ({{count}})',
    'labels.clear': 'إفراغ',
    'labels.format': 'التنسيق',
    'labels.formatBixolon': 'Bixolon 50 × 30 مم (حرارية)',
    'labels.formatA4': 'ورقة A4 (قديمة)',
    'labels.pageTitle': 'ملصقات المنتجات',
    'labels.pageSubtitle': 'ملصقات منتجات قابلة للتخصيص',
    'labels.config': 'إعدادات',
    'labels.searchPlaceholder': 'ابحث عن منتج...',
    'labels.boutique': 'المتجر',
    'labels.depot': 'المستودع',
    'labels.deselectAll': 'إلغاء تحديد الكل',
    'labels.colProduct': 'المنتج',
    'labels.colPrice': 'السعر',
    'labels.colBoutiqueShort': 'المتجر',
    'labels.colQtyToPrint': 'الكمية للطباعة',
    'labels.noProduct': 'لا يوجد منتج',
    'labels.autoShort': 'تلقائي',
    'labels.previewTitle': 'معاينة الملصق',
    'labels.refLabel': 'المرجع:',
    'labels.selectedProducts': 'المنتجات المحددة',
    'labels.totalLabels': 'إجمالي الملصقات',
    'labels.autoGenAtPdf': 'يتم إنشاؤه تلقائيًا في ملف PDF',
    'labels.selectToPreview': 'اختر منتجًا للمعاينة',
    'labels.batchVeryLarge': 'دفعة كبيرة جدًا',
    'labels.batchConfirmTitle': 'تأكيد الدفعة الكبيرة',
    'labels.confirmBodyPrefix': 'أنت على وشك إنشاء',
    'labels.confirmBodySuffix': 'ملصق.',
    'labels.estRoll': '≈ {{meters}} م من اللفة (50×30مم)',
    'labels.estTime': '≈ {{minutes}} دقيقة طباعة (~1.5 ثانية/ملصق)',
    'labels.cancel': 'إلغاء',
    'labels.confirmAnyway': 'تأكيد على أي حال',
    'labels.continue': 'متابعة',
    'rep.status.awaitingDeposit': 'بانتظار إحضار الجهاز',
    'rep.status.received': 'مُستلَم',
    'rep.status.inProgress': 'قيد التنفيذ',
    'rep.status.awaitingParts': 'بانتظار القطع',
    'rep.status.completed': 'مكتمل',
    'rep.status.notRepairable': 'غير قابل للإصلاح',
    'rep.status.delivered': 'تم التسليم',
    'rep.status.refused': 'مرفوض',
    'rep.payCash': 'نقداً',
    'rep.payCard': 'بطاقة مصرفية',
    'rep.payTransfer': 'تحويل بنكي',
    'rep.payCheck': 'شيك',
    'rep.accept': 'قبول',
    'rep.addError': 'حدث خطأ أثناء الإضافة',
    'rep.adminOnlyStatus': 'لا يمكن تغيير هذه الحالة إلا للمسؤول.',
    'rep.allowPopups': 'يُرجى السماح بالنوافذ المنبثقة للطباعة.',
    'rep.chatTitle': 'محادثة الإصلاح {{ref}}',
    'rep.confirmArrivalAsk': 'تأكيد استلام الجهاز {{ref}} في المتجر؟',
    'rep.confirmArrivalDone': 'تم تأكيد الجهاز! الإصلاح نشط الآن.',
    'rep.confirmArrivalError': 'حدث خطأ أثناء التأكيد',
    'rep.created': 'تم الإنشاء',
    'rep.currentStatus': 'الحالة الحالية:',
    'rep.deleteError': 'حدث خطأ أثناء الحذف',
    'rep.deleteRecordAsk': 'حذف هذا السجل؟',
    'rep.deleteStatusAsk': 'حذف الحالة «{{name}}»؟',
    'rep.depositAmountEuro': 'مبلغ العربون (€)',
    'rep.diagnosticPaid': 'تم دفع التشخيص',
    'rep.diagnosticRemaining': 'التشخيص: {{amount}} متبقٍ',
    'rep.downloadError': 'حدث خطأ أثناء التنزيل',
    'rep.error': 'خطأ',
    'rep.invalidAmount': 'مبلغ غير صالح',
    'rep.newStatus': 'حالة جديدة',
    'rep.noDeposits': 'لم يُدفع أي عربون',
    'rep.noOnlineRequests': 'لا توجد طلبات إلكترونية معلّقة',
    'rep.onlineRequests': 'الطلبات الإلكترونية ({{count}})',
    'rep.or': 'أو',
    'rep.pointAtTicketQr': 'وجّه الكاميرا نحو رمز QR الموجود على الإيصال',
    'rep.printAcompteError': 'خطأ في طباعة إيصال العربون',
    'rep.qrPrintHint': 'امسح الرمز لتتبّع إصلاحك',
    'rep.qrSearchPlaceholder': 'مثال: REM0094',
    'rep.qrTrackingHint': 'يمسح العميل رمز QR هذا لتتبّع إصلاحه في الوقت الفعلي',
    'rep.qrTrackingTitle': 'رمز QR للتتبّع',
    'rep.reference': 'المرجع:',
    'rep.repair': 'الإصلاح',
    'rep.scanOrEnterRef': 'امسح رمز QR أو أدخل المرجع',
    'rep.scanWithCamera': 'المسح بالكاميرا',
    'rep.searchRepair': 'البحث عن إصلاح',
    'rep.statusManagement': 'إدارة الحالات',
    'rep.ticket': 'إيصال',
    'rep.updateError': 'حدث خطأ أثناء التحديث',
    'rep.bulkNoteSentSingular': 'تم إرسال الملاحظة إلى {{count}} ملف{{skip}}.',
    'rep.bulkNoteSentPlural': 'تم إرسال الملاحظة إلى {{count}} ملفات{{skip}}.',
    'rep.bulkNoteSkippedSingular': '(تم تجاهل {{count}})',
    'rep.bulkNoteSkippedPlural': '(تم تجاهل {{count}})',
    'devisDepl.title': 'عروض أسعار الزيارة المنزلية',
    'devisDepl.subtitle': 'إدارة عروض الأسعار للإصلاحات المنزلية',
    'devisDepl.newDevis': 'عرض سعر جديد',
    'devisDepl.exportCsv': 'تصدير CSV',
    'devisDepl.remindBtn': 'تذكير ({{count}})',
    'devisDepl.sending': 'جارٍ الإرسال...',
    'devisDepl.send': 'إرسال',
    'devisDepl.cancel': 'إلغاء',
    'devisDepl.errGeneric': 'خطأ',
    'devisDepl.confirmSendReminders': 'إرسال تذكير إلى {{count}} عميل لديهم عروض أسعار معلّقة منذ أكثر من 3 أيام؟',
    'devisDepl.remindersSent': 'تم إرسال {{count}} تذكير!',
    'devisDepl.sentByEmail': 'تم إرسال عرض السعر بالبريد الإلكتروني!',
    'devisDepl.errSend': 'خطأ في الإرسال',
    'devisDepl.confirmDelete': 'حذف عرض السعر هذا؟',
    'devisDepl.searchPlaceholder': 'بحث بالمرجع أو الاسم أو البريد...',
    'devisDepl.noResults': 'لا توجد نتائج',
    'devisDepl.empty': 'لم يتم إنشاء أي عرض سعر',
    'devisDepl.travelFeeLabel': 'رسوم التنقل',
    'devisDepl.invalidAmount': 'مبلغ غير صالح',
    'devisDepl.errPayment': 'خطأ في الدفع',
    'devisDepl.confirmStaffAccept': 'اعتماد عرض السعر هذا؟ سيتم إنشاء أمر شراء وفاتورة.',
    'devisDepl.errValidation': 'خطأ في الاعتماد',
    'devisDepl.reminderSent': 'تم إرسال التذكير',
    'devisDepl.errSendReminder': 'خطأ في إرسال التذكير',
    'devisDepl.confirmValidateBon': 'اعتماد أمر الشراء؟',
    'devisDepl.errSendFacture': 'خطأ في إرسال الفاتورة',
    'devisDepl.confirmDetach': 'فصل عرض السعر هذا عن الإصلاح {{ref}}؟',
    'devisDepl.status.pending': 'قيد الانتظار',
    'devisDepl.status.accepted': 'مقبول',
    'devisDepl.status.refused': 'مرفوض',
    'devisDepl.status.depositPaid': 'تم دفع العربون',
    'devisDepl.status.paid': 'مدفوع',
    'devisDepl.stats.total': 'الإجمالي',
    'devisDepl.stats.pending': 'قيد الانتظار',
    'devisDepl.stats.accepted': 'مقبولة',
    'devisDepl.stats.refused': 'مرفوضة',
    'devisDepl.stats.revenue': 'الإيرادات',
    'devisDepl.filter.all': 'كل الحالات',
    'devisDepl.requests.title': 'طلبات عروض الأسعار الواردة',
    'devisDepl.requests.newCountSingular': '{{count}} جديد',
    'devisDepl.requests.newCountPlural': '{{count}} جديدة',
    'devisDepl.requests.defaultTitle': 'طلب عرض سعر',
    'devisDepl.requests.statusNew': 'جديد',
    'devisDepl.requests.statusInProgress': 'قيد المعالجة',
    'devisDepl.requests.statusRefused': 'مرفوض',
    'devisDepl.requests.statusTreated': 'تمت المعالجة',
    'devisDepl.requests.client': 'عميل',
    'devisDepl.requests.addressLabel': 'العنوان',
    'devisDepl.requests.createDevis': 'إنشاء عرض سعر',
    'devisDepl.requests.markTreated': 'تمت المعالجة',
    'devisDepl.requests.refuse': 'رفض',
    'devisDepl.requests.refuseMotifLabel': 'سبب الرفض',
    'devisDepl.requests.refuseMotifPlaceholder': 'سبب الرفض (اختياري)...',
    'devisDepl.requests.confirmRefuse': 'تأكيد الرفض',
    'devisDepl.requests.refuseMotifShownLabel': 'سبب الرفض:',
    'devisDepl.sumup.title': 'طلبات رابط SumUp',
    'devisDepl.sumup.pendingCount': '{{count}} قيد الانتظار',
    'devisDepl.sumup.enterLinkAlert': 'يرجى إدخال رابط SumUp',
    'devisDepl.sumup.linkSentAlert': 'تم إرسال رابط SumUp إلى العميل بالبريد الإلكتروني!',
    'devisDepl.sumup.linkPlaceholder': 'الصق رابط SumUp هنا...',
    'devisDepl.chart.title': 'النشاط خلال آخر 30 يومًا',
    'devisDepl.chart.accepted': 'مقبولة',
    'devisDepl.chart.pending': 'قيد الانتظار',
    'devisDepl.chart.refused': 'مرفوضة',
    'devisDepl.chart.noData': 'لا توجد بيانات لهذه الفترة',
    'devisDepl.form.editTitle': 'تعديل عرض السعر',
    'devisDepl.form.newTitle': 'عرض سعر جديد',
    'devisDepl.form.clientName': 'اسم العميل *',
    'devisDepl.form.searchPlaceholder': 'اكتب للبحث...',
    'devisDepl.form.phone': 'الهاتف',
    'devisDepl.form.email': 'البريد الإلكتروني *',
    'devisDepl.form.emailPlaceholder': 'email@example.com',
    'devisDepl.form.address': 'العنوان',
    'devisDepl.form.addressPlaceholder': 'عنوان العميل',
    'devisDepl.form.descriptionLabel': 'وصف الإصلاح',
    'devisDepl.form.descriptionPlaceholder': 'وصف العمل المطلوب تنفيذه...',
    'devisDepl.form.lines': 'بنود عرض السعر',
    'devisDepl.form.addLine': 'إضافة',
    'devisDepl.form.designation': 'البيان',
    'devisDepl.form.price': 'السعر',
    'devisDepl.form.travelFee': 'رسوم التنقل ({{amount}})',
    'devisDepl.form.acceptOnline': 'قبول الدفع عبر الإنترنت (SumUp)',
    'devisDepl.form.acceptOnlineHint': 'سيتمكن العميل من طلب رابط دفع SumUp',
    'devisDepl.form.total': 'الإجمالي',
    'devisDepl.form.submitEdit': 'تحديث',
    'devisDepl.form.submitCreate': 'إنشاء عرض السعر',
    'devisDepl.form.nameEmailRequired': 'اسم العميل والبريد الإلكتروني مطلوبان',
    'devisDepl.form.atLeastOneLine': 'أضف بندًا واحدًا على الأقل مع البيان والسعر',
    'devisDepl.detail.phone': 'الهاتف:',
    'devisDepl.detail.address': 'العنوان:',
    'devisDepl.detail.purchaseOrder': 'أمر الشراء:',
    'devisDepl.detail.invoice': 'الفاتورة:',
    'devisDepl.detail.emailSentOn': 'أُرسل البريد في {{date}}',
    'devisDepl.detail.reminderSentOn': 'أُرسل التذكير في {{date}}',
    'devisDepl.table.designation': 'البيان',
    'devisDepl.table.qty': 'الكمية',
    'devisDepl.table.price': 'السعر',
    'devisDepl.table.total': 'الإجمالي',
    'devisDepl.actions.validateDevis': 'اعتماد عرض السعر',
    'devisDepl.actions.sendByEmail': 'إرسال عرض السعر بالبريد',
    'devisDepl.actions.remindAcceptance': 'تذكير بالقبول',
    'devisDepl.actions.edit': 'تعديل',
    'devisDepl.actions.validateBon': 'اعتماد أمر الشراء',
    'devisDepl.actions.bonValidated': 'تم اعتماد الأمر',
    'devisDepl.actions.remindPayment': 'تذكير بالدفع',
    'devisDepl.actions.pdfDevis': 'PDF عرض السعر',
    'devisDepl.actions.pdfBon': 'PDF أمر الشراء',
    'devisDepl.actions.pdfFacture': 'PDF الفاتورة',
    'devisDepl.actions.sendFactureEmail': 'إرسال الفاتورة بالبريد',
    'devisDepl.actions.registerPayment': 'تسجيل الدفع',
    'devisDepl.actions.delete': 'حذف',
    'devisDepl.actions.linkedTo': 'مرتبط بـ {{ref}}',
    'devisDepl.actions.attachToRepair': 'ربط بإصلاح',
    'devisDepl.payment.title': 'تسجيل دفعة',
    'devisDepl.payment.devisLabel': 'عرض السعر:',
    'devisDepl.payment.totalLabel': 'الإجمالي:',
    'devisDepl.payment.methodLabel': 'طريقة الدفع',
    'devisDepl.payment.cash': 'نقدًا',
    'devisDepl.payment.card': 'بطاقة',
    'devisDepl.payment.transfer': 'تحويل',
    'devisDepl.payment.mixed': 'مختلط',
    'devisDepl.payment.amount': 'المبلغ',
    'devisDepl.payment.noteLabel': 'ملاحظة (اختياري)',
    'devisDepl.payment.notePlaceholder': 'مثال: عربون، رصيد متبقٍ...',
    'devisDepl.payment.submit': 'تأكيد الدفع',
    'reviews.ratingFallback': 'عملاؤنا يقيّموننا على Google',
    'reviews.subtitle': 'اطّلع على آراء عملائنا على Google وشاركنا تجربتك.',
    'reviews.readCta': 'اقرأ تقييماتنا على Google',
    'reviews.writeCta': 'اترك تقييماً',
    'acompteStart.title': 'عربون عرض السعر الخاص بك',
    'acompteStart.subtitle': 'Resurrection Mobile · دفع آمن عبر SumUp',
    'acompteStart.loading': 'جارٍ تحضير الدفع…',
    'acompteStart.redirecting': 'إعادة توجيه إلى صفحة الدفع',
    'acompteStart.clickHere': 'انقر هنا إذا لم يحدث شيء.',
    'acompteStart.paid': 'تم دفع هذا العربون بالفعل. شكرًا لك! جارٍ تحضير طلبك.',
    'acompteStart.orderRef': 'الطلب {{ref}}',
    'acompteStart.errTitle': 'الدفع عبر الإنترنت غير متاح مؤقتًا',
    'acompteStart.retry': 'إعادة المحاولة',
    'acompteStart.whatsappPay': 'الدفع عبر واتساب / تواصل معنا',
    'acompteStart.inStore': 'يمكن أيضًا دفع العربون مباشرةً في المتجر.',
    'acompteStart.footer': 'بعد الدفع، يُسجَّل طلب القطعة تلقائيًا ويُرسَل إليك إيصال عبر البريد الإلكتروني.',
    'acompteStart.backToSite': 'العودة إلى الموقع',
    'acompteStart.errLinkUnavailable': 'رابط الدفع غير متاح.',
    'acompteStart.errOnlineUnavailable': 'الدفع عبر الإنترنت غير متاح مؤقتًا.',
    'acompteStart.waMessage': 'مرحبًا، أرغب في دفع عربون عرض السعر الخاص بي ({{id}}).',
    'emailVerif.loadingTitle': 'جارٍ التحقق...',
    'emailVerif.loadingSub': 'يرجى الانتظار',
    'emailVerif.successTitle': 'تم تفعيل الحساب!',
    'emailVerif.successDefault': 'تم التحقق من البريد الإلكتروني بنجاح!',
    'emailVerif.login': 'تسجيل الدخول',
    'emailVerif.errorTitle': 'خطأ في التحقق',
    'emailVerif.errorDefault': 'خطأ في التحقق',
    'emailVerif.invalidLink': 'رابط التحقق غير صالح.',
    'emailVerif.backLogin': 'العودة إلى تسجيل الدخول',
    'emailVerif.expiredTitle': 'انتهت صلاحية الرابط',
    'emailVerif.expiredDefault': 'انتهت صلاحية هذا الرابط.',
    'emailVerif.backLoginResend': 'العودة إلى تسجيل الدخول (إعادة إرسال البريد الإلكتروني)',
    'paySuccess.noPaymentToVerify': 'لا يوجد دفع للتحقق منه',
    'paySuccess.statusCheckFailed': 'تعذّر التحقق من الحالة. ستتم معالجة الدفع تلقائيًا.',
    'paySuccess.verificationError': 'خطأ أثناء التحقق من الدفع',
    'paySuccess.completedTitle': 'تم الدفع بنجاح!',
    'paySuccess.completedDesc': 'تم تأكيد دفعتك وتطبيقها على ملفك.',
    'paySuccess.failedTitle': 'فشل الدفع',
    'paySuccess.failedDesc': 'تعذّرت معالجة الدفع. يرجى المحاولة مرة أخرى.',
    'paySuccess.pendingTitle': 'جارٍ معالجة الدفع',
    'paySuccess.pendingDesc': 'يجري التحقق من دفعتك. ستُطبَّق تلقائيًا.',
    'paySuccess.verifying': 'جارٍ التحقق من الدفع...',
    'paySuccess.errorTitle': 'خطأ',
    'paySuccess.amountLabel': 'المبلغ:',
    'paySuccess.repairLabel': 'الإصلاح:',
    'paySuccess.orderLabel': 'الطلب:',
    'paySuccess.referenceLabel': 'المرجع:',
    'paySuccess.noInfo': 'لا تتوفر معلومات دفع.',
    'paySuccess.backToSpace': 'العودة إلى مساحتي',
    'devisChat.errStart': 'تعذّر بدء المحادثة. حاول مرة أخرى.',
    'devisChat.errSend': 'خطأ في الإرسال',
    'devisChat.errNetwork': 'خطأ في الشبكة',
    'devisChat.hint': 'اطلب عرض سعرك عبر البريد الإلكتروني',
    'devisChat.fabAria': 'طلب عرض سعر',
    'devisChat.fabLabel': 'عرض سعر مجاني',
    'devisChat.panelTitle': 'عرض سعر R.E.Mobiles',
    'devisChat.panelSubtitle': 'يُرسَل عبر البريد الإلكتروني بعد الموافقة',
    'devisChat.close': 'إغلاق',
    'devisChat.connecting': 'جارٍ الاتصال…',
    'devisChat.inputPlaceholder': 'مثال: شاشة iPhone 13…',
    'register.emailRequired': 'البريد الإلكتروني مطلوب لإنشاء حساب.',
    'register.passwordMinLength': 'يجب أن تحتوي كلمة المرور على 4 أحرف على الأقل.',
    'register.passwordMismatch': 'كلمتا المرور غير متطابقتين.',
    'register.registerError': 'حدث خطأ أثناء التسجيل',
    'register.verifyEmailTitle': 'تحقق من بريدك الإلكتروني!',
    'register.confirmationSentTo': 'تم إرسال بريد تأكيد إلى:',
    'register.activateHint': 'انقر على الرابط الموجود في البريد لتفعيل حسابك. تحقق أيضًا من مجلد الرسائل غير المرغوب فيها إذا لم تجده.',
    'register.goToLogin': 'الذهاب إلى تسجيل الدخول',
    'register.clientSubtitle': 'تابع حالة إصلاحاتك',
    'register.namePlaceholder': 'محمد أحمد',
    'register.emailPlaceholder': 'email@example.com',
    'register.emailHint': 'سيُرسَل بريد تأكيد لتفعيل حسابك',
    'register.addressPlaceholder': '123 شارع المثال',
    'register.password': 'كلمة المرور',
    'register.confirmPassword': 'تأكيد كلمة المرور',
    'register.referralCode': 'رمز الإحالة (اختياري)',
    'register.referredBy': 'بإحالة من {{nom}}',
    'register.invalidReferral': 'رمز إحالة غير صالح',
    'register.termsNotice': 'بإنشائك حسابًا، فإنك توافق على شروط الاستخدام الخاصة بنا',
    'login.googleDisabled': 'تم تعطيل تسجيل الدخول عبر Google. استخدم اسم المستخدم وكلمة المرور الخاصة بك.',
    'login.invalid2FA': 'رمز المصادقة الثنائية غير صالح',
    'login.tabStaff': 'الفريق',
    'login.tabClient': 'العميل',
    'login.tabBusiness': 'شركة',
    'login.frenchGuiana': 'غويانا الفرنسية',
    'login.emailNotVerifiedTitle': 'البريد الإلكتروني غير مُوثَّق',
    'login.emailNotVerifiedDesc': 'يجب عليك تأكيد بريدك الإلكتروني قبل تسجيل الدخول.',
    'login.emailResent': 'تمت إعادة إرسال البريد الإلكتروني! تحقق من صندوق الوارد.',
    'login.sending': 'جارٍ الإرسال...',
    'login.resendVerification': 'إعادة إرسال بريد التأكيد',
    'login.back': 'رجوع',
    'login.twoFATitle': 'التحقق بخطوتين',
    'login.twoFASubtitle': 'أدخل الرمز من تطبيقك',
    'login.verifying': 'جارٍ التحقق...',
    'login.verify': 'تحقّق',
    'login.passwordPlaceholder': 'كلمة المرور الخاصة بك',
    'login.allRightsReserved': 'جميع الحقوق محفوظة.',
    'acompteSuccess.errorIncompleteLink': 'رابط الدفع غير مكتمل.',
    'acompteSuccess.errorCannotConfirm': 'تعذّر تأكيد الدفع في الوقت الحالي.',
    'acompteSuccess.whatsappMessage': 'مرحبًا، لقد دفعت عربون عرض السعر الخاص بي (المرجع {{ref}}). هل يمكنكم تأكيد طلبي؟',
    'acompteSuccess.whatsappDefault': 'راسلنا عبر واتساب',
    'acompteSuccess.errorHint': 'إذا تم خصم مبلغ الدفع فعلًا، فسيتم تسجيل طلبك تلقائيًا خلال الدقائق القليلة القادمة وستتلقى رسالة تأكيد بالبريد الإلكتروني.',
    'acompteSuccess.appliedTitle': 'تم استلام العربون',
    'acompteSuccess.orderRegisteredLead': 'شكرًا لك. طلب القطعة الخاص بك',
    'acompteSuccess.orderRegisteredTail': 'قد تم تسجيله. تم إرسال إيصال إليك عبر البريد الإلكتروني؛ وستتلقى رقم التتبع فور الشحن.',
    'acompteSuccess.staffPendingTitle': 'تم استلام الدفع',
    'acompteSuccess.staffPendingBody': 'تم تسجيل عربونك بنجاح لدى SumUp. يقوم فريقنا بإتمام طلبك يدويًا وسيؤكّده لك عبر البريد الإلكتروني قريبًا جدًا.',
    'acompteSuccess.whatsappQuestion': 'لديك سؤال؟ واتساب',
    'acompteSuccess.sumupFailedTitle': 'لم يكتمل الدفع',
    'acompteSuccess.sumupFailedBody': 'لم تؤكّد SumUp الدفع ({{status}}). يمكنك المحاولة مجددًا من الرابط الموجود في بريد عرض السعر، أو التواصل معنا.',
    'acompteSuccess.timedOutTitle': 'التأكيد قيد المعالجة',
    'acompteSuccess.timedOutBody': 'لم تؤكّد SumUp دفعتك بعد. لا تقلق: إذا تم الخصم، فسيتم إنشاء طلبك تلقائيًا خلال الدقائق القليلة القادمة وستتلقى رسالة تأكيد بالبريد الإلكتروني. يمكنك إغلاق هذه الصفحة.',
    'acompteSuccess.recheckNow': 'إعادة التحقق الآن',
    'acompteSuccess.whatsappProof': 'إرسال إثبات الدفع عبر واتساب',
    'acompteSuccess.verifyingTitle': 'جارٍ التحقق من الدفع…',
    'acompteSuccess.verifyingBody': 'يُرجى الانتظار بضع ثوانٍ.',
    'acompteSuccess.backHome': 'العودة إلى الصفحة الرئيسية',
    'b2bDashboard.acceptRefuse': 'قبول / رفض',
    'b2bDashboard.actions': 'إجراءات',
    'b2bDashboard.addNotePlaceholder': 'أضف ملاحظة حول هذا الإصلاح...',
    'b2bDashboard.addPhoto': '+ إضافة',
    'b2bDashboard.additionalInfoPlaceholder': 'معلومات إضافية...',
    'b2bDashboard.additionalNotes': 'ملاحظات إضافية',
    'b2bDashboard.addressOptional': 'العنوان (اختياري)',
    'b2bDashboard.addressPlaceholder': 'العنوان للانتقال عند الحاجة',
    'b2bDashboard.alertDescribeRequest': 'يرجى وصف طلبك',
    'b2bDashboard.amount': 'المبلغ',
    'b2bDashboard.awaitingReceptionStore': 'بانتظار الاستلام في المتجر',
    'b2bDashboard.back': 'رجوع',
    'b2bDashboard.backGlass': 'الزجاج الخلفي',
    'b2bDashboard.backGlassBroken': 'الزجاج الخلفي مكسور',
    'b2bDashboard.backGlassIntact': 'الزجاج الخلفي سليم',
    'b2bDashboard.brandModelRequired': 'العلامة التجارية والطراز مطلوبان',
    'b2bDashboard.broken': 'مكسور',
    'b2bDashboard.changePassword': 'تغيير كلمة المرور',
    'b2bDashboard.chat': 'محادثة',
    'b2bDashboard.clear': 'مسح',
    'b2bDashboard.clickNewRequestHint': 'انقر على «طلب جديد» لإنشاء واحد',
    'b2bDashboard.clickToAddPhotos': 'انقر لإضافة صور',
    'b2bDashboard.code': 'رمز',
    'b2bDashboard.code6Digits': 'رمز من 6 أرقام',
    'b2bDashboard.codeDigitsLetters': 'رمز (أرقام/حروف)',
    'b2bDashboard.codeValidatedSuccess': 'تم التحقق من الرمز بنجاح!',
    'b2bDashboard.confirmOrderEmailPre': 'تم إرسال أمر شراء مع رمز تأكيد إلى بريدك الإلكتروني. أدخل هذا الرمز في قسم ',
    'b2bDashboard.confirmOrderEmailPost': ' للتحقق من طلبك.',
    'b2bDashboard.createdOn': 'أُنشئت في',
    'b2bDashboard.customerProvidesPart': 'أنا أوفّر القطعة',
    'b2bDashboard.date': 'التاريخ',
    'b2bDashboard.delivery': 'التسليم',
    'b2bDashboard.delivery.pickup': 'الاستلام',
    'b2bDashboard.delivery.postal': 'إرسال بالبريد',
    'b2bDashboard.delivery.store': 'في المتجر',
    'b2bDashboard.describeProblemPlaceholder': 'صف المشكلة...',
    'b2bDashboard.designation': 'البيان',
    'b2bDashboard.device': 'الجهاز',
    'b2bDashboard.devisStatus.accepted': 'مقبول',
    'b2bDashboard.devisStatus.depositPaid': 'تم دفع العربون',
    'b2bDashboard.devisStatus.paid': 'مدفوع',
    'b2bDashboard.devisStatus.pending': 'قيد الانتظار',
    'b2bDashboard.devisStatus.refused': 'مرفوض',
    'b2bDashboard.diagRef': 'مرجع التشخيص:',
    'b2bDashboard.documentsWord': 'المستندات',
    'b2bDashboard.downloadError': 'خطأ أثناء التنزيل',
    'b2bDashboard.downloadPdf': 'تنزيل PDF',
    'b2bDashboard.enter6DigitCode': 'أدخل الرمز المكوّن من 6 أرقام',
    'b2bDashboard.enterCodePerOrder': 'أدخل الرمز المستلم عبر البريد الإلكتروني للتحقق من كل أمر شراء.',
    'b2bDashboard.enterCodeToValidate': 'أدخل الرمز المستلم عبر البريد الإلكتروني للتحقق من طلبك.',
    'b2bDashboard.enterPinPlaceholder': 'أدخل رمز PIN، كلمة المرور...',
    'b2bDashboard.enterValidationCode': 'يرجى إدخال رمز التحقق',
    'b2bDashboard.error': 'خطأ',
    'b2bDashboard.filter.all': 'الكل',
    'b2bDashboard.history': 'السجل',
    'b2bDashboard.imeiSerial': 'IMEI / الرقم التسلسلي',
    'b2bDashboard.imeiSerialShort': 'IMEI / التسلسلي',
    'b2bDashboard.incorrectCode': 'رمز غير صحيح',
    'b2bDashboard.invoiceLabel': 'الفاتورة:',
    'b2bDashboard.invoiceType.combined': 'مجمّعة',
    'b2bDashboard.invoiceType.diag': 'تشخيص',
    'b2bDashboard.invoiceType.repair': 'إصلاح',
    'b2bDashboard.invoices': 'الفواتير',
    'b2bDashboard.invoicesAppearWhenPriced': 'تظهر الفواتير بمجرد تحديد السعر من قبل R.E.Mobiles',
    'b2bDashboard.latePayment': 'تأخّر في الدفع - {{days}} يوماً',
    'b2bDashboard.lock': 'القفل',
    'b2bDashboard.lockCode': 'رمز القفل',
    'b2bDashboard.mostRecent': 'الأحدث',
    'b2bDashboard.nav.documents': 'عروض الأسعار / الفواتير',
    'b2bDashboard.nav.quoteRequest': 'طلب عرض سعر',
    'b2bDashboard.newQuoteRequest': 'طلب عرض سعر جديد',
    'b2bDashboard.newRequest': 'طلب جديد',
    'b2bDashboard.noInvoiceAvailable': 'لا توجد فاتورة متاحة',
    'b2bDashboard.noPhoto': 'لا توجد صورة',
    'b2bDashboard.noPosInvoice': 'لا توجد فاتورة شراء',
    'b2bDashboard.noQuoteRequest': 'لا توجد طلبات عروض أسعار',
    'b2bDashboard.noTravelQuote': 'لا توجد عروض أسعار للتنقّل',
    'b2bDashboard.nonFunctionalParts': 'قطع غير عاملة',
    'b2bDashboard.noteSaveError': 'خطأ أثناء حفظ الملاحظة',
    'b2bDashboard.notes': 'ملاحظات',
    'b2bDashboard.oldest': 'الأقدم',
    'b2bDashboard.optional': 'اختياري',
    'b2bDashboard.orderValidated': 'تم التحقق من أمر الشراء',
    'b2bDashboard.orderValidatedSuccess': 'تم التحقق من أمر الشراء!',
    'b2bDashboard.orderValidationCode': 'رمز التحقق من أمر الشراء',
    'b2bDashboard.paid': 'مدفوعة',
    'b2bDashboard.paidLabel': 'المدفوع',
    'b2bDashboard.partProvidedByStore': 'ستوفّر R.E.Mobiles القطعة',
    'b2bDashboard.parts.backCam': 'الكاميرا الخلفية',
    'b2bDashboard.parts.backGlass': 'الزجاج الخلفي',
    'b2bDashboard.parts.battery': 'البطارية',
    'b2bDashboard.parts.chargingPort': 'منفذ الشحن',
    'b2bDashboard.parts.earSpeaker': 'سماعة الأذن',
    'b2bDashboard.parts.fingerprint': 'البصمة',
    'b2bDashboard.parts.frontCam': 'الكاميرا الأمامية',
    'b2bDashboard.parts.homeButton': 'زر الرئيسية',
    'b2bDashboard.parts.lcd': 'الشاشة',
    'b2bDashboard.parts.microphone': 'الميكروفون',
    'b2bDashboard.parts.powerButton': 'زر التشغيل',
    'b2bDashboard.parts.signal': 'الإشارة',
    'b2bDashboard.parts.speaker': 'مكبّر الصوت',
    'b2bDashboard.parts.volumeButton': 'زر الصوت',
    'b2bDashboard.parts.wifiBt': 'واي فاي/بلوتوث',
    'b2bDashboard.pattern': 'النمط',
    'b2bDashboard.pay': 'ادفع',
    'b2bDashboard.payRemaining': 'ادفع المبلغ المتبقّي ({{amount}})',
    'b2bDashboard.paymentCreateError': 'خطأ أثناء إنشاء الدفعة',
    'b2bDashboard.paymentLinkUnavailable': 'رابط الدفع غير متاح. تواصل مع R.E.Mobiles.',
    'b2bDashboard.pdfDownloadError': 'خطأ أثناء تنزيل ملف PDF',
    'b2bDashboard.pdfInvoice': 'PDF الفاتورة',
    'b2bDashboard.pdfPurchaseOrder': 'PDF أمر الشراء',
    'b2bDashboard.pdfQuote': 'PDF عرض السعر',
    'b2bDashboard.penaltiesLine': 'غرامات: {{penalty}} + تعويض: {{indemnity}}',
    'b2bDashboard.photos': 'الصور',
    'b2bDashboard.pickupAddress': 'عنوان الاستلام',
    'b2bDashboard.pickupAddressPlaceholder': 'العنوان الكامل لاستلام الهاتف...',
    'b2bDashboard.pickupAddressRequired': 'يرجى إدخال عنوان الاستلام',
    'b2bDashboard.pickupRequested': 'تم طلب الاستلام - سنأتي لأخذ الجهاز',
    'b2bDashboard.posInvoices': 'فواتير الشراء (POS)',
    'b2bDashboard.price': 'السعر',
    'b2bDashboard.priceCol': 'السعر',
    'b2bDashboard.priceDiagnostic': 'سعر التشخيص',
    'b2bDashboard.pricePending': 'قيد الانتظار - سيُحدَّد من قبل R.E.Mobiles',
    'b2bDashboard.priceRepair': 'سعر الإصلاح',
    'b2bDashboard.problem': 'المشكلة',
    'b2bDashboard.problemDescription': 'المشكلة / الوصف',
    'b2bDashboard.purchaseOrderLabel': 'أمر الشراء:',
    'b2bDashboard.quoteRequestTitle': 'طلب عرض سعر',
    'b2bDashboard.refusalReason': 'سبب الرفض:',
    'b2bDashboard.remaining': 'المتبقّي',
    'b2bDashboard.repairAcceptedByStaff': 'تم قبول الإصلاح من قبل الفريق',
    'b2bDashboard.repairRefusedByStaff': 'تم رفض الإصلاح من قبل الفريق',
    'b2bDashboard.repairTitle': 'إصلاح {{ref}}',
    'b2bDashboard.requestDescription': 'وصف طلبك',
    'b2bDashboard.requestDescriptionPlaceholder': 'صف ما تريده: نوع الإصلاح، الكمية، المشاكل، إلخ.',
    'b2bDashboard.requestStatus.inProgress': 'قيد المعالجة',
    'b2bDashboard.requestStatus.new': 'جديد',
    'b2bDashboard.requestStatus.processed': 'تمت المعالجة',
    'b2bDashboard.requestStatus.refused': 'مرفوض',
    'b2bDashboard.retentionInvoices': 'تُحفظ الفواتير على خوادمنا لمدة 18 شهراً.',
    'b2bDashboard.retentionQuotes': 'تُحفظ عروض الأسعار على خوادمنا لمدة شهر واحد.',
    'b2bDashboard.saveNote': 'حفظ الملاحظة',
    'b2bDashboard.saving': 'جارٍ الحفظ...',
    'b2bDashboard.searchPlaceholder': 'بحث...',
    'b2bDashboard.sendRequest': 'إرسال طلبي',
    'b2bDashboard.sending': 'جارٍ الإرسال...',
    'b2bDashboard.status.awaitingParts': 'بانتظار القطع',
    'b2bDashboard.status.awaitingPickup': 'بانتظار الأخذ',
    'b2bDashboard.status.awaitingReception': 'بانتظار الاستلام',
    'b2bDashboard.status.completed': 'مكتمل',
    'b2bDashboard.status.delivered': 'تم التسليم',
    'b2bDashboard.status.inProgress': 'قيد التنفيذ',
    'b2bDashboard.status.received': 'تم الاستلام',
    'b2bDashboard.status.refused': 'مرفوض',
    'b2bDashboard.statusCol': 'الحالة',
    'b2bDashboard.submitError': 'خطأ أثناء الإرسال',
    'b2bDashboard.teamResponse': 'رد الفريق:',
    'b2bDashboard.titleOptional': 'العنوان (اختياري)',
    'b2bDashboard.titlePlaceholder': 'مثال: إصلاح دفعة شاشات Samsung',
    'b2bDashboard.total': 'الإجمالي',
    'b2bDashboard.totalDue': 'الإجمالي المستحق: {{amount}}',
    'b2bDashboard.trackingBadge': 'التتبّع:',
    'b2bDashboard.trackingNumber': 'رقم التتبّع',
    'b2bDashboard.trackingPlaceholder': 'مثال: 1Z999AA10123456784',
    'b2bDashboard.trackingRequired': 'يرجى إدخال رقم التتبّع للإرسال بالبريد',
    'b2bDashboard.trackingShort': 'رقم التتبّع',
    'b2bDashboard.travelFee': 'رسوم التنقّل',
    'b2bDashboard.travelQuotes': 'عروض أسعار التنقّل',
    'b2bDashboard.uploadError': 'خطأ أثناء الرفع',
    'b2bDashboard.uploading': 'جارٍ الرفع...',
    'b2bDashboard.validate': 'تأكيد',
    'b2bDashboard.validationCodeConfirmed': 'تم تأكيد رمز التحقق',
    'client.mySpace': 'مساحتي',
    'client.invoiceDownloadError': 'حدث خطأ أثناء تنزيل الفاتورة',
    'client.invoiceViewError': 'حدث خطأ أثناء عرض الفاتورة',
    'client.invoicePrintError': 'حدث خطأ أثناء طباعة الفاتورة',
    'client.pinMustBe4': 'يجب أن يتكوّن رمز PIN من 4 أرقام',
    'client.pinMismatch': 'رمزا PIN غير متطابقين',
    'client.pinChanged': 'تم تغيير رمز PIN بنجاح!',
    'client.pinChangeError': 'حدث خطأ أثناء تغيير رمز PIN',
    'client.describeRequest': 'يرجى وصف طلبك',
    'client.error': 'خطأ',
    'client.enterValidationCode': 'يرجى إدخال رمز التحقق',
    'client.codeValidated': 'تم التحقق من الرمز بنجاح!',
    'client.codeIncorrect': 'الرمز غير صحيح',
    'client.sumupUrlUnavailable': 'خطأ: رابط الدفع عبر SumUp غير متاح',
    'client.sumupCreateError': 'حدث خطأ أثناء إنشاء عملية الدفع عبر SumUp',
    'client.fillRequired': 'يرجى تعبئة جميع الحقول الإلزامية',
    'client.invalidEmail': 'عنوان البريد الإلكتروني غير صالح',
    'client.requestError': 'حدث خطأ أثناء الطلب',
    'client.trackingSaved': 'تم حفظ رقم التتبع!',
    'client.statusText.recu': 'تم استلام الجهاز في الورشة',
    'client.statusText.enCours': 'الإصلاح قيد التنفيذ',
    'client.statusText.attentePieces': 'بانتظار قطع الغيار',
    'client.statusText.termine': 'اكتمل الإصلاح - جاهز للاستلام',
    'client.statusText.livre': 'تم استلام الجهاز',
    'client.statusText.demandeEnLigne': 'بانتظار استلام الجهاز',
    'client.statusText.nonReparable': 'الجهاز غير قابل للإصلاح',
    'client.statusLabel.recu': 'مُستلَم',
    'client.statusLabel.enCours': 'قيد التنفيذ',
    'client.statusLabel.attentePieces': 'بانتظار القطع',
    'client.statusLabel.termine': 'مكتمل',
    'client.statusLabel.livre': 'تم التسليم',
    'client.statusLabel.recupere': 'تم الاستلام',
    'client.statusLabel.demandeEnLigne': 'طلب عبر الإنترنت',
    'client.statusLabel.nonReparable': 'غير قابل للإصلاح',
    'client.created': 'تم الإنشاء',
    'client.technicianNotes': 'ملاحظات الفني',
    'client.noNotes': 'لا توجد ملاحظات حتى الآن',
    'client.file': 'ملف',
    'client.files': 'ملفات',
    'client.navigation': 'التنقّل',
    'client.devisFactures': 'عروض الأسعار / الفواتير',
    'client.myAddresses': 'عناويني',
    'client.myAccount': 'حسابي',
    'client.needHelp': 'بحاجة إلى مساعدة؟',
    'client.helpHours': 'فريقنا في خدمتك من الإثنين إلى السبت من الساعة 9 صباحًا حتى 7 مساءً.',
    'client.contactUs': 'اتصل بنا',
    'client.contactSupport': 'التواصل مع الدعم',
    'client.guideMe': 'أرشدني',
    'client.logout': 'تسجيل الخروج',
    'client.changePassword': 'تغيير كلمة المرور',
    'client.addresses': 'العناوين',
    'client.requestRepair': 'طلب إصلاح',
    'client.showDelivered': 'عرض المُسلَّمة',
    'client.hideDelivered': 'إخفاء المُسلَّمة',
    'client.noRepairsInProgress': 'لا توجد إصلاحات قيد التنفيذ',
    'client.onlineRepairRequest': 'طلب إصلاح عبر الإنترنت',
    'client.diagFeeFormPre': 'املأ النموذج أدناه. رسوم التشخيص البالغة',
    'client.diagFeeFormPost': 'يجب دفعها عبر الإنترنت.',
    'client.repairReason': 'سبب الإصلاح',
    'client.repairReasonPlaceholder': 'مثال: شاشة مكسورة، بطارية...',
    'client.fullName': 'الاسم الكامل',
    'client.fullNamePlaceholder': 'اسمك الكامل',
    'client.postalAddress': 'العنوان البريدي',
    'client.addressPlaceholder': 'عنوانك',
    'client.emailAddress': 'البريد الإلكتروني',
    'client.emailPlaceholder': 'email@example.com',
    'client.describeIssue': 'صِف العطل بالتفصيل',
    'client.describeIssuePlaceholder': 'أخبرنا كيف تعطّل الهاتف/الجهاز اللوحي والأعراض التي لاحظتها...',
    'client.devicePhotos': 'صور الجهاز',
    'client.addPhotos': 'إضافة صور',
    'client.cancel': 'إلغاء',
    'client.sending': 'جارٍ الإرسال...',
    'client.sendRequest': 'إرسال الطلب',
    'client.requestSaved': 'تم تسجيل الطلب: {{ref}}',
    'client.redirecting': 'جارٍ إعادة التوجيه...',
    'client.payDiagnosticSumup': 'ادفع {{amount}} عبر SumUp (تشخيص)',
    'client.diagFeePending': 'طلبك قيد الانتظار. لبدء التشخيص، يرجى دفع رسوم قدرها',
    'client.depositOrSend': 'سلّم جهازك في المتجر أو أرسله بالبريد مع إشعار بالاستلام:',
    'client.trackingPlaceholder': 'رقم التتبع البريدي',
    'client.save': 'حفظ',
    'client.postalDelayNotice': 'في حال الإرسال بالبريد: تمتد المهلة إلى 20 يومًا قبل انتهاء صلاحية الطلب (40 يومًا قبل الحذف)',
    'client.close': 'إغلاق',
    'client.progress': 'التقدّم',
    'client.deposits': 'الدفعات المقدمة',
    'client.rest': 'المتبقّي',
    'client.payWithSumup': 'ادفع {{amount}} عبر SumUp',
    'client.detailedTracking': 'تتبّع مفصّل',
    'client.chatRepair': 'محادثة الإصلاح {{ref}}',
    'client.contact': 'تواصل',
    'client.photosCount': 'الصور ({{count}})',
    'client.level': 'المستوى {{name}}',
    'client.tierOr': 'ذهبي',
    'client.tierArgent': 'فضّي',
    'client.tierBronze': 'برونزي',
    'client.totalPurchases': '{{count}} عملية شراء إجمالًا',
    'client.nextLevel': 'المستوى التالي:',
    'client.purchasesToNext': '{{count}} عملية شراء متبقّية',
    'client.rewardAvailable': 'مكافأة متاحة!',
    'client.reward10Reached': 'تهانينا، لقد وصلت إلى {{count}} عمليات شراء',
    'client.rewardPosDesc': 'على عملية الشراء التالية في المتجر',
    'client.rewardRepairDesc': 'على إصلاحك التالي',
    'client.loyaltyPoints': 'نقاط الولاء',
    'client.purchasesUntilReward': 'بقي {{count}} عملية شراء حتى المكافأة',
    'client.rewardReached': 'تم بلوغ المكافأة!',
    'client.rewardsHistory': 'سجل المكافآت',
    'client.reward15Pos': '-15% في المتجر',
    'client.reward10Repair': '-10% إصلاح',
    'client.referralProgram': 'برنامج الإحالة',
    'client.referralSubtitle': 'شارك رمزك واكسب نقاطًا إضافية',
    'client.yourReferralCode': 'رمز الإحالة الخاص بك',
    'client.copied': 'تم النسخ!',
    'client.copy': 'نسخ',
    'client.referralShare1': 'شارك هذا الرمز مع أصدقائك. عندما يسجّلون باستخدامه، تكسب',
    'client.referralBonusPoints': '+2 نقطة',
    'client.referralShare2': 'من نقاط الولاء!',
    'client.copyReferralLink': 'نسخ رابط التسجيل',
    'client.referrals': 'المُحالون',
    'client.bonusPoints': 'نقاط إضافية',
    'client.yourReferrals': 'المُحالون من قِبلك',
    'client.referralFallback': 'مُحال',
    'client.myDevis': 'عروض أسعاري',
    'client.newRequest': 'طلب جديد',
    'client.newDevisRequest': 'طلب عرض سعر جديد',
    'client.titleOptional': 'العنوان (اختياري)',
    'client.devisTitlePlaceholder': 'مثال: إصلاح شاشة iPhone 15',
    'client.requestDescription': 'وصف طلبك',
    'client.devisDescPlaceholder': 'صِف ما تريده: نوع الإصلاح، المشكلة، إلخ.',
    'client.addressOptional': 'العنوان (اختياري، للزيارة الميدانية)',
    'client.devisAddressPlaceholder': 'عنوانك إذا كنت ترغب بزيارة ميدانية',
    'client.sendMyRequest': 'إرسال طلبي',
    'client.myDevisRequests': 'طلبات عروض الأسعار الخاصة بي',
    'client.devisRequestTitle': 'طلب عرض سعر',
    'client.devisReqNouveau': 'جديد',
    'client.devisReqEnCours': 'قيد المعالجة',
    'client.devisReqRefuse': 'مرفوض',
    'client.devisReqTraite': 'تمت المعالجة',
    'client.teamResponse': 'رد الفريق:',
    'client.refusalReason': 'سبب الرفض:',
    'client.clickNewRequest': 'انقر على «طلب جديد» لإنشاء واحد',
    'client.designation': 'البند',
    'client.price': 'السعر',
    'client.travelFees': 'رسوم التنقّل',
    'client.totalUpper': 'الإجمالي',
    'client.paid': 'مدفوع',
    'client.purchaseOrder': 'أمر الشراء',
    'client.invoice': 'الفاتورة',
    'client.latePayment': 'تأخّر في الدفع - {{days}} يومًا',
    'client.latePenaltyLabel': 'غرامات التأخير ({{rate}}% سنويًا)',
    'client.recoveryIndemnity': 'تعويض مقطوع للتحصيل',
    'client.totalWithPenalties': 'الإجمالي المستحق مع الغرامات',
    'client.validationCodeTitle': 'رمز التحقق لأمر الشراء',
    'client.validationCodeDesc': 'أدخل الرمز الذي تلقّيته عبر البريد الإلكتروني للتحقق من طلبك.',
    'client.code6digits': 'رمز من 6 أرقام',
    'client.validate': 'تأكيد',
    'client.codeConfirmed': 'تم تأكيد رمز التحقق',
    'client.pdfDevis': 'PDF عرض السعر',
    'client.pdfPurchaseOrder': 'PDF أمر الشراء',
    'client.pdfInvoice': 'PDF الفاتورة',
    'client.payRest': 'دفع المتبقّي ({{amount}})',
    'client.deposit50': 'دفعة مقدّمة 50%',
    'client.fullPayment': 'دفع كامل',
    'client.myInvoices': 'فواتيري',
    'client.mostRecent': 'الأحدث',
    'client.oldest': 'الأقدم',
    'client.noInvoices': 'لا توجد فواتير متاحة',
    'client.view': 'عرض',
    'client.print': 'طباعة',
    'client.seeLess': 'عرض أقل',
    'client.seeMoreInvoices': 'عرض المزيد ({{count}} فاتورة)',
    'client.invoiceRetention': 'تُحفظ الفواتير على خوادمنا لمدة 18 شهرًا.',
    'client.devisRetention': 'تُحفظ عروض الأسعار على خوادمنا لمدة شهر واحد.',
    'client.createCaricature': 'أنشئ رسمتي الكاريكاتورية',
    'client.copyrightBy': 'حقوق النشر لـ',
    'client.notifications': 'الإشعارات',
    'client.markAllRead': 'تعليم الكل كمقروء',
    'client.noNotifications': 'لا توجد إشعارات',
    'client.pinChangeTitle': 'تغيير رمز PIN',
    'client.pinChangeDesc': 'من أجل أمانك، يرجى اختيار رمز PIN جديد مكوّن من 4 أرقام.',
    'client.newPin': 'رمز PIN الجديد',
    'client.confirmPin': 'تأكيد رمز PIN',
    'client.modifying': 'جارٍ التعديل...',
    'client.changePin': 'تغيير رمز PIN الخاص بي',
    'client.proofSent': 'تم إرسال إثبات الدفع! سيقوم الفريق بمراجعته.',
    'client.sendError': 'حدث خطأ أثناء الإرسال',
    'client.orderStatusEnAttente': 'قيد الانتظار',
    'client.orderStatusPayee': 'مدفوعة',
    'client.orderStatusProofUploaded': 'تم إرسال الإثبات',
    'client.orderStatusConfirmee': 'مؤكَّدة',
    'client.orderStatusPreparee': 'جاهزة',
    'client.orderStatusExpediee': 'تم الشحن',
    'client.orderStatusLivree': 'تم التسليم',
    'client.orderStatusAnnulee': 'ملغاة',
    'client.trackingNumber': 'رقم التتبع:',
    'client.trackingHint': 'استخدم هذا الرقم لتتبّع طردك',
    'client.stepCommande': 'الطلب',
    'client.proofSentLabel': 'تم إرسال إثبات الدفع',
    'client.sentOn': 'أُرسلت في',
    'client.validatedByStaff': 'تم التحقق من قِبل الفريق',
    'client.payWithSumupPlain': 'الدفع عبر SumUp',
    'client.sendProof': 'إرسال إثبات الدفع (لقطة شاشة)',
    'client.history': 'السجل',
    'client.chatOrder': 'محادثة الطلب {{ref}}',
    'client.homeLabel': 'المنزل',
    'client.enterFullAddress': 'يرجى إدخال عنوانك الكامل.',
    'client.saveError': 'حدث خطأ أثناء الحفظ',
    'client.addressLabelField': 'التسمية',
    'client.labelPlaceholder': 'المنزل، المكتب...',
    'client.phone': 'الهاتف',
    'client.phonePlaceholder': '06 94 ...',
    'client.recipient': 'المستلِم',
    'client.recipientPlaceholder': 'اسم المستلِم',
    'client.deliveryAddress': 'عنوان التسليم',
    'client.addressInputPlaceholder': 'أدخل عنوانك الكامل',
    'client.freeAddressHint': 'إدخال حر: اختر اقتراحًا إذا ظهر، وإلا فاكتب عنوانك ببساطة.',
    'client.searching': 'جارٍ البحث...',
    'client.addressValidated': 'تم التحقق من العنوان',
    'client.saving': 'جارٍ الحفظ...',
    'client.confirmDeleteAddress': 'هل تريد حذف هذا العنوان؟',
    'client.manageAddressesSubtitle': 'أدِر عناوين التسليم الخاصة بك',
    'client.addAddress': 'إضافة عنوان',
    'client.newAddress': 'عنوان جديد',
    'client.editAddress': 'تعديل العنوان',
    'client.default': 'افتراضي',
    'client.edit': 'تعديل',
    'client.delete': 'حذف',
    'client.setDefault': 'تعيين كافتراضي',
    'client.selectAddress': 'يرجى اختيار أو إضافة عنوان تسليم.',
    'client.orderSuccess': 'تم تقديم الطلب بنجاح!',
    'client.orderError': 'حدث خطأ أثناء الطلب',
    'client.ourAccessories': 'إكسسواراتنا',
    'client.expertSelection': 'تشكيلة مختبَرة من قِبل خبرائنا',
    'client.allCategories': 'جميع الفئات',
    'client.cart': 'السلة',
    'client.noArticles': 'لا توجد منتجات متاحة',
    'client.inStock': 'متوفّر',
    'client.unavailable': 'غير متوفّر',
    'client.add': 'إضافة',
    'client.myCart': 'سلّتي',
    'client.articleSingular': 'منتج',
    'client.articlesPlural': 'منتجات',
    'client.cartEmpty': 'سلّتك فارغة',
    'client.manage': 'إدارة',
    'client.processing': 'جارٍ المعالجة...',
    'client.payOnDelivery': 'الدفع عند التسليم',
    'publicShop.status.en_attente': 'قيد الانتظار',
    'publicShop.status.en_cours': 'قيد التنفيذ',
    'publicShop.status.termine': 'مكتمل',
    'publicShop.status.pret': 'جاهز',
    'publicShop.status.livre': 'تم التسليم',
    'publicShop.status.annule': 'ملغى',
    'publicShop.repairNotFound': 'لم يتم العثور على الإصلاح',
    'publicShop.shopNotFound': 'لم يتم العثور على المتجر',
    'publicShop.trackTitle': 'تتبع إصلاحي',
    'publicShop.trackSubtitle': 'أدخل الرقم التسلسلي أو رمز التتبع',
    'publicShop.trackPlaceholder': 'الرقم التسلسلي أو رمز التتبع...',
    'publicShop.trackButton': 'تتبع',
    'publicShop.labelDateEntree': 'تاريخ الاستلام:',
    'publicShop.labelSortiePrevue': 'موعد التسليم المتوقع:',
    'publicShop.labelProbleme': 'المشكلة:',
    'publicShop.labelRemarques': 'ملاحظات:',
    'publicShop.poweredBy': 'مشغّل بواسطة {{brand}}',
    'invoiceRequest.subtitle': 'طلب فاتورة',
    'invoiceRequest.search.title': 'ابحث عن عملية الشراء',
    'invoiceRequest.search.hint': 'أدخل المبلغ الدقيق والوقت التقريبي.',
    'invoiceRequest.search.amountLabel': 'المبلغ المدفوع (EUR)',
    'invoiceRequest.search.amountPlaceholder': 'مثال: 25.00',
    'invoiceRequest.search.timeLabel': 'الوقت',
    'invoiceRequest.search.dateLabel': 'التاريخ',
    'invoiceRequest.search.loading': 'جارٍ البحث…',
    'invoiceRequest.search.submit': 'بحث',
    'invoiceRequest.results.title': 'اختر عملية الشراء',
    'invoiceRequest.results.paidLabel': 'المدفوع:',
    'invoiceRequest.itemsCount': '{{count}} عنصر',
    'invoiceRequest.back': 'رجوع',
    'invoiceRequest.form.title': 'معلوماتك',
    'invoiceRequest.form.purchase': 'الشراء',
    'invoiceRequest.form.alreadyPaid': 'المدفوع مسبقًا',
    'invoiceRequest.form.payment': 'الدفع',
    'invoiceRequest.form.remaining': 'المتبقي',
    'invoiceRequest.form.nameLabel': 'الاسم الكامل',
    'invoiceRequest.form.namePlaceholder': 'محمد أحمد',
    'invoiceRequest.form.emailLabel': 'البريد الإلكتروني',
    'invoiceRequest.form.emailPlaceholder': 'mohammed@example.com',
    'invoiceRequest.form.phoneLabel': 'الهاتف',
    'invoiceRequest.form.phonePlaceholder': '0694XXXXXX',
    'invoiceRequest.form.sending': 'جارٍ الإرسال…',
    'invoiceRequest.form.submit': 'إرسال الفاتورة',
    'invoiceRequest.pending.title': 'الطلب قيد الانتظار',
    'invoiceRequest.pending.desc': 'تم إرسال هذه الفاتورة مسبقًا إلى عنوان آخر.',
    'invoiceRequest.pending.validationRequired': 'التحقق مطلوب',
    'invoiceRequest.pending.info': 'تم إرسال طلبك إلى فريقنا. ستستلم الفاتورة على {{email}} بعد الموافقة عليها.',
    'invoiceRequest.newRequest': 'طلب جديد',
    'invoiceRequest.success.title': 'تم إرسال الفاتورة!',
    'invoiceRequest.success.desc': 'تم إرسال فاتورتك إلى {{email}}.',
    'invoiceRequest.success.accountCreated': 'تم إنشاء حساب العميل!',
    'invoiceRequest.success.newAccountDesc': 'تم إرسال بيانات تسجيل الدخول إلى {{email}}.',
    'invoiceRequest.success.sendingCredentials': 'جارٍ الإرسال…',
    'invoiceRequest.success.resendCredentials': 'استلام بيانات الدخول عبر البريد الإلكتروني',
    'invoiceRequest.success.credentialsSent': 'تم إرسال بيانات الدخول إلى {{email}}',
    'invoiceRequest.success.trackRepairs': 'متابعة إصلاحاتي',
    'invoiceRequest.footer': 'R.E.Mobiles — 102 Avenue Général de Gaulle, Porte 2, 97300 Cayenne',
    'invoiceRequest.errors.search': 'خطأ في البحث',
    'invoiceRequest.errors.notFound': 'لم يتم العثور على أي عملية بيع بهذا المبلغ وهذا الوقت. يرجى التحقق من المعلومات.',
    'invoiceRequest.errors.send': 'حدث خطأ أثناء الإرسال',
    'invoiceRequest.errors.generic': 'خطأ',
    'storefront.notfound.title': 'الشركة غير موجودة',
    'storefront.notfound.desc': 'هذه الشركة غير موجودة أو لم تعد نشطة.',
    'storefront.notfound.back': 'العودة إلى الصفحة الرئيسية',
    'storefront.tab.track': 'تتبّع إصلاحي',
    'storefront.tab.login': 'مساحة العميل',
    'storefront.track.title': 'تتبّع الإصلاح',
    'storefront.track.subtitle': 'أدخل رقم المرجع لتتبّع تقدّم إصلاحك',
    'storefront.track.format': 'صيغة المرجع:',
    'storefront.track.submit': 'تتبّع',
    'storefront.track.not_found': 'الإصلاح غير موجود',
    'storefront.track.ref': 'المرجع',
    'storefront.track.device': 'الجهاز',
    'storefront.track.problem': 'المشكلة',
    'storefront.track.date_in': 'تاريخ الاستلام',
    'storefront.track.date_out': 'تاريخ التسليم المتوقّع',
    'storefront.status.waiting': 'قيد الانتظار',
    'storefront.status.in_progress': 'قيد التنفيذ',
    'storefront.status.done': 'مكتمل',
    'storefront.status.delivered': 'تم التسليم',
    'storefront.status.cancelled': 'ملغى',
    'storefront.status.unknown': 'غير معروف',
    'storefront.login.title': 'تسجيل دخول العميل',
    'storefront.login.subtitle': 'سجّل الدخول إلى مساحة العميل لدى {{name}}',
    'storefront.login.phone': 'الهاتف',
    'storefront.login.pin': 'رمز PIN',
    'storefront.login.error_fields': 'أدخل رقم هاتفك ورمز PIN (4 أو 6 أرقام)',
    'storefront.login.error_invalid': 'بيانات الدخول غير صحيحة',
    'storefront.login.loading': 'جارٍ تسجيل الدخول...',
    'storefront.login.submit': 'تسجيل الدخول',
    'storefront.login.create_account': 'ليس لديك حساب بعد؟ أنشئ حسابًا',
    'storefront.register.title': 'إنشاء حساب',
    'storefront.register.subtitle': 'سجّل لدى {{name}}',
    'storefront.register.name': 'الاسم الكامل',
    'storefront.register.name_ph': 'محمد أحمد',
    'storefront.register.phone': 'الهاتف',
    'storefront.register.email': 'البريد الإلكتروني (اختياري)',
    'storefront.register.email_ph': 'email@example.com',
    'storefront.register.pin': 'رمز PIN',
    'storefront.register.pin_confirm': 'تأكيد رمز PIN',
    'storefront.register.error_required': 'الاسم والهاتف مطلوبان',
    'storefront.register.error_pin_short': 'يجب أن يحتوي رمز PIN على 4 أرقام على الأقل',
    'storefront.register.error_pin_mismatch': 'رمزا PIN غير متطابقين',
    'storefront.register.error_generic': 'خطأ أثناء إنشاء الحساب',
    'storefront.register.loading': 'جارٍ الإنشاء...',
    'storefront.register.submit': 'إنشاء حسابي',
    'storefront.register.back_to_login': 'لديك حساب بالفعل؟ سجّل الدخول',
    'landing.svcScreenTitle': 'شاشة مكسورة',
    'landing.svcScreenDesc': 'استبدال شاشة آيفون وسامسونج وهواوي',
    'landing.svcBatteryTitle': 'البطارية',
    'landing.svcBatteryDesc': 'استبدال البطارية لجميع الماركات',
    'landing.svcConnectorTitle': 'الموصل',
    'landing.svcConnectorDesc': 'موصل الشحن ومقبس الصوت',
    'landing.svcCameraTitle': 'الكاميرا',
    'landing.svcCameraDesc': 'الكاميرا الأمامية والخلفية',
    'landing.svcOxidationTitle': 'إزالة الأكسدة',
    'landing.svcOxidationDesc': 'هاتف سقط في الماء',
    'landing.svcDiagTitle': 'التشخيص',
    'landing.svcDiagDesc': 'من 35 إلى 80 € حسب الجهاز · تقدير مجاني',
    'landing.tip1': '**مرحباً!** يمكنني متابعة إصلاحك أو تقديم تقدير لك.',
    'landing.tip2': '**ضمان 6 أشهر** على جميع إصلاحاتنا وقطع الغيار واليد العاملة.',
    'landing.tip3': '**التشخيص** من 35 إلى 80 € حسب الجهاز، يُعلَن قبل البدء.',
    'landing.tip4': 'سقط في الماء؟ **أطفئه** وتعال بسرعة: إزالة الأكسدة في الورشة.',
    'landing.tip5': 'تابع إصلاحك مباشرةً باستخدام رقمك المرجعي **REM0001**.',
    'landing.tip6': '**لحام دقيق** واستعادة البيانات، حتى لو لم يعد الجهاز يعمل.',
    'landing.tip7': 'مفتوح **الإثنين–الجمعة 9ص–7م** و**السبت 9ص–2م**، الإيداع دون موعد.',
    'landing.tip8': '**تقدير مجاني** عبر الإنترنت، يُرسَل بالبريد الإلكتروني بعد التأكيد.',
    'landing.tip9': 'للمحترفين: **مساحة الشركات** مخصصة (بوابة B2B).',
    'landing.tip10': 'آيفون وسامسونج وهواوي وشاومي والأجهزة اللوحية و**أجهزة الألعاب**: نصلح كل شيء.',
    'landing.tipFromPrice': 'ابتداءً من {{price}} — السعر يُؤكَّد في المتجر.',
    'landing.guideMe': 'أرشدني',
    'landing.flashUntil': 'حتى {{date}}',
    'landing.cadbotTitle': 'CADBOT، مساعدك',
    'landing.cadbotDesc': 'متابعة الإصلاح، تقدير عروض الأسعار، أوقات العمل — يجيبك مباشرةً على الموقع. السعر النهائي يُؤكَّد دائماً في المتجر.',
    'landing.servicesTitle': 'خدمات الإصلاح لدينا',
    'landing.servicesDesc': 'إصلاح سريع للهواتف الذكية والأجهزة اللوحية في كايين، غويانا الفرنسية',
    'landing.seeAllPrices': 'عرض جميع أسعارنا',
    'landing.readBlog': 'اقرأ مدونتنا',
    'landing.diagTitle': 'التشخيص في المتجر',
    'landing.diagDesc': 'من 35 إلى 80 € حسب الجهاز. يُعلَن لك السعر قبل البدء. يبقى التقدير عبر الإنترنت مجانياً.',
    'landing.tierFrom': 'ابتداءً من',
    'landing.tierUpTo': 'حتى',
    'landing.tierEntryTitle': 'الفئة الاقتصادية والمتوسطة',
    'landing.tierEntryDesc': 'عطل بسيط ومحدَّد',
    'landing.tierRecentTitle': 'الهواتف الذكية الحديثة',
    'landing.tierRecentDesc': 'عدة أعراض تحتاج فحصاً',
    'landing.tierComplexTitle': 'الحالات المعقّدة',
    'landing.tierComplexDesc': 'أضرار المياه، اللحام الدقيق، أجهزة الألعاب، الأجهزة اللوحية',
    'landing.enlarge': 'تكبير',
    'landing.storePhotoAlt': 'متجرنا Resurrection Mobile في كايين',
    'landing.storeTag': 'متجرنا · كايين',
    'landing.enlargedPhoto': 'صورة مكبَّرة',
    'landing.close': 'إغلاق',
    'landing.storePhotoAltSimple': 'متجر Resurrection Mobile',
    'landing.freeQuote': 'تقدير مجاني',
    'privacy.title': 'سياسة الخصوصية',
    'privacy.last_updated': 'آخر تحديث: 19 مارس 2026',
    'privacy.intro.part1': 'توضح سياسة الخصوصية هذه كيفية قيام ',
    'privacy.intro.part2': ' (« نحن »، « ـنا »، « خاصتنا ») بجمع البيانات الشخصية للمستخدمين (« أنت »، « خاصتك ») واستخدامها والاحتفاظ بها وحمايتها وفقاً لـ ',
    'privacy.intro.rgpd': 'اللائحة العامة لحماية البيانات (RGPD — الاتحاد الأوروبي 2016/679)',
    'privacy.intro.part3': ' المعمول به في فرنسا وغيانا الفرنسية.',
    'privacy.s1.title': 'المسؤول عن المعالجة',
    'privacy.s1.company_label': 'الشركة',
    'privacy.s1.status_label': 'الشكل القانوني',
    'privacy.s1.controller_note': 'المسؤول عن المعالجة هو الشخص أو الكيان الذي يحدد أغراض ووسائل معالجة بياناتك الشخصية.',
    'privacy.s2.title': 'البيانات الشخصية المجمَّعة',
    'privacy.s2.sub1_title': '2.1 بيانات التعريف',
    'privacy.s2.sub1_b1': 'الاسم واللقب',
    'privacy.s2.sub1_b2': 'العنوان البريدي',
    'privacy.s2.sub1_b3': 'رقم الهاتف',
    'privacy.s2.sub1_b4': 'عنوان البريد الإلكتروني',
    'privacy.s2.sub1_b5': 'اسم الشركة (إذا كان العميل محترفاً)',
    'privacy.s2.sub2_title': '2.2 البيانات المتعلقة بالخدمات',
    'privacy.s2.sub2_b1': 'معلومات عن الأجهزة المودَعة لدينا (العلامة التجارية، الطراز، IMEI، الرقم التسلسلي)',
    'privacy.s2.sub2_b2': 'سجل الإصلاحات',
    'privacy.s2.sub2_b3': 'الطلبات وعروض الأسعار والفواتير',
    'privacy.s2.sub2_b4': 'التوقيعات الإلكترونية',
    'privacy.s2.sub3_title': '2.3 بيانات الدفع',
    'privacy.s2.sub3_b1': 'معلومات المعاملة',
    'privacy.s2.sub3_b2': 'وسيلة الدفع المستخدمة',
    'privacy.s2.payment_important_label': 'هام:',
    'privacy.s2.payment_important_text': 'نحن لا نخزّن أبداً بياناتك المصرفية الكاملة. تتم معالجة المدفوعات عبر مزوّدين آمنين (Stripe).',
    'privacy.s2.sub4_title': '2.4 البيانات التقنية',
    'privacy.s2.sub4_b1': 'عنوان IP',
    'privacy.s2.sub4_b2': 'بيانات الاتصال',
    'privacy.s2.sub4_b3': 'ملفات تعريف الارتباط وأدوات التتبع',
    'privacy.s2.sub4_b4': 'بيانات التصفح',
    'privacy.s3.title': 'أغراض المعالجة',
    'privacy.s3.b1': 'تقديم خدمات الإصلاح والبيع الخاصة بنا',
    'privacy.s3.b2': 'إدارة الطلبات وعروض الأسعار والفوترة',
    'privacy.s3.b3': 'ضمان متابعة العملاء وخدمة ما بعد البيع',
    'privacy.s3.b4': 'التواصل معك (رسائل SMS، البريد الإلكتروني، الهاتف)',
    'privacy.s3.b5': 'الامتثال لالتزاماتنا القانونية والمحاسبية',
    'privacy.s3.b6': 'تحسين خدماتنا وأمننا',
    'privacy.s3.b7': 'منع الاحتيال',
    'privacy.s4.title': 'الأساس القانوني للمعالجة',
    'privacy.s4.intro': 'وفقاً للائحة العامة لحماية البيانات، تستند عمليات المعالجة إلى:',
    'privacy.s4.i1': 'تنفيذ عقد',
    'privacy.s4.i2': 'الامتثال للالتزامات القانونية',
    'privacy.s4.i3': 'موافقتك (مثل: التسويق)',
    'privacy.s4.i4': 'مصلحتنا المشروعة (الأمان، التحسين)',
    'privacy.s5.title': 'الجهات المستقبِلة للبيانات',
    'privacy.s5.b1': 'موظفونا المخوَّلون',
    'privacy.s5.b2': 'مزوّدو الخدمات التقنية لدينا (الاستضافة، الدفع، الرسائل النصية، البريد الإلكتروني)',
    'privacy.s5.b3': 'السلطات الإدارية أو القضائية إذا اقتضى القانون ذلك',
    'privacy.s5.no_sale': 'لا تُباع أي بيانات شخصية لأطراف ثالثة.',
    'privacy.s6.title': 'نقل البيانات خارج الاتحاد الأوروبي',
    'privacy.s6.text': 'إذا كان بعض المزوّدين يقعون خارج الاتحاد الأوروبي، فإننا نتأكد من أنهم يوفّرون مستوى حماية ملائماً يتوافق مع اللائحة العامة لحماية البيانات (البنود التعاقدية النموذجية، قرارات الكفاية، إلخ).',
    'privacy.s7.title': 'مدة الاحتفاظ بالبيانات',
    'privacy.s7.r1_label': 'بيانات العملاء',
    'privacy.s7.r1_value': '5 سنوات بعد آخر علاقة تجارية',
    'privacy.s7.r2_label': 'بيانات الفوترة',
    'privacy.s7.r2_value': '10 سنوات (التزام قانوني)',
    'privacy.s7.r3_label': 'بيانات التسويق',
    'privacy.s7.r3_value': 'حتى سحب الموافقة',
    'privacy.s7.r4_label': 'ملفات تعريف الارتباط',
    'privacy.s7.r4_value': '13 شهراً كحد أقصى',
    'privacy.s8.title': 'أمن البيانات',
    'privacy.s8.intro': 'نطبّق تدابير تقنية وتنظيمية مناسبة:',
    'privacy.s8.b1': 'وصول مقيَّد إلى البيانات',
    'privacy.s8.b2': 'استضافة آمنة',
    'privacy.s8.b3': 'التشفير عند الضرورة',
    'privacy.s8.b4': 'نسخ احتياطية منتظمة',
    'privacy.s8.b5': 'الحماية من الوصول غير المصرَّح به',
    'privacy.s9.title': 'حقوقك',
    'privacy.s9.intro': 'وفقاً للائحة العامة لحماية البيانات، تتمتع بالحقوق التالية:',
    'privacy.s9.r1': 'الحق في الوصول',
    'privacy.s9.r2': 'الحق في التصحيح',
    'privacy.s9.r3': 'الحق في المحو (« الحق في النسيان »)',
    'privacy.s9.r4': 'الحق في تقييد المعالجة',
    'privacy.s9.r5': 'الحق في الاعتراض',
    'privacy.s9.r6': 'الحق في نقل البيانات',
    'privacy.s9.r7': 'الحق في سحب موافقتك',
    'privacy.s9.exercise': 'لممارسة حقوقك، تواصل معنا عبر:',
    'privacy.s9.complaint_before': 'يمكنك أيضاً تقديم شكوى إلى ',
    'privacy.s9.complaint_after': '.',
    'privacy.s10.title': 'ملفات تعريف الارتباط',
    'privacy.s10.intro': 'قد يستخدم موقعنا ملفات تعريف الارتباط من أجل:',
    'privacy.s10.b1': 'ضمان عمل الموقع',
    'privacy.s10.b2': 'قياس عدد الزوار',
    'privacy.s10.b3': 'تحسين تجربة المستخدم',
    'privacy.s10.manage': 'يمكنك إدارة تفضيلاتك عبر متصفحك أو عبر شريط ملفات تعريف الارتباط الخاص بنا.',
    'privacy.s11.title': 'بيانات القاصرين',
    'privacy.s11.text': 'خدماتنا ليست موجَّهة للقاصرين دون إذن الوالدين. إذا تم جمع بيانات قاصر عن طريق الخطأ، يُرجى التواصل معنا لحذفها.',
    'privacy.s12.title': 'تعديلات السياسة',
    'privacy.s12.text': 'يمكننا تعديل هذه السياسة في أي وقت لتعكس التطورات القانونية أو التقنية. النسخة السارية هي المنشورة على موقعنا.',
    'privacy.s13.title': 'التواصل',
    'privacy.s13.intro': 'لأي سؤال يتعلق بهذه السياسة أو ببياناتك الشخصية:',
    'privacy.footer': 'باستخدامك خدماتنا، فإنك تقرّ بأنك اطّلعت على سياسة الخصوصية هذه.',
    'track.title': 'تتبّع إصلاحي',
    'track.label_ref': 'المرجع',
    'track.label_device': 'الجهاز',
    'track.label_received': 'تاريخ الاستلام',
    'track.label_expected': 'موعد التسليم المتوقّع',
    'track.label_completed': 'تاريخ الإنجاز',
    'track.label_amount': 'المبلغ',
    'track.status_pending': 'قيد الانتظار',
    'track.see_full': 'عرض التفاصيل الكاملة',
    'track.input_placeholder': 'أدخل مرجعك (مثال: REM0001)',
    'track.btn_track': 'تتبّع',
    'track.scan_qr': 'مسح رمز QR الخاص بإيصالي',
    'track.err_invalid_ref': 'مرجع غير صالح. الصيغة المتوقّعة: REM0001',
    'track.err_not_found': 'لم يُعثر على الإصلاح',
    'chatWidget.statusStaffOnline': 'الفريق متصل',
    'chatWidget.statusAiActive': 'الذكاء الاصطناعي نشط — رد تلقائي',
    'chatWidget.statusOffline': 'غير متصل — اترك رسالة',
    'chatWidget.launcherLabel': 'الدردشة والمساعدة',
    'chatWidget.tabStaff': 'دردشة الدعم',
    'chatWidget.tabAi': 'مساعدة الذكاء الاصطناعي',
    'chatWidget.newMessage': 'رسالة جديدة',
    'chatWidget.loading': 'جارٍ التحميل...',
    'chatWidget.noConversations': 'لا توجد محادثات',
    'chatWidget.emptyConvoHint': 'انقر على «{{action}}» للتواصل معنا',
    'chatWidget.conversationFallback': 'محادثة',
    'chatWidget.autoReplyTitle': 'وضع الرد التلقائي بالذكاء الاصطناعي مفعّل',
    'chatWidget.autoReplyDesc': 'الفريق غير متصل. يردّ الذكاء الاصطناعي في هذه الأثناء.',
    'chatWidget.staffEmptyTitle': 'أرسل رسالة إلى الفريق',
    'chatWidget.staffEmptyDesc': 'سنردّ عليك في أقرب وقت ممكن',
    'chatWidget.aiAssistant': 'المساعد الذكي',
    'chatWidget.badgeAuto': 'تلقائي',
    'chatWidget.badgeQuoteIndicative': 'عرض سعر تقريبي',
    'chatWidget.badgeQuotePending': 'عرض السعر قيد الإعداد',
    'chatWidget.supportFallback': 'الدعم',
    'chatWidget.sending': 'جارٍ الإرسال...',
    'chatWidget.staffInputPlaceholder': 'رسالتك...',
    'chatWidget.interactiveGuides': 'أدلة تفاعلية',
    'chatWidget.stepsCount': '{{count}} خطوات',
    'chatWidget.faqTitle': 'الأسئلة الشائعة',
    'chatWidget.back': 'رجوع',
    'chatWidget.stepProgress': 'الخطوة {{current}} / {{total}}',
    'chatWidget.previous': 'السابق',
    'chatWidget.next': 'التالي',
    'chatWidget.finish': 'إنهاء',
    'chatWidget.aiInputPlaceholder': 'اطرح سؤالك...',
    'chatWidget.aiError': 'عذرًا، حدث خطأ.',
    'chatWidget.me': 'أنا',
    'chatWidget.newConversationSubject': 'محادثة جديدة',
    'hours.title': 'ساعات العمل',
    'hours.rows.weekdays.label': 'الاثنين - الجمعة',
    'hours.rows.weekdays.hours': '9:00 - 19:00',
    'hours.rows.saturday.label': 'السبت',
    'hours.rows.saturday.hours': '9:00 - 14:00',
    'hours.rows.sunday.label': 'الأحد',
    'hours.closed': 'مغلق',
    'hours.unit.hour': 'س',
    'hours.unit.minute': 'د',
    'hours.unit.second': 'ث',
    'hours.clock': 'الساعة الآن {{time}} في كايين',
    'hours.ring.dayProgress': 'من اليوم',
    'hours.ring.untilReopen': 'حتى إعادة الفتح',
    'hours.state.openNow': 'مفتوح الآن',
    'hours.state.closingSoon': 'يُغلق قريبًا',
    'hours.state.closed': 'مغلق',
    'hours.count.untilClose': 'حتى الإغلاق (الساعة {{hour}})',
    'hours.count.untilOpen': 'حتى الفتح',
    'hours.sub.openSince': 'مفتوح منذ {{duration}}',
    'hours.sub.nextOpen': 'الفتح القادم: {{when}} الساعة {{hour}}',
    'hours.when.today': 'اليوم',
    'hours.when.tomorrow': 'غدًا',
    'hours.mood.closingSoon': '⏳ اللحظات الأخيرة — ما زلنا بانتظارك قليلًا!',
    'hours.mood.justOpened': '☕ فتحنا للتو — مرّ علينا!',
    'hours.mood.open': '🟢 نحن مفتوحون، مرّ علينا وقتما تشاء!',
    'hours.mood.opensSoon': '🚪 نفتح خلال أقل من ساعة — سنرفع الستار قريبًا!',
    'hours.mood.sundayRest': '🌴 الأحد يوم راحتنا — نلتقي الاثنين الساعة 9!',
    'hours.mood.morning': '🌅 صباح الخير! نفتح الساعة {{hour}}، جهّز أجهزتك.',
    'hours.mood.evening': '🌙 مغلق هذا المساء — إلى اللقاء قريبًا!',
    'hours.dayName.0': 'الأحد',
    'hours.dayName.1': 'الاثنين',
    'hours.dayName.2': 'الثلاثاء',
    'hours.dayName.3': 'الأربعاء',
    'hours.dayName.4': 'الخميس',
    'hours.dayName.5': 'الجمعة',
    'hours.dayName.6': 'السبت',
    'cadbot.welcome': 'مرحبًا، أنا **CADBOT**، مساعد Resurrection Mobile. اكتب رقمك المرجعي **REM0001** لمتابعة إصلاحك، أو صِف العطل للحصول على تقدير.',
    'cadbot.chip.status': 'أين وصل إصلاحي؟',
    'cadbot.chip.screen': 'شاشة iPhone 11 مكسورة، كم السعر؟',
    'cadbot.chip.battery': 'بطارية Galaxy S21، كم السعر؟',
    'cadbot.chip.diagnostic': 'كم تكلفة التشخيص؟',
    'cadbot.chip.hours': 'أوقات العمل والعنوان؟',
    'cadbot.note': 'التقديرات إرشادية ويتم تأكيدها دائمًا في المتجر. يُرسَل عرض السعر المفصّل عبر البريد الإلكتروني بعد مصادقة فريقنا.',
    'cadbot.status.online': 'متصل',
    'cadbot.resume.label': 'استئناف محادثتي',
    'cadbot.resume.title': 'إظهار المحادثة التي بدأت في هذه النافذة',
    'cadbot.reset.label': 'محادثة جديدة',
    'cadbot.reset.title': 'مسح هذه المحادثة والبدء من جديد',
    'cadbot.input.label': 'رسالتك',
    'cadbot.input.placeholderIdentity': 'اسمك أو هاتفك أو بريدك الإلكتروني…',
    'cadbot.input.placeholderDefault': 'REM0001، شاشة iPhone 13، بطارية…',
    'cadbot.send.aria': 'إرسال',
    'cadbot.local.greeting': 'مرحبًا! أنا **CADBOT**. يمكنني متابعة إصلاحك (الرقم المرجعي REM0001)، أو تقدير عرض سعر، أو إخبارك بأوقات عملنا.',
    'cadbot.local.diagnostic': 'يتراوح التشخيص في المتجر بين {{min}} و{{max}} حسب الجهاز ومدى التعقيد. يُعلَن لك السعر قبل البدء. أما عرض السعر عبر الإنترنت فهو مجاني.',
    'cadbot.local.water': 'أطفئه ولا تشحنه، ثم أحضره إلى المتجر في أسرع وقت. تُحدَّد تكلفة إزالة الأكسدة بعرض سعر بعد التشخيص.',
    'cadbot.local.hoursLine': 'نحن في **{{address}}**. أوقات العمل: {{hours}}. {{state}}',
    'cadbot.local.hoursOpen': '**{{state}}** — {{time}} {{countLabel}}.',
    'cadbot.local.hoursClosed': '**مغلق** — {{sub}}.',
    'cadbot.local.closedLower': 'مغلق',
    'cadbot.local.warranty': 'جميع إصلاحاتنا مضمونة لمدة **6 أشهر**، القطع واليد العاملة.',
    'cadbot.local.accounts': 'روابط الدخول في الأعلى مباشرة: **مساحة العميل** (متابعة إصلاحاتك)، **مساحة الشركات** (بوابة B2B) و**مساحة الفريق**.',
    'cadbot.local.trackAsk': 'اكتب رقمك المرجعي بصيغة **REM0001** (تجده في إيصال الإيداع) وسأطلعك على التقدّم.',
    'cadbot.local.quoteFollowup': 'يُرسَل عرض سعرك عبر البريد الإلكتروني فور مصادقة فريقنا عليه (تحقّق من مجلد الرسائل غير المرغوب فيها). إذا لم يصلك رد خلال 24 ساعة، راسلنا على واتساب على **{{phone}}**.',
    'cadbot.local.contact': 'يمكنك التواصل معنا على **{{phone}}** (اتصال وواتساب).',
    'cadbot.track.here': 'إليك حالة متابعة **{{ref}}**:',
    'cadbot.track.notFound': 'لا أجد الإصلاح **{{ref}}**. تحقّق من الرقم المرجعي في إيصال الإيداع.',
    'cadbot.track.unavailable': 'خدمة المتابعة غير متوفرة مؤقتًا، أعد المحاولة بعد لحظات.',
    'cadbot.server.ackDefault': 'شكرًا، سيرد عليك فني قريبًا جدًا.',
    'cadbot.error.rateLimit': 'طلبات كثيرة دفعة واحدة — انتظر {{wait}} ثم أعد المحاولة.',
    'cadbot.error.waitMinutes': '{{n}} دقيقة',
    'cadbot.error.waitFallback': 'دقيقة واحدة',
    'cadbot.error.server': 'لا أستطيع الوصول إلى الخادم. راسلنا على واتساب على **{{phone}}**.',
    // ── tarifs.* (pilote i18n 2026-09-12 — à relire) ──
    'tarifs.back': 'الرئيسية',
    'tarifs.searchPlaceholder': 'ابحث عن طراز أو نوع إصلاح…',
    'tarifs.loading': 'جارٍ تحميل الأسعار…',
    'tarifs.updateTitle': 'يتم تحديث الأسعار',
    'tarifs.updateDesc': 'يتم تحديث أسعارنا حاليًا. تواصل معنا للحصول على عرض سعر مجاني ومخصّص.',
    'tarifs.call': 'اتصل',
    'tarifs.callPrefix': 'اتصل: ',
    'tarifs.callNow': 'اتصل الآن',
    'tarifs.noResult': 'لا توجد نتائج',
    'tarifs.soon': 'الأسعار قريبًا',
    'tarifs.tryOther': 'جرّب كلمات أخرى',
    'tarifs.contactFree': 'تواصل معنا للحصول على عرض سعر مجاني',
    'tarifs.repairBrand': 'إصلاح {{brand}}',
    'tarifs.tariffsCount': '{{count}} سعر متاح',
    'tarifs.colModel': 'الطراز',
    'tarifs.colRepair': 'الإصلاح',
    'tarifs.colPrice': 'السعر',
    'tarifs.colDelay': 'المدة',
    'tarifs.allModels': 'كل الطُرز',
    'tarifs.whatsapp': 'واتساب',
    'tarifs.portal': 'بوابة العميل',
    'tarifs.faqTitle': 'الأسئلة الشائعة',
    'tarifs.titleFallback': 'أسعار إصلاح الهواتف',
    'tarifs.subtitleFallback': 'اكتشف أسعار الإصلاح لدينا لأجهزة iPhone وSamsung وHuawei وغيرها. إصلاح سريع ومضمون في كايين، غيانا الفرنسية.',
    'tarifs.ctaTitleFallback': 'هل تحتاج إلى عرض سعر مخصّص؟',
    'tarifs.ctaDescFallback': 'كل عملية إصلاح فريدة. تواصل معنا للحصول على تشخيص مجاني وعرض سعر دقيق يناسب حالتك.',
    'nav.activityHub': 'مركز النشاط', 'nav.salesHistory': 'سجل المبيعات', 'nav.equipeMagasins': 'الفريق والمتاجر', 'nav.usersLegacy': 'المستخدمون (قديم)', // [i18n-P0 2026-09-12: a relire]
    _name: 'العربية',
    _flag: '🇸🇦',
    _rtl: true,
    'nav.dashboard': 'لوحة التحكم', 'nav.pos': 'نقطة البيع', 'nav.calcul': 'حساب السعر', 'nav.devis': 'عروض / فواتير', 'nav.devisDeplacement': 'عروض التنقل', 'nav.commandes': 'طلبات', 'nav.addDevice': 'إضافة جهاز', 'nav.reparations': 'إصلاحات', 'nav.clients': 'عملاء', 'nav.stock': 'مخزون', 'nav.addStock': 'إضافة مخزون', 'nav.etiquettes': 'ملصقات', 'nav.users': 'مستخدمون', 'nav.clientPwd': 'كلمات مرور العملاء', 'nav.boutiqueOrders': 'طلبات المتجر', 'nav.caisseHistory': 'سجل الصندوق', 'nav.database': 'قاعدة البيانات', 'nav.historique': 'السجل', 'nav.paiements': 'مدفوعات إلكترونية', 'nav.chatClients': 'محادثة العملاء', 'nav.chat': 'رسائل', 'nav.notes': 'ملاحظات', 'nav.logout': 'تسجيل خروج', 'nav.quit': 'خروج', 'nav.admin': 'إدارة', 'nav.navigation': 'تنقل', 'nav.b2b': 'إدارة B2B', 'nav.b2bPayments': 'مدفوعات B2B', 'nav.brandsModels': 'علامات ونماذج',
    'common.save': 'حفظ', 'common.cancel': 'إلغاء', 'common.delete': 'حذف', 'common.edit': 'تعديل', 'common.search': 'بحث', 'common.add': 'إضافة', 'common.close': 'إغلاق', 'common.confirm': 'تأكيد', 'common.loading': 'جاري التحميل...', 'common.noData': 'لا توجد بيانات', 'common.actions': 'إجراءات', 'common.status': 'الحالة', 'common.date': 'التاريخ', 'common.total': 'المجموع', 'common.print': 'طباعة', 'common.yes': 'نعم', 'common.no': 'لا', 'common.back': 'رجوع', 'common.next': 'التالي', 'common.validate': 'تأكيد', 'common.ref': 'المرجع', 'common.client': 'العميل', 'common.phone': 'الهاتف', 'common.email': 'البريد', 'common.price': 'السعر', 'common.quantity': 'الكمية', 'common.amount': 'المبلغ', 'common.send': 'إرسال', 'common.download': 'تحميل', 'common.export': 'تصدير', 'common.refresh': 'تحديث', 'common.filter': 'تصفية', 'common.all': 'الكل', 'common.name': 'الاسم', 'common.address': 'العنوان', 'common.description': 'الوصف', 'common.payment': 'الدفع', 'common.paid': 'مدفوع', 'common.pending': 'قيد الانتظار', 'common.accepted': 'مقبول', 'common.refused': 'مرفوض',
    'layout.panel': 'لوحة الإدارة',
    'pos.title': 'نقطة البيع', 'pos.emptyCart': 'السلة فارغة', 'pos.cash': 'نقدي', 'pos.card': 'بطاقة', 'pos.confirmPayment': 'تأكيد الدفع', 'pos.caisseClosed': 'الصندوق مغلق. افتحه من لوحة التحكم.',
    'devis.title': 'عروض وفواتير', 'devis.noDoc': 'لا يوجد مستند',
    'devDep.title': 'عروض التنقل', 'devDep.subtitle': 'إدارة عروض الإصلاح المنزلي', 'devDep.new': 'عرض جديد', 'devDep.sendByEmail': 'إرسال بالبريد', 'devDep.travelFee': 'رسوم التنقل', 'devDep.pending': 'قيد الانتظار', 'devDep.accepted': 'مقبول', 'devDep.refused': 'مرفوض', 'devDep.fullyPaid': 'مدفوع', 'devDep.noDevis': 'لا توجد عروض', 'devDep.remind': 'تذكير',
    'rep.title': 'إصلاحات', 'cmd.title': 'طلبات', 'clients.title': 'عملاء', 'stock.title': 'إدارة المخزون',
    'dash.title': 'لوحة التحكم', 'dash.openCaisse': 'فتح الصندوق', 'dash.closeCaisse': 'إغلاق الصندوق',
    'login.title': 'تسجيل الدخول', 'login.username': 'اسم المستخدم', 'login.password': 'رمز الدخول', 'login.submit': 'دخول', 'login.clientAccess': 'دخول العميل', 'login.staffAccess': 'دخول الموظف', 'lang.select': 'اللغة',
    'client.space': 'منطقة العميل', 'client.repairs': 'إصلاحات', 'client.boutique': 'متجر', 'client.orders': 'طلبات', 'client.messages': 'رسائل', 'client.devis': 'عروض', 'client.send': 'إرسال', 'client.noDevis': 'لا توجد عروض', 'client.acceptRefuse': 'قبول / رفض', 'client.pay': 'دفع',
      // Translated keys
    'adminB2b.actions': 'الإجراءات', 'adminB2b.address': 'العنوان', 'adminB2b.all': 'الكل', 'adminB2b.awaitingPayment': 'في انتظار الدفع', 'adminB2b.b2bRepairs': 'إصلاحات B2B', 'adminB2b.backGlassBroken': 'زجاج خلفي مكسور', 'adminB2b.bcValidated': 'أمر شراء مؤكد', 'adminB2b.brandModel': 'العلامة / الموديل', 'adminB2b.changeStatus': 'تغيير الحالة', 'adminB2b.clearFilter': 'مسح', 'adminB2b.clientPart': 'قطعة العميل', 'adminB2b.combined': 'مجمع', 'adminB2b.companies': 'الشركات', 'adminB2b.company': 'الشركة', 'adminB2b.confirmReception': 'تأكيد الاستلام', 'adminB2b.confirmRefuse': 'رفض هذه الشركة؟', 'adminB2b.confirmSuspend': 'تعليق هذه الشركة؟', 'adminB2b.confirmValidate': 'تأكيد هذه الشركة؟', 'adminB2b.delivery': 'التسليم', 'adminB2b.diagPrice': 'سعر التشخيص', 'adminB2b.diagnostic': 'تشخيص', 'adminB2b.downloadKbis': 'تحميل KBIS', 'adminB2b.existingInvoices': 'الفواتير الموجودة', 'adminB2b.filter': 'تصفية', 'adminB2b.filterCompany': 'الشركة', 'adminB2b.filterDateEnd': 'تاريخ النهاية', 'adminB2b.filterDateStart': 'تاريخ البداية', 'adminB2b.finalize': 'إنهاء الفوترة', 'adminB2b.home': 'الرئيسية', 'adminB2b.inStore': 'في المتجر', 'adminB2b.invoice': 'فاتورة', 'adminB2b.invoiceCancelled': 'فاتورة ملغاة', 'adminB2b.locked': 'مقفل (مدفوع)', 'adminB2b.markPaid': 'مدفوع', 'adminB2b.monthPrompt': 'الشهر (1-12)؟ اتركه فارغاً للشهر السابق:', 'adminB2b.monthlyRecap': 'ملخص شهري', 'adminB2b.noCompany': 'لم يتم العثور على شركات', 'adminB2b.noPayments': 'لا مدفوعات B2B', 'adminB2b.noRepairs': 'لا إصلاحات B2B', 'adminB2b.paidMethod': 'مدفوع', 'adminB2b.payHistoryTitle': 'سجل مدفوعات B2B', 'adminB2b.paymentHistory': 'سجل المدفوعات', 'adminB2b.paymentMethodPrompt': 'طريقة الدفع؟', 'adminB2b.payments': 'مدفوعات', 'adminB2b.pending': 'قيد الانتظار', 'adminB2b.pendingReception': 'في انتظار الاستلام', 'adminB2b.phone': 'الهاتف', 'adminB2b.pickup': 'استلام', 'adminB2b.postal': 'بريدي', 'adminB2b.price': 'السعر', 'adminB2b.problem': 'المشكلة', 'adminB2b.recapError': 'خطأ', 'adminB2b.recapSent': 'تم الإرسال', 'adminB2b.recapSkipped': 'لا إصلاحات', 'adminB2b.recapTitle': 'نتائج الملخص الشهري', 'adminB2b.ref': 'المرجع', 'adminB2b.refuse': 'رفض', 'adminB2b.refused': 'مرفوضة', 'adminB2b.registeredOn': 'مسجل في', 'adminB2b.repair': 'إصلاح', 'adminB2b.repairPrice': 'سعر الإصلاح', 'adminB2b.search': 'بحث...', 'adminB2b.sending': 'جاري الإرسال...', 'adminB2b.setPrice': 'تحديد السعر', 'adminB2b.siret': 'SIRET', 'adminB2b.status': 'الحالة', 'adminB2b.suspend': 'تعليق', 'adminB2b.suspended': 'معلقة', 'adminB2b.title': 'إدارة B2B', 'adminB2b.total': 'الإجمالي', 'adminB2b.totalCollected': 'إجمالي المحصّل', 'adminB2b.validate': 'تأكيد', 'adminB2b.validated': 'مؤكدة', 'adminB2b.validatedBy': 'مؤكد بواسطة', 'adminB2b.yearPrompt': 'السنة؟',
    'adminDb.accessDenied': 'الوصول مرفوض', 'adminDb.adminOnly': 'للمسؤولين فقط', 'adminDb.clients': 'العملاء', 'adminDb.exportBtn': 'تصدير كامل', 'adminDb.exportConfirm': 'تصدير قاعدة البيانات الكاملة؟', 'adminDb.exportDesc': 'تصدير جميع البيانات كملف JSON.', 'adminDb.exportError': 'خطأ في التصدير', 'adminDb.exportSuccess': 'تم التصدير بنجاح!', 'adminDb.exportTitle': 'تصدير قاعدة البيانات', 'adminDb.fileSelected': 'تم اختيار الملف', 'adminDb.importClientsBtn': 'استيراد العملاء', 'adminDb.importClientsConfirm': 'استيراد العملاء؟ سيتم إنشاء حسابات بالهاتف.', 'adminDb.importConfirm': 'تحذير: سيتم استبدال البيانات الموجودة. متابعة؟', 'adminDb.importDesc': 'استيراد ملف JSON لاستعادة أو نقل البيانات.', 'adminDb.importDone': 'اكتمل الاستيراد!', 'adminDb.importError': 'خطأ في الاستيراد', 'adminDb.importFullBtn': 'استيراد كامل', 'adminDb.importSuccess': 'تم الاستيراد بنجاح!', 'adminDb.importTitle': 'استيراد قاعدة البيانات', 'adminDb.importWarning': 'الاستيراد الكامل سيستبدل البيانات الموجودة', 'adminDb.logsTitle': 'سجل العمليات', 'adminDb.noLogs': 'لا توجد عمليات', 'adminDb.repairs': 'الإصلاحات', 'adminDb.selectFile': 'اختر ملفاً', 'adminDb.selectFileClients': 'اختر ملف JSON بالعملاء', 'adminDb.stockArticles': 'مواد المخزون', 'adminDb.subtitle': 'تصدير واستيراد وإدارة البيانات', 'adminDb.title': 'إدارة قاعدة البيانات', 'adminDb.uploading': 'جاري رفع الملف...', 'adminDb.users': 'المستخدمون',
    'adminSettings.accentColor': 'لون التمييز (hex)', 'adminSettings.addImage': 'إضافة صورة', 'adminSettings.bgImage': 'صورة الخلفية', 'adminSettings.capital': 'رأس المال', 'adminSettings.change': 'تغيير', 'adminSettings.companyInfo': 'معلومات الشركة', 'adminSettings.companyName': 'اسم الشركة', 'adminSettings.companyType': 'النوع (SAS, SARL...)', 'adminSettings.contactHours': 'الاتصال والمواعيد', 'adminSettings.email': 'البريد', 'adminSettings.error': 'خطأ', 'adminSettings.euid': 'EUID', 'adminSettings.gallery': 'معرض الصور', 'adminSettings.googleMaps': 'بحث Google Maps', 'adminSettings.headquarters': 'المقر الرئيسي', 'adminSettings.heroSection': 'العنوان الرئيسي', 'adminSettings.mainTitle': 'العنوان الرئيسي', 'adminSettings.phone': 'الهاتف', 'adminSettings.preview': 'معاينة', 'adminSettings.rcs': 'RCS', 'adminSettings.salesPoint': 'نقطة البيع', 'adminSettings.save': 'حفظ', 'adminSettings.saved': 'تم الحفظ!', 'adminSettings.saving': 'جاري الحفظ...', 'adminSettings.siret': 'SIRET', 'adminSettings.subtitle': 'العنوان الفرعي', 'adminSettings.title': 'الصفحة الرئيسية', 'adminSettings.whatsapp': 'واتساب',
    'b2b.actions': 'الإجراءات', 'b2b.addPhotos': 'انقر لإضافة صور', 'b2b.additionalNotes': 'ملاحظات إضافية', 'b2b.allStatus': 'الكل', 'b2b.amount': 'المبلغ', 'b2b.anotherRepair': 'إصلاح جديد', 'b2b.backGlass': 'الزجاج الخلفي', 'b2b.backGlassBroken': 'زجاج خلفي مكسور', 'b2b.backGlassOk': 'زجاج خلفي سليم', 'b2b.brand': 'العلامة', 'b2b.brandModelRequired': 'العلامة والموديل مطلوبان', 'b2b.brokenParts': 'الأجزاء المعطلة', 'b2b.clear': 'مسح', 'b2b.completed': 'مكتمل', 'b2b.createdOn': 'أُنشئ في', 'b2b.date': 'التاريخ', 'b2b.delivered': 'تم التسليم', 'b2b.deliveryMethod': 'طريقة التسليم', 'b2b.device': 'الجهاز', 'b2b.deviceInfo': 'معلومات الجهاز', 'b2b.devicePhotos': 'صور الجهاز', 'b2b.diagPrice': 'سعر التشخيص', 'b2b.documents': 'الوثائق والفواتير', 'b2b.documentsDesc': 'تحقق من الطلبات وحمّل الفواتير', 'b2b.enterCode': 'أدخل الرمز المستلم بالبريد للتحقق من كل طلب.', 'b2b.history': 'السجل', 'b2b.inProgress': 'قيد التنفيذ', 'b2b.inStore': 'في المتجر', 'b2b.inStoreDesc': 'تسليم في المتجر', 'b2b.invoices': 'الفواتير', 'b2b.lockCode': 'رمز القفل', 'b2b.lockTypeCode': 'رمز (أرقام/حروف)', 'b2b.lockTypeSchema': 'نمط', 'b2b.model': 'الموديل', 'b2b.myRepairs': 'إصلاحاتي', 'b2b.newRepair': 'إصلاح جديد', 'b2b.noInvoices': 'لا فواتير', 'b2b.noPhotos': 'لا صور', 'b2b.noRepairFound': 'لم يتم العثور على إصلاحات', 'b2b.noRepairs': 'لا إصلاحات', 'b2b.orderValidated': 'طلب مؤكد', 'b2b.paid': 'مدفوع', 'b2b.partByShop': 'قطعة من R.E.Mobiles', 'b2b.pendingValidation': 'طلبات بانتظار التحقق', 'b2b.pickup': 'استلام', 'b2b.pickupAddress': 'عنوان الاستلام', 'b2b.pickupDesc': 'نأتي لاستلامه', 'b2b.postal': 'بريدي', 'b2b.postalDesc': 'مع رقم التتبع', 'b2b.priceWaiting': 'قيد الانتظار - سيحدده R.E.Mobiles', 'b2b.problem': 'المشكلة / الوصف', 'b2b.providePart': 'أوفر القطعة', 'b2b.received': 'مُستلم', 'b2b.recentRepairs': 'الإصلاحات الأخيرة', 'b2b.reference': 'المرجع', 'b2b.registerDevice': 'تسجيل جهاز', 'b2b.repairAccepted': 'إصلاح مقبول', 'b2b.repairPrice': 'سعر الإصلاح', 'b2b.repairRefused': 'إصلاح مرفوض', 'b2b.repairRegistered': 'تم تسجيل الإصلاح', 'b2b.submitRepair': 'إرسال الإصلاح', 'b2b.submitting': 'جاري الإرسال...', 'b2b.thisMonth': 'هذا الشهر', 'b2b.trackingNumber': 'رقم التتبع', 'b2b.validate': 'تحقق', 'b2b.viewAll': 'عرض الكل', 'b2b.viewDetails': 'عرض التفاصيل', 'b2b.waitingParts': 'في انتظار القطع', 'b2b.waitingReception': 'في انتظار الاستلام', 'b2b.welcome': 'مرحباً',
    'b2bDevis.acceptFirst': 'اقبل العرض أولاً للتحقق.', 'b2bDevis.alreadyPaid': 'مدفوع مسبقاً', 'b2bDevis.codeHint': 'أدخل الرمز المكون من 6 أرقام المستلم بالبريد.', 'b2bDevis.invoiceDownload': 'تحميل الفاتورة', 'b2bDevis.noDevis': 'لا عروض أسعار', 'b2bDevis.noDevisDesc': 'ليس لديك عروض أسعار تنقل حالياً.', 'b2bDevis.orderDownload': 'تحميل أمر الشراء', 'b2bDevis.payDeposit': 'دفع مقدم 50%', 'b2bDevis.payFull': 'دفع كامل', 'b2bDevis.payRemaining': 'دفع المتبقي', 'b2bDevis.pending': 'قيد الانتظار', 'b2bDevis.quoteDownload': 'تحميل عرض السعر', 'b2bDevis.remaining': 'المتبقي', 'b2bDevis.title': 'عروض أسعار التنقل', 'b2bDevis.travelFee': 'رسوم التنقل', 'b2bDevis.validationCode': 'رمز التحقق',
    'b2bPay.noPayments': 'لا مدفوعات', 'b2bPay.title': 'مدفوعات B2B',
    'b2bRegister.address': 'العنوان', 'b2bRegister.alreadyAccount': 'مسجل بالفعل؟', 'b2bRegister.companyName': 'اسم الشركة', 'b2bRegister.confirmPassword': 'تأكيد كلمة المرور', 'b2bRegister.creating': 'جاري التسجيل...', 'b2bRegister.dropFile': 'انقر أو اسحب الملف هنا', 'b2bRegister.fillAll': 'أكمل جميع الحقول المطلوبة', 'b2bRegister.goLogin': 'الذهاب لتسجيل الدخول', 'b2bRegister.kbis': 'مستخرج KBIS (PDF)', 'b2bRegister.kbisDesc': 'ارفع مستخرج KBIS أو وثيقة إثبات (PDF)', 'b2bRegister.kbisRequired': 'ارفع مستخرج KBIS', 'b2bRegister.managerName': 'اسم المسؤول', 'b2bRegister.password': 'كلمة المرور', 'b2bRegister.phone': 'الهاتف', 'b2bRegister.proEmail': 'البريد المهني', 'b2bRegister.pwdMinLength': 'يجب أن تكون كلمة المرور 6 أحرف على الأقل', 'b2bRegister.pwdNoMatch': 'كلمات المرور غير متطابقة', 'b2bRegister.siret': 'SIRET', 'b2bRegister.siretError': 'يجب أن يحتوي SIRET على 14 رقماً', 'b2bRegister.submit': 'تسجيل', 'b2bRegister.subtitle': 'إنشاء حسابك المهني', 'b2bRegister.success': 'تم التسجيل بنجاح!', 'b2bRegister.successMsg': 'حسابك قيد المراجعة. ستتلقى تأكيداً بالبريد.', 'b2bRegister.title': 'تسجيل الشركة',
    'boutique.clientName': 'العميل', 'boutique.noOrders': 'لا طلبات', 'boutique.orderRef': 'مرجع الطلب', 'boutique.status': 'الحالة', 'boutique.title': 'طلبات المتجر', 'boutique.total': 'الإجمالي',
    'brands.addBrand': 'إضافة علامة', 'brands.addModel': 'إضافة موديل', 'brands.deleteConfirm': 'حذف هذه العلامة؟', 'brands.noBrands': 'لا علامات', 'brands.title': 'العلامات والموديلات',
    'caisse.closeDate': 'الإغلاق', 'caisse.closingAmount': 'مبلغ الإغلاق', 'caisse.noCaisse': 'لا صندوق', 'caisse.openDate': 'الافتتاح', 'caisse.openedBy': 'فُتح بواسطة', 'caisse.openingAmount': 'مبلغ الافتتاح', 'caisse.sales': 'المبيعات', 'caisse.title': 'سجل الصندوق',
    'calc.generateInvoice': 'إنشاء فاتورة', 'calc.generateQuote': 'إنشاء عرض سعر', 'calc.searchDevice': 'بحث عن جهاز...', 'calc.selectRepair': 'اختيار إصلاح', 'calc.title': 'حاسبة الأسعار',
    'chat.noConversations': 'لا محادثات', 'chat.title': 'الرسائل', 'chat.typeMessage': 'اكتب رسالتك...',
    'clientPwd.generatePin': 'إنشاء PIN', 'clientPwd.noClients': 'لا عملاء', 'clientPwd.search': 'بحث عن عميل...', 'clientPwd.sendByEmail': 'إرسال بالبريد', 'clientPwd.title': 'كلمات مرور العملاء',
    'clients.account': 'حساب', 'clients.activeAccount': 'نشط', 'clients.add': 'إضافة', 'clients.business': 'شركة', 'clients.clientType': 'نوع العميل', 'clients.company': 'شركة', 'clients.deleteConfirm': 'حذف هذا العميل؟', 'clients.discount': 'خصم', 'clients.discountPct': 'خصم (%)', 'clients.editClient': 'تعديل العميل', 'clients.individual': 'فرد', 'clients.manage': 'إدارة العملاء', 'clients.newClient': 'عميل جديد', 'clients.noClients': 'لم يتم العثور على عملاء', 'clients.noEmail': 'بدون بريد', 'clients.page': 'صفحة', 'clients.sent': 'مُرسل', 'clients.total': 'عملاء إجمالاً', 'clients.type': 'النوع',
    'closeCaisse.actualTotal': 'الإجمالي الفعلي', 'closeCaisse.close': 'إغلاق الصندوق', 'closeCaisse.closing': 'جاري الإغلاق...', 'closeCaisse.countCoins': 'عد النقود', 'closeCaisse.difference': 'الفرق', 'closeCaisse.theoreticalTotal': 'الإجمالي النظري', 'closeCaisse.title': 'إغلاق الصندوق',
    'cmd.addOrder': 'طلب جديد', 'cmd.allStatuses': 'جميع الحالات', 'cmd.cancelled': 'ملغي', 'cmd.deleteConfirm': 'حذف هذا الطلب؟', 'cmd.editOrder': 'تعديل الطلب', 'cmd.manage': 'إدارة الطلبات', 'cmd.noOrders': 'لا طلبات', 'cmd.ordered': 'طُلب', 'cmd.received': 'مُستلم', 'cmd.ref': 'المرجع', 'cmd.status': 'الحالة',
    'dash.activeRepairs': 'الإصلاحات النشطة', 'dash.addDevice': 'إضافة', 'dash.b2bPaymentsDesc': 'متابعة الفواتير والمدفوعات', 'dash.b2bPaymentsLabel': 'مدفوعات B2B', 'dash.brandsModelsDesc': 'إدارة كتالوج الأجهزة', 'dash.brandsModelsLabel': 'العلامات والموديلات', 'dash.caisseOpen': 'الصندوق مفتوح', 'dash.calculation': 'الآلة الحاسبة', 'dash.clients': 'العملاء', 'dash.closeCaisseReminder': 'لا تنسَ إغلاق الصندوق', 'dash.closeNormal': 'إغلاق عادي', 'dash.closing': 'جاري الإغلاق...', 'dash.completed': 'مكتملة', 'dash.contactAdmin': 'اتصل بمسؤول لإغلاقه.', 'dash.dontOpen': 'لا تفتح (متابعة)', 'dash.errorForceClose': 'خطأ في الإغلاق الإجباري', 'dash.errorOpenCaisse': 'خطأ في فتح الصندوق', 'dash.forceClose': 'إغلاق إجباري', 'dash.forceCloseConfirm': 'إغلاق إجباري للصندوق من', 'dash.hello': 'مرحباً', 'dash.inProgress': 'قيد التنفيذ', 'dash.loggedAs': 'مسجل الدخول كـ', 'dash.lowStock': 'منتجات بمخزون منخفض', 'dash.mustClose': 'يجب إغلاقه قبل المتابعة.', 'dash.noCaisse': 'لا يوجد صندوق مفتوح', 'dash.noCaisseToday': 'لا يوجد صندوق مفتوح اليوم.', 'dash.noClient': 'بدون عميل', 'dash.noResults': 'لا نتائج', 'dash.open': 'فتح', 'dash.openCaisseTitle': 'فتح الصندوق', 'dash.openQuestion': 'هل تريد فتح الصندوق الآن؟', 'dash.openTotal': 'مبلغ الافتتاح', 'dash.openedBy': 'فُتح بواسطة', 'dash.opening': 'جاري الفتح...', 'dash.outOfStock': 'نفدت من المخزون', 'dash.recentRepairs': 'الإصلاحات الأخيرة', 'dash.registeredMonth': 'مسجلة هذا الشهر', 'dash.repairs': 'الإصلاحات', 'dash.repairsSub': 'إصلاحات', 'dash.salesBlocked': 'المبيعات محظورة حتى فتح الصندوق.', 'dash.searchPlaceholder': 'بحث بالمرجع، العميل، الهاتف...', 'dash.statsDesc': 'الإيرادات، الإصلاحات، B2B، العملاء', 'dash.statsTitle': 'الإحصائيات والتحليلات', 'dash.stockAlerts': 'تنبيهات المخزون', 'dash.thisMonth': 'هذا الشهر', 'dash.today': 'اليوم', 'dash.todaySales': 'مبيعات اليوم', 'dash.unclosedNotClosed': 'لم يتم إغلاقه', 'dash.unclosedTitle': 'صندوق غير مغلق', 'dash.unknown': 'غير معروف', 'dash.waitingParts': 'بما في ذلك انتظار قطع الغيار',
    'devDep.remindConfirm': 'إرسال تذكير للعملاء بعروض أسعار تجاوزت 3 أيام؟',
    'devisAccept.accept': 'قبول العرض', 'devisAccept.accepted': 'تم قبول عرض السعر!', 'devisAccept.acceptedMsg': 'شكراً لقبول عرض السعر', 'devisAccept.alreadyAccepted': 'تم قبول هذا العرض مسبقاً.', 'devisAccept.alreadyRefused': 'تم رفض هذا العرض.', 'devisAccept.bonCommande': 'أمر شراء', 'devisAccept.confirmRefuse': 'هل أنت متأكد من رفض هذا العرض؟', 'devisAccept.deposit50': 'مقدم 50%', 'devisAccept.designation': 'الوصف', 'devisAccept.emailSent': 'تم إرسال بريد إلكتروني بالطلب ورمز التحقق وبيانات الدخول.', 'devisAccept.error': 'خطأ', 'devisAccept.facture': 'فاتورة', 'devisAccept.findBelow': 'تفاصيل عرض السعر أدناه:', 'devisAccept.fullPayment': 'دفع كامل', 'devisAccept.hello': 'مرحباً', 'devisAccept.homeRepairQuote': 'عرض سعر إصلاح منزلي', 'devisAccept.notFound': 'عرض السعر غير موجود', 'devisAccept.payDeposit': 'دفع مقدم 50%', 'devisAccept.paymentMsg': 'لإتمام طلبك، ادفع مقدم أو المبلغ الكامل:', 'devisAccept.proceedPayment': 'المتابعة للدفع', 'devisAccept.refuse': 'رفض', 'devisAccept.refused': 'عرض السعر مرفوض', 'devisAccept.refusedMsg': 'لقد رفضت عرض السعر', 'devisAccept.statusMsg': 'حالة العرض', 'devisAccept.thanks': 'شكراً لإبلاغنا.', 'devisAccept.travelFee': 'رسوم التنقل', 'devisAccept.tvaNote': 'ضريبة القيمة المضافة غير مطبقة. العرض صالح 30 يوماً.',
    'hist.amount': 'المبلغ', 'hist.articles': 'المواد', 'hist.client': 'العميل', 'hist.date': 'التاريخ', 'hist.noSales': 'لا مبيعات', 'hist.payment': 'الدفع', 'hist.ref': 'المرجع', 'hist.refund': 'استرداد', 'hist.refundConfirm': 'استرداد هذا البيع؟', 'hist.search': 'بحث عن بيع...', 'hist.title': 'سجل المبيعات',
    'labels.noLabels': 'لا ملصقات', 'labels.print': 'طباعة', 'labels.search': 'بحث...', 'labels.selectAll': 'تحديد الكل', 'labels.title': 'الملصقات',
    'landing.allRights': 'جميع الحقوق محفوظة', 'landing.heroSubtitle': 'متخصصكم في إصلاح الهواتف في غيانا', 'landing.mondayFriday': 'الاثنين - الجمعة', 'landing.saturday': 'السبت', 'landing.sunday': 'الأحد', 'landing.closed': 'مغلق', 'landing.companyType': 'شركة مساهمة مبسطة (SAS)', 'landing.openMaps': 'فتح في الخرائط', 'landing.rcs': 'السجل التجاري', 'landing.siret': 'رقم التسجيل', 'landing.euid': 'معرف الشركة الأوروبي', 'landing.shopAddress': 'عنوان المتجر', 'landing.businessDesc': 'بوابة B2B', 'landing.businessSpace': 'منطقة الأعمال', 'landing.callWhatsapp': 'اتصال وواتساب', 'landing.capital': 'برأس مال', 'landing.clientDesc': 'متابعة الإصلاحات', 'landing.clientSpace': 'منطقة العميل', 'landing.contact': 'اتصل بنا', 'landing.headquarters': 'المقر الرئيسي', 'landing.hours': 'ساعات العمل', 'landing.legal': 'معلومات قانونية', 'landing.mobileRepair': 'إصلاح الهواتف في غويانا الفرنسية', 'landing.staffDesc': 'وصول الفريق التقني', 'landing.staffSpace': 'المنطقة الشخصية', 'landing.writeUs': 'راسلنا مباشرة',
    'login.b2bPassword': 'كلمة المرور', 'login.b2bPlaceholder': 'كلمة المرور الخاصة بك', 'login.backHome': 'العودة للرئيسية', 'login.businessRegister': 'تسجيل الشركة', 'login.businessSpace': 'منطقة الأعمال', 'login.caricature': 'إنشاء كاريكاتيري', 'login.clientSpace': 'منطقة العميل', 'login.connect': 'تسجيل الدخول', 'login.connectYou': 'تسجيل الدخول', 'login.connecting': 'جاري الاتصال...', 'login.createAccount': 'إنشاء حساب', 'login.forgotPwd': 'نسيت كلمة المرور؟', 'login.noAccount': 'ليس لديك حساب بعد؟', 'login.notRegistered': 'لم تسجل بعد؟', 'login.phoneNumber': 'رقم الهاتف', 'login.pin': 'رمز PIN (4 أو 6 أرقام)', 'login.pinError': 'يجب أن يكون PIN من 4 أو 6 أرقام', 'login.pinHint': 'أدخل رمزك باستخدام لوحة المفاتيح.', 'login.proEmail': 'البريد المهني', 'login.secure': 'اتصال آمن', 'login.staffSpace': 'المنطقة الشخصية', 'login.wrongCredentials': 'بيانات دخول غير صحيحة', 'login.yourId': 'المعرّف الخاص بك',
    'notes.deleteConfirm': 'حذف هذه الملاحظة؟', 'notes.new': 'ملاحظة جديدة', 'notes.noNotes': 'لا ملاحظات', 'notes.title': 'الملاحظات',
    'pay.amount': 'المبلغ', 'pay.client': 'العميل', 'pay.date': 'التاريخ', 'pay.noPayments': 'لا مدفوعات', 'pay.ref': 'المرجع', 'pay.search': 'بحث...', 'pay.status': 'الحالة', 'pay.title': 'المدفوعات عبر الإنترنت', 'pay.type': 'النوع',
    'paySuccess.amountPaid': 'المبلغ المدفوع', 'paySuccess.checking': 'جاري التحقق...', 'paySuccess.confirmed': 'تم تأكيد الدفع!', 'paySuccess.depositDone': 'تم تسجيله.', 'paySuccess.depositFor': 'المقدم لعرض السعر', 'paySuccess.depositRegistered': 'تم تسجيل المقدم!', 'paySuccess.loginClient': 'الدخول لمنطقة العميل', 'paySuccess.payRemaining': 'دفع المتبقي', 'paySuccess.paymentFor': 'دفعتك لعرض السعر', 'paySuccess.pleaseWait': 'نحن نتحقق من دفعتك، يرجى الانتظار.', 'paySuccess.processing': 'جاري معالجة دفعتك. ستتلقى تأكيداً بالبريد.', 'paySuccess.registered': 'تم تسجيلها بنجاح.', 'paySuccess.remaining': 'المتبقي', 'paySuccess.totalInvoice': 'إجمالي الفاتورة', 'paySuccess.waitingConfirm': 'في انتظار التأكيد',
    'payment.accessClient': 'الوصول لمنطقة العميل', 'payment.alreadyPaid': 'مدفوعة بالكامل بالفعل.', 'payment.alreadyPaidAmount': 'المدفوع مسبقاً', 'payment.amountToPay': 'المبلغ المطلوب', 'payment.backToDevis': 'العودة للعرض', 'payment.client': 'العميل', 'payment.creationError': 'خطأ في إنشاء الدفع', 'payment.deposit50': 'مقدم 50%', 'payment.depositPercent': 'مقدم (50%)', 'payment.devis': 'عرض السعر', 'payment.error': 'خطأ', 'payment.fullPayment': 'دفع كامل', 'payment.fullyPaid': 'الفاتورة مدفوعة بالكامل', 'payment.mustAcceptFirst': 'يجب قبول العرض قبل الدفع.', 'payment.notAccepted': 'العرض غير مقبول', 'payment.pay': 'ادفع', 'payment.redirecting': 'جاري التحويل إلى Stripe...', 'payment.remaining': 'المتبقي', 'payment.secure': 'دفع آمن', 'payment.securedBy': 'الدفع مؤمن بواسطة Stripe', 'payment.totalDevis': 'إجمالي العرض', 'payment.urlNotAvailable': 'رابط الدفع غير متوفر', 'payment.viewDevis': 'عرض التقدير',
    'register.address': 'العنوان (اختياري)', 'register.alreadyAccount': 'لديك حساب بالفعل؟', 'register.backHome': 'العودة للرئيسية', 'register.clientTitle': 'إنشاء حساب عميل', 'register.confirmPin': 'تأكيد رمز PIN', 'register.createAccount': 'إنشاء حسابي', 'register.creating': 'جاري الإنشاء...', 'register.email': 'البريد (اختياري)', 'register.fullName': 'الاسم الكامل', 'register.login': 'تسجيل الدخول', 'register.phone': 'الهاتف', 'register.pin': 'رمز PIN (4 أو 6 أرقام)', 'register.pinError': 'يجب أن يكون PIN من 4 أو 6 أرقام', 'register.pinMinLength': 'يجب أن يكون PIN 4 أرقام على الأقل', 'register.pinNoMatch': 'رموز PIN غير متطابقة',
    'remcaches.noItems': 'لا عناصر', 'remcaches.title': 'حوالات نقدية',
    'rep.addDeposit': 'إضافة مقدم', 'rep.allStatuses': 'جميع الحالات', 'rep.changeStatus': 'تغيير الحالة', 'rep.client': 'العميل', 'rep.date': 'التاريخ', 'rep.deleteConfirm': 'حذف هذا الإصلاح؟', 'rep.deposit': 'المقدم', 'rep.depositAmount': 'مبلغ المقدم', 'rep.depositHistory': 'سجل المقدمات', 'rep.imei': 'IMEI / المسلسل', 'rep.manage': 'إدارة الإصلاحات', 'rep.noRepairs': 'لا إصلاحات', 'rep.noTimeline': 'لا أحداث', 'rep.notes': 'ملاحظات داخلية', 'rep.paymentMode': 'طريقة الدفع', 'rep.phone': 'الهاتف', 'rep.printEtiquette': 'طباعة الملصق', 'rep.printFiche': 'طباعة البطاقة', 'rep.sendChat': 'إرسال رسالة', 'rep.totalDeposits': 'إجمالي المقدمات',
    'repForm.brand': 'العلامة', 'repForm.client': 'العميل', 'repForm.editTitle': 'تعديل الإصلاح', 'repForm.imei': 'IMEI / الرقم المسلسل', 'repForm.lockCode': 'رمز القفل', 'repForm.model': 'الموديل', 'repForm.price': 'سعر الإصلاح', 'repForm.problem': 'المشكلة المكتشفة', 'repForm.submit': 'حفظ', 'repForm.submitting': 'جاري الحفظ...', 'repForm.technician': 'الفني المعين', 'repForm.title': 'إضافة جهاز',
    'reset.backLogin': 'العودة لتسجيل الدخول', 'reset.clientEmail': 'بريد حسابك', 'reset.confirmPwd': 'تأكيد كلمة المرور', 'reset.emailSent': 'تم إرسال البريد', 'reset.emailSentMsg': 'إذا كان الحساب موجوداً، ستتلقى رابط إعادة تعيين.', 'reset.enterEmail': 'أدخل بريدك الإلكتروني', 'reset.error': 'حدث خطأ', 'reset.forgotDesc': 'احصل على رابط إعادة تعيين بالبريد', 'reset.forgotTitle': 'نسيت كلمة المرور', 'reset.linkValid': 'الرابط صالح لمدة ساعة.', 'reset.newPwd': 'كلمة مرور جديدة', 'reset.newPwdDesc': 'اختر كلمة مرور جديدة', 'reset.newPwdTitle': 'كلمة مرور جديدة', 'reset.pwdMinLength': 'يجب أن تكون كلمة المرور 4 أحرف على الأقل', 'reset.pwdNoMatch': 'كلمات المرور غير متطابقة', 'reset.pwdReset': 'تم إعادة تعيين كلمة المرور', 'reset.pwdResetMsg': 'تم تغيير كلمة المرور بنجاح.', 'reset.resetPwd': 'إعادة تعيين كلمة المرور', 'reset.resetting': 'جاري إعادة التعيين...', 'reset.sendLink': 'إرسال رابط إعادة التعيين', 'reset.sending': 'جاري الإرسال...',
    'stats.avgRepairTime': 'متوسط المدة', 'stats.b2b': 'B2B', 'stats.b2bByCompany': 'حسب الشركة', 'stats.b2bCompanies': 'شركات B2B', 'stats.b2bRepairs': 'إصلاحات B2B', 'stats.b2bRevenue': 'إيرادات B2B', 'stats.back': 'رجوع', 'stats.clients': 'العملاء', 'stats.clientsByType': 'حسب النوع', 'stats.completionRate': 'معدل الإنجاز', 'stats.monthly': 'الاتجاه الشهري', 'stats.monthlyRevenue': 'الإيرادات الشهرية', 'stats.newThisMonth': 'جدد هذا الشهر', 'stats.noData': 'لا بيانات', 'stats.registrations': 'التسجيلات الشهرية', 'stats.repairs': 'الإصلاحات', 'stats.repairsByBrand': 'حسب العلامة', 'stats.repairsByStatus': 'حسب الحالة', 'stats.revenue': 'الإيرادات', 'stats.revenueByPayment': 'الإيرادات حسب طريقة الدفع', 'stats.revenueByType': 'الإيرادات حسب النوع', 'stats.title': 'الإحصائيات والتحليلات', 'stats.topModels': 'أفضل الموديلات', 'stats.totalClients': 'إجمالي العملاء', 'stats.totalRepairs': 'إجمالي الإصلاحات', 'stats.totalRevenue': 'إجمالي الإيرادات (12 شهراً)', 'stats.withAccount': 'مع حساب',
    'stock.addForm': 'إضافة مادة', 'stock.alert': 'تنبيه', 'stock.barcode': 'رمز شريطي', 'stock.deleteConfirm': 'حذف هذه المادة؟', 'stock.editForm': 'تعديل المادة', 'stock.lowStockAlert': 'مخزون منخفض', 'stock.manage': 'إدارة المخزون', 'stock.noItems': 'لا مواد', 'stock.reference': 'المرجع',
    'users.accessDenied': 'للمسؤولين فقط', 'users.active': 'نشط', 'users.count': 'مستخدم(ين)', 'users.createdAt': 'أُنشئ في', 'users.deleteConfirm': 'حذف هذا المستخدم؟', 'users.edit': 'تعديل', 'users.inactive': 'غير نشط', 'users.new': 'مستخدم جديد', 'users.newPassword': 'كلمة مرور جديدة (اتركها فارغة للاحتفاظ)', 'users.noUsers': 'لا مستخدمين', 'users.password': 'كلمة المرور', 'users.role': 'الدور', 'users.roleAdmin': 'مسؤول', 'users.roleTech': 'فني', 'users.roleUser': 'بائع', 'users.status': 'الحالة', 'users.title': 'إدارة المستخدمين', 'users.username': 'اسم المستخدم',
    // Missing POS keys
    'pos.scanner': 'ماسح', 'pos.searchProduct': 'البحث عن منتج (مرجع، اسم، باركود)...', 'pos.outOfStock': 'غير متوفر', 'pos.article': 'منتج', 'pos.unitPrice': 'سعر الوحدة', 'pos.qty': 'الكمية', 'pos.checkout': 'الدفع', 'pos.clientOptional': 'العميل (اختياري)', 'pos.discount': 'خصم', 'pos.subtotal': 'المجموع الفرعي', 'pos.validateSale': 'تأكيد البيع', 'pos.paymentMode': 'طريقة الدفع', 'pos.choosePayment': 'اختر طريقة الدفع:', 'pos.mixed': 'مختلط', 'pos.totalToCollect': 'المبلغ المطلوب', 'pos.change': 'الباقي', 'pos.validating': 'جارٍ التأكيد...', 'pos.lastTicket': 'آخر إيصال', 'pos.insufficientCash': 'المبلغ النقدي غير كافٍ', 'pos.insufficientCard': 'مبلغ البطاقة غير كافٍ', 'pos.mixedMustEqual': 'الدفع المختلط يجب أن يساوي المجموع', 'pos.emptyCartAlert': 'السلة فارغة', 'pos.selectPayment': 'يرجى اختيار طريقة دفع', 'pos.saleValidated': 'تم تأكيد البيع!', 'pos.adminOverride': 'تفويض المسؤول', 'pos.outOfStockProduct': 'منتج غير متوفر', 'pos.adminId': 'معرف المسؤول', 'pos.adminCode': 'رمز المسؤول', 'pos.manualAdd': 'إضافة منتج غير متوفر', 'pos.designation': 'التسمية', 'pos.stockInsufficient': 'المخزون غير كافٍ',
    // Missing devis keys
    'devis.subtitle': 'مستندات حساب الأسعار (قابلة للتحويل إلى طلب).', 'devis.type': 'النوع', 'devis.convertConfirm': 'تحويل هذا العرض إلى طلب؟', 'devis.orderCreated': 'تم إنشاء الطلب', 'devis.deleteConfirm': 'حذف هذا المستند؟', 'devis.deleted': 'تم حذف المستند',
    // Missing devDep keys
    'devDep.edit': 'تعديل العرض', 'devDep.clientName': 'اسم العميل', 'devDep.clientPhone': 'الهاتف', 'devDep.clientEmail': 'البريد الإلكتروني', 'devDep.clientAddress': 'العنوان', 'devDep.repairDesc': 'وصف الإصلاح', 'devDep.lines': 'بنود العرض', 'devDep.addLine': 'إضافة', 'devDep.sendByEmail': 'إرسال بالبريد', 'devDep.sending': 'جارٍ الإرسال...', 'devDep.pdfDevis': 'PDF عرض', 'devDep.pdfBon': 'PDF طلب', 'devDep.pdfFacture': 'PDF فاتورة', 'devDep.searchPlaceholder': 'بحث بالمرجع، الاسم، البريد...', 'devDep.allStatuses': 'كل الحالات', 'devDep.depositPaid': 'تم دفع العربون', 'devDep.stats': 'إحصائيات', 'devDep.revenues': 'الإيرادات', 'devDep.activity30d': 'نشاط آخر 30 يوم', 'devDep.noResults': 'لا نتائج', 'devDep.bon': 'أمر شراء', 'devDep.facture': 'فاتورة', 'devDep.emailSent': 'تم إرسال البريد في', 'devDep.reminderSent': 'تم إرسال التذكير في',
    // Missing rep keys
    'rep.search': 'البحث عن إصلاح...', 'rep.new': 'إصلاح جديد', 'rep.deviceRef': 'مرجع الجهاز', 'rep.brand': 'العلامة', 'rep.model': 'الموديل', 'rep.problem': 'المشكلة', 'rep.technician': 'الفني', 'rep.timeline': 'التسلسل الزمني',
    // Missing cmd keys
    'cmd.search': 'البحث عن طلب...', 'cmd.piece': 'القطعة', 'cmd.supplier': 'المورد', 'cmd.deposit': 'العربون', 'cmd.remaining': 'المبلغ المتبقي',
    // Missing clients keys
    'clients.search': 'البحث عن عميل...', 'clients.name': 'الاسم', 'clients.address': 'العنوان', 'clients.addClient': 'عميل جديد',
    // Missing stock keys
    'stock.search': 'البحث عن مادة...', 'stock.addArticle': 'إضافة مادة', 'stock.category': 'الفئة', 'stock.buyPrice': 'سعر الشراء', 'stock.sellPrice': 'سعر البيع', 'stock.available': 'متوفر',
    // Missing dash keys
    'dash.monthSales': 'مبيعات الشهر', 'dash.pendingOrders': 'طلبات معلقة',
    // Missing client keys
    'client.trackRepairs': 'تتبع إصلاحاتك', 'client.noRepairs': 'لا إصلاحات جارية', 'client.trackOrders': 'تتبع طلباتك', 'client.noOrders': 'لا طلبات جارية', 'client.shop': 'المتجر الإلكتروني', 'client.noProducts': 'لا منتجات متوفرة', 'client.addToCart': 'أضف إلى السلة', 'client.yourMessages': 'رسائلك', 'client.noMessages': 'لا رسائل', 'client.brand': 'العلامة', 'client.model': 'الموديل', 'client.problem': 'المشكلة', 'client.status': 'الحالة', 'client.deposit': 'العربون', 'client.remaining': 'المتبقي', 'client.total': 'المجموع', 'client.timeline': 'التسلسل الزمني',
    'sumup.acceptOnlinePayment': 'قبول الدفع عبر الإنترنت (SumUp)', 'sumup.acceptOnlinePaymentDesc': 'يمكن للعميل طلب رابط دفع SumUp', 'sumup.requestLink': 'طلب رابط دفع SumUp', 'sumup.requestSent': 'تم إرسال الطلب! ستتلقى الرابط عبر البريد الإلكتروني قريبًا.', 'sumup.alreadyRequested': 'الطلب قيد المعالجة بالفعل.', 'sumup.onlinePayment': 'دفع عبر الإنترنت SumUp', 'sumup.receiveLink': 'تلقي رابط دفع آمن عبر البريد الإلكتروني', 'sumup.linkRequested': 'تم طلب الرابط', 'sumup.pendingRequests': 'طلبات روابط SumUp', 'sumup.pending': 'قيد الانتظار', 'sumup.pasteLinkHere': 'الصق رابط SumUp هنا...', 'sumup.send': 'إرسال', 'sumup.linkSent': 'تم إرسال رابط SumUp للعميل عبر البريد الإلكتروني!',
};

export default ar;
